function A(r, t, o) {
  function s(m, S) {
    if (m._zod || Object.defineProperty(m, "_zod", {
      value: {
        def: S,
        constr: p,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), m._zod.traits.has(r))
      return;
    m._zod.traits.add(r), t(m, S);
    const x = p.prototype, N = Object.keys(x);
    for (let L = 0; L < N.length; L++) {
      const O = N[L];
      O in m || (m[O] = x[O].bind(m));
    }
  }
  const u = o?.Parent ?? Object;
  class f extends u {
  }
  Object.defineProperty(f, "name", { value: r });
  function p(m) {
    var S;
    const x = o?.Parent ? new f() : this;
    s(x, m), (S = x._zod).deferred ?? (S.deferred = []);
    for (const N of x._zod.deferred)
      N();
    return x;
  }
  return Object.defineProperty(p, "init", { value: s }), Object.defineProperty(p, Symbol.hasInstance, {
    value: (m) => o?.Parent && m instanceof o.Parent ? !0 : m?._zod?.traits?.has(r)
  }), Object.defineProperty(p, "name", { value: r }), p;
}
class ur extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class Ru extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const zu = {};
function Dn(r) {
  return zu;
}
function Ou(r) {
  const t = Object.values(r).filter((s) => typeof s == "number");
  return Object.entries(r).filter(([s, u]) => t.indexOf(+s) === -1).map(([s, u]) => u);
}
function vi(r, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Ai(r) {
  return {
    get value() {
      {
        const t = r();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Ci(r) {
  return r == null;
}
function yi(r) {
  const t = r.startsWith("^") ? 1 : 0, o = r.endsWith("$") ? r.length - 1 : r.length;
  return r.slice(t, o);
}
function Ig(r, t) {
  const o = (r.toString().split(".")[1] || "").length, s = t.toString();
  let u = (s.split(".")[1] || "").length;
  if (u === 0 && /\d?e-\d?/.test(s)) {
    const S = s.match(/\d?e-(\d?)/);
    S?.[1] && (u = Number.parseInt(S[1]));
  }
  const f = o > u ? o : u, p = Number.parseInt(r.toFixed(f).replace(".", "")), m = Number.parseInt(t.toFixed(f).replace(".", ""));
  return p % m / 10 ** f;
}
const lu = /* @__PURE__ */ Symbol("evaluating");
function J(r, t, o) {
  let s;
  Object.defineProperty(r, t, {
    get() {
      if (s !== lu)
        return s === void 0 && (s = lu, s = o()), s;
    },
    set(u) {
      Object.defineProperty(r, t, {
        value: u
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Un(r, t, o) {
  Object.defineProperty(r, t, {
    value: o,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Mn(...r) {
  const t = {};
  for (const o of r) {
    const s = Object.getOwnPropertyDescriptors(o);
    Object.assign(t, s);
  }
  return Object.defineProperties({}, t);
}
function cu(r) {
  return JSON.stringify(r);
}
function bg(r) {
  return r.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const Lu = "captureStackTrace" in Error ? Error.captureStackTrace : (...r) => {
};
function Gt(r) {
  return typeof r == "object" && r !== null && !Array.isArray(r);
}
const Sg = Ai(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const r = Function;
    return new r(""), !0;
  } catch {
    return !1;
  }
});
function Gr(r) {
  if (Gt(r) === !1)
    return !1;
  const t = r.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const o = t.prototype;
  return !(Gt(o) === !1 || Object.prototype.hasOwnProperty.call(o, "isPrototypeOf") === !1);
}
function Fu(r) {
  return Gr(r) ? { ...r } : Array.isArray(r) ? [...r] : r;
}
const Tg = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function lr(r) {
  return r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Nn(r, t, o) {
  const s = new r._zod.constr(t ?? r._zod.def);
  return (!t || o?.parent) && (s._zod.parent = r), s;
}
function k(r) {
  const t = r;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function Ag(r) {
  return Object.keys(r).filter((t) => r[t]._zod.optin === "optional" && r[t]._zod.optout === "optional");
}
const Cg = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function yg(r, t) {
  const o = r._zod.def, s = o.checks;
  if (s && s.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const f = Mn(r._zod.def, {
    get shape() {
      const p = {};
      for (const m in t) {
        if (!(m in o.shape))
          throw new Error(`Unrecognized key: "${m}"`);
        t[m] && (p[m] = o.shape[m]);
      }
      return Un(this, "shape", p), p;
    },
    checks: []
  });
  return Nn(r, f);
}
function xg(r, t) {
  const o = r._zod.def, s = o.checks;
  if (s && s.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const f = Mn(r._zod.def, {
    get shape() {
      const p = { ...r._zod.def.shape };
      for (const m in t) {
        if (!(m in o.shape))
          throw new Error(`Unrecognized key: "${m}"`);
        t[m] && delete p[m];
      }
      return Un(this, "shape", p), p;
    },
    checks: []
  });
  return Nn(r, f);
}
function wg(r, t) {
  if (!Gr(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const o = r._zod.def.checks;
  if (o && o.length > 0) {
    const f = r._zod.def.shape;
    for (const p in t)
      if (Object.getOwnPropertyDescriptor(f, p) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const u = Mn(r._zod.def, {
    get shape() {
      const f = { ...r._zod.def.shape, ...t };
      return Un(this, "shape", f), f;
    }
  });
  return Nn(r, u);
}
function Mg(r, t) {
  if (!Gr(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const o = Mn(r._zod.def, {
    get shape() {
      const s = { ...r._zod.def.shape, ...t };
      return Un(this, "shape", s), s;
    }
  });
  return Nn(r, o);
}
function Ng(r, t) {
  const o = Mn(r._zod.def, {
    get shape() {
      const s = { ...r._zod.def.shape, ...t._zod.def.shape };
      return Un(this, "shape", s), s;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Nn(r, o);
}
function Eg(r, t, o) {
  const u = t._zod.def.checks;
  if (u && u.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const p = Mn(t._zod.def, {
    get shape() {
      const m = t._zod.def.shape, S = { ...m };
      if (o)
        for (const x in o) {
          if (!(x in m))
            throw new Error(`Unrecognized key: "${x}"`);
          o[x] && (S[x] = r ? new r({
            type: "optional",
            innerType: m[x]
          }) : m[x]);
        }
      else
        for (const x in m)
          S[x] = r ? new r({
            type: "optional",
            innerType: m[x]
          }) : m[x];
      return Un(this, "shape", S), S;
    },
    checks: []
  });
  return Nn(t, p);
}
function kg(r, t, o) {
  const s = Mn(t._zod.def, {
    get shape() {
      const u = t._zod.def.shape, f = { ...u };
      if (o)
        for (const p in o) {
          if (!(p in f))
            throw new Error(`Unrecognized key: "${p}"`);
          o[p] && (f[p] = new r({
            type: "nonoptional",
            innerType: u[p]
          }));
        }
      else
        for (const p in u)
          f[p] = new r({
            type: "nonoptional",
            innerType: u[p]
          });
      return Un(this, "shape", f), f;
    }
  });
  return Nn(t, s);
}
function ar(r, t = 0) {
  if (r.aborted === !0)
    return !0;
  for (let o = t; o < r.issues.length; o++)
    if (r.issues[o]?.continue !== !0)
      return !0;
  return !1;
}
function Gu(r, t) {
  return t.map((o) => {
    var s;
    return (s = o).path ?? (s.path = []), o.path.unshift(r), o;
  });
}
function Ot(r) {
  return typeof r == "string" ? r : r?.message;
}
function Zn(r, t, o) {
  const s = { ...r, path: r.path ?? [] };
  if (!r.message) {
    const u = Ot(r.inst?._zod.def?.error?.(r)) ?? Ot(t?.error?.(r)) ?? Ot(o.customError?.(r)) ?? Ot(o.localeError?.(r)) ?? "Invalid input";
    s.message = u;
  }
  return delete s.inst, delete s.continue, t?.reportInput || delete s.input, s;
}
function xi(r) {
  return Array.isArray(r) ? "array" : typeof r == "string" ? "string" : "unknown";
}
function Dr(...r) {
  const [t, o, s] = r;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: o,
    inst: s
  } : { ...t };
}
const Du = (r, t) => {
  r.name = "$ZodError", Object.defineProperty(r, "_zod", {
    value: r._zod,
    enumerable: !1
  }), Object.defineProperty(r, "issues", {
    value: t,
    enumerable: !1
  }), r.message = JSON.stringify(t, vi, 2), Object.defineProperty(r, "toString", {
    value: () => r.message,
    enumerable: !1
  });
}, Zu = A("$ZodError", Du), Uu = A("$ZodError", Du, { Parent: Error });
function Bg(r, t = (o) => o.message) {
  const o = {}, s = [];
  for (const u of r.issues)
    u.path.length > 0 ? (o[u.path[0]] = o[u.path[0]] || [], o[u.path[0]].push(t(u))) : s.push(t(u));
  return { formErrors: s, fieldErrors: o };
}
function Pg(r, t = (o) => o.message) {
  const o = { _errors: [] }, s = (u) => {
    for (const f of u.issues)
      if (f.code === "invalid_union" && f.errors.length)
        f.errors.map((p) => s({ issues: p }));
      else if (f.code === "invalid_key")
        s({ issues: f.issues });
      else if (f.code === "invalid_element")
        s({ issues: f.issues });
      else if (f.path.length === 0)
        o._errors.push(t(f));
      else {
        let p = o, m = 0;
        for (; m < f.path.length; ) {
          const S = f.path[m];
          m === f.path.length - 1 ? (p[S] = p[S] || { _errors: [] }, p[S]._errors.push(t(f))) : p[S] = p[S] || { _errors: [] }, p = p[S], m++;
        }
      }
  };
  return s(r), o;
}
const wi = (r) => (t, o, s, u) => {
  const f = s ? Object.assign(s, { async: !1 }) : { async: !1 }, p = t._zod.run({ value: o, issues: [] }, f);
  if (p instanceof Promise)
    throw new ur();
  if (p.issues.length) {
    const m = new (u?.Err ?? r)(p.issues.map((S) => Zn(S, f, Dn())));
    throw Lu(m, u?.callee), m;
  }
  return p.value;
}, Mi = (r) => async (t, o, s, u) => {
  const f = s ? Object.assign(s, { async: !0 }) : { async: !0 };
  let p = t._zod.run({ value: o, issues: [] }, f);
  if (p instanceof Promise && (p = await p), p.issues.length) {
    const m = new (u?.Err ?? r)(p.issues.map((S) => Zn(S, f, Dn())));
    throw Lu(m, u?.callee), m;
  }
  return p.value;
}, Kt = (r) => (t, o, s) => {
  const u = s ? { ...s, async: !1 } : { async: !1 }, f = t._zod.run({ value: o, issues: [] }, u);
  if (f instanceof Promise)
    throw new ur();
  return f.issues.length ? {
    success: !1,
    error: new (r ?? Zu)(f.issues.map((p) => Zn(p, u, Dn())))
  } : { success: !0, data: f.value };
}, Rg = /* @__PURE__ */ Kt(Uu), Ht = (r) => async (t, o, s) => {
  const u = s ? Object.assign(s, { async: !0 }) : { async: !0 };
  let f = t._zod.run({ value: o, issues: [] }, u);
  return f instanceof Promise && (f = await f), f.issues.length ? {
    success: !1,
    error: new r(f.issues.map((p) => Zn(p, u, Dn())))
  } : { success: !0, data: f.value };
}, zg = /* @__PURE__ */ Ht(Uu), Og = (r) => (t, o, s) => {
  const u = s ? Object.assign(s, { direction: "backward" }) : { direction: "backward" };
  return wi(r)(t, o, u);
}, Lg = (r) => (t, o, s) => wi(r)(t, o, s), Fg = (r) => async (t, o, s) => {
  const u = s ? Object.assign(s, { direction: "backward" }) : { direction: "backward" };
  return Mi(r)(t, o, u);
}, Gg = (r) => async (t, o, s) => Mi(r)(t, o, s), Dg = (r) => (t, o, s) => {
  const u = s ? Object.assign(s, { direction: "backward" }) : { direction: "backward" };
  return Kt(r)(t, o, u);
}, Zg = (r) => (t, o, s) => Kt(r)(t, o, s), Ug = (r) => async (t, o, s) => {
  const u = s ? Object.assign(s, { direction: "backward" }) : { direction: "backward" };
  return Ht(r)(t, o, u);
}, $g = (r) => async (t, o, s) => Ht(r)(t, o, s), Kg = /^[cC][^\s-]{8,}$/, Hg = /^[0-9a-z]+$/, Wg = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, qg = /^[0-9a-vA-V]{20}$/, Vg = /^[A-Za-z0-9]{27}$/, Jg = /^[a-zA-Z0-9_-]{21}$/, jg = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Yg = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, du = (r) => r ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${r}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, Xg = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Qg = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function ev() {
  return new RegExp(Qg, "u");
}
const nv = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, rv = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, tv = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, ov = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, iv = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, $u = /^[A-Za-z0-9_-]*$/, av = /^\+[1-9]\d{6,14}$/, Ku = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", sv = /* @__PURE__ */ new RegExp(`^${Ku}$`);
function Hu(r) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof r.precision == "number" ? r.precision === -1 ? `${t}` : r.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${r.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function uv(r) {
  return new RegExp(`^${Hu(r)}$`);
}
function lv(r) {
  const t = Hu({ precision: r.precision }), o = ["Z"];
  r.local && o.push(""), r.offset && o.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const s = `${t}(?:${o.join("|")})`;
  return new RegExp(`^${Ku}T(?:${s})$`);
}
const cv = (r) => {
  const t = r ? `[\\s\\S]{${r?.minimum ?? 0},${r?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, dv = /^-?\d+$/, pv = /^-?\d+(?:\.\d+)?$/, fv = /^[^A-Z]*$/, hv = /^[^a-z]*$/, ke = /* @__PURE__ */ A("$ZodCheck", (r, t) => {
  var o;
  r._zod ?? (r._zod = {}), r._zod.def = t, (o = r._zod).onattach ?? (o.onattach = []);
}), Wu = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, qu = /* @__PURE__ */ A("$ZodCheckLessThan", (r, t) => {
  ke.init(r, t);
  const o = Wu[typeof t.value];
  r._zod.onattach.push((s) => {
    const u = s._zod.bag, f = (t.inclusive ? u.maximum : u.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < f && (t.inclusive ? u.maximum = t.value : u.exclusiveMaximum = t.value);
  }), r._zod.check = (s) => {
    (t.inclusive ? s.value <= t.value : s.value < t.value) || s.issues.push({
      origin: o,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: s.value,
      inclusive: t.inclusive,
      inst: r,
      continue: !t.abort
    });
  };
}), Vu = /* @__PURE__ */ A("$ZodCheckGreaterThan", (r, t) => {
  ke.init(r, t);
  const o = Wu[typeof t.value];
  r._zod.onattach.push((s) => {
    const u = s._zod.bag, f = (t.inclusive ? u.minimum : u.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > f && (t.inclusive ? u.minimum = t.value : u.exclusiveMinimum = t.value);
  }), r._zod.check = (s) => {
    (t.inclusive ? s.value >= t.value : s.value > t.value) || s.issues.push({
      origin: o,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: s.value,
      inclusive: t.inclusive,
      inst: r,
      continue: !t.abort
    });
  };
}), _v = /* @__PURE__ */ A("$ZodCheckMultipleOf", (r, t) => {
  ke.init(r, t), r._zod.onattach.push((o) => {
    var s;
    (s = o._zod.bag).multipleOf ?? (s.multipleOf = t.value);
  }), r._zod.check = (o) => {
    if (typeof o.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof o.value == "bigint" ? o.value % t.value === BigInt(0) : Ig(o.value, t.value) === 0) || o.issues.push({
      origin: typeof o.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: o.value,
      inst: r,
      continue: !t.abort
    });
  };
}), mv = /* @__PURE__ */ A("$ZodCheckNumberFormat", (r, t) => {
  ke.init(r, t), t.format = t.format || "float64";
  const o = t.format?.includes("int"), s = o ? "int" : "number", [u, f] = Cg[t.format];
  r._zod.onattach.push((p) => {
    const m = p._zod.bag;
    m.format = t.format, m.minimum = u, m.maximum = f, o && (m.pattern = dv);
  }), r._zod.check = (p) => {
    const m = p.value;
    if (o) {
      if (!Number.isInteger(m)) {
        p.issues.push({
          expected: s,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: m,
          inst: r
        });
        return;
      }
      if (!Number.isSafeInteger(m)) {
        m > 0 ? p.issues.push({
          input: m,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: r,
          origin: s,
          inclusive: !0,
          continue: !t.abort
        }) : p.issues.push({
          input: m,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: r,
          origin: s,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    m < u && p.issues.push({
      origin: "number",
      input: m,
      code: "too_small",
      minimum: u,
      inclusive: !0,
      inst: r,
      continue: !t.abort
    }), m > f && p.issues.push({
      origin: "number",
      input: m,
      code: "too_big",
      maximum: f,
      inclusive: !0,
      inst: r,
      continue: !t.abort
    });
  };
}), gv = /* @__PURE__ */ A("$ZodCheckMaxLength", (r, t) => {
  var o;
  ke.init(r, t), (o = r._zod.def).when ?? (o.when = (s) => {
    const u = s.value;
    return !Ci(u) && u.length !== void 0;
  }), r._zod.onattach.push((s) => {
    const u = s._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < u && (s._zod.bag.maximum = t.maximum);
  }), r._zod.check = (s) => {
    const u = s.value;
    if (u.length <= t.maximum)
      return;
    const p = xi(u);
    s.issues.push({
      origin: p,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: u,
      inst: r,
      continue: !t.abort
    });
  };
}), vv = /* @__PURE__ */ A("$ZodCheckMinLength", (r, t) => {
  var o;
  ke.init(r, t), (o = r._zod.def).when ?? (o.when = (s) => {
    const u = s.value;
    return !Ci(u) && u.length !== void 0;
  }), r._zod.onattach.push((s) => {
    const u = s._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > u && (s._zod.bag.minimum = t.minimum);
  }), r._zod.check = (s) => {
    const u = s.value;
    if (u.length >= t.minimum)
      return;
    const p = xi(u);
    s.issues.push({
      origin: p,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: u,
      inst: r,
      continue: !t.abort
    });
  };
}), Iv = /* @__PURE__ */ A("$ZodCheckLengthEquals", (r, t) => {
  var o;
  ke.init(r, t), (o = r._zod.def).when ?? (o.when = (s) => {
    const u = s.value;
    return !Ci(u) && u.length !== void 0;
  }), r._zod.onattach.push((s) => {
    const u = s._zod.bag;
    u.minimum = t.length, u.maximum = t.length, u.length = t.length;
  }), r._zod.check = (s) => {
    const u = s.value, f = u.length;
    if (f === t.length)
      return;
    const p = xi(u), m = f > t.length;
    s.issues.push({
      origin: p,
      ...m ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: s.value,
      inst: r,
      continue: !t.abort
    });
  };
}), Wt = /* @__PURE__ */ A("$ZodCheckStringFormat", (r, t) => {
  var o, s;
  ke.init(r, t), r._zod.onattach.push((u) => {
    const f = u._zod.bag;
    f.format = t.format, t.pattern && (f.patterns ?? (f.patterns = /* @__PURE__ */ new Set()), f.patterns.add(t.pattern));
  }), t.pattern ? (o = r._zod).check ?? (o.check = (u) => {
    t.pattern.lastIndex = 0, !t.pattern.test(u.value) && u.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: u.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: r,
      continue: !t.abort
    });
  }) : (s = r._zod).check ?? (s.check = () => {
  });
}), bv = /* @__PURE__ */ A("$ZodCheckRegex", (r, t) => {
  Wt.init(r, t), r._zod.check = (o) => {
    t.pattern.lastIndex = 0, !t.pattern.test(o.value) && o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: o.value,
      pattern: t.pattern.toString(),
      inst: r,
      continue: !t.abort
    });
  };
}), Sv = /* @__PURE__ */ A("$ZodCheckLowerCase", (r, t) => {
  t.pattern ?? (t.pattern = fv), Wt.init(r, t);
}), Tv = /* @__PURE__ */ A("$ZodCheckUpperCase", (r, t) => {
  t.pattern ?? (t.pattern = hv), Wt.init(r, t);
}), Av = /* @__PURE__ */ A("$ZodCheckIncludes", (r, t) => {
  ke.init(r, t);
  const o = lr(t.includes), s = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${o}` : o);
  t.pattern = s, r._zod.onattach.push((u) => {
    const f = u._zod.bag;
    f.patterns ?? (f.patterns = /* @__PURE__ */ new Set()), f.patterns.add(s);
  }), r._zod.check = (u) => {
    u.value.includes(t.includes, t.position) || u.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: u.value,
      inst: r,
      continue: !t.abort
    });
  };
}), Cv = /* @__PURE__ */ A("$ZodCheckStartsWith", (r, t) => {
  ke.init(r, t);
  const o = new RegExp(`^${lr(t.prefix)}.*`);
  t.pattern ?? (t.pattern = o), r._zod.onattach.push((s) => {
    const u = s._zod.bag;
    u.patterns ?? (u.patterns = /* @__PURE__ */ new Set()), u.patterns.add(o);
  }), r._zod.check = (s) => {
    s.value.startsWith(t.prefix) || s.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: s.value,
      inst: r,
      continue: !t.abort
    });
  };
}), yv = /* @__PURE__ */ A("$ZodCheckEndsWith", (r, t) => {
  ke.init(r, t);
  const o = new RegExp(`.*${lr(t.suffix)}$`);
  t.pattern ?? (t.pattern = o), r._zod.onattach.push((s) => {
    const u = s._zod.bag;
    u.patterns ?? (u.patterns = /* @__PURE__ */ new Set()), u.patterns.add(o);
  }), r._zod.check = (s) => {
    s.value.endsWith(t.suffix) || s.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: s.value,
      inst: r,
      continue: !t.abort
    });
  };
}), xv = /* @__PURE__ */ A("$ZodCheckOverwrite", (r, t) => {
  ke.init(r, t), r._zod.check = (o) => {
    o.value = t.tx(o.value);
  };
});
class wv {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const s = t.split(`
`).filter((p) => p), u = Math.min(...s.map((p) => p.length - p.trimStart().length)), f = s.map((p) => p.slice(u)).map((p) => " ".repeat(this.indent * 2) + p);
    for (const p of f)
      this.content.push(p);
  }
  compile() {
    const t = Function, o = this?.args, u = [...(this?.content ?? [""]).map((f) => `  ${f}`)];
    return new t(...o, u.join(`
`));
  }
}
const Mv = {
  major: 4,
  minor: 3,
  patch: 6
}, le = /* @__PURE__ */ A("$ZodType", (r, t) => {
  var o;
  r ?? (r = {}), r._zod.def = t, r._zod.bag = r._zod.bag || {}, r._zod.version = Mv;
  const s = [...r._zod.def.checks ?? []];
  r._zod.traits.has("$ZodCheck") && s.unshift(r);
  for (const u of s)
    for (const f of u._zod.onattach)
      f(r);
  if (s.length === 0)
    (o = r._zod).deferred ?? (o.deferred = []), r._zod.deferred?.push(() => {
      r._zod.run = r._zod.parse;
    });
  else {
    const u = (p, m, S) => {
      let x = ar(p), N;
      for (const L of m) {
        if (L._zod.def.when) {
          if (!L._zod.def.when(p))
            continue;
        } else if (x)
          continue;
        const O = p.issues.length, z = L._zod.check(p);
        if (z instanceof Promise && S?.async === !1)
          throw new ur();
        if (N || z instanceof Promise)
          N = (N ?? Promise.resolve()).then(async () => {
            await z, p.issues.length !== O && (x || (x = ar(p, O)));
          });
        else {
          if (p.issues.length === O)
            continue;
          x || (x = ar(p, O));
        }
      }
      return N ? N.then(() => p) : p;
    }, f = (p, m, S) => {
      if (ar(p))
        return p.aborted = !0, p;
      const x = u(m, s, S);
      if (x instanceof Promise) {
        if (S.async === !1)
          throw new ur();
        return x.then((N) => r._zod.parse(N, S));
      }
      return r._zod.parse(x, S);
    };
    r._zod.run = (p, m) => {
      if (m.skipChecks)
        return r._zod.parse(p, m);
      if (m.direction === "backward") {
        const x = r._zod.parse({ value: p.value, issues: [] }, { ...m, skipChecks: !0 });
        return x instanceof Promise ? x.then((N) => f(N, p, m)) : f(x, p, m);
      }
      const S = r._zod.parse(p, m);
      if (S instanceof Promise) {
        if (m.async === !1)
          throw new ur();
        return S.then((x) => u(x, s, m));
      }
      return u(S, s, m);
    };
  }
  J(r, "~standard", () => ({
    validate: (u) => {
      try {
        const f = Rg(r, u);
        return f.success ? { value: f.data } : { issues: f.error?.issues };
      } catch {
        return zg(r, u).then((p) => p.success ? { value: p.data } : { issues: p.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), Ni = /* @__PURE__ */ A("$ZodString", (r, t) => {
  le.init(r, t), r._zod.pattern = [...r?._zod.bag?.patterns ?? []].pop() ?? cv(r._zod.bag), r._zod.parse = (o, s) => {
    if (t.coerce)
      try {
        o.value = String(o.value);
      } catch {
      }
    return typeof o.value == "string" || o.issues.push({
      expected: "string",
      code: "invalid_type",
      input: o.value,
      inst: r
    }), o;
  };
}), ee = /* @__PURE__ */ A("$ZodStringFormat", (r, t) => {
  Wt.init(r, t), Ni.init(r, t);
}), Nv = /* @__PURE__ */ A("$ZodGUID", (r, t) => {
  t.pattern ?? (t.pattern = Yg), ee.init(r, t);
}), Ev = /* @__PURE__ */ A("$ZodUUID", (r, t) => {
  if (t.version) {
    const s = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (s === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = du(s));
  } else
    t.pattern ?? (t.pattern = du());
  ee.init(r, t);
}), kv = /* @__PURE__ */ A("$ZodEmail", (r, t) => {
  t.pattern ?? (t.pattern = Xg), ee.init(r, t);
}), Bv = /* @__PURE__ */ A("$ZodURL", (r, t) => {
  ee.init(r, t), r._zod.check = (o) => {
    try {
      const s = o.value.trim(), u = new URL(s);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(u.hostname) || o.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: o.value,
        inst: r,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(u.protocol.endsWith(":") ? u.protocol.slice(0, -1) : u.protocol) || o.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: o.value,
        inst: r,
        continue: !t.abort
      })), t.normalize ? o.value = u.href : o.value = s;
      return;
    } catch {
      o.issues.push({
        code: "invalid_format",
        format: "url",
        input: o.value,
        inst: r,
        continue: !t.abort
      });
    }
  };
}), Pv = /* @__PURE__ */ A("$ZodEmoji", (r, t) => {
  t.pattern ?? (t.pattern = ev()), ee.init(r, t);
}), Rv = /* @__PURE__ */ A("$ZodNanoID", (r, t) => {
  t.pattern ?? (t.pattern = Jg), ee.init(r, t);
}), zv = /* @__PURE__ */ A("$ZodCUID", (r, t) => {
  t.pattern ?? (t.pattern = Kg), ee.init(r, t);
}), Ov = /* @__PURE__ */ A("$ZodCUID2", (r, t) => {
  t.pattern ?? (t.pattern = Hg), ee.init(r, t);
}), Lv = /* @__PURE__ */ A("$ZodULID", (r, t) => {
  t.pattern ?? (t.pattern = Wg), ee.init(r, t);
}), Fv = /* @__PURE__ */ A("$ZodXID", (r, t) => {
  t.pattern ?? (t.pattern = qg), ee.init(r, t);
}), Gv = /* @__PURE__ */ A("$ZodKSUID", (r, t) => {
  t.pattern ?? (t.pattern = Vg), ee.init(r, t);
}), Dv = /* @__PURE__ */ A("$ZodISODateTime", (r, t) => {
  t.pattern ?? (t.pattern = lv(t)), ee.init(r, t);
}), Zv = /* @__PURE__ */ A("$ZodISODate", (r, t) => {
  t.pattern ?? (t.pattern = sv), ee.init(r, t);
}), Uv = /* @__PURE__ */ A("$ZodISOTime", (r, t) => {
  t.pattern ?? (t.pattern = uv(t)), ee.init(r, t);
}), $v = /* @__PURE__ */ A("$ZodISODuration", (r, t) => {
  t.pattern ?? (t.pattern = jg), ee.init(r, t);
}), Kv = /* @__PURE__ */ A("$ZodIPv4", (r, t) => {
  t.pattern ?? (t.pattern = nv), ee.init(r, t), r._zod.bag.format = "ipv4";
}), Hv = /* @__PURE__ */ A("$ZodIPv6", (r, t) => {
  t.pattern ?? (t.pattern = rv), ee.init(r, t), r._zod.bag.format = "ipv6", r._zod.check = (o) => {
    try {
      new URL(`http://[${o.value}]`);
    } catch {
      o.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: o.value,
        inst: r,
        continue: !t.abort
      });
    }
  };
}), Wv = /* @__PURE__ */ A("$ZodCIDRv4", (r, t) => {
  t.pattern ?? (t.pattern = tv), ee.init(r, t);
}), qv = /* @__PURE__ */ A("$ZodCIDRv6", (r, t) => {
  t.pattern ?? (t.pattern = ov), ee.init(r, t), r._zod.check = (o) => {
    const s = o.value.split("/");
    try {
      if (s.length !== 2)
        throw new Error();
      const [u, f] = s;
      if (!f)
        throw new Error();
      const p = Number(f);
      if (`${p}` !== f)
        throw new Error();
      if (p < 0 || p > 128)
        throw new Error();
      new URL(`http://[${u}]`);
    } catch {
      o.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: o.value,
        inst: r,
        continue: !t.abort
      });
    }
  };
});
function Ju(r) {
  if (r === "")
    return !0;
  if (r.length % 4 !== 0)
    return !1;
  try {
    return atob(r), !0;
  } catch {
    return !1;
  }
}
const Vv = /* @__PURE__ */ A("$ZodBase64", (r, t) => {
  t.pattern ?? (t.pattern = iv), ee.init(r, t), r._zod.bag.contentEncoding = "base64", r._zod.check = (o) => {
    Ju(o.value) || o.issues.push({
      code: "invalid_format",
      format: "base64",
      input: o.value,
      inst: r,
      continue: !t.abort
    });
  };
});
function Jv(r) {
  if (!$u.test(r))
    return !1;
  const t = r.replace(/[-_]/g, (s) => s === "-" ? "+" : "/"), o = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return Ju(o);
}
const jv = /* @__PURE__ */ A("$ZodBase64URL", (r, t) => {
  t.pattern ?? (t.pattern = $u), ee.init(r, t), r._zod.bag.contentEncoding = "base64url", r._zod.check = (o) => {
    Jv(o.value) || o.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: o.value,
      inst: r,
      continue: !t.abort
    });
  };
}), Yv = /* @__PURE__ */ A("$ZodE164", (r, t) => {
  t.pattern ?? (t.pattern = av), ee.init(r, t);
});
function Xv(r, t = null) {
  try {
    const o = r.split(".");
    if (o.length !== 3)
      return !1;
    const [s] = o;
    if (!s)
      return !1;
    const u = JSON.parse(atob(s));
    return !("typ" in u && u?.typ !== "JWT" || !u.alg || t && (!("alg" in u) || u.alg !== t));
  } catch {
    return !1;
  }
}
const Qv = /* @__PURE__ */ A("$ZodJWT", (r, t) => {
  ee.init(r, t), r._zod.check = (o) => {
    Xv(o.value, t.alg) || o.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: o.value,
      inst: r,
      continue: !t.abort
    });
  };
}), ju = /* @__PURE__ */ A("$ZodNumber", (r, t) => {
  le.init(r, t), r._zod.pattern = r._zod.bag.pattern ?? pv, r._zod.parse = (o, s) => {
    if (t.coerce)
      try {
        o.value = Number(o.value);
      } catch {
      }
    const u = o.value;
    if (typeof u == "number" && !Number.isNaN(u) && Number.isFinite(u))
      return o;
    const f = typeof u == "number" ? Number.isNaN(u) ? "NaN" : Number.isFinite(u) ? void 0 : "Infinity" : void 0;
    return o.issues.push({
      expected: "number",
      code: "invalid_type",
      input: u,
      inst: r,
      ...f ? { received: f } : {}
    }), o;
  };
}), eI = /* @__PURE__ */ A("$ZodNumberFormat", (r, t) => {
  mv.init(r, t), ju.init(r, t);
}), nI = /* @__PURE__ */ A("$ZodUnknown", (r, t) => {
  le.init(r, t), r._zod.parse = (o) => o;
}), rI = /* @__PURE__ */ A("$ZodNever", (r, t) => {
  le.init(r, t), r._zod.parse = (o, s) => (o.issues.push({
    expected: "never",
    code: "invalid_type",
    input: o.value,
    inst: r
  }), o);
});
function pu(r, t, o) {
  r.issues.length && t.issues.push(...Gu(o, r.issues)), t.value[o] = r.value;
}
const tI = /* @__PURE__ */ A("$ZodArray", (r, t) => {
  le.init(r, t), r._zod.parse = (o, s) => {
    const u = o.value;
    if (!Array.isArray(u))
      return o.issues.push({
        expected: "array",
        code: "invalid_type",
        input: u,
        inst: r
      }), o;
    o.value = Array(u.length);
    const f = [];
    for (let p = 0; p < u.length; p++) {
      const m = u[p], S = t.element._zod.run({
        value: m,
        issues: []
      }, s);
      S instanceof Promise ? f.push(S.then((x) => pu(x, o, p))) : pu(S, o, p);
    }
    return f.length ? Promise.all(f).then(() => o) : o;
  };
});
function Dt(r, t, o, s, u) {
  if (r.issues.length) {
    if (u && !(o in s))
      return;
    t.issues.push(...Gu(o, r.issues));
  }
  r.value === void 0 ? o in s && (t.value[o] = void 0) : t.value[o] = r.value;
}
function Yu(r) {
  const t = Object.keys(r.shape);
  for (const s of t)
    if (!r.shape?.[s]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${s}": expected a Zod schema`);
  const o = Ag(r.shape);
  return {
    ...r,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(o)
  };
}
function Xu(r, t, o, s, u, f) {
  const p = [], m = u.keySet, S = u.catchall._zod, x = S.def.type, N = S.optout === "optional";
  for (const L in t) {
    if (m.has(L))
      continue;
    if (x === "never") {
      p.push(L);
      continue;
    }
    const O = S.run({ value: t[L], issues: [] }, s);
    O instanceof Promise ? r.push(O.then((z) => Dt(z, o, L, t, N))) : Dt(O, o, L, t, N);
  }
  return p.length && o.issues.push({
    code: "unrecognized_keys",
    keys: p,
    input: t,
    inst: f
  }), r.length ? Promise.all(r).then(() => o) : o;
}
const oI = /* @__PURE__ */ A("$ZodObject", (r, t) => {
  if (le.init(r, t), !Object.getOwnPropertyDescriptor(t, "shape")?.get) {
    const m = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const S = { ...m };
        return Object.defineProperty(t, "shape", {
          value: S
        }), S;
      }
    });
  }
  const s = Ai(() => Yu(t));
  J(r._zod, "propValues", () => {
    const m = t.shape, S = {};
    for (const x in m) {
      const N = m[x]._zod;
      if (N.values) {
        S[x] ?? (S[x] = /* @__PURE__ */ new Set());
        for (const L of N.values)
          S[x].add(L);
      }
    }
    return S;
  });
  const u = Gt, f = t.catchall;
  let p;
  r._zod.parse = (m, S) => {
    p ?? (p = s.value);
    const x = m.value;
    if (!u(x))
      return m.issues.push({
        expected: "object",
        code: "invalid_type",
        input: x,
        inst: r
      }), m;
    m.value = {};
    const N = [], L = p.shape;
    for (const O of p.keys) {
      const z = L[O], te = z._zod.optout === "optional", oe = z._zod.run({ value: x[O], issues: [] }, S);
      oe instanceof Promise ? N.push(oe.then((Ie) => Dt(Ie, m, O, x, te))) : Dt(oe, m, O, x, te);
    }
    return f ? Xu(N, x, m, S, s.value, r) : N.length ? Promise.all(N).then(() => m) : m;
  };
}), iI = /* @__PURE__ */ A("$ZodObjectJIT", (r, t) => {
  oI.init(r, t);
  const o = r._zod.parse, s = Ai(() => Yu(t)), u = (O) => {
    const z = new wv(["shape", "payload", "ctx"]), te = s.value, oe = (de) => {
      const pe = cu(de);
      return `shape[${pe}]._zod.run({ value: input[${pe}], issues: [] }, ctx)`;
    };
    z.write("const input = payload.value;");
    const Ie = /* @__PURE__ */ Object.create(null);
    let gn = 0;
    for (const de of te.keys)
      Ie[de] = `key_${gn++}`;
    z.write("const newResult = {};");
    for (const de of te.keys) {
      const pe = Ie[de], ae = cu(de), qe = O[de]?._zod?.optout === "optional";
      z.write(`const ${pe} = ${oe(de)};`), qe ? z.write(`
        if (${pe}.issues.length) {
          if (${ae} in input) {
            payload.issues = payload.issues.concat(${pe}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${ae}, ...iss.path] : [${ae}]
            })));
          }
        }
        
        if (${pe}.value === undefined) {
          if (${ae} in input) {
            newResult[${ae}] = undefined;
          }
        } else {
          newResult[${ae}] = ${pe}.value;
        }
        
      `) : z.write(`
        if (${pe}.issues.length) {
          payload.issues = payload.issues.concat(${pe}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${ae}, ...iss.path] : [${ae}]
          })));
        }
        
        if (${pe}.value === undefined) {
          if (${ae} in input) {
            newResult[${ae}] = undefined;
          }
        } else {
          newResult[${ae}] = ${pe}.value;
        }
        
      `);
    }
    z.write("payload.value = newResult;"), z.write("return payload;");
    const Ur = z.compile();
    return (de, pe) => Ur(O, de, pe);
  };
  let f;
  const p = Gt, m = !zu.jitless, x = m && Sg.value, N = t.catchall;
  let L;
  r._zod.parse = (O, z) => {
    L ?? (L = s.value);
    const te = O.value;
    return p(te) ? m && x && z?.async === !1 && z.jitless !== !0 ? (f || (f = u(t.shape)), O = f(O, z), N ? Xu([], te, O, z, L, r) : O) : o(O, z) : (O.issues.push({
      expected: "object",
      code: "invalid_type",
      input: te,
      inst: r
    }), O);
  };
});
function fu(r, t, o, s) {
  for (const f of r)
    if (f.issues.length === 0)
      return t.value = f.value, t;
  const u = r.filter((f) => !ar(f));
  return u.length === 1 ? (t.value = u[0].value, u[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: o,
    errors: r.map((f) => f.issues.map((p) => Zn(p, s, Dn())))
  }), t);
}
const aI = /* @__PURE__ */ A("$ZodUnion", (r, t) => {
  le.init(r, t), J(r._zod, "optin", () => t.options.some((u) => u._zod.optin === "optional") ? "optional" : void 0), J(r._zod, "optout", () => t.options.some((u) => u._zod.optout === "optional") ? "optional" : void 0), J(r._zod, "values", () => {
    if (t.options.every((u) => u._zod.values))
      return new Set(t.options.flatMap((u) => Array.from(u._zod.values)));
  }), J(r._zod, "pattern", () => {
    if (t.options.every((u) => u._zod.pattern)) {
      const u = t.options.map((f) => f._zod.pattern);
      return new RegExp(`^(${u.map((f) => yi(f.source)).join("|")})$`);
    }
  });
  const o = t.options.length === 1, s = t.options[0]._zod.run;
  r._zod.parse = (u, f) => {
    if (o)
      return s(u, f);
    let p = !1;
    const m = [];
    for (const S of t.options) {
      const x = S._zod.run({
        value: u.value,
        issues: []
      }, f);
      if (x instanceof Promise)
        m.push(x), p = !0;
      else {
        if (x.issues.length === 0)
          return x;
        m.push(x);
      }
    }
    return p ? Promise.all(m).then((S) => fu(S, u, r, f)) : fu(m, u, r, f);
  };
}), sI = /* @__PURE__ */ A("$ZodIntersection", (r, t) => {
  le.init(r, t), r._zod.parse = (o, s) => {
    const u = o.value, f = t.left._zod.run({ value: u, issues: [] }, s), p = t.right._zod.run({ value: u, issues: [] }, s);
    return f instanceof Promise || p instanceof Promise ? Promise.all([f, p]).then(([S, x]) => hu(o, S, x)) : hu(o, f, p);
  };
});
function Ii(r, t) {
  if (r === t)
    return { valid: !0, data: r };
  if (r instanceof Date && t instanceof Date && +r == +t)
    return { valid: !0, data: r };
  if (Gr(r) && Gr(t)) {
    const o = Object.keys(t), s = Object.keys(r).filter((f) => o.indexOf(f) !== -1), u = { ...r, ...t };
    for (const f of s) {
      const p = Ii(r[f], t[f]);
      if (!p.valid)
        return {
          valid: !1,
          mergeErrorPath: [f, ...p.mergeErrorPath]
        };
      u[f] = p.data;
    }
    return { valid: !0, data: u };
  }
  if (Array.isArray(r) && Array.isArray(t)) {
    if (r.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const o = [];
    for (let s = 0; s < r.length; s++) {
      const u = r[s], f = t[s], p = Ii(u, f);
      if (!p.valid)
        return {
          valid: !1,
          mergeErrorPath: [s, ...p.mergeErrorPath]
        };
      o.push(p.data);
    }
    return { valid: !0, data: o };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function hu(r, t, o) {
  const s = /* @__PURE__ */ new Map();
  let u;
  for (const m of t.issues)
    if (m.code === "unrecognized_keys") {
      u ?? (u = m);
      for (const S of m.keys)
        s.has(S) || s.set(S, {}), s.get(S).l = !0;
    } else
      r.issues.push(m);
  for (const m of o.issues)
    if (m.code === "unrecognized_keys")
      for (const S of m.keys)
        s.has(S) || s.set(S, {}), s.get(S).r = !0;
    else
      r.issues.push(m);
  const f = [...s].filter(([, m]) => m.l && m.r).map(([m]) => m);
  if (f.length && u && r.issues.push({ ...u, keys: f }), ar(r))
    return r;
  const p = Ii(t.value, o.value);
  if (!p.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(p.mergeErrorPath)}`);
  return r.value = p.data, r;
}
const uI = /* @__PURE__ */ A("$ZodEnum", (r, t) => {
  le.init(r, t);
  const o = Ou(t.entries), s = new Set(o);
  r._zod.values = s, r._zod.pattern = new RegExp(`^(${o.filter((u) => Tg.has(typeof u)).map((u) => typeof u == "string" ? lr(u) : u.toString()).join("|")})$`), r._zod.parse = (u, f) => {
    const p = u.value;
    return s.has(p) || u.issues.push({
      code: "invalid_value",
      values: o,
      input: p,
      inst: r
    }), u;
  };
}), lI = /* @__PURE__ */ A("$ZodLiteral", (r, t) => {
  if (le.init(r, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  const o = new Set(t.values);
  r._zod.values = o, r._zod.pattern = new RegExp(`^(${t.values.map((s) => typeof s == "string" ? lr(s) : s ? lr(s.toString()) : String(s)).join("|")})$`), r._zod.parse = (s, u) => {
    const f = s.value;
    return o.has(f) || s.issues.push({
      code: "invalid_value",
      values: t.values,
      input: f,
      inst: r
    }), s;
  };
}), cI = /* @__PURE__ */ A("$ZodTransform", (r, t) => {
  le.init(r, t), r._zod.parse = (o, s) => {
    if (s.direction === "backward")
      throw new Ru(r.constructor.name);
    const u = t.transform(o.value, o);
    if (s.async)
      return (u instanceof Promise ? u : Promise.resolve(u)).then((p) => (o.value = p, o));
    if (u instanceof Promise)
      throw new ur();
    return o.value = u, o;
  };
});
function _u(r, t) {
  return r.issues.length && t === void 0 ? { issues: [], value: void 0 } : r;
}
const Qu = /* @__PURE__ */ A("$ZodOptional", (r, t) => {
  le.init(r, t), r._zod.optin = "optional", r._zod.optout = "optional", J(r._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), J(r._zod, "pattern", () => {
    const o = t.innerType._zod.pattern;
    return o ? new RegExp(`^(${yi(o.source)})?$`) : void 0;
  }), r._zod.parse = (o, s) => {
    if (t.innerType._zod.optin === "optional") {
      const u = t.innerType._zod.run(o, s);
      return u instanceof Promise ? u.then((f) => _u(f, o.value)) : _u(u, o.value);
    }
    return o.value === void 0 ? o : t.innerType._zod.run(o, s);
  };
}), dI = /* @__PURE__ */ A("$ZodExactOptional", (r, t) => {
  Qu.init(r, t), J(r._zod, "values", () => t.innerType._zod.values), J(r._zod, "pattern", () => t.innerType._zod.pattern), r._zod.parse = (o, s) => t.innerType._zod.run(o, s);
}), pI = /* @__PURE__ */ A("$ZodNullable", (r, t) => {
  le.init(r, t), J(r._zod, "optin", () => t.innerType._zod.optin), J(r._zod, "optout", () => t.innerType._zod.optout), J(r._zod, "pattern", () => {
    const o = t.innerType._zod.pattern;
    return o ? new RegExp(`^(${yi(o.source)}|null)$`) : void 0;
  }), J(r._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), r._zod.parse = (o, s) => o.value === null ? o : t.innerType._zod.run(o, s);
}), fI = /* @__PURE__ */ A("$ZodDefault", (r, t) => {
  le.init(r, t), r._zod.optin = "optional", J(r._zod, "values", () => t.innerType._zod.values), r._zod.parse = (o, s) => {
    if (s.direction === "backward")
      return t.innerType._zod.run(o, s);
    if (o.value === void 0)
      return o.value = t.defaultValue, o;
    const u = t.innerType._zod.run(o, s);
    return u instanceof Promise ? u.then((f) => mu(f, t)) : mu(u, t);
  };
});
function mu(r, t) {
  return r.value === void 0 && (r.value = t.defaultValue), r;
}
const hI = /* @__PURE__ */ A("$ZodPrefault", (r, t) => {
  le.init(r, t), r._zod.optin = "optional", J(r._zod, "values", () => t.innerType._zod.values), r._zod.parse = (o, s) => (s.direction === "backward" || o.value === void 0 && (o.value = t.defaultValue), t.innerType._zod.run(o, s));
}), _I = /* @__PURE__ */ A("$ZodNonOptional", (r, t) => {
  le.init(r, t), J(r._zod, "values", () => {
    const o = t.innerType._zod.values;
    return o ? new Set([...o].filter((s) => s !== void 0)) : void 0;
  }), r._zod.parse = (o, s) => {
    const u = t.innerType._zod.run(o, s);
    return u instanceof Promise ? u.then((f) => gu(f, r)) : gu(u, r);
  };
});
function gu(r, t) {
  return !r.issues.length && r.value === void 0 && r.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: r.value,
    inst: t
  }), r;
}
const mI = /* @__PURE__ */ A("$ZodCatch", (r, t) => {
  le.init(r, t), J(r._zod, "optin", () => t.innerType._zod.optin), J(r._zod, "optout", () => t.innerType._zod.optout), J(r._zod, "values", () => t.innerType._zod.values), r._zod.parse = (o, s) => {
    if (s.direction === "backward")
      return t.innerType._zod.run(o, s);
    const u = t.innerType._zod.run(o, s);
    return u instanceof Promise ? u.then((f) => (o.value = f.value, f.issues.length && (o.value = t.catchValue({
      ...o,
      error: {
        issues: f.issues.map((p) => Zn(p, s, Dn()))
      },
      input: o.value
    }), o.issues = []), o)) : (o.value = u.value, u.issues.length && (o.value = t.catchValue({
      ...o,
      error: {
        issues: u.issues.map((f) => Zn(f, s, Dn()))
      },
      input: o.value
    }), o.issues = []), o);
  };
}), gI = /* @__PURE__ */ A("$ZodPipe", (r, t) => {
  le.init(r, t), J(r._zod, "values", () => t.in._zod.values), J(r._zod, "optin", () => t.in._zod.optin), J(r._zod, "optout", () => t.out._zod.optout), J(r._zod, "propValues", () => t.in._zod.propValues), r._zod.parse = (o, s) => {
    if (s.direction === "backward") {
      const f = t.out._zod.run(o, s);
      return f instanceof Promise ? f.then((p) => Lt(p, t.in, s)) : Lt(f, t.in, s);
    }
    const u = t.in._zod.run(o, s);
    return u instanceof Promise ? u.then((f) => Lt(f, t.out, s)) : Lt(u, t.out, s);
  };
});
function Lt(r, t, o) {
  return r.issues.length ? (r.aborted = !0, r) : t._zod.run({ value: r.value, issues: r.issues }, o);
}
const vI = /* @__PURE__ */ A("$ZodReadonly", (r, t) => {
  le.init(r, t), J(r._zod, "propValues", () => t.innerType._zod.propValues), J(r._zod, "values", () => t.innerType._zod.values), J(r._zod, "optin", () => t.innerType?._zod?.optin), J(r._zod, "optout", () => t.innerType?._zod?.optout), r._zod.parse = (o, s) => {
    if (s.direction === "backward")
      return t.innerType._zod.run(o, s);
    const u = t.innerType._zod.run(o, s);
    return u instanceof Promise ? u.then(vu) : vu(u);
  };
});
function vu(r) {
  return r.value = Object.freeze(r.value), r;
}
const II = /* @__PURE__ */ A("$ZodCustom", (r, t) => {
  ke.init(r, t), le.init(r, t), r._zod.parse = (o, s) => o, r._zod.check = (o) => {
    const s = o.value, u = t.fn(s);
    if (u instanceof Promise)
      return u.then((f) => Iu(f, o, s, r));
    Iu(u, o, s, r);
  };
});
function Iu(r, t, o, s) {
  if (!r) {
    const u = {
      code: "custom",
      input: o,
      inst: s,
      // incorporates params.error into issue reporting
      path: [...s._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !s._zod.def.abort
      // params: inst._zod.def.params,
    };
    s._zod.def.params && (u.params = s._zod.def.params), t.issues.push(Dr(u));
  }
}
var bu;
class bI {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...o) {
    const s = o[0];
    return this._map.set(t, s), s && typeof s == "object" && "id" in s && this._idmap.set(s.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const o = this._map.get(t);
    return o && typeof o == "object" && "id" in o && this._idmap.delete(o.id), this._map.delete(t), this;
  }
  get(t) {
    const o = t._zod.parent;
    if (o) {
      const s = { ...this.get(o) ?? {} };
      delete s.id;
      const u = { ...s, ...this._map.get(t) };
      return Object.keys(u).length ? u : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function SI() {
  return new bI();
}
(bu = globalThis).__zod_globalRegistry ?? (bu.__zod_globalRegistry = SI());
const zr = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function TI(r, t) {
  return new r({
    type: "string",
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function AI(r, t) {
  return new r({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Su(r, t) {
  return new r({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function el(r, t) {
  return new r({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function CI(r, t) {
  return new r({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function yI(r, t) {
  return new r({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function xI(r, t) {
  return new r({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function wI(r, t) {
  return new r({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function MI(r, t) {
  return new r({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function NI(r, t) {
  return new r({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function EI(r, t) {
  return new r({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function kI(r, t) {
  return new r({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function BI(r, t) {
  return new r({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function PI(r, t) {
  return new r({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function RI(r, t) {
  return new r({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function zI(r, t) {
  return new r({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function OI(r, t) {
  return new r({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function LI(r, t) {
  return new r({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function FI(r, t) {
  return new r({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function GI(r, t) {
  return new r({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function DI(r, t) {
  return new r({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ZI(r, t) {
  return new r({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function UI(r, t) {
  return new r({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function $I(r, t) {
  return new r({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function KI(r, t) {
  return new r({
    type: "string",
    format: "date",
    check: "string_format",
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function HI(r, t) {
  return new r({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function WI(r, t) {
  return new r({
    type: "string",
    format: "duration",
    check: "string_format",
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function qI(r, t) {
  return new r({
    type: "number",
    checks: [],
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function VI(r, t) {
  return new r({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function JI(r) {
  return new r({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function jI(r, t) {
  return new r({
    type: "never",
    ...k(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Tu(r, t) {
  return new qu({
    check: "less_than",
    ...k(t),
    value: r,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function mi(r, t) {
  return new qu({
    check: "less_than",
    ...k(t),
    value: r,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Au(r, t) {
  return new Vu({
    check: "greater_than",
    ...k(t),
    value: r,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function gi(r, t) {
  return new Vu({
    check: "greater_than",
    ...k(t),
    value: r,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Cu(r, t) {
  return new _v({
    check: "multiple_of",
    ...k(t),
    value: r
  });
}
// @__NO_SIDE_EFFECTS__
function nl(r, t) {
  return new gv({
    check: "max_length",
    ...k(t),
    maximum: r
  });
}
// @__NO_SIDE_EFFECTS__
function Zt(r, t) {
  return new vv({
    check: "min_length",
    ...k(t),
    minimum: r
  });
}
// @__NO_SIDE_EFFECTS__
function rl(r, t) {
  return new Iv({
    check: "length_equals",
    ...k(t),
    length: r
  });
}
// @__NO_SIDE_EFFECTS__
function YI(r, t) {
  return new bv({
    check: "string_format",
    format: "regex",
    ...k(t),
    pattern: r
  });
}
// @__NO_SIDE_EFFECTS__
function XI(r) {
  return new Sv({
    check: "string_format",
    format: "lowercase",
    ...k(r)
  });
}
// @__NO_SIDE_EFFECTS__
function QI(r) {
  return new Tv({
    check: "string_format",
    format: "uppercase",
    ...k(r)
  });
}
// @__NO_SIDE_EFFECTS__
function eb(r, t) {
  return new Av({
    check: "string_format",
    format: "includes",
    ...k(t),
    includes: r
  });
}
// @__NO_SIDE_EFFECTS__
function nb(r, t) {
  return new Cv({
    check: "string_format",
    format: "starts_with",
    ...k(t),
    prefix: r
  });
}
// @__NO_SIDE_EFFECTS__
function rb(r, t) {
  return new yv({
    check: "string_format",
    format: "ends_with",
    ...k(t),
    suffix: r
  });
}
// @__NO_SIDE_EFFECTS__
function dr(r) {
  return new xv({
    check: "overwrite",
    tx: r
  });
}
// @__NO_SIDE_EFFECTS__
function tb(r) {
  return /* @__PURE__ */ dr((t) => t.normalize(r));
}
// @__NO_SIDE_EFFECTS__
function ob() {
  return /* @__PURE__ */ dr((r) => r.trim());
}
// @__NO_SIDE_EFFECTS__
function ib() {
  return /* @__PURE__ */ dr((r) => r.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function ab() {
  return /* @__PURE__ */ dr((r) => r.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function sb() {
  return /* @__PURE__ */ dr((r) => bg(r));
}
// @__NO_SIDE_EFFECTS__
function ub(r, t, o) {
  return new r({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...k(o)
  });
}
// @__NO_SIDE_EFFECTS__
function lb(r, t, o) {
  return new r({
    type: "custom",
    check: "custom",
    fn: t,
    ...k(o)
  });
}
// @__NO_SIDE_EFFECTS__
function cb(r) {
  const t = /* @__PURE__ */ db((o) => (o.addIssue = (s) => {
    if (typeof s == "string")
      o.issues.push(Dr(s, o.value, t._zod.def));
    else {
      const u = s;
      u.fatal && (u.continue = !1), u.code ?? (u.code = "custom"), u.input ?? (u.input = o.value), u.inst ?? (u.inst = t), u.continue ?? (u.continue = !t._zod.def.abort), o.issues.push(Dr(u));
    }
  }, r(o.value, o)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function db(r, t) {
  const o = new ke({
    check: "custom",
    ...k(t)
  });
  return o._zod.check = r, o;
}
function tl(r) {
  let t = r?.target ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: r.processors ?? {},
    metadataRegistry: r?.metadata ?? zr,
    target: t,
    unrepresentable: r?.unrepresentable ?? "throw",
    override: r?.override ?? (() => {
    }),
    io: r?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: r?.cycles ?? "ref",
    reused: r?.reused ?? "inline",
    external: r?.external ?? void 0
  };
}
function ve(r, t, o = { path: [], schemaPath: [] }) {
  var s;
  const u = r._zod.def, f = t.seen.get(r);
  if (f)
    return f.count++, o.schemaPath.includes(r) && (f.cycle = o.path), f.schema;
  const p = { schema: {}, count: 1, cycle: void 0, path: o.path };
  t.seen.set(r, p);
  const m = r._zod.toJSONSchema?.();
  if (m)
    p.schema = m;
  else {
    const N = {
      ...o,
      schemaPath: [...o.schemaPath, r],
      path: o.path
    };
    if (r._zod.processJSONSchema)
      r._zod.processJSONSchema(t, p.schema, N);
    else {
      const O = p.schema, z = t.processors[u.type];
      if (!z)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${u.type}`);
      z(r, t, O, N);
    }
    const L = r._zod.parent;
    L && (p.ref || (p.ref = L), ve(L, t, N), t.seen.get(L).isParent = !0);
  }
  const S = t.metadataRegistry.get(r);
  return S && Object.assign(p.schema, S), t.io === "input" && ye(r) && (delete p.schema.examples, delete p.schema.default), t.io === "input" && p.schema._prefault && ((s = p.schema).default ?? (s.default = p.schema._prefault)), delete p.schema._prefault, t.seen.get(r).schema;
}
function ol(r, t) {
  const o = r.seen.get(t);
  if (!o)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const s = /* @__PURE__ */ new Map();
  for (const p of r.seen.entries()) {
    const m = r.metadataRegistry.get(p[0])?.id;
    if (m) {
      const S = s.get(m);
      if (S && S !== p[0])
        throw new Error(`Duplicate schema id "${m}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      s.set(m, p[0]);
    }
  }
  const u = (p) => {
    const m = r.target === "draft-2020-12" ? "$defs" : "definitions";
    if (r.external) {
      const L = r.external.registry.get(p[0])?.id, O = r.external.uri ?? ((te) => te);
      if (L)
        return { ref: O(L) };
      const z = p[1].defId ?? p[1].schema.id ?? `schema${r.counter++}`;
      return p[1].defId = z, { defId: z, ref: `${O("__shared")}#/${m}/${z}` };
    }
    if (p[1] === o)
      return { ref: "#" };
    const x = `#/${m}/`, N = p[1].schema.id ?? `__schema${r.counter++}`;
    return { defId: N, ref: x + N };
  }, f = (p) => {
    if (p[1].schema.$ref)
      return;
    const m = p[1], { ref: S, defId: x } = u(p);
    m.def = { ...m.schema }, x && (m.defId = x);
    const N = m.schema;
    for (const L in N)
      delete N[L];
    N.$ref = S;
  };
  if (r.cycles === "throw")
    for (const p of r.seen.entries()) {
      const m = p[1];
      if (m.cycle)
        throw new Error(`Cycle detected: #/${m.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const p of r.seen.entries()) {
    const m = p[1];
    if (t === p[0]) {
      f(p);
      continue;
    }
    if (r.external) {
      const x = r.external.registry.get(p[0])?.id;
      if (t !== p[0] && x) {
        f(p);
        continue;
      }
    }
    if (r.metadataRegistry.get(p[0])?.id) {
      f(p);
      continue;
    }
    if (m.cycle) {
      f(p);
      continue;
    }
    if (m.count > 1 && r.reused === "ref") {
      f(p);
      continue;
    }
  }
}
function il(r, t) {
  const o = r.seen.get(t);
  if (!o)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const s = (p) => {
    const m = r.seen.get(p);
    if (m.ref === null)
      return;
    const S = m.def ?? m.schema, x = { ...S }, N = m.ref;
    if (m.ref = null, N) {
      s(N);
      const O = r.seen.get(N), z = O.schema;
      if (z.$ref && (r.target === "draft-07" || r.target === "draft-04" || r.target === "openapi-3.0") ? (S.allOf = S.allOf ?? [], S.allOf.push(z)) : Object.assign(S, z), Object.assign(S, x), p._zod.parent === N)
        for (const oe in S)
          oe === "$ref" || oe === "allOf" || oe in x || delete S[oe];
      if (z.$ref && O.def)
        for (const oe in S)
          oe === "$ref" || oe === "allOf" || oe in O.def && JSON.stringify(S[oe]) === JSON.stringify(O.def[oe]) && delete S[oe];
    }
    const L = p._zod.parent;
    if (L && L !== N) {
      s(L);
      const O = r.seen.get(L);
      if (O?.schema.$ref && (S.$ref = O.schema.$ref, O.def))
        for (const z in S)
          z === "$ref" || z === "allOf" || z in O.def && JSON.stringify(S[z]) === JSON.stringify(O.def[z]) && delete S[z];
    }
    r.override({
      zodSchema: p,
      jsonSchema: S,
      path: m.path ?? []
    });
  };
  for (const p of [...r.seen.entries()].reverse())
    s(p[0]);
  const u = {};
  if (r.target === "draft-2020-12" ? u.$schema = "https://json-schema.org/draft/2020-12/schema" : r.target === "draft-07" ? u.$schema = "http://json-schema.org/draft-07/schema#" : r.target === "draft-04" ? u.$schema = "http://json-schema.org/draft-04/schema#" : r.target, r.external?.uri) {
    const p = r.external.registry.get(t)?.id;
    if (!p)
      throw new Error("Schema is missing an `id` property");
    u.$id = r.external.uri(p);
  }
  Object.assign(u, o.def ?? o.schema);
  const f = r.external?.defs ?? {};
  for (const p of r.seen.entries()) {
    const m = p[1];
    m.def && m.defId && (f[m.defId] = m.def);
  }
  r.external || Object.keys(f).length > 0 && (r.target === "draft-2020-12" ? u.$defs = f : u.definitions = f);
  try {
    const p = JSON.parse(JSON.stringify(u));
    return Object.defineProperty(p, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: Ut(t, "input", r.processors),
          output: Ut(t, "output", r.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), p;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function ye(r, t) {
  const o = t ?? { seen: /* @__PURE__ */ new Set() };
  if (o.seen.has(r))
    return !1;
  o.seen.add(r);
  const s = r._zod.def;
  if (s.type === "transform")
    return !0;
  if (s.type === "array")
    return ye(s.element, o);
  if (s.type === "set")
    return ye(s.valueType, o);
  if (s.type === "lazy")
    return ye(s.getter(), o);
  if (s.type === "promise" || s.type === "optional" || s.type === "nonoptional" || s.type === "nullable" || s.type === "readonly" || s.type === "default" || s.type === "prefault")
    return ye(s.innerType, o);
  if (s.type === "intersection")
    return ye(s.left, o) || ye(s.right, o);
  if (s.type === "record" || s.type === "map")
    return ye(s.keyType, o) || ye(s.valueType, o);
  if (s.type === "pipe")
    return ye(s.in, o) || ye(s.out, o);
  if (s.type === "object") {
    for (const u in s.shape)
      if (ye(s.shape[u], o))
        return !0;
    return !1;
  }
  if (s.type === "union") {
    for (const u of s.options)
      if (ye(u, o))
        return !0;
    return !1;
  }
  if (s.type === "tuple") {
    for (const u of s.items)
      if (ye(u, o))
        return !0;
    return !!(s.rest && ye(s.rest, o));
  }
  return !1;
}
const pb = (r, t = {}) => (o) => {
  const s = tl({ ...o, processors: t });
  return ve(r, s), ol(s, r), il(s, r);
}, Ut = (r, t, o = {}) => (s) => {
  const { libraryOptions: u, target: f } = s ?? {}, p = tl({ ...u ?? {}, target: f, io: t, processors: o });
  return ve(r, p), ol(p, r), il(p, r);
}, fb = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, hb = (r, t, o, s) => {
  const u = o;
  u.type = "string";
  const { minimum: f, maximum: p, format: m, patterns: S, contentEncoding: x } = r._zod.bag;
  if (typeof f == "number" && (u.minLength = f), typeof p == "number" && (u.maxLength = p), m && (u.format = fb[m] ?? m, u.format === "" && delete u.format, m === "time" && delete u.format), x && (u.contentEncoding = x), S && S.size > 0) {
    const N = [...S];
    N.length === 1 ? u.pattern = N[0].source : N.length > 1 && (u.allOf = [
      ...N.map((L) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: L.source
      }))
    ]);
  }
}, _b = (r, t, o, s) => {
  const u = o, { minimum: f, maximum: p, format: m, multipleOf: S, exclusiveMaximum: x, exclusiveMinimum: N } = r._zod.bag;
  typeof m == "string" && m.includes("int") ? u.type = "integer" : u.type = "number", typeof N == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (u.minimum = N, u.exclusiveMinimum = !0) : u.exclusiveMinimum = N), typeof f == "number" && (u.minimum = f, typeof N == "number" && t.target !== "draft-04" && (N >= f ? delete u.minimum : delete u.exclusiveMinimum)), typeof x == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (u.maximum = x, u.exclusiveMaximum = !0) : u.exclusiveMaximum = x), typeof p == "number" && (u.maximum = p, typeof x == "number" && t.target !== "draft-04" && (x <= p ? delete u.maximum : delete u.exclusiveMaximum)), typeof S == "number" && (u.multipleOf = S);
}, mb = (r, t, o, s) => {
  o.not = {};
}, gb = (r, t, o, s) => {
}, vb = (r, t, o, s) => {
  const u = r._zod.def, f = Ou(u.entries);
  f.every((p) => typeof p == "number") && (o.type = "number"), f.every((p) => typeof p == "string") && (o.type = "string"), o.enum = f;
}, Ib = (r, t, o, s) => {
  const u = r._zod.def, f = [];
  for (const p of u.values)
    if (p === void 0) {
      if (t.unrepresentable === "throw")
        throw new Error("Literal `undefined` cannot be represented in JSON Schema");
    } else if (typeof p == "bigint") {
      if (t.unrepresentable === "throw")
        throw new Error("BigInt literals cannot be represented in JSON Schema");
      f.push(Number(p));
    } else
      f.push(p);
  if (f.length !== 0) if (f.length === 1) {
    const p = f[0];
    o.type = p === null ? "null" : typeof p, t.target === "draft-04" || t.target === "openapi-3.0" ? o.enum = [p] : o.const = p;
  } else
    f.every((p) => typeof p == "number") && (o.type = "number"), f.every((p) => typeof p == "string") && (o.type = "string"), f.every((p) => typeof p == "boolean") && (o.type = "boolean"), f.every((p) => p === null) && (o.type = "null"), o.enum = f;
}, bb = (r, t, o, s) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, Sb = (r, t, o, s) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, Tb = (r, t, o, s) => {
  const u = o, f = r._zod.def, { minimum: p, maximum: m } = r._zod.bag;
  typeof p == "number" && (u.minItems = p), typeof m == "number" && (u.maxItems = m), u.type = "array", u.items = ve(f.element, t, { ...s, path: [...s.path, "items"] });
}, Ab = (r, t, o, s) => {
  const u = o, f = r._zod.def;
  u.type = "object", u.properties = {};
  const p = f.shape;
  for (const x in p)
    u.properties[x] = ve(p[x], t, {
      ...s,
      path: [...s.path, "properties", x]
    });
  const m = new Set(Object.keys(p)), S = new Set([...m].filter((x) => {
    const N = f.shape[x]._zod;
    return t.io === "input" ? N.optin === void 0 : N.optout === void 0;
  }));
  S.size > 0 && (u.required = Array.from(S)), f.catchall?._zod.def.type === "never" ? u.additionalProperties = !1 : f.catchall ? f.catchall && (u.additionalProperties = ve(f.catchall, t, {
    ...s,
    path: [...s.path, "additionalProperties"]
  })) : t.io === "output" && (u.additionalProperties = !1);
}, Cb = (r, t, o, s) => {
  const u = r._zod.def, f = u.inclusive === !1, p = u.options.map((m, S) => ve(m, t, {
    ...s,
    path: [...s.path, f ? "oneOf" : "anyOf", S]
  }));
  f ? o.oneOf = p : o.anyOf = p;
}, yb = (r, t, o, s) => {
  const u = r._zod.def, f = ve(u.left, t, {
    ...s,
    path: [...s.path, "allOf", 0]
  }), p = ve(u.right, t, {
    ...s,
    path: [...s.path, "allOf", 1]
  }), m = (x) => "allOf" in x && Object.keys(x).length === 1, S = [
    ...m(f) ? f.allOf : [f],
    ...m(p) ? p.allOf : [p]
  ];
  o.allOf = S;
}, xb = (r, t, o, s) => {
  const u = r._zod.def, f = ve(u.innerType, t, s), p = t.seen.get(r);
  t.target === "openapi-3.0" ? (p.ref = u.innerType, o.nullable = !0) : o.anyOf = [f, { type: "null" }];
}, wb = (r, t, o, s) => {
  const u = r._zod.def;
  ve(u.innerType, t, s);
  const f = t.seen.get(r);
  f.ref = u.innerType;
}, Mb = (r, t, o, s) => {
  const u = r._zod.def;
  ve(u.innerType, t, s);
  const f = t.seen.get(r);
  f.ref = u.innerType, o.default = JSON.parse(JSON.stringify(u.defaultValue));
}, Nb = (r, t, o, s) => {
  const u = r._zod.def;
  ve(u.innerType, t, s);
  const f = t.seen.get(r);
  f.ref = u.innerType, t.io === "input" && (o._prefault = JSON.parse(JSON.stringify(u.defaultValue)));
}, Eb = (r, t, o, s) => {
  const u = r._zod.def;
  ve(u.innerType, t, s);
  const f = t.seen.get(r);
  f.ref = u.innerType;
  let p;
  try {
    p = u.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  o.default = p;
}, kb = (r, t, o, s) => {
  const u = r._zod.def, f = t.io === "input" ? u.in._zod.def.type === "transform" ? u.out : u.in : u.out;
  ve(f, t, s);
  const p = t.seen.get(r);
  p.ref = f;
}, Bb = (r, t, o, s) => {
  const u = r._zod.def;
  ve(u.innerType, t, s);
  const f = t.seen.get(r);
  f.ref = u.innerType, o.readOnly = !0;
}, al = (r, t, o, s) => {
  const u = r._zod.def;
  ve(u.innerType, t, s);
  const f = t.seen.get(r);
  f.ref = u.innerType;
}, Pb = /* @__PURE__ */ A("ZodISODateTime", (r, t) => {
  Dv.init(r, t), re.init(r, t);
});
function Rb(r) {
  return /* @__PURE__ */ $I(Pb, r);
}
const zb = /* @__PURE__ */ A("ZodISODate", (r, t) => {
  Zv.init(r, t), re.init(r, t);
});
function Ob(r) {
  return /* @__PURE__ */ KI(zb, r);
}
const Lb = /* @__PURE__ */ A("ZodISOTime", (r, t) => {
  Uv.init(r, t), re.init(r, t);
});
function Fb(r) {
  return /* @__PURE__ */ HI(Lb, r);
}
const Gb = /* @__PURE__ */ A("ZodISODuration", (r, t) => {
  $v.init(r, t), re.init(r, t);
});
function Db(r) {
  return /* @__PURE__ */ WI(Gb, r);
}
const Zb = (r, t) => {
  Zu.init(r, t), r.name = "ZodError", Object.defineProperties(r, {
    format: {
      value: (o) => Pg(r, o)
      // enumerable: false,
    },
    flatten: {
      value: (o) => Bg(r, o)
      // enumerable: false,
    },
    addIssue: {
      value: (o) => {
        r.issues.push(o), r.message = JSON.stringify(r.issues, vi, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (o) => {
        r.issues.push(...o), r.message = JSON.stringify(r.issues, vi, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return r.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, We = A("ZodError", Zb, {
  Parent: Error
}), Ub = /* @__PURE__ */ wi(We), $b = /* @__PURE__ */ Mi(We), Kb = /* @__PURE__ */ Kt(We), Hb = /* @__PURE__ */ Ht(We), Wb = /* @__PURE__ */ Og(We), qb = /* @__PURE__ */ Lg(We), Vb = /* @__PURE__ */ Fg(We), Jb = /* @__PURE__ */ Gg(We), jb = /* @__PURE__ */ Dg(We), Yb = /* @__PURE__ */ Zg(We), Xb = /* @__PURE__ */ Ug(We), Qb = /* @__PURE__ */ $g(We), ce = /* @__PURE__ */ A("ZodType", (r, t) => (le.init(r, t), Object.assign(r["~standard"], {
  jsonSchema: {
    input: Ut(r, "input"),
    output: Ut(r, "output")
  }
}), r.toJSONSchema = pb(r, {}), r.def = t, r.type = t.type, Object.defineProperty(r, "_def", { value: t }), r.check = (...o) => r.clone(Mn(t, {
  checks: [
    ...t.checks ?? [],
    ...o.map((s) => typeof s == "function" ? { _zod: { check: s, def: { check: "custom" }, onattach: [] } } : s)
  ]
}), {
  parent: !0
}), r.with = r.check, r.clone = (o, s) => Nn(r, o, s), r.brand = () => r, r.register = ((o, s) => (o.add(r, s), r)), r.parse = (o, s) => Ub(r, o, s, { callee: r.parse }), r.safeParse = (o, s) => Kb(r, o, s), r.parseAsync = async (o, s) => $b(r, o, s, { callee: r.parseAsync }), r.safeParseAsync = async (o, s) => Hb(r, o, s), r.spa = r.safeParseAsync, r.encode = (o, s) => Wb(r, o, s), r.decode = (o, s) => qb(r, o, s), r.encodeAsync = async (o, s) => Vb(r, o, s), r.decodeAsync = async (o, s) => Jb(r, o, s), r.safeEncode = (o, s) => jb(r, o, s), r.safeDecode = (o, s) => Yb(r, o, s), r.safeEncodeAsync = async (o, s) => Xb(r, o, s), r.safeDecodeAsync = async (o, s) => Qb(r, o, s), r.refine = (o, s) => r.check(HS(o, s)), r.superRefine = (o) => r.check(WS(o)), r.overwrite = (o) => r.check(/* @__PURE__ */ dr(o)), r.optional = () => Nu(r), r.exactOptional = () => BS(r), r.nullable = () => Eu(r), r.nullish = () => Nu(Eu(r)), r.nonoptional = (o) => FS(r, o), r.array = () => AS(r), r.or = (o) => ll([r, o]), r.and = (o) => wS(r, o), r.transform = (o) => ku(r, ES(o)), r.default = (o) => zS(r, o), r.prefault = (o) => LS(r, o), r.catch = (o) => DS(r, o), r.pipe = (o) => ku(r, o), r.readonly = () => $S(r), r.describe = (o) => {
  const s = r.clone();
  return zr.add(s, { description: o }), s;
}, Object.defineProperty(r, "description", {
  get() {
    return zr.get(r)?.description;
  },
  configurable: !0
}), r.meta = (...o) => {
  if (o.length === 0)
    return zr.get(r);
  const s = r.clone();
  return zr.add(s, o[0]), s;
}, r.isOptional = () => r.safeParse(void 0).success, r.isNullable = () => r.safeParse(null).success, r.apply = (o) => o(r), r)), sl = /* @__PURE__ */ A("_ZodString", (r, t) => {
  Ni.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (s, u, f) => hb(r, s, u);
  const o = r._zod.bag;
  r.format = o.format ?? null, r.minLength = o.minimum ?? null, r.maxLength = o.maximum ?? null, r.regex = (...s) => r.check(/* @__PURE__ */ YI(...s)), r.includes = (...s) => r.check(/* @__PURE__ */ eb(...s)), r.startsWith = (...s) => r.check(/* @__PURE__ */ nb(...s)), r.endsWith = (...s) => r.check(/* @__PURE__ */ rb(...s)), r.min = (...s) => r.check(/* @__PURE__ */ Zt(...s)), r.max = (...s) => r.check(/* @__PURE__ */ nl(...s)), r.length = (...s) => r.check(/* @__PURE__ */ rl(...s)), r.nonempty = (...s) => r.check(/* @__PURE__ */ Zt(1, ...s)), r.lowercase = (s) => r.check(/* @__PURE__ */ XI(s)), r.uppercase = (s) => r.check(/* @__PURE__ */ QI(s)), r.trim = () => r.check(/* @__PURE__ */ ob()), r.normalize = (...s) => r.check(/* @__PURE__ */ tb(...s)), r.toLowerCase = () => r.check(/* @__PURE__ */ ib()), r.toUpperCase = () => r.check(/* @__PURE__ */ ab()), r.slugify = () => r.check(/* @__PURE__ */ sb());
}), eS = /* @__PURE__ */ A("ZodString", (r, t) => {
  Ni.init(r, t), sl.init(r, t), r.email = (o) => r.check(/* @__PURE__ */ AI(nS, o)), r.url = (o) => r.check(/* @__PURE__ */ wI(rS, o)), r.jwt = (o) => r.check(/* @__PURE__ */ UI(gS, o)), r.emoji = (o) => r.check(/* @__PURE__ */ MI(tS, o)), r.guid = (o) => r.check(/* @__PURE__ */ Su(yu, o)), r.uuid = (o) => r.check(/* @__PURE__ */ el(Or, o)), r.uuidv4 = (o) => r.check(/* @__PURE__ */ CI(Or, o)), r.uuidv6 = (o) => r.check(/* @__PURE__ */ yI(Or, o)), r.uuidv7 = (o) => r.check(/* @__PURE__ */ xI(Or, o)), r.nanoid = (o) => r.check(/* @__PURE__ */ NI(oS, o)), r.guid = (o) => r.check(/* @__PURE__ */ Su(yu, o)), r.cuid = (o) => r.check(/* @__PURE__ */ EI(iS, o)), r.cuid2 = (o) => r.check(/* @__PURE__ */ kI(aS, o)), r.ulid = (o) => r.check(/* @__PURE__ */ BI(sS, o)), r.base64 = (o) => r.check(/* @__PURE__ */ GI(hS, o)), r.base64url = (o) => r.check(/* @__PURE__ */ DI(_S, o)), r.xid = (o) => r.check(/* @__PURE__ */ PI(uS, o)), r.ksuid = (o) => r.check(/* @__PURE__ */ RI(lS, o)), r.ipv4 = (o) => r.check(/* @__PURE__ */ zI(cS, o)), r.ipv6 = (o) => r.check(/* @__PURE__ */ OI(dS, o)), r.cidrv4 = (o) => r.check(/* @__PURE__ */ LI(pS, o)), r.cidrv6 = (o) => r.check(/* @__PURE__ */ FI(fS, o)), r.e164 = (o) => r.check(/* @__PURE__ */ ZI(mS, o)), r.datetime = (o) => r.check(Rb(o)), r.date = (o) => r.check(Ob(o)), r.time = (o) => r.check(Fb(o)), r.duration = (o) => r.check(Db(o));
});
function xe(r) {
  return /* @__PURE__ */ TI(eS, r);
}
const re = /* @__PURE__ */ A("ZodStringFormat", (r, t) => {
  ee.init(r, t), sl.init(r, t);
}), nS = /* @__PURE__ */ A("ZodEmail", (r, t) => {
  kv.init(r, t), re.init(r, t);
}), yu = /* @__PURE__ */ A("ZodGUID", (r, t) => {
  Nv.init(r, t), re.init(r, t);
}), Or = /* @__PURE__ */ A("ZodUUID", (r, t) => {
  Ev.init(r, t), re.init(r, t);
});
function $t(r) {
  return /* @__PURE__ */ el(Or, r);
}
const rS = /* @__PURE__ */ A("ZodURL", (r, t) => {
  Bv.init(r, t), re.init(r, t);
}), tS = /* @__PURE__ */ A("ZodEmoji", (r, t) => {
  Pv.init(r, t), re.init(r, t);
}), oS = /* @__PURE__ */ A("ZodNanoID", (r, t) => {
  Rv.init(r, t), re.init(r, t);
}), iS = /* @__PURE__ */ A("ZodCUID", (r, t) => {
  zv.init(r, t), re.init(r, t);
}), aS = /* @__PURE__ */ A("ZodCUID2", (r, t) => {
  Ov.init(r, t), re.init(r, t);
}), sS = /* @__PURE__ */ A("ZodULID", (r, t) => {
  Lv.init(r, t), re.init(r, t);
}), uS = /* @__PURE__ */ A("ZodXID", (r, t) => {
  Fv.init(r, t), re.init(r, t);
}), lS = /* @__PURE__ */ A("ZodKSUID", (r, t) => {
  Gv.init(r, t), re.init(r, t);
}), cS = /* @__PURE__ */ A("ZodIPv4", (r, t) => {
  Kv.init(r, t), re.init(r, t);
}), dS = /* @__PURE__ */ A("ZodIPv6", (r, t) => {
  Hv.init(r, t), re.init(r, t);
}), pS = /* @__PURE__ */ A("ZodCIDRv4", (r, t) => {
  Wv.init(r, t), re.init(r, t);
}), fS = /* @__PURE__ */ A("ZodCIDRv6", (r, t) => {
  qv.init(r, t), re.init(r, t);
}), hS = /* @__PURE__ */ A("ZodBase64", (r, t) => {
  Vv.init(r, t), re.init(r, t);
}), _S = /* @__PURE__ */ A("ZodBase64URL", (r, t) => {
  jv.init(r, t), re.init(r, t);
}), mS = /* @__PURE__ */ A("ZodE164", (r, t) => {
  Yv.init(r, t), re.init(r, t);
}), gS = /* @__PURE__ */ A("ZodJWT", (r, t) => {
  Qv.init(r, t), re.init(r, t);
}), ul = /* @__PURE__ */ A("ZodNumber", (r, t) => {
  ju.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (s, u, f) => _b(r, s, u), r.gt = (s, u) => r.check(/* @__PURE__ */ Au(s, u)), r.gte = (s, u) => r.check(/* @__PURE__ */ gi(s, u)), r.min = (s, u) => r.check(/* @__PURE__ */ gi(s, u)), r.lt = (s, u) => r.check(/* @__PURE__ */ Tu(s, u)), r.lte = (s, u) => r.check(/* @__PURE__ */ mi(s, u)), r.max = (s, u) => r.check(/* @__PURE__ */ mi(s, u)), r.int = (s) => r.check(wu(s)), r.safe = (s) => r.check(wu(s)), r.positive = (s) => r.check(/* @__PURE__ */ Au(0, s)), r.nonnegative = (s) => r.check(/* @__PURE__ */ gi(0, s)), r.negative = (s) => r.check(/* @__PURE__ */ Tu(0, s)), r.nonpositive = (s) => r.check(/* @__PURE__ */ mi(0, s)), r.multipleOf = (s, u) => r.check(/* @__PURE__ */ Cu(s, u)), r.step = (s, u) => r.check(/* @__PURE__ */ Cu(s, u)), r.finite = () => r;
  const o = r._zod.bag;
  r.minValue = Math.max(o.minimum ?? Number.NEGATIVE_INFINITY, o.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, r.maxValue = Math.min(o.maximum ?? Number.POSITIVE_INFINITY, o.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, r.isInt = (o.format ?? "").includes("int") || Number.isSafeInteger(o.multipleOf ?? 0.5), r.isFinite = !0, r.format = o.format ?? null;
});
function xu(r) {
  return /* @__PURE__ */ qI(ul, r);
}
const vS = /* @__PURE__ */ A("ZodNumberFormat", (r, t) => {
  eI.init(r, t), ul.init(r, t);
});
function wu(r) {
  return /* @__PURE__ */ VI(vS, r);
}
const IS = /* @__PURE__ */ A("ZodUnknown", (r, t) => {
  nI.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (o, s, u) => gb();
});
function Mu() {
  return /* @__PURE__ */ JI(IS);
}
const bS = /* @__PURE__ */ A("ZodNever", (r, t) => {
  rI.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (o, s, u) => mb(r, o, s);
});
function SS(r) {
  return /* @__PURE__ */ jI(bS, r);
}
const TS = /* @__PURE__ */ A("ZodArray", (r, t) => {
  tI.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (o, s, u) => Tb(r, o, s, u), r.element = t.element, r.min = (o, s) => r.check(/* @__PURE__ */ Zt(o, s)), r.nonempty = (o) => r.check(/* @__PURE__ */ Zt(1, o)), r.max = (o, s) => r.check(/* @__PURE__ */ nl(o, s)), r.length = (o, s) => r.check(/* @__PURE__ */ rl(o, s)), r.unwrap = () => r.element;
});
function AS(r, t) {
  return /* @__PURE__ */ ub(TS, r, t);
}
const CS = /* @__PURE__ */ A("ZodObject", (r, t) => {
  iI.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (o, s, u) => Ab(r, o, s, u), J(r, "shape", () => t.shape), r.keyof = () => cl(Object.keys(r._zod.def.shape)), r.catchall = (o) => r.clone({ ...r._zod.def, catchall: o }), r.passthrough = () => r.clone({ ...r._zod.def, catchall: Mu() }), r.loose = () => r.clone({ ...r._zod.def, catchall: Mu() }), r.strict = () => r.clone({ ...r._zod.def, catchall: SS() }), r.strip = () => r.clone({ ...r._zod.def, catchall: void 0 }), r.extend = (o) => wg(r, o), r.safeExtend = (o) => Mg(r, o), r.merge = (o) => Ng(r, o), r.pick = (o) => yg(r, o), r.omit = (o) => xg(r, o), r.partial = (...o) => Eg(pl, r, o[0]), r.required = (...o) => kg(fl, r, o[0]);
});
function Zr(r, t) {
  const o = {
    type: "object",
    shape: r ?? {},
    ...k(t)
  };
  return new CS(o);
}
const yS = /* @__PURE__ */ A("ZodUnion", (r, t) => {
  aI.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (o, s, u) => Cb(r, o, s, u), r.options = t.options;
});
function ll(r, t) {
  return new yS({
    type: "union",
    options: r,
    ...k(t)
  });
}
const xS = /* @__PURE__ */ A("ZodIntersection", (r, t) => {
  sI.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (o, s, u) => yb(r, o, s, u);
});
function wS(r, t) {
  return new xS({
    type: "intersection",
    left: r,
    right: t
  });
}
const bi = /* @__PURE__ */ A("ZodEnum", (r, t) => {
  uI.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (s, u, f) => vb(r, s, u), r.enum = t.entries, r.options = Object.values(t.entries);
  const o = new Set(Object.keys(t.entries));
  r.extract = (s, u) => {
    const f = {};
    for (const p of s)
      if (o.has(p))
        f[p] = t.entries[p];
      else
        throw new Error(`Key ${p} not found in enum`);
    return new bi({
      ...t,
      checks: [],
      ...k(u),
      entries: f
    });
  }, r.exclude = (s, u) => {
    const f = { ...t.entries };
    for (const p of s)
      if (o.has(p))
        delete f[p];
      else
        throw new Error(`Key ${p} not found in enum`);
    return new bi({
      ...t,
      checks: [],
      ...k(u),
      entries: f
    });
  };
});
function cl(r, t) {
  const o = Array.isArray(r) ? Object.fromEntries(r.map((s) => [s, s])) : r;
  return new bi({
    type: "enum",
    entries: o,
    ...k(t)
  });
}
const MS = /* @__PURE__ */ A("ZodLiteral", (r, t) => {
  lI.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (o, s, u) => Ib(r, o, s), r.values = new Set(t.values), Object.defineProperty(r, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function dl(r, t) {
  return new MS({
    type: "literal",
    values: Array.isArray(r) ? r : [r],
    ...k(t)
  });
}
const NS = /* @__PURE__ */ A("ZodTransform", (r, t) => {
  cI.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (o, s, u) => Sb(r, o), r._zod.parse = (o, s) => {
    if (s.direction === "backward")
      throw new Ru(r.constructor.name);
    o.addIssue = (f) => {
      if (typeof f == "string")
        o.issues.push(Dr(f, o.value, t));
      else {
        const p = f;
        p.fatal && (p.continue = !1), p.code ?? (p.code = "custom"), p.input ?? (p.input = o.value), p.inst ?? (p.inst = r), o.issues.push(Dr(p));
      }
    };
    const u = t.transform(o.value, o);
    return u instanceof Promise ? u.then((f) => (o.value = f, o)) : (o.value = u, o);
  };
});
function ES(r) {
  return new NS({
    type: "transform",
    transform: r
  });
}
const pl = /* @__PURE__ */ A("ZodOptional", (r, t) => {
  Qu.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (o, s, u) => al(r, o, s, u), r.unwrap = () => r._zod.def.innerType;
});
function Nu(r) {
  return new pl({
    type: "optional",
    innerType: r
  });
}
const kS = /* @__PURE__ */ A("ZodExactOptional", (r, t) => {
  dI.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (o, s, u) => al(r, o, s, u), r.unwrap = () => r._zod.def.innerType;
});
function BS(r) {
  return new kS({
    type: "optional",
    innerType: r
  });
}
const PS = /* @__PURE__ */ A("ZodNullable", (r, t) => {
  pI.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (o, s, u) => xb(r, o, s, u), r.unwrap = () => r._zod.def.innerType;
});
function Eu(r) {
  return new PS({
    type: "nullable",
    innerType: r
  });
}
const RS = /* @__PURE__ */ A("ZodDefault", (r, t) => {
  fI.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (o, s, u) => Mb(r, o, s, u), r.unwrap = () => r._zod.def.innerType, r.removeDefault = r.unwrap;
});
function zS(r, t) {
  return new RS({
    type: "default",
    innerType: r,
    get defaultValue() {
      return typeof t == "function" ? t() : Fu(t);
    }
  });
}
const OS = /* @__PURE__ */ A("ZodPrefault", (r, t) => {
  hI.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (o, s, u) => Nb(r, o, s, u), r.unwrap = () => r._zod.def.innerType;
});
function LS(r, t) {
  return new OS({
    type: "prefault",
    innerType: r,
    get defaultValue() {
      return typeof t == "function" ? t() : Fu(t);
    }
  });
}
const fl = /* @__PURE__ */ A("ZodNonOptional", (r, t) => {
  _I.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (o, s, u) => wb(r, o, s, u), r.unwrap = () => r._zod.def.innerType;
});
function FS(r, t) {
  return new fl({
    type: "nonoptional",
    innerType: r,
    ...k(t)
  });
}
const GS = /* @__PURE__ */ A("ZodCatch", (r, t) => {
  mI.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (o, s, u) => Eb(r, o, s, u), r.unwrap = () => r._zod.def.innerType, r.removeCatch = r.unwrap;
});
function DS(r, t) {
  return new GS({
    type: "catch",
    innerType: r,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const ZS = /* @__PURE__ */ A("ZodPipe", (r, t) => {
  gI.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (o, s, u) => kb(r, o, s, u), r.in = t.in, r.out = t.out;
});
function ku(r, t) {
  return new ZS({
    type: "pipe",
    in: r,
    out: t
    // ...util.normalizeParams(params),
  });
}
const US = /* @__PURE__ */ A("ZodReadonly", (r, t) => {
  vI.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (o, s, u) => Bb(r, o, s, u), r.unwrap = () => r._zod.def.innerType;
});
function $S(r) {
  return new US({
    type: "readonly",
    innerType: r
  });
}
const KS = /* @__PURE__ */ A("ZodCustom", (r, t) => {
  II.init(r, t), ce.init(r, t), r._zod.processJSONSchema = (o, s, u) => bb(r, o);
});
function HS(r, t = {}) {
  return /* @__PURE__ */ lb(KS, r, t);
}
function WS(r) {
  return /* @__PURE__ */ cb(r);
}
const hl = Zr({
  userId: $t(),
  companyId: $t()
}), qS = hl.extend({
  auctionId: $t()
}), VS = hl.extend({
  directSaleId: $t()
}), v1 = ll([qS, VS]), I1 = 50, b1 = "bnk_", S1 = {
  // Exteriors
  photo_front: {
    name: "photo_front",
    position: 10,
    position_admin: 30,
    label: "front photo",
    group: "exteriors",
    description: "A photo capturing the front view of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_3_4_front_side_left: {
    name: "photo_3_4_front_side_left",
    position: 20,
    position_admin: 40,
    label: "3/4 front left",
    group: "exteriors",
    description: "A 3/4 angled photo of the front side of the vehicle from the left.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_side_left: {
    name: "photo_side_left",
    position: 30,
    position_admin: 70,
    label: "left side photo",
    group: "exteriors",
    description: "A photo showing the left side of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_left_rear: {
    name: "photo_3_4_side_left_rear",
    position: 40,
    position_admin: 120,
    label: "3/4 left rear side",
    group: "exteriors",
    description: "A 3/4 angled photo of the left rear side of the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_rear_hatch_closed: {
    name: "photo_rear_hatch_closed",
    position: 50,
    position_admin: 130,
    label: "rear hatch closed",
    group: "exteriors",
    description: "A photo showing the rear of the vehicle with the hatch closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_right_rear_doors_closed: {
    name: "photo_3_4_side_right_rear_doors_closed",
    position: 60,
    position_admin: 190,
    label: "3/4 right rear doors closed",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right rear side with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_side_right_doors_closed: {
    name: "photo_side_right_doors_closed",
    position: 70,
    position_admin: 200,
    label: "right side doors closed",
    group: "exteriors",
    description: "A photo showing the right side of the vehicle with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  turntable_photo_external_if_present_only_18mt: {
    name: "turntable_photo_external_if_present_only_18mt",
    position: 80,
    position_admin: 210,
    label: "turntable external (18m)",
    group: "exteriors",
    description: "An external photo of the turntable if present (only for 18 meters).",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_front_side_right_doors_closed: {
    name: "photo_3_4_front_side_right_doors_closed",
    position: 90,
    position_admin: 10,
    label: "3/4 front right doors",
    group: "exteriors",
    description: "A 3/4 angled photo of the front side of the vehicle from the right, with doors closed.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !0
  },
  photo_3_4_side_right_front_doors_open: {
    name: "photo_3_4_side_right_front_doors_open",
    position: 100,
    position_admin: 230,
    label: "3/4 right front doors open",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right front side of the vehicle with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_1: {
    name: "front_photo_per_door_doors_open_door_1",
    position: 110,
    position_admin: 300,
    label: "front door 1 open",
    group: "exteriors",
    description: "A photo of the front door 1 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_side_right_doors_open: {
    name: "photo_side_right_doors_open",
    position: 120,
    position_admin: 240,
    label: "right side doors open",
    group: "exteriors",
    description: "A photo showing the right side of the vehicle with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_2: {
    name: "front_photo_per_door_doors_open_door_2",
    position: 130,
    position_admin: 270,
    label: "front door 2 open",
    group: "exteriors",
    description: "A photo of the front door 2 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  front_photo_per_door_doors_open_door_3: {
    name: "front_photo_per_door_doors_open_door_3",
    position: 140,
    position_admin: 260,
    label: "front door 3 open",
    group: "exteriors",
    description: "A photo of the front door 3 in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_3_4_side_right_rear_doors_open: {
    name: "photo_3_4_side_right_rear_doors_open",
    position: 150,
    position_admin: 250,
    label: "3/4 right rear doors open",
    group: "exteriors",
    description: "A 3/4 angled photo showing the right rear side with doors open.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_luggage: {
    name: "photo_luggage",
    position: 160,
    position_admin: 80,
    label: "luggage rack photo",
    group: "exteriors",
    description: "A photo showing the luggage rack in the vehicle.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_internal_frame_for_potential_rust: {
    name: "photo_internal_frame_for_potential_rust",
    position: 170,
    position_admin: 90,
    label: "internal frame rust check",
    group: "exteriors",
    description: "A photo showing the internal frame of the vehicle to check for potential rust.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_under_carpet_if_carpet_present: {
    name: "photo_under_carpet_if_carpet_present",
    position: 180,
    position_admin: 95,
    label: "under carpet photo",
    group: "exteriors",
    description: "A photo showing the area under the carpet if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_hatch_open: {
    name: "photo_rear_hatch_open",
    position: 190,
    position_admin: 140,
    label: "rear hatch open",
    group: "exteriors",
    description: "A photo showing the rear of the vehicle with the hatch open.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_compressor_air_conditioning: {
    name: "photo_compressor_air_conditioning",
    position: 200,
    position_admin: 150,
    label: "air conditioning compressor",
    group: "exteriors",
    description: "A photo showing the air conditioning compressor.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_preheater_webasto_if_present: {
    name: "photo_preheater_webasto_if_present",
    position: 210,
    position_admin: 170,
    label: "preheater webasto photo",
    group: "exteriors",
    description: "A photo of the preheater (webasto) system if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_fire_extinguishing_system: {
    name: "photo_fire_extinguishing_system",
    position: 220,
    position_admin: 160,
    label: "fire extinguishing system",
    group: "exteriors",
    description: "A photo showing the fire extinguishing system of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_external_compartments_various_internal_photo: {
    name: "photo_external_compartments_various_internal_photo",
    position: 230,
    position_admin: 60,
    label: "external compartments photo",
    group: "exteriors",
    description: "A photo showing various external compartments.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_platform_open_platform: {
    name: "photo_platform_open_platform",
    position: 240,
    position_admin: 215,
    label: "platform open photo",
    group: "exteriors",
    description: "A photo of the platform in an open position.",
    performTextInpaint: !0,
    requiredForToBeScrapped: !1
  },
  photo_platform_code: {
    name: "photo_platform_code",
    position: 250,
    position_admin: 216,
    label: "platform code photo",
    group: "exteriors",
    description: "A photo showing the platform's code.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  engine_plate_photo_if_present: {
    name: "engine_plate_photo_if_present",
    position: 260,
    position_admin: 165,
    label: "engine plate photo",
    group: "exteriors",
    description: "A photo showing the engine plate if present.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_plate_vehicle: {
    name: "photo_plate_vehicle",
    position: 270,
    position_admin: 310,
    label: "vehicle plate photo",
    group: "exteriors",
    description: "A photo showing the vehicle's plate.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  // Interiors
  photo_plate_seats: {
    name: "photo_plate_seats",
    position: 280,
    position_admin: 320,
    label: "seat plate photo",
    group: "interiors",
    description: "A photo showing the seat plate inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_driver_microphone: {
    name: "photo_accessories_driver_microphone",
    position: 290,
    position_admin: 330,
    label: "driver microphone accessories photo",
    group: "interiors",
    description: "A photo showing the driver's microphone accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_drive_seat: {
    name: "photo_drive_seat",
    position: 300,
    position_admin: 340,
    label: "driver's seat photo",
    group: "interiors",
    description: "A photo of the driver's seat.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_steering_wheel: {
    name: "photo_steering_wheel",
    position: 310,
    position_admin: 350,
    label: "steering wheel photo",
    group: "interiors",
    description: "A photo of the steering wheel in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_dashboard_on_for_number_km_and_lights_on: {
    name: "photo_dashboard_on_for_number_km_and_lights_on",
    position: 320,
    position_admin: 360,
    label: "dashboard lights on",
    group: "interiors",
    description: "A photo showing the dashboard with the vehicle's odometer reading and warning lights illuminated.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_buttons_e_panels_on: {
    name: "photo_buttons_e_panels_on",
    position: 330,
    position_admin: 370,
    label: "buttons panels on",
    group: "interiors",
    description: "A photo showing the vehicle's buttons and panels in an 'on' state.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_tachograph: {
    name: "photo_tachograph",
    position: 340,
    position_admin: 380,
    label: "Tachograph",
    group: "interiors",
    description: "A photo of the Tachograph.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_radio: {
    name: "photo_accessories_radio",
    position: 350,
    position_admin: 390,
    label: "radio accessories photo",
    group: "interiors",
    description: "A photo showing the radio accessories inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_any_devices_onboard_1: {
    name: "photo_any_devices_onboard_1",
    position: 360,
    position_admin: 400,
    label: "onboard devices 1",
    group: "interiors",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_any_devices_onboard_2: {
    name: "photo_any_devices_onboard_2",
    position: 370,
    position_admin: 410,
    label: "onboard devices 2",
    group: "interiors",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  control_unit_command_signs_indicators: {
    name: "control_unit_command_signs_indicators",
    position: 380,
    position_admin: 430,
    label: "command unit indicators",
    group: "interiors",
    description: "A photo of the control unit for signs and indicators.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_seat_hostess: {
    name: "photo_seat_hostess",
    position: 390,
    position_admin: 440,
    label: "hostess seat photo",
    group: "interiors",
    description: "A photo of the hostess seat in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_hostes_microphone: {
    name: "photo_accessories_hostes_microphone",
    position: 400,
    position_admin: 450,
    label: "hostes microphone accessories photo",
    group: "interiors",
    description: "A photo showing the hostes's microphone accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_handrails: {
    name: "photo_handrails",
    position: 410,
    position_admin: 460,
    label: "handrails photo",
    group: "interiors",
    description: "A photo showing the handrails inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_door_mechanism_internal_photo: {
    name: "photo_door_mechanism_internal_photo",
    position: 420,
    position_admin: 470,
    label: "door mechanism photo",
    group: "interiors",
    description: "A photo of the internal door mechanism.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_interior_contromarcia_inquadrare_tutti_i_seats_height_seat_autista: {
    name: "photo_interior_contromarcia_inquadrare_tutti_i_seats_height_seat_autista",
    position: 430,
    position_admin: 480,
    label: "interior reverse seats driver height",
    group: "interiors",
    description: "A photo showing the interior seats in reverse view, including driver seat height.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_interior_reverse_view_from_middle_aisle: {
    name: "photo_interior_reverse_view_from_middle_aisle",
    position: 440,
    position_admin: 490,
    label: "reverse view middle aisle",
    group: "interiors",
    description: "A reverse view photo from the middle aisle of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_interior_senso_di_marcia_inquadrare_tutti_i_seats_height_ultima_fila: {
    name: "photo_interior_senso_di_marcia_inquadrare_tutti_i_seats_height_ultima_fila",
    position: 450,
    position_admin: 500,
    label: "forward view all seats last row height",
    group: "interiors",
    description: "A forward view photo showing all seats, focusing on the height of the last row.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_overhead_compartments: {
    name: "photo_overhead_compartments",
    position: 460,
    position_admin: 510,
    label: "overhead compartments photo",
    group: "interiors",
    description: "A photo showing the overhead compartments inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_toilette: {
    name: "photo_accessories_toilette",
    position: 470,
    position_admin: 520,
    label: "toilette accessories photo",
    group: "interiors",
    description: "A photo showing the toilette accessories inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_interior_forward_view_from_middle_aisle: {
    name: "photo_interior_forward_view_from_middle_aisle",
    position: 480,
    position_admin: 530,
    label: "forward view middle aisle",
    group: "interiors",
    description: "A forward view photo from the middle aisle of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_floor: {
    name: "photo_hatches_floor",
    position: 490,
    position_admin: 535,
    label: "floor hatches photo",
    group: "interiors",
    description: "A photo of the floor hatches in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_central_seat_with_safety_belt_fastened: {
    name: "photo_central_seat_with_safety_belt_fastened",
    position: 500,
    position_admin: 540,
    label: "central seat safety belt",
    group: "interiors",
    description: "A photo showing the central seat with the safety belt fastened.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  turntable_photo_internal_if_present_only_18mt: {
    name: "turntable_photo_internal_if_present_only_18mt",
    position: 510,
    position_admin: 550,
    label: "turntable internal (18m)",
    group: "interiors",
    description: "An internal photo of the turntable if present (only for 18 meters).",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_1: {
    name: "photo_hatches_roof_1",
    position: 520,
    position_admin: 560,
    label: "roof hatch 1",
    group: "interiors",
    description: "A photo of the roof hatch number 1.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_2: {
    name: "photo_hatches_roof_2",
    position: 530,
    position_admin: 570,
    label: "roof hatch 2",
    group: "interiors",
    description: "A photo of the roof hatch number 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_hatches_roof_3: {
    name: "photo_hatches_roof_3",
    position: 540,
    position_admin: 575,
    label: "roof hatch 3",
    group: "interiors",
    description: "A photo of the roof hatch number 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_disabled_area: {
    name: "photo_disabled_area",
    position: 550,
    position_admin: 580,
    label: "disabled area photo",
    group: "interiors",
    description: "A photo showing the designated disabled area in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_folding_seat: {
    name: "photo_folding_seat",
    position: 560,
    position_admin: 590,
    label: "folding seat photo",
    group: "interiors",
    description: "A photo showing the folding seat in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_detail_of_single_seat: {
    name: "photo_detail_of_single_seat",
    position: 570,
    position_admin: 620,
    label: "single seat detail",
    group: "interiors",
    description: "A detailed photo of a single seat in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_detail_of_mesh: {
    name: "photo_detail_of_mesh",
    position: 580,
    position_admin: 630,
    label: "mesh detail photo",
    group: "interiors",
    description: "A detailed photo of the mesh inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_table_detail: {
    name: "photo_table_detail",
    position: 590,
    position_admin: 640,
    label: "table detail photo",
    group: "interiors",
    description: "A detailed photo of the table inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_charging_usb_detail: {
    name: "photo_charging_usb_detail",
    position: 600,
    position_admin: 650,
    label: "usb charging detail",
    group: "interiors",
    description: "A detailed photo showing the USB charging ports.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_armrest_detail: {
    name: "photo_armrest_detail",
    position: 610,
    position_admin: 660,
    label: "armrest detail photo",
    group: "interiors",
    description: "A detailed photo of the armrest in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_footrest_detail: {
    name: "photo_footrest_detail",
    position: 620,
    position_admin: 670,
    label: "footrest detail photo",
    group: "interiors",
    description: "A detailed photo of the footrest in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_monitor_detail: {
    name: "photo_monitor_detail",
    position: 630,
    position_admin: 680,
    label: "monitor detail photo",
    group: "interiors",
    description: "A detailed photo of the monitor in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_outlets_di_current_detail: {
    name: "photo_outlets_di_current_detail",
    position: 640,
    position_admin: 690,
    label: "power outlets detail",
    group: "interiors",
    description: "A detailed photo of the power outlets in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_coffee_machine_accessories: {
    name: "photo_coffee_machine_accessories",
    position: 650,
    position_admin: 710,
    label: "coffee machine accessories",
    group: "interiors",
    description: "A photo of the coffee machine accessories in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_brackets_seats: {
    name: "photo_brackets_seats",
    position: 660,
    position_admin: 710,
    label: "seat brackets photo",
    group: "interiors",
    description: "A photo showing the seat brackets in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_accessories_cameras: {
    name: "photo_accessories_cameras",
    position: 670,
    position_admin: 720,
    label: "camera accessories photo",
    group: "interiors",
    description: "A photo showing the camera accessories inside the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  jack_e_keys_for_driver: {
    name: "jack_e_keys_for_driver",
    position: 680,
    position_admin: 730,
    label: "jack and driver keys",
    group: "interiors",
    description: "A photo showing the jack and keys for the driver.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  // Tire sizes
  spare_wheel: {
    name: "spare_wheel",
    position: 690,
    position_admin: 20,
    label: "spare wheel",
    group: "tire-sizes",
    description: "A photo of the spare wheel in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_tire_front_left_measurements: {
    name: "photo_tire_front_left_measurements",
    position: 700,
    position_admin: 50,
    label: "front left tire measurements",
    group: "tire-sizes",
    description: "A photo showing the measurements of the front left tire.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_tire_rear_left: {
    name: "photo_tire_rear_left",
    position: 710,
    position_admin: 110,
    label: "rear left tire photo",
    group: "tire-sizes",
    description: "A photo showing the rear left tire of the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_front_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_front_right",
    position: 720,
    position_admin: 760,
    label: "tread condition front tires right",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the front tires right.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_front_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_front_left",
    position: 730,
    position_admin: 1190,
    label: "tread condition front tires left",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the front tires left.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_second_axle_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_second_axle_left",
    position: 740,
    position_admin: 1190,
    label: "tread condition second axle tires left",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the second axle tires left.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_second_axle_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_second_axle_right",
    position: 750,
    position_admin: 1200,
    label: "tread condition second axle tires right",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the second axle tires right.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_third_axle_left: {
    name: "photo_of_tires_with_tread_pattern_and_condition_third_axle_left",
    position: 760,
    position_admin: 1210,
    label: "tread condition third axle tires left",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the third axle tires left.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_of_tires_with_tread_pattern_and_condition_third_axle_right: {
    name: "photo_of_tires_with_tread_pattern_and_condition_third_axle_right",
    position: 770,
    position_admin: 1220,
    label: "tread condition third axle tires right",
    group: "tire-sizes",
    description: "A photo showing the tread pattern and condition of the third axle tires right.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  // Undercarriage
  photo_undercarriage_front_part_from_front: {
    name: "photo_undercarriage_front_part_from_front",
    position: 780,
    position_admin: 740,
    label: "front undercarriage from front",
    group: "undercarriage",
    description: "A photo showing the front part of the undercarriage from the front.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_side_right: {
    name: "photo_undercarriage_axle_front_side_right",
    position: 790,
    position_admin: 770,
    label: "front axle right side",
    group: "undercarriage",
    description: "A photo of the front axle from the right side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_discs_right: {
    name: "photo_front_discs_right",
    position: 800,
    position_admin: 780,
    label: "front discs right",
    group: "undercarriage",
    description: "A photo of the right front brake discs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_brake_calipers_right: {
    name: "photo_front_brake_calipers_right",
    position: 810,
    position_admin: 790,
    label: "front brake calipers right",
    group: "undercarriage",
    description: "A photo of the right front brake calipers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_shock_absorbers_if_separate_from_springs_right: {
    name: "photo_front_shock_absorbers_if_separate_from_springs_right",
    position: 820,
    position_admin: 800,
    label: "front shock absorbers right",
    group: "undercarriage",
    description: "A photo of the right front shock absorbers, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_air_springs_or_group_of_springs_and_shock_absorbers_right: {
    name: "photo_front_air_springs_or_group_of_springs_and_shock_absorbers_right",
    position: 830,
    position_admin: 810,
    label: "front air springs right",
    group: "undercarriage",
    description: "A photo of the right front air springs or group of springs and shock absorbers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_central: {
    name: "photo_undercarriage_axle_front_central",
    position: 840,
    position_admin: 820,
    label: "front axle central",
    group: "undercarriage",
    description: "A photo of the front axle from the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_front_side_left: {
    name: "photo_undercarriage_axle_front_side_left",
    position: 850,
    position_admin: 830,
    label: "front axle left side",
    group: "undercarriage",
    description: "A photo of the front axle from the left side of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_discs_left: {
    name: "photo_front_discs_left",
    position: 860,
    position_admin: 840,
    label: "front discs left",
    group: "undercarriage",
    description: "A photo of the left front brake discs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_brake_calipers_left: {
    name: "photo_front_brake_calipers_left",
    position: 870,
    position_admin: 850,
    label: "front brake calipers left",
    group: "undercarriage",
    description: "A photo of the left front brake calipers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_shock_absorbers_if_separate_from_springs_left: {
    name: "photo_front_shock_absorbers_if_separate_from_springs_left",
    position: 880,
    position_admin: 860,
    label: "front shock absorbers left",
    group: "undercarriage",
    description: "A photo of the left front shock absorbers, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_front_air_springs_or_group_of_springs_and_shock_absorbers_left: {
    name: "photo_front_air_springs_or_group_of_springs_and_shock_absorbers_left",
    position: 890,
    position_admin: 870,
    label: "front air springs left",
    group: "undercarriage",
    description: "A photo of the left front air springs or group of springs and shock absorbers.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_central: {
    name: "photo_undercarriage_central",
    position: 900,
    position_admin: 880,
    label: "central undercarriage photo",
    group: "undercarriage",
    description: "A photo of the central part of the undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_axle_central_right: {
    name: "photo_discs_axle_central_right",
    position: 910,
    position_admin: 890,
    label: "axle 2 discs right",
    group: "undercarriage",
    description: "A photo of the right brake discs on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_axle_central_right: {
    name: "photo_caliper_brakes_axle_central_right",
    position: 920,
    position_admin: 900,
    label: "axle 2 caliper brakes right",
    group: "undercarriage",
    description: "A photo of the right brake calipers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_right_1: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_right_1",
    position: 930,
    position_admin: 910,
    label: "axle 2 shock absorbers 1 right",
    group: "undercarriage",
    description: "A photo of the first right shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_right_2: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_right_2",
    position: 940,
    position_admin: 920,
    label: "axle 2 shock absorbers 2 left",
    group: "undercarriage",
    description: "A photo of the second right shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_1: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_1",
    position: 950,
    position_admin: 930,
    label: "axel 2 air springs 1 right",
    group: "undercarriage",
    description: "A photo of the first right air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_2: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_right_2",
    position: 960,
    position_admin: 940,
    label: "axel 2 air springs 2 right",
    group: "undercarriage",
    description: "A photo of the second right air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_axle_central_left: {
    name: "photo_discs_axle_central_left",
    position: 970,
    position_admin: 950,
    label: "axle 2 discs left",
    group: "undercarriage",
    description: "A photo of the left brake discs on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_axle_central_left: {
    name: "photo_caliper_brakes_axle_central_left",
    position: 980,
    position_admin: 960,
    label: "axle 2 caliper brakes left",
    group: "undercarriage",
    description: "A photo of the left brake calipers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_left_1: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_left_1",
    position: 990,
    position_admin: 970,
    label: "axle 2 shock absorbers 1 left",
    group: "undercarriage",
    description: "A photo of the first left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_1: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_1",
    position: 1e3,
    position_admin: 980,
    label: "axel 2 air springs 1 left",
    group: "undercarriage",
    description: "A photo of the first left air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_shock_absorbers_central_axle_if_separate_from_springs_left_2: {
    name: "photo_shock_absorbers_central_axle_if_separate_from_springs_left_2",
    position: 1010,
    position_admin: 990,
    label: "axle 2 shock absorbers 2 left",
    group: "undercarriage",
    description: "A photo of the second left shock absorbers on the axle 2, if they are separate from the springs.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_2: {
    name: "photo_air_springs_central_axle_or_group_of_springs_and_shock_absorbers_left_2",
    position: 1020,
    position_admin: 1e3,
    label: "axel 2 air springs 2 left",
    group: "undercarriage",
    description: "A photo of the second left air springs or group of springs and shock absorbers on the axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_central: {
    name: "photo_undercarriage_axle_rear_central",
    position: 1030,
    position_admin: 1010,
    label: "axle 3 central",
    group: "undercarriage",
    description: "A photo of the central part of the axle 3 undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_side_right: {
    name: "photo_undercarriage_axle_rear_side_right",
    position: 1040,
    position_admin: 1020,
    label: "axle 3 right side",
    group: "undercarriage",
    description: "A photo of the right side of the axle 3 undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_rear_right: {
    name: "photo_discs_rear_right",
    position: 1050,
    position_admin: 1030,
    label: "axel 3  discs right",
    group: "undercarriage",
    description: "A photo of the right brake discs axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_rear_right: {
    name: "photo_caliper_brakes_rear_right",
    position: 1060,
    position_admin: 1040,
    label: "axel 3 caliper brakes right",
    group: "undercarriage",
    description: "A photo of the right caliper brakes axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_right_1: {
    name: "photo_rear_shock_absorbers_right_1",
    position: 1070,
    position_admin: 1050,
    label: "axel 3 shock absorbers 1 right",
    group: "undercarriage",
    description: "A photo of the right shock absorbers (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_right_1: {
    name: "photo_rear_air_springs_if_present_right_1",
    position: 1080,
    position_admin: 1060,
    label: "axle 3 air springs 1 right",
    group: "undercarriage",
    description: "A photo of the right air springs if present (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_right_2: {
    name: "photo_rear_shock_absorbers_right_2",
    position: 1090,
    position_admin: 1070,
    label: "axel 3 shock absorbers 2 right",
    group: "undercarriage",
    description: "A photo of the right shock absorbers (position 2) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_right_2: {
    name: "photo_rear_air_springs_if_present_right_2",
    position: 1100,
    position_admin: 1080,
    label: "axle 3 air springs 2 right",
    group: "undercarriage",
    description: "A photo of the right air springs if present (position 2) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_leaf_spring_if_present_right: {
    name: "photo_rear_leaf_spring_if_present_right",
    position: 1110,
    position_admin: 1090,
    label: "axel 2 leaf spring right",
    group: "undercarriage",
    description: "A photo of the right leaf spring if present axle 2.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_undercarriage_axle_rear_side_left: {
    name: "photo_undercarriage_axle_rear_side_left",
    position: 1120,
    position_admin: 1100,
    label: "axle 3 left side",
    group: "undercarriage",
    description: "A photo of the left side of the axle 3 undercarriage.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_discs_rear_left: {
    name: "photo_discs_rear_left",
    position: 1130,
    position_admin: 1110,
    label: "axel 3 discs left",
    group: "undercarriage",
    description: "A photo of the left brake discs axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_caliper_brakes_rear_left: {
    name: "photo_caliper_brakes_rear_left",
    position: 1140,
    position_admin: 1120,
    label: "axel 3 caliper brakes left",
    group: "undercarriage",
    description: "A photo of the left caliper brakes axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_left_1: {
    name: "photo_rear_shock_absorbers_left_1",
    position: 1150,
    position_admin: 1130,
    label: "axel 3 shock absorbers 1 left",
    group: "undercarriage",
    description: "A photo of the left shock absorbers (position 1) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_shock_absorbers_left_2: {
    name: "photo_rear_shock_absorbers_left_2",
    position: 1160,
    position_admin: 1140,
    label: "axel 3 shock absorbers 2 left",
    group: "undercarriage",
    description: "A photo of the left shock absorbers (position 2) axel 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_left_1: {
    name: "photo_rear_air_springs_if_present_left_1",
    position: 1170,
    position_admin: 1150,
    label: "axle 3 air springs 1 left",
    group: "undercarriage",
    description: "A photo of the left air springs if present (position 1) axle 3.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_air_springs_if_present_left_2: {
    name: "photo_rear_air_springs_if_present_left_2",
    position: 1180,
    position_admin: 1160,
    label: "axle 3 air springs 2 left",
    group: "undercarriage",
    description: "A photo of the left rear air springs if present (position 2).",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_rear_leaf_spring_if_present_left: {
    name: "photo_rear_leaf_spring_if_present_left",
    position: 1190,
    position_admin: 1170,
    label: "axel 3 leaf spring left",
    group: "undercarriage",
    description: "A photo of the left leaf spring if present. Axle 3",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_differential: {
    name: "photo_differential",
    position: 1200,
    position_admin: 1180,
    label: "differential photo",
    group: "undercarriage",
    description: "A photo of the vehicle's differential.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_gearbox: {
    name: "photo_gearbox",
    position: 1210,
    position_admin: 1230,
    label: "gearbox photo",
    group: "undercarriage",
    description: "A photo of the vehicle's gearbox.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_plate_gearbox: {
    name: "photo_plate_gearbox",
    position: 1220,
    position_admin: 1240,
    label: "gearbox plate photo",
    group: "undercarriage",
    description: "A photo of the vehicle's gearbox plate.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_driveshaft: {
    name: "photo_driveshaft",
    position: 1230,
    position_admin: 1250,
    label: "driveshaft photo",
    group: "undercarriage",
    description: "A photo of the vehicle's driveshaft.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_engine_below_without_protection: {
    name: "photo_engine_below_without_protection",
    position: 1240,
    position_admin: 1260,
    label: "engine without protection",
    group: "undercarriage",
    description: "A photo showing the engine from below without any protection.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_exhaust: {
    name: "photo_exhaust",
    position: 1250,
    position_admin: 1270,
    label: "exhaust photo",
    group: "undercarriage",
    description: "A photo showing the vehicle's exhaust.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_axle_central_18_meters: {
    name: "photo_axle_central_18_meters",
    position: 1260,
    position_admin: 1280,
    label: "central axle (18m)",
    group: "undercarriage",
    description: "A photo of the central axle for 18-meter vehicles.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  photo_bellows_turntable_18_meters: {
    name: "photo_bellows_turntable_18_meters",
    position: 1270,
    position_admin: 1290,
    label: "bellows turntable (18m)",
    group: "undercarriage",
    description: "A photo showing the bellows of the turntable for 18-meter vehicles.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  },
  // Technical Data
  photo_chassis_vin: {
    name: "photo_chassis_vin",
    position: 1280,
    position_admin: 1300,
    label: "chassis VIN photo",
    group: "technical-data",
    description: "A photo of the vehicle's chassis VIN.",
    requiredForToBeScrapped: !0,
    performTextInpaint: !1
  },
  photo_any_devices_onboard_3: {
    name: "photo_any_devices_onboard_3",
    position: 1290,
    position_admin: 1310,
    label: "onboard devices 3",
    group: "technical-data",
    description: "A photo of any onboard devices in the vehicle.",
    performTextInpaint: !1,
    requiredForToBeScrapped: !1
  }
}, T1 = {
  photo_cover_base: {
    name: "photo_cover_base",
    position: 2e3,
    position_admin: 2e3,
    label: "Base cover photo",
    group: "cover",
    description: "The photo displayed in the listing page (default: photo_3_4_front_side_right_doors_closed)",
    performTextInpaint: !0
  },
  photo_cover_hover: {
    name: "photo_cover_hover",
    position: 2010,
    position_admin: 2010,
    label: "Hover cover photo",
    group: "cover",
    description: "The photo usually on mouse hover in the listing page, (default: photo_front)",
    performTextInpaint: !0
  }
}, JS = [
  {
    name: "Baden-Württemberg",
    code: "DE-BW",
    provinces: [{ name: "Baden-Württemberg", code: "BW" }]
  },
  {
    name: "Bayern",
    code: "DE-BY",
    provinces: [{ name: "Bayern", code: "BY" }]
  },
  {
    name: "Berlin",
    code: "DE-BE",
    provinces: [{ name: "Berlin", code: "BE" }]
  },
  {
    name: "Brandenburg",
    code: "DE-BB",
    provinces: [{ name: "Brandenburg", code: "BB" }]
  },
  {
    name: "Bremen",
    code: "DE-HB",
    provinces: [{ name: "Bremen", code: "HB" }]
  },
  {
    name: "Hamburg",
    code: "DE-HH",
    provinces: [{ name: "Hamburg", code: "HH" }]
  },
  {
    name: "Hessen",
    code: "DE-HE",
    provinces: [{ name: "Hessen", code: "HE" }]
  },
  {
    name: "Mecklenburg-Vorpommern",
    code: "DE-MV",
    provinces: [{ name: "Mecklenburg-Vorpommern", code: "MV" }]
  },
  {
    name: "Niedersachsen",
    code: "DE-NI",
    provinces: [{ name: "Niedersachsen", code: "NI" }]
  },
  {
    name: "Nordrhein-Westfalen",
    code: "DE-NW",
    provinces: [{ name: "Nordrhein-Westfalen", code: "NW" }]
  },
  {
    name: "Rheinland-Pfalz",
    code: "DE-RP",
    provinces: [{ name: "Rheinland-Pfalz", code: "RP" }]
  },
  {
    name: "Saarland",
    code: "DE-SL",
    provinces: [{ name: "Saarland", code: "SL" }]
  },
  {
    name: "Sachsen",
    code: "DE-SN",
    provinces: [{ name: "Sachsen", code: "SN" }]
  },
  {
    name: "Sachsen-Anhalt",
    code: "DE-ST",
    provinces: [{ name: "Sachsen-Anhalt", code: "ST" }]
  },
  {
    name: "Schleswig-Holstein",
    code: "DE-SH",
    provinces: [{ name: "Schleswig-Holstein", code: "SH" }]
  },
  {
    name: "Thüringen",
    code: "DE-TH",
    provinces: [{ name: "Thüringen", code: "TH" }]
  }
], jS = [
  {
    name: "Abruzzo",
    code: "IT-65",
    provinces: [
      { name: "L'Aquila", code: "AQ" },
      { name: "Chieti", code: "CH" },
      { name: "Pescara", code: "PE" },
      { name: "Teramo", code: "TE" }
    ]
  },
  {
    name: "Basilicata",
    code: "IT-77",
    provinces: [
      { name: "Matera", code: "MT" },
      { name: "Potenza", code: "PZ" }
    ]
  },
  {
    name: "Calabria",
    code: "IT-78",
    provinces: [
      { name: "Cosenza", code: "CS" },
      { name: "Catanzaro", code: "CZ" },
      { name: "Crotone", code: "KR" },
      { name: "Reggio Calabria", code: "RC" },
      { name: "Vibo Valentia", code: "VV" }
    ]
  },
  {
    name: "Campania",
    code: "IT-72",
    provinces: [
      { name: "Avellino", code: "AV" },
      { name: "Benevento", code: "BN" },
      { name: "Caserta", code: "CE" },
      { name: "Napoli", code: "NA" },
      { name: "Salerno", code: "SA" }
    ]
  },
  {
    name: "Emilia-Romagna",
    code: "IT-45",
    provinces: [
      { name: "Bologna", code: "BO" },
      { name: "Forlì-Cesena", code: "FC" },
      { name: "Ferrara", code: "FE" },
      { name: "Modena", code: "MO" },
      { name: "Piacenza", code: "PC" },
      { name: "Parma", code: "PR" },
      { name: "Ravenna", code: "RA" },
      { name: "Reggio Emilia", code: "RE" },
      { name: "Rimini", code: "RN" }
    ]
  },
  {
    name: "Friuli-Venezia Giulia",
    code: "IT-36",
    provinces: [
      { name: "Gorizia", code: "GO" },
      { name: "Pordenone", code: "PN" },
      { name: "Trieste", code: "TS" },
      { name: "Udine", code: "UD" }
    ]
  },
  {
    name: "Lazio",
    code: "IT-62",
    provinces: [
      { name: "Frosinone", code: "FR" },
      { name: "Latina", code: "LT" },
      { name: "Rieti", code: "RI" },
      { name: "Roma", code: "RM" },
      { name: "Viterbo", code: "VT" }
    ]
  },
  {
    name: "Liguria",
    code: "IT-42",
    provinces: [
      { name: "Genova", code: "GE" },
      { name: "Imperia", code: "IM" },
      { name: "La Spezia", code: "SP" },
      { name: "Savona", code: "SV" }
    ]
  },
  {
    name: "Lombardia",
    code: "IT-25",
    provinces: [
      { name: "Bergamo", code: "BG" },
      { name: "Brescia", code: "BS" },
      { name: "Como", code: "CO" },
      { name: "Cremona", code: "CR" },
      { name: "Lecco", code: "LC" },
      { name: "Lodi", code: "LO" },
      { name: "Monza e della Brianza", code: "MB" },
      { name: "Milano", code: "MI" },
      { name: "Mantova", code: "MN" },
      { name: "Pavia", code: "PV" },
      { name: "Sondrio", code: "SO" },
      { name: "Varese", code: "VA" }
    ]
  },
  {
    name: "Marche",
    code: "IT-57",
    provinces: [
      { name: "Ancona", code: "AN" },
      { name: "Ascoli Piceno", code: "AP" },
      { name: "Fermo", code: "FM" },
      { name: "Macerata", code: "MC" },
      { name: "Pesaro e Urbino", code: "PU" }
    ]
  },
  {
    name: "Molise",
    code: "IT-67",
    provinces: [
      { name: "Campobasso", code: "CB" },
      { name: "Isernia", code: "IS" }
    ]
  },
  {
    name: "Piemonte",
    code: "IT-21",
    provinces: [
      { name: "Alessandria", code: "AL" },
      { name: "Asti", code: "AT" },
      { name: "Biella", code: "BI" },
      { name: "Cuneo", code: "CN" },
      { name: "Novara", code: "NO" },
      { name: "Torino", code: "TO" },
      { name: "Verbano-Cusio-Ossola", code: "VB" },
      { name: "Vercelli", code: "VC" }
    ]
  },
  {
    name: "Puglia",
    code: "IT-75",
    provinces: [
      { name: "Bari", code: "BA" },
      { name: "Brindisi", code: "BR" },
      { name: "Barletta-Andria-Trani", code: "BT" },
      { name: "Foggia", code: "FG" },
      { name: "Lecce", code: "LE" },
      { name: "Taranto", code: "TA" }
    ]
  },
  {
    name: "Sardegna",
    code: "IT-88",
    provinces: [
      { name: "Cagliari", code: "CA" },
      { name: "Nuoro", code: "NU" },
      { name: "Oristano", code: "OR" },
      { name: "Sassari", code: "SS" },
      { name: "Carbonia-Iglesias", code: "CI" },
      { name: "Olbia-Tempio", code: "OT" },
      { name: "Medio Campidano", code: "VS" },
      { name: "Ogliastra", code: "OG" }
    ]
  },
  {
    name: "Sicilia",
    code: "IT-82",
    provinces: [
      { name: "Agrigento", code: "AG" },
      { name: "Caltanissetta", code: "CL" },
      { name: "Catania", code: "CT" },
      { name: "Enna", code: "EN" },
      { name: "Messina", code: "ME" },
      { name: "Palermo", code: "PA" },
      { name: "Ragusa", code: "RG" },
      { name: "Siracusa", code: "SR" },
      { name: "Trapani", code: "TP" }
    ]
  },
  {
    name: "Toscana",
    code: "IT-52",
    provinces: [
      { name: "Arezzo", code: "AR" },
      { name: "Firenze", code: "FI" },
      { name: "Grosseto", code: "GR" },
      { name: "Livorno", code: "LI" },
      { name: "Lucca", code: "LU" },
      { name: "Massa-Carrara", code: "MS" },
      { name: "Pisa", code: "PI" },
      { name: "Prato", code: "PO" },
      { name: "Pistoia", code: "PT" },
      { name: "Siena", code: "SI" }
    ]
  },
  {
    name: "Trentino-Alto Adige, Trentino-Südtirol",
    code: "IT-32",
    provinces: [
      { name: "Bolzano", code: "BZ" },
      { name: "Trento", code: "TN" }
    ]
  },
  {
    name: "Umbria",
    code: "IT-55",
    provinces: [
      { name: "Perugia", code: "PG" },
      { name: "Terni", code: "TR" }
    ]
  },
  { name: "Valle d'Aosta, Vallée d'Aoste", code: "IT-23", provinces: [{ name: "Aosta", code: "AO" }] },
  {
    name: "Veneto",
    code: "IT-34",
    provinces: [
      { name: "Belluno", code: "BL" },
      { name: "Padova", code: "PD" },
      { name: "Rovigo", code: "RO" },
      { name: "Treviso", code: "TV" },
      { name: "Venezia", code: "VE" },
      { name: "Vicenza", code: "VI" },
      { name: "Verona", code: "VR" }
    ]
  }
], YS = [
  {
    name: "Dolnośląskie",
    code: "PL-02",
    provinces: [{ name: "Dolnośląskie", code: "DS" }]
  },
  {
    name: "Kujawsko-Pomorskie",
    code: "PL-04",
    provinces: [{ name: "Kujawsko-Pomorskie", code: "KP" }]
  },
  {
    name: "Lubelskie",
    code: "PL-06",
    provinces: [{ name: "Lubelskie", code: "LU" }]
  },
  {
    name: "Lubuskie",
    code: "PL-08",
    provinces: [{ name: "Lubuskie", code: "LB" }]
  },
  {
    name: "Łódzkie",
    code: "PL-10",
    provinces: [{ name: "Łódzkie", code: "LD" }]
  },
  {
    name: "Małopolskie",
    code: "PL-12",
    provinces: [{ name: "Małopolskie", code: "MP" }]
  },
  {
    name: "Mazowieckie",
    code: "PL-14",
    provinces: [{ name: "Mazowieckie", code: "MZ" }]
  },
  {
    name: "Opolskie",
    code: "PL-16",
    provinces: [{ name: "Opolskie", code: "OP" }]
  },
  {
    name: "Podkarpackie",
    code: "PL-18",
    provinces: [{ name: "Podkarpackie", code: "PK" }]
  },
  {
    name: "Podlaskie",
    code: "PL-20",
    provinces: [{ name: "Podlaskie", code: "PD" }]
  },
  {
    name: "Pomorskie",
    code: "PL-22",
    provinces: [{ name: "Pomorskie", code: "PM" }]
  },
  {
    name: "Śląskie",
    code: "PL-24",
    provinces: [{ name: "Śląskie", code: "SL" }]
  },
  {
    name: "Świętokrzyskie",
    code: "PL-26",
    provinces: [{ name: "Świętokrzyskie", code: "SK" }]
  },
  {
    name: "Warmińsko-Mazurskie",
    code: "PL-28",
    provinces: [{ name: "Warmińsko-Mazurskie", code: "WM" }]
  },
  {
    name: "Wielkopolskie",
    code: "PL-30",
    provinces: [{ name: "Wielkopolskie", code: "WP" }]
  },
  {
    name: "Zachodniopomorskie",
    code: "PL-32",
    provinces: [{ name: "Zachodniopomorskie", code: "ZP" }]
  }
], XS = [
  {
    name: "Andalucía",
    code: "ES-AN",
    provinces: [
      { name: "Almería", code: "AL" },
      { name: "Cádiz", code: "CA" },
      { name: "Córdoba", code: "CO" },
      { name: "Granada", code: "GR" },
      { name: "Huelva", code: "H" },
      { name: "Jaén", code: "J" },
      { name: "Málaga", code: "MA" },
      { name: "Sevilla", code: "SE" }
    ]
  },
  {
    name: "Aragón",
    code: "ES-AR",
    provinces: [
      { name: "Huesca", code: "HU" },
      { name: "Teruel", code: "TE" },
      { name: "Zaragoza", code: "Z" }
    ]
  },
  {
    name: "Asturias",
    code: "ES-AS",
    provinces: [{ name: "Asturias", code: "AS" }]
  },
  {
    name: "Islas Baleares",
    code: "ES-IB",
    provinces: [{ name: "Islas Baleares", code: "IB" }]
  },
  {
    name: "País Vasco",
    code: "ES-PV",
    provinces: [
      { name: "Álava", code: "VI" },
      { name: "Bizkaia", code: "BI" },
      { name: "Gipuzkoa", code: "SS" }
    ]
  },
  {
    name: "Canarias",
    code: "ES-CN",
    provinces: [
      { name: "Las Palmas", code: "GC" },
      { name: "Santa Cruz de Tenerife", code: "TF" }
    ]
  },
  {
    name: "Cantabria",
    code: "ES-CB",
    provinces: [{ name: "Cantabria", code: "CB" }]
  },
  {
    name: "Castilla y León",
    code: "ES-CL",
    provinces: [
      { name: "Ávila", code: "AV" },
      { name: "Burgos", code: "BU" },
      { name: "León", code: "LE" },
      { name: "Palencia", code: "P" },
      { name: "Salamanca", code: "SA" },
      { name: "Segovia", code: "SG" },
      { name: "Soria", code: "SO" },
      { name: "Valladolid", code: "VA" },
      { name: "Zamora", code: "ZA" }
    ]
  },
  {
    name: "Castilla-La Mancha",
    code: "ES-CM",
    provinces: [
      { name: "Albacete", code: "AB" },
      { name: "Ciudad Real", code: "CR" },
      { name: "Cuenca", code: "CU" },
      { name: "Guadalajara", code: "GU" },
      { name: "Toledo", code: "TO" }
    ]
  },
  {
    name: "Cataluña",
    code: "ES-CT",
    provinces: [
      { name: "Barcelona", code: "B" },
      { name: "Girona", code: "GI" },
      { name: "Lleida", code: "L" },
      { name: "Tarragona", code: "T" }
    ]
  },
  {
    name: "Extremadura",
    code: "ES-EX",
    provinces: [
      { name: "Badajoz", code: "BA" },
      { name: "Cáceres", code: "CC" }
    ]
  },
  {
    name: "Galicia",
    code: "ES-GA",
    provinces: [
      { name: "A Coruña", code: "C" },
      { name: "Lugo", code: "LU" },
      { name: "Ourense", code: "OR" },
      { name: "Pontevedra", code: "PO" }
    ]
  },
  {
    name: "La Rioja",
    code: "ES-RI",
    provinces: [{ name: "La Rioja", code: "RI" }]
  },
  {
    name: "Comunidad de Madrid",
    code: "ES-MD",
    provinces: [{ name: "Madrid", code: "MD" }]
  },
  {
    name: "Región de Murcia",
    code: "ES-MC",
    provinces: [{ name: "Murcia", code: "MC" }]
  },
  {
    name: "Navarra",
    code: "ES-NC",
    provinces: [{ name: "Navarra", code: "NC" }]
  },
  {
    name: "Comunidad Valenciana",
    code: "ES-VC",
    provinces: [
      { name: "Alicante", code: "A" },
      { name: "Castellón", code: "CS" },
      { name: "Valencia", code: "V" }
    ]
  },
  {
    name: "Ceuta",
    code: "ES-CE",
    provinces: [{ name: "Ceuta", code: "CE" }]
  },
  {
    name: "Melilla",
    code: "ES-ML",
    provinces: [{ name: "Melilla", code: "ML" }]
  }
], QS = {
  AD: {
    i18nNames: {
      en: "Andorra",
      it: "Andorra",
      es: "Andorra",
      de: "Andorra",
      pl: "Andora",
      fr: "Andorre",
      nl: "Andorra",
      pt: "Andorra",
      cs: "Andorra",
      ro: "Andorra",
      ru: "Андорра"
    },
    rootIddCode: "+376",
    taxIdMandatory: !0,
    taxIdPattern: "^[A-Z]-\\d{6}-[A-Z]$",
    taxIdExample: "X-123456-Y"
  },
  AE: {
    i18nNames: {
      en: "United Arab Emirates",
      es: "Emiratos Árabes Unidos",
      it: "Emirati Arabi Uniti",
      de: "Vereinigte Arabische Emirate",
      pl: "Zjednoczone Emiraty Arabskie",
      fr: "Émirats arabes unis",
      nl: "Verenigde Arabische Emiraten",
      pt: "Emirados Árabes Unidos",
      cs: "Spojené arabské emiráty",
      ro: "Emiratele Arabe Unite",
      ru: "Объединённые Арабские Эмираты"
    },
    rootIddCode: "+971",
    taxIdMandatory: !1,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  AF: {
    i18nNames: {
      en: "Afghanistan",
      it: "Afghanistan",
      es: "Afganistán",
      de: "Afghanistan",
      pl: "Afganistan",
      fr: "Afghanistan",
      nl: "Afghanistan",
      pt: "Afeganistão",
      cs: "Afghánistán",
      ro: "Afganistan",
      ru: "Афганистан"
    },
    rootIddCode: "+93"
  },
  AG: {
    i18nNames: {
      en: "Antigua and Barbuda",
      es: "Antigua y Barbuda",
      it: "Antigua e Barbuda",
      de: "Antigua und Barbuda",
      pl: "Antigua i Barbuda",
      fr: "Antigua-et-Barbuda",
      nl: "Antigua en Barbuda",
      pt: "Antígua e Barbuda",
      cs: "Antigua a Barbuda",
      ro: "Antigua și Barbuda",
      ru: "Антигуа и Барбуда"
    },
    rootIddCode: "+1268"
  },
  AI: {
    i18nNames: {
      en: "Anguilla",
      it: "Anguilla",
      es: "Anguila",
      de: "Anguilla",
      pl: "Anguilla",
      fr: "Anguilla",
      nl: "Anguilla",
      pt: "Anguila",
      cs: "Anguilla",
      ro: "Anguilla",
      ru: "Ангилья"
    },
    rootIddCode: "+1264"
  },
  AL: {
    i18nNames: {
      en: "Albania",
      it: "Albania",
      es: "Albania",
      de: "Albanien",
      pl: "Albania",
      fr: "Albanie",
      nl: "Albanië",
      pt: "Albânia",
      cs: "Albánie",
      ro: "Albania",
      ru: "Албания"
    },
    rootIddCode: "+355",
    taxIdMandatory: !0,
    taxIdPattern: "^[JKLM]\\d{8}[A-Z]$",
    taxIdExample: "J12345678K"
  },
  AM: {
    i18nNames: {
      en: "Armenia",
      it: "Armenia",
      es: "Armenia",
      de: "Armenien",
      pl: "Armenia",
      fr: "Arménie",
      nl: "Armenië",
      pt: "Arménia",
      cs: "Arménie",
      ro: "Armenia",
      ru: "Армения"
    },
    rootIddCode: "+374"
  },
  AO: {
    i18nNames: {
      en: "Angola",
      it: "Angola",
      es: "Angola",
      de: "Angola",
      pl: "Angola",
      fr: "Angola",
      nl: "Angola",
      pt: "Angola",
      cs: "Angola",
      ro: "Angola",
      ru: "Ангола"
    },
    rootIddCode: "+244"
  },
  AQ: {
    i18nNames: {
      en: "Antarctica",
      it: "Antartide",
      es: "Antártida",
      de: "Antarktis",
      pl: "Antarktyka",
      fr: "Antarctique",
      nl: "Antarctica",
      pt: "Antártica",
      cs: "Antarktida",
      ro: "Antarctica",
      ru: "Антарктида"
    },
    rootIddCode: "undefined"
  },
  AR: {
    i18nNames: {
      en: "Argentina",
      it: "Argentina",
      es: "Argentina",
      de: "Argentinien",
      pl: "Argentyna",
      fr: "Argentine",
      nl: "Argentinië",
      pt: "Argentina",
      cs: "Argentina",
      ro: "Argentina",
      ru: "Аргентина"
    },
    rootIddCode: "+54"
  },
  AS: {
    i18nNames: {
      en: "American Samoa",
      it: "Samoa Americane",
      es: "Samoa Americana",
      de: "Amerikanisch-Samoa",
      pl: "Samoa Amerykańskie",
      fr: "Samoa américaines",
      nl: "Amerikaans-Samoa",
      pt: "Samoa Americana",
      cs: "Americká Samoa",
      ro: "Samoa Americană",
      ru: "Американское Самоа"
    },
    rootIddCode: "+1684"
  },
  AT: {
    i18nNames: {
      en: "Austria",
      it: "Austria",
      es: "Austria",
      de: "Österreich",
      pl: "Austria",
      fr: "Autriche",
      nl: "Oostenrijk",
      pt: "Áustria",
      cs: "Rakousko",
      ro: "Austria",
      ru: "Австрия"
    },
    rootIddCode: "+43",
    blocMemberships: ["EU"],
    taxIdMandatory: !1,
    taxIdPattern: "^ATU\\d{8}$",
    taxIdExample: "ATU12345678"
  },
  AU: {
    i18nNames: {
      en: "Australia",
      it: "Australia",
      es: "Australia",
      de: "Australien",
      pl: "Australia",
      fr: "Australie",
      nl: "Australië",
      pt: "Austrália",
      cs: "Austrálie",
      ro: "Australia",
      ru: "Австралия"
    },
    rootIddCode: "+61"
  },
  AW: {
    i18nNames: {
      en: "Aruba",
      it: "Aruba",
      es: "Aruba",
      de: "Aruba",
      pl: "Aruba",
      fr: "Aruba",
      nl: "Aruba",
      pt: "Aruba",
      cs: "Aruba",
      ro: "Aruba",
      ru: "Аруба"
    },
    rootIddCode: "+297"
  },
  AX: {
    i18nNames: {
      en: "Åland Islands",
      it: "Isole Aland",
      es: "Islas Åland",
      de: "Ålandinseln",
      pl: "Wyspy Alandzkie",
      fr: "Îles Åland",
      nl: "Ålandeilanden",
      pt: "Ilhas Åland",
      cs: "Ålandské ostrovy",
      ro: "Insulele Åland",
      ru: "Аландские острова"
    },
    rootIddCode: "+35818",
    blocMemberships: ["EU"]
  },
  AZ: {
    i18nNames: {
      en: "Azerbaijan",
      it: "Azerbaijan",
      es: "Azerbaiyán",
      de: "Aserbaidschan",
      pl: "Azerbejdżan",
      fr: "Azerbaïdjan",
      nl: "Azerbeidzjan",
      pt: "Azerbaijão",
      cs: "Ázerbájdžán",
      ro: "Azerbaidjan",
      ru: "Азербайджан"
    },
    rootIddCode: "+994"
  },
  BB: {
    i18nNames: {
      en: "Barbados",
      it: "Barbados",
      es: "Barbados",
      de: "Barbados",
      pl: "Barbados",
      fr: "Barbade",
      nl: "Barbados",
      pt: "Barbados",
      cs: "Barbados",
      ro: "Barbados",
      ru: "Барбадос"
    },
    rootIddCode: "+1246"
  },
  BD: {
    i18nNames: {
      en: "Bangladesh",
      it: "Bangladesh",
      es: "Bangladés",
      de: "Bangladesch",
      pl: "Bangladesz",
      fr: "Bangladesh",
      nl: "Bangladesh",
      pt: "Bangladesh",
      cs: "Bangladéš",
      ro: "Bangladesh",
      ru: "Бангладеш"
    },
    rootIddCode: "+880"
  },
  BE: {
    i18nNames: {
      en: "Belgium",
      it: "Belgio",
      es: "Bélgica",
      de: "Belgien",
      pl: "Belgia",
      fr: "Belgique",
      nl: "België",
      pt: "Bélgica",
      cs: "Belgie",
      ro: "Belgia",
      ru: "Бельгия"
    },
    rootIddCode: "+32",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^BE\\d{10}$",
    taxIdExample: "BE0123456789"
  },
  BF: {
    i18nNames: {
      en: "Burkina Faso",
      it: "Burkina Faso",
      es: "Burkina Faso",
      de: "Burkina Faso",
      pl: "Burkina Faso",
      fr: "Burkina Faso",
      nl: "Burkina Faso",
      pt: "Burquina Faso",
      cs: "Burkina Faso",
      ro: "Burkina Faso",
      ru: "Буркина-Фасо"
    },
    rootIddCode: "+226"
  },
  BG: {
    i18nNames: {
      en: "Bulgaria",
      it: "Bulgaria",
      es: "Bulgaria",
      de: "Bulgarien",
      pl: "Bułgaria",
      fr: "Bulgarie",
      nl: "Bulgarije",
      pt: "Bulgária",
      cs: "Bulharsko",
      ro: "Bulgaria",
      ru: "Болгария"
    },
    rootIddCode: "+359",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^BG(\\d{9}|\\d{10})$",
    taxIdExample: "BG123456789"
  },
  BH: {
    i18nNames: {
      en: "Bahrain",
      it: "Bahrein",
      es: "Baréin",
      de: "Bahrain",
      pl: "Bahrajn",
      fr: "Bahreïn",
      nl: "Bahrein",
      pt: "Bahrein",
      cs: "Bahrajn",
      ro: "Bahrein",
      ru: "Бахрейн"
    },
    rootIddCode: "+973",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  BI: {
    i18nNames: {
      en: "Burundi",
      it: "Burundi",
      es: "Burundi",
      de: "Burundi",
      pl: "Burundi",
      fr: "Burundi",
      nl: "Burundi",
      pt: "Burundi",
      cs: "Burundi",
      ro: "Burundi",
      ru: "Бурунди"
    },
    rootIddCode: "+257"
  },
  BJ: {
    i18nNames: {
      en: "Benin",
      it: "Benin",
      es: "Benín",
      de: "Benin",
      pl: "Benin",
      fr: "Bénin",
      nl: "Benin",
      pt: "Benim",
      cs: "Benin",
      ro: "Benin",
      ru: "Бенин"
    },
    rootIddCode: "+229"
  },
  BL: {
    i18nNames: {
      en: "Saint Barthélemy",
      es: "San Bartolomé",
      it: "Antille Francesi",
      de: "Saint-Barthélemy",
      pl: "Saint-Barthélemy",
      fr: "Saint-Barthélemy",
      nl: "Saint-Barthélemy",
      pt: "São Bartolomeu",
      cs: "Svatý Bartoloměj",
      ro: "Sfântul Bartolomeu",
      ru: "Сен-Бартелеми"
    },
    rootIddCode: "+590"
  },
  BM: {
    i18nNames: {
      en: "Bermuda",
      it: "Bermuda",
      es: "Bermudas",
      de: "Bermuda",
      pl: "Bermudy",
      fr: "Bermudes",
      nl: "Bermuda",
      pt: "Bermudas",
      cs: "Bermudy",
      ro: "Bermuda",
      ru: "Бермуды"
    },
    rootIddCode: "+1441"
  },
  BN: {
    i18nNames: {
      en: "Brunei",
      it: "Brunei",
      es: "Brunéi",
      de: "Brunei",
      pl: "Brunei",
      fr: "Brunei",
      nl: "Brunei",
      pt: "Brunei",
      cs: "Brunej",
      ro: "Brunei",
      ru: "Бруней"
    },
    rootIddCode: "+673"
  },
  BO: {
    i18nNames: {
      en: "Bolivia",
      it: "Bolivia",
      es: "Bolivia",
      de: "Bolivien",
      pl: "Boliwia",
      fr: "Bolivie",
      nl: "Bolivia",
      pt: "Bolívia",
      cs: "Bolívie",
      ro: "Bolivia",
      ru: "Боливия"
    },
    rootIddCode: "+591"
  },
  BQ: {
    i18nNames: {
      en: "Caribbean Netherlands",
      es: "Bonaire, San Eustaquio y Saba",
      it: "Paesi Bassi caraibici",
      de: "Karibische Niederlande",
      pl: "Niderlandy Karaibskie",
      fr: "Pays-Bas caribéens",
      nl: "Caribisch Nederland",
      pt: "Países Baixos Caribenhos",
      cs: "Karibské Nizozemsko",
      ro: "Antilele Olandeze",
      ru: "Карибские Нидерланды"
    },
    rootIddCode: "+599"
  },
  BR: {
    i18nNames: {
      en: "Brazil",
      it: "Brasile",
      es: "Brasil",
      de: "Brasilien",
      pl: "Brazylia",
      fr: "Brésil",
      nl: "Brazilië",
      pt: "Brasil",
      cs: "Brazílie",
      ro: "Brazilia",
      ru: "Бразилия"
    },
    rootIddCode: "+55"
  },
  BS: {
    i18nNames: {
      en: "Bahamas",
      it: "Bahamas",
      es: "Bahamas",
      de: "Bahamas",
      pl: "Bahamy",
      fr: "Bahamas",
      nl: "Bahama's",
      pt: "Bahamas",
      cs: "Bahamy",
      ro: "Bahamas",
      ru: "Багамы"
    },
    rootIddCode: "+1242"
  },
  BT: {
    i18nNames: {
      en: "Bhutan",
      it: "Bhutan",
      es: "Bután",
      de: "Bhutan",
      pl: "Bhutan",
      fr: "Bhoutan",
      nl: "Bhutan",
      pt: "Butão",
      cs: "Bhútán",
      ro: "Bhutan",
      ru: "Бутан"
    },
    rootIddCode: "+975"
  },
  BV: {
    i18nNames: {
      en: "Bouvet Island",
      it: "Isola Bouvet",
      es: "Isla Bouvet",
      de: "Bouvetinsel",
      pl: "Wyspa Bouveta",
      fr: "Île Bouvet",
      nl: "Bouveteiland",
      pt: "Ilha Bouvet",
      cs: "Bouvetův ostrov",
      ro: "Insula Bouvet",
      ru: "Остров Буве"
    },
    rootIddCode: "+47"
  },
  BW: {
    i18nNames: {
      en: "Botswana",
      it: "Botswana",
      es: "Botsuana",
      de: "Botswana",
      pl: "Botswana",
      fr: "Botswana",
      nl: "Botswana",
      pt: "Botsuana",
      cs: "Botswana",
      ro: "Botswana",
      ru: "Ботсвана"
    },
    rootIddCode: "+267"
  },
  BY: {
    i18nNames: {
      en: "Belarus",
      it: "Bielorussia",
      es: "Bielorrusia",
      de: "Weißrussland",
      pl: "Białoruś",
      fr: "Biélorussie",
      nl: "Wit-Rusland",
      pt: "Bielorrússia",
      cs: "Bělorusko",
      ro: "Belarus",
      ru: "Беларусь"
    },
    rootIddCode: "+375",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  BZ: {
    i18nNames: {
      en: "Belize",
      it: "Belize",
      es: "Belice",
      de: "Belize",
      pl: "Belize",
      fr: "Belize",
      nl: "Belize",
      pt: "Belize",
      cs: "Belize",
      ro: "Belize",
      ru: "Белиз"
    },
    rootIddCode: "+501"
  },
  CA: {
    i18nNames: {
      en: "Canada",
      it: "Canada",
      es: "Canadá",
      de: "Kanada",
      pl: "Kanada",
      fr: "Canada",
      nl: "Canada",
      pt: "Canadá",
      cs: "Kanada",
      ro: "Canada",
      ru: "Канада"
    },
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
    rootIddCode: "+1"
  },
  CC: {
    i18nNames: {
      en: "Cocos (Keeling) Islands",
      es: "Islas Cocos",
      it: "Isole Cocos e Keeling",
      de: "Kokosinseln",
      pl: "Wyspy Kokosowe",
      fr: "Îles Cocos",
      nl: "Cocoseilanden",
      pt: "Ilhas Cocos (Keeling)",
      cs: "Kokosové ostrovy",
      ro: "Insulele Cocos (Keeling)",
      ru: "Кокосовые (Килинг) острова"
    },
    rootIddCode: "+61"
  },
  CD: {
    i18nNames: {
      en: "DR Congo",
      it: "Congo (Rep. Dem.)",
      es: "República Democrática del Congo",
      de: "Demokratische Republik Kongo",
      pl: "Demokratyczna Republika Konga",
      fr: "RDC (République Démocratique du Congo)",
      nl: "Congo (DRC)",
      pt: "RD Congo",
      cs: "Demokratická republika Kongo",
      ro: "Congo (R.D.)",
      ru: "Демократическая Республика Конго"
    },
    rootIddCode: "+243"
  },
  CF: {
    i18nNames: {
      en: "Central African Republic",
      es: "República Centroafricana",
      it: "Repubblica Centrafricana",
      de: "Zentralafrikanische Republik",
      pl: "Republika Środkowoafrykańska",
      fr: "République centrafricaine",
      nl: "Centraal-Afrikaanse Republiek",
      pt: "República Centro-Africana",
      cs: "Středoafrická republika",
      ro: "Republica Centrafricană",
      ru: "Центральноафриканская Республика"
    },
    rootIddCode: "+236"
  },
  CG: {
    i18nNames: {
      en: "Republic of the Congo",
      it: "Congo",
      es: "República del Congo",
      de: "Republik Kongo",
      pl: "Kongo",
      fr: "République du Congo",
      nl: "Republiek Congo",
      pt: "República do Congo",
      cs: "Republika Kongo",
      ro: "Republica Congo",
      ru: "Республика Конго"
    },
    rootIddCode: "+242"
  },
  CH: {
    i18nNames: {
      en: "Switzerland",
      it: "Svizzera",
      es: "Suiza",
      de: "Schweiz",
      pl: "Szwajcaria",
      fr: "Suisse",
      nl: "Zwitserland",
      pt: "Suíça",
      cs: "Švýcarsko",
      ro: "Elveția",
      ru: "Швейцария"
    },
    rootIddCode: "+41",
    taxIdMandatory: !1,
    taxIdPattern: "^CHE\\d{9}(MWST|TVA|IVA)?$",
    taxIdExample: "CHE123456789MWST"
  },
  CI: {
    i18nNames: {
      en: "Ivory Coast",
      it: "Costa d'Avorio",
      es: "Costa de Marfil",
      de: "Elfenbeinküste",
      pl: "Wybrzeże Kości Słoniowej",
      fr: "Côte d'Ivoire",
      nl: "Ivoorkust",
      pt: "Costa do Marfim",
      cs: "Pobřeží slonoviny",
      ro: "Coasta de Fildeș",
      ru: "Кот-д’Ивуар"
    },
    rootIddCode: "+225"
  },
  CK: {
    i18nNames: {
      en: "Cook Islands",
      it: "Isole Cook",
      es: "Islas Cook",
      de: "Cookinseln",
      pl: "Wyspy Cooka",
      fr: "Îles Cook",
      nl: "Cookeilanden",
      pt: "Ilhas Cook",
      cs: "Cookovy ostrovy",
      ro: "Insulele Cook",
      ru: "Острова Кука"
    },
    rootIddCode: "+682"
  },
  CL: {
    i18nNames: {
      en: "Chile",
      it: "Cile",
      es: "Chile",
      de: "Chile",
      pl: "Chile",
      fr: "Chili",
      nl: "Chili",
      pt: "Chile",
      cs: "Chile",
      ro: "Chile",
      ru: "Чили"
    },
    rootIddCode: "+56"
  },
  CM: {
    i18nNames: {
      en: "Cameroon",
      it: "Camerun",
      es: "Camerún",
      de: "Kamerun",
      pl: "Kamerun",
      fr: "Cameroun",
      nl: "Kameroen",
      pt: "Camarões",
      cs: "Kamerun",
      ro: "Camerun",
      ru: "Камерун"
    },
    rootIddCode: "+237"
  },
  CN: {
    i18nNames: {
      en: "China",
      it: "Cina",
      es: "China",
      de: "China",
      pl: "Chiny",
      fr: "Chine",
      nl: "China",
      pt: "China",
      cs: "Čína",
      ro: "China",
      ru: "Китай"
    },
    rootIddCode: "+86"
  },
  CO: {
    i18nNames: {
      en: "Colombia",
      it: "Colombia",
      es: "Colombia",
      de: "Kolumbien",
      pl: "Kolumbia",
      fr: "Colombie",
      nl: "Colombia",
      pt: "Colômbia",
      cs: "Kolumbie",
      ro: "Columbia",
      ru: "Колумбия"
    },
    rootIddCode: "+57"
  },
  CR: {
    i18nNames: {
      en: "Costa Rica",
      it: "Costa Rica",
      es: "Costa Rica",
      de: "Costa Rica",
      pl: "Kostaryka",
      fr: "Costa Rica",
      nl: "Costa Rica",
      pt: "Costa Rica",
      cs: "Kostarika",
      ro: "Costa Rica",
      ru: "Коста-Рика"
    },
    rootIddCode: "+506"
  },
  CU: {
    i18nNames: {
      en: "Cuba",
      it: "Cuba",
      es: "Cuba",
      de: "Kuba",
      pl: "Kuba",
      fr: "Cuba",
      nl: "Cuba",
      pt: "Cuba",
      cs: "Kuba",
      ro: "Cuba",
      ru: "Куба"
    },
    rootIddCode: "+53"
  },
  CV: {
    i18nNames: {
      en: "Cape Verde",
      it: "Capo Verde",
      es: "Cabo Verde",
      de: "Kap Verde",
      pl: "Republika Zielonego Przylądka",
      fr: "Cap-Vert",
      nl: "Kaapverdië",
      pt: "Cabo Verde",
      cs: "Kapverdy",
      ro: "Capul Verde",
      ru: "Кабо-Верде"
    },
    rootIddCode: "+238"
  },
  CW: {
    i18nNames: {
      en: "Curaçao",
      it: "Curaçao",
      es: "Curazao",
      de: "Curaçao",
      pl: "Curaçao",
      fr: "Curaçao",
      nl: "Curaçao",
      pt: "Curaçau",
      cs: "Curaçao",
      ro: "Curaçao",
      ru: "Кюрасао"
    },
    rootIddCode: "+599"
  },
  CX: {
    i18nNames: {
      en: "Christmas Island",
      es: "Isla Christmas",
      it: "Isola di Natale",
      de: "Weihnachtsinsel",
      pl: "Wyspa Bożego Narodzenia",
      fr: "Île Christmas",
      nl: "Christmaseiland",
      pt: "Ilha Christmas",
      cs: "Vánoční ostrov",
      ro: "Insula Christmas",
      ru: "Остров Рождества"
    },
    rootIddCode: "+61"
  },
  CY: {
    i18nNames: {
      en: "Cyprus",
      it: "Cipro",
      es: "Chipre",
      de: "Zypern",
      pl: "Cypr",
      fr: "Chypre",
      nl: "Cyprus",
      pt: "Chipre",
      cs: "Kypr",
      ro: "Cipru",
      ru: "Кипр"
    },
    rootIddCode: "+357",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^CY\\d{8}[A-Z]$",
    taxIdExample: "CY12345678A"
  },
  CZ: {
    i18nNames: {
      en: "Czechia",
      it: "Cechia",
      es: "Chequia",
      de: "Tschechien",
      pl: "Czechy",
      fr: "Tchéquie",
      nl: "Tsjechië",
      pt: "Chéquia",
      cs: "Česko",
      ro: "Cehia",
      ru: "Чехия"
    },
    rootIddCode: "+420",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^CZ(\\d{8}|\\d{9}|\\d{10})$",
    taxIdExample: "CZ12345678"
  },
  DE: {
    i18nNames: {
      en: "Germany",
      it: "Germania",
      es: "Alemania",
      de: "Deutschland",
      pl: "Niemcy",
      fr: "Allemagne",
      nl: "Duitsland",
      pt: "Alemanha",
      cs: "Německo",
      ro: "Germania",
      ru: "Германия"
    },
    rootIddCode: "+49",
    blocMemberships: ["EU"],
    regions: JS,
    taxIdMandatory: !1,
    taxIdPattern: "^DE\\d{9}$",
    taxIdExample: "DE123456789"
  },
  DJ: {
    i18nNames: {
      en: "Djibouti",
      it: "Gibuti",
      es: "Yibuti",
      de: "Dschibuti",
      pl: "Dżibuti",
      fr: "Djibouti",
      nl: "Djibouti",
      pt: "Djibuti",
      cs: "Džibutsko",
      ro: "Djibouti",
      ru: "Джибути"
    },
    rootIddCode: "+253"
  },
  DK: {
    i18nNames: {
      en: "Denmark",
      it: "Danimarca",
      es: "Dinamarca",
      de: "Dänemark",
      pl: "Dania",
      fr: "Danemark",
      nl: "Denemarken",
      pt: "Dinamarca",
      cs: "Dánsko",
      ro: "Danemarca",
      ru: "Дания"
    },
    rootIddCode: "+45",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^DK\\d{8}$",
    taxIdExample: "DK12345678"
  },
  DM: {
    i18nNames: {
      en: "Dominica",
      it: "Dominica",
      es: "Dominica",
      de: "Dominica",
      pl: "Dominika",
      fr: "Dominique",
      nl: "Dominica",
      pt: "Dominica",
      cs: "Dominika",
      ro: "Dominica",
      ru: "Доминика"
    },
    rootIddCode: "+1767"
  },
  DO: {
    i18nNames: {
      en: "Dominican Republic",
      es: "República Dominicana",
      it: "Repubblica Dominicana",
      de: "Dominikanische Republik",
      pl: "Dominikana",
      fr: "République dominicaine",
      nl: "Dominicaanse Republiek",
      pt: "República Dominicana",
      cs: "Dominikánská republika",
      ro: "Republica Dominicană",
      ru: "Доминиканская Республика"
    },
    rootIddCode: "+1849"
  },
  DZ: {
    i18nNames: {
      en: "Algeria",
      it: "Algeria",
      es: "Argelia",
      de: "Algerien",
      pl: "Algieria",
      fr: "Algérie",
      nl: "Algerije",
      pt: "Argélia",
      cs: "Alžírsko",
      ro: "Algeria",
      ru: "Алжир"
    },
    rootIddCode: "+213",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{15}|\\d{20})$",
    taxIdExample: "123456789012345"
  },
  EC: {
    i18nNames: {
      en: "Ecuador",
      it: "Ecuador",
      es: "Ecuador",
      de: "Ecuador",
      pl: "Ekwador",
      fr: "Équateur",
      nl: "Ecuador",
      pt: "Equador",
      cs: "Ekvádor",
      ro: "Ecuador",
      ru: "Эквадор"
    },
    rootIddCode: "+593"
  },
  EE: {
    i18nNames: {
      en: "Estonia",
      it: "Estonia",
      es: "Estonia",
      de: "Estland",
      pl: "Estonia",
      fr: "Estonie",
      nl: "Estland",
      pt: "Estónia",
      cs: "Estonsko",
      ro: "Estonia",
      ru: "Эстония"
    },
    rootIddCode: "+372",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^EE\\d{9}$",
    taxIdExample: "EE123456789"
  },
  EG: {
    i18nNames: {
      en: "Egypt",
      it: "Egitto",
      es: "Egipto",
      de: "Ägypten",
      pl: "Egipt",
      fr: "Égypte",
      nl: "Egypte",
      pt: "Egito",
      cs: "Egypt",
      ro: "Egipt",
      ru: "Египет"
    },
    rootIddCode: "+20",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  EH: {
    i18nNames: {
      en: "Western Sahara",
      it: "Sahara Occidentale",
      es: "Sáhara Occidental",
      de: "Westsahara",
      pl: "Sahara Zachodnia",
      fr: "Sahara occidental",
      nl: "Westelijke Sahara",
      pt: "Saara Ocidental",
      cs: "Západní Sahara",
      ro: "Sahara Occidentală",
      ru: "Западная Сахара"
    },
    rootIddCode: "+2125289"
  },
  ER: {
    i18nNames: {
      en: "Eritrea",
      it: "Eritrea",
      es: "Eritrea",
      de: "Eritrea",
      pl: "Erytrea",
      fr: "Érythrée",
      nl: "Eritrea",
      pt: "Eritreia",
      cs: "Eritrea",
      ro: "Eritreea",
      ru: "Эритрея"
    },
    rootIddCode: "+291"
  },
  ES: {
    i18nNames: {
      en: "Spain",
      it: "Spagna",
      es: "España",
      de: "Spanien",
      pl: "Hiszpania",
      fr: "Espagne",
      nl: "Spanje",
      pt: "Espanha",
      cs: "Španělsko",
      ro: "Spania",
      ru: "Испания"
    },
    rootIddCode: "+34",
    blocMemberships: ["EU"],
    regions: XS,
    taxIdMandatory: !0,
    taxIdPattern: "^ES[A-Z0-9]\\d{7}[A-Z0-9]$",
    taxIdExample: "ESX1234567Y"
  },
  ET: {
    i18nNames: {
      en: "Ethiopia",
      it: "Etiopia",
      es: "Etiopía",
      de: "Äthiopien",
      pl: "Etiopia",
      fr: "Éthiopie",
      nl: "Ethiopië",
      pt: "Etiópia",
      cs: "Etiopie",
      ro: "Etiopia",
      ru: "Эфиопия"
    },
    rootIddCode: "+251"
  },
  FI: {
    i18nNames: {
      en: "Finland",
      it: "Finlandia",
      es: "Finlandia",
      de: "Finnland",
      pl: "Finlandia",
      fr: "Finlande",
      nl: "Finland",
      pt: "Finlândia",
      cs: "Finsko",
      ro: "Finlanda",
      ru: "Финляндия"
    },
    rootIddCode: "+358",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^FI\\d{8}$",
    taxIdExample: "FI12345678"
  },
  FJ: {
    i18nNames: {
      en: "Fiji",
      it: "Figi",
      es: "Fiyi",
      de: "Fidschi",
      pl: "Fidżi",
      fr: "Fidji",
      nl: "Fiji",
      pt: "Fiji",
      cs: "Fidži",
      ro: "Fiji",
      ru: "Фиджи"
    },
    rootIddCode: "+679"
  },
  FK: {
    i18nNames: {
      en: "Falkland Islands",
      es: "Islas Malvinas",
      it: "Isole Falkland o Isole Malvine",
      de: "Falklandinseln",
      pl: "Wyspy Falklandzkie",
      fr: "Îles Falkland",
      nl: "Falklandeilanden",
      pt: "Ilhas Malvinas",
      cs: "Falklandské ostrovy",
      ro: "Insulele Falkland",
      ru: "Фолклендские острова"
    },
    rootIddCode: "+500"
  },
  FM: {
    i18nNames: {
      en: "Micronesia",
      it: "Micronesia",
      es: "Estados Federados de Micronesia",
      de: "Mikronesien",
      pl: "Mikronezja",
      fr: "Micronésie",
      nl: "Micronesië",
      pt: "Micronésia",
      cs: "Mikronésie",
      ro: "Micronezia",
      ru: "Микронезия"
    },
    rootIddCode: "+691"
  },
  FO: {
    i18nNames: {
      en: "Faroe Islands",
      it: "Isole Far Oer",
      es: "Islas Feroe",
      de: "Färöer-Inseln",
      pl: "Wyspy Owcze",
      fr: "Îles Féroé",
      nl: "Faeröer",
      pt: "Ilhas Faroé",
      cs: "Faerské ostrovy",
      ro: "Insulele Feroe",
      ru: "Фарерские острова"
    },
    rootIddCode: "+298"
  },
  FR: {
    i18nNames: {
      en: "France",
      it: "Francia",
      es: "Francia",
      de: "Frankreich",
      pl: "Francja",
      fr: "France",
      nl: "Frankrijk",
      pt: "França",
      cs: "Francie",
      ro: "Franța",
      ru: "Франция"
    },
    rootIddCode: "+33",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^FR[A-Z0-9]{2}\\d{9}$",
    taxIdExample: "FR1A123456789"
  },
  GA: {
    i18nNames: {
      en: "Gabon",
      it: "Gabon",
      es: "Gabón",
      de: "Gabun",
      pl: "Gabon",
      fr: "Gabon",
      nl: "Gabon",
      pt: "Gabão",
      cs: "Gabon",
      ro: "Gabon",
      ru: "Габон"
    },
    rootIddCode: "+241"
  },
  GB: {
    i18nNames: {
      en: "United Kingdom",
      it: "Regno Unito",
      es: "Reino Unido",
      de: "Vereinigtes Königreich",
      pl: "Zjednoczone Królestwo",
      fr: "Royaume-Uni",
      nl: "Verenigd Koninkrijk",
      pt: "Reino Unido",
      cs: "Spojené království",
      ro: "Regatul Unit",
      ru: "Великобритания"
    },
    rootIddCode: "+44",
    taxIdMandatory: !1,
    taxIdPattern: "^GB(\\d{9}|\\d{12}|GD(0\\d{2}|[1-4]\\d{2})|HA([5-9]\\d{2}))$",
    taxIdExample: "GB123456789"
  },
  GD: {
    i18nNames: {
      en: "Grenada",
      it: "Grenada",
      es: "Granada",
      de: "Grenada",
      pl: "Grenada",
      fr: "Grenade",
      nl: "Grenada",
      pt: "Granada",
      cs: "Grenada",
      ro: "Grenada",
      ru: "Гренада"
    },
    rootIddCode: "+1473"
  },
  GE: {
    i18nNames: {
      en: "Georgia",
      it: "Georgia",
      es: "Georgia",
      de: "Georgien",
      pl: "Gruzja",
      fr: "Géorgie",
      nl: "Georgië",
      pt: "Geórgia",
      cs: "Gruzie",
      ro: "Georgia",
      ru: "Грузия"
    },
    rootIddCode: "+995"
  },
  GF: {
    i18nNames: {
      en: "French Guiana",
      it: "Guyana francese",
      es: "Guayana Francesa",
      de: "Französisch-Guayana",
      pl: "Gujana Francuska",
      fr: "Guyane française",
      nl: "Frans-Guyana",
      pt: "Guiana Francesa",
      cs: "Francouzská Guyana",
      ro: "Guyana Franceză",
      ru: "Французская Гвиана"
    },
    rootIddCode: "+594",
    blocMemberships: ["EU"]
  },
  GG: {
    i18nNames: {
      en: "Guernsey",
      it: "Guernsey",
      es: "Guernsey",
      de: "Guernsey",
      pl: "Guernsey",
      fr: "Guernesey",
      nl: "Guernsey",
      pt: "Guernsey",
      cs: "Guernsey",
      ro: "Guernsey",
      ru: "Гернси"
    },
    rootIddCode: "+44"
  },
  GH: {
    i18nNames: {
      en: "Ghana",
      it: "Ghana",
      es: "Ghana",
      de: "Ghana",
      pl: "Ghana",
      fr: "Ghana",
      nl: "Ghana",
      pt: "Gana",
      cs: "Ghana",
      ro: "Ghana",
      ru: "Гана"
    },
    rootIddCode: "+233"
  },
  GI: {
    i18nNames: {
      en: "Gibraltar",
      it: "Gibilterra",
      es: "Gibraltar",
      de: "Gibraltar",
      pl: "Gibraltar",
      fr: "Gibraltar",
      nl: "Gibraltar",
      pt: "Gibraltar",
      cs: "Gibraltar",
      ro: "Gibraltar",
      ru: "Гибралтар"
    },
    rootIddCode: "+350"
  },
  GL: {
    i18nNames: {
      en: "Greenland",
      it: "Groenlandia",
      es: "Groenlandia",
      de: "Grönland",
      pl: "Grenlandia",
      fr: "Groenland",
      nl: "Groenland",
      pt: "Gronelândia",
      cs: "Grónsko",
      ro: "Groenlanda",
      ru: "Гренландия"
    },
    rootIddCode: "+299"
  },
  GM: {
    i18nNames: {
      en: "Gambia",
      it: "Gambia",
      es: "Gambia",
      de: "Gambia",
      pl: "Gambia",
      fr: "Gambie",
      nl: "Gambia",
      pt: "Gâmbia",
      cs: "Gambie",
      ro: "Gambia",
      ru: "Гамбия"
    },
    rootIddCode: "+220"
  },
  GN: {
    i18nNames: {
      en: "Guinea",
      it: "Guinea",
      es: "Guinea",
      de: "Guinea",
      pl: "Gwinea",
      fr: "Guinée",
      nl: "Guinee",
      pt: "Guiné",
      cs: "Guinea",
      ro: "Guineea",
      ru: "Гвинея"
    },
    rootIddCode: "+224"
  },
  GP: {
    i18nNames: {
      en: "Guadeloupe",
      it: "Guadeloupa",
      es: "Guadalupe",
      de: "Guadeloupe",
      pl: "Gwadelupa",
      fr: "Guadeloupe",
      nl: "Guadeloupe",
      pt: "Guadalupe",
      cs: "Guadeloupe",
      ro: "Guadelupa",
      ru: "Гваделупа"
    },
    rootIddCode: "+590"
  },
  GQ: {
    i18nNames: {
      en: "Equatorial Guinea",
      es: "Guinea Ecuatorial",
      it: "Guinea Equatoriale",
      de: "Äquatorialguinea",
      pl: "Gwinea Równikowa",
      fr: "Guinée équatoriale",
      nl: "Equatoriaal-Guinea",
      pt: "Guiné Equatorial",
      cs: "Rovníková Guinea",
      ro: "Guineea Ecuatorială",
      ru: "Экваториальная Гвинея"
    },
    rootIddCode: "+240"
  },
  GR: {
    i18nNames: {
      en: "Greece",
      it: "Grecia",
      es: "Grecia",
      de: "Griechenland",
      pl: "Grecja",
      fr: "Grèce",
      nl: "Griekenland",
      pt: "Grécia",
      cs: "Řecko",
      ro: "Grecia",
      ru: "Греция"
    },
    rootIddCode: "+30",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^EL\\d{9}$",
    taxIdExample: "EL123456789"
  },
  GS: {
    i18nNames: {
      en: "South Georgia",
      it: "Georgia del Sud e Isole Sandwich Meridionali",
      es: "Islas Georgias del Sur y Sandwich del Sur",
      de: "Südgeorgien",
      pl: "Georgia Południowa",
      fr: "Géorgie du Sud et îles Sandwich du Sud",
      nl: "Zuid-Georgië en Zuidelijke Sandwicheilanden",
      pt: "Geórgia do Sul e Ilhas Sandwich do Sul",
      cs: "Jižní Georgie a Jižní Sandwichovy ostrovy",
      ro: "Georgia de Sud și Insulele Sandwich de Sud",
      ru: "Южная Георгия и Южные Сандвичевы острова"
    },
    rootIddCode: "+500"
  },
  GT: {
    i18nNames: {
      en: "Guatemala",
      it: "Guatemala",
      es: "Guatemala",
      de: "Guatemala",
      pl: "Gwatemala",
      fr: "Guatemala",
      nl: "Guatemala",
      pt: "Guatemala",
      cs: "Guatemala",
      ro: "Guatemala",
      ru: "Гватемала"
    },
    rootIddCode: "+502"
  },
  GU: {
    i18nNames: {
      en: "Guam",
      it: "Guam",
      es: "Guam",
      de: "Guam",
      pl: "Guam",
      fr: "Guam",
      nl: "Guam",
      pt: "Guam",
      cs: "Guam",
      ro: "Guam",
      ru: "Гуам"
    },
    rootIddCode: "+1671"
  },
  GW: {
    i18nNames: {
      en: "Guinea-Bissau",
      it: "Guinea-Bissau",
      es: "Guinea-Bisáu",
      de: "Guinea-Bissau",
      pl: "Gwinea-Bissau",
      fr: "Guinée-Bissau",
      nl: "Guinee-Bissau",
      pt: "Guiné-Bissau",
      cs: "Guinea-Bissau",
      ro: "Guineea-Bissau",
      ru: "Гвинея-Бисау"
    },
    rootIddCode: "+245"
  },
  GY: {
    i18nNames: {
      en: "Guyana",
      it: "Guyana",
      es: "Guyana",
      de: "Guyana",
      pl: "Gujana",
      fr: "Guyana",
      nl: "Guyana",
      pt: "Guiana",
      cs: "Guyana",
      ro: "Guyana",
      ru: "Гайана"
    },
    rootIddCode: "+592"
  },
  HK: {
    i18nNames: {
      en: "Hong Kong",
      it: "Hong Kong",
      es: "Hong Kong",
      de: "Hongkong",
      pl: "Hongkong",
      fr: "Hong Kong",
      nl: "Hongkong",
      pt: "Hong Kong",
      cs: "Hongkong",
      ro: "Hong Kong",
      ru: "Гонконг"
    },
    rootIddCode: "+852"
  },
  HM: {
    i18nNames: {
      en: "Heard Island and McDonald Islands",
      es: "Islas Heard y McDonald",
      it: "Isole Heard e McDonald",
      de: "Heard und McDonaldinseln",
      pl: "Wyspy Heard i McDonalda",
      fr: "Îles Heard et McDonald",
      nl: "Heard en McDonaldeilanden",
      pt: "Ilhas Heard e McDonald",
      cs: "Heardův ostrov a McDonaldovy ostrovy",
      ro: "Insula Heard și Insulele McDonald",
      ru: "Остров Херд и острова Макдональд"
    },
    rootIddCode: "undefined"
  },
  HN: {
    i18nNames: {
      en: "Honduras",
      it: "Honduras",
      es: "Honduras",
      de: "Honduras",
      pl: "Honduras",
      fr: "Honduras",
      nl: "Honduras",
      pt: "Honduras",
      cs: "Honduras",
      ro: "Honduras",
      ru: "Гондурас"
    },
    rootIddCode: "+504"
  },
  HR: {
    i18nNames: {
      en: "Croatia",
      it: "Croazia",
      es: "Croacia",
      de: "Kroatien",
      pl: "Chorwacja",
      fr: "Croatie",
      nl: "Kroatië",
      pt: "Croácia",
      cs: "Chorvatsko",
      ro: "Croația",
      ru: "Хорватия"
    },
    rootIddCode: "+385",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^HR\\d{11}$",
    taxIdExample: "HR12345678901"
  },
  HT: {
    i18nNames: {
      en: "Haiti",
      it: "Haiti",
      es: "Haití",
      de: "Haiti",
      pl: "Haiti",
      fr: "Haïti",
      nl: "Haïti",
      pt: "Haiti",
      cs: "Haiti",
      ro: "Haiti",
      ru: "Гаити"
    },
    rootIddCode: "+509"
  },
  HU: {
    i18nNames: {
      en: "Hungary",
      it: "Ungheria",
      es: "Hungría",
      de: "Ungarn",
      pl: "Węgry",
      fr: "Hongrie",
      nl: "Hongarije",
      pt: "Hungria",
      cs: "Maďarsko",
      ro: "Ungaria",
      ru: "Венгрия"
    },
    rootIddCode: "+36",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^HU\\d{8}$",
    taxIdExample: "HU12345678"
  },
  ID: {
    i18nNames: {
      en: "Indonesia",
      it: "Indonesia",
      es: "Indonesia",
      de: "Indonesien",
      pl: "Indonezja",
      fr: "Indonésie",
      nl: "Indonesië",
      pt: "Indonésia",
      cs: "Indonésie",
      ro: "Indonezia",
      ru: "Индонезия"
    },
    rootIddCode: "+62"
  },
  IE: {
    i18nNames: {
      en: "Ireland",
      it: "Irlanda",
      es: "Irlanda",
      de: "Irland",
      pl: "Irlandia",
      fr: "Irlande",
      nl: "Ierland",
      pt: "Irlanda",
      cs: "Irsko",
      ro: "Irlanda",
      ru: "Ирландия"
    },
    rootIddCode: "+353",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^IE\\d{7}[A-Z]{1,2}$",
    taxIdExample: "IE1234567A"
  },
  IL: {
    i18nNames: {
      en: "Israel",
      it: "Israele",
      es: "Israel",
      de: "Israel",
      pl: "Израиль",
      fr: "Israël",
      nl: "Israël",
      pt: "Israel",
      cs: "Izrael",
      ro: "Israel",
      ru: "Израиль"
    },
    rootIddCode: "+972",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  IM: {
    i18nNames: {
      en: "Isle of Man",
      it: "Isola di Man",
      es: "Isla de Man",
      de: "Isle of Man",
      pl: "Wyspa Man",
      fr: "Île de Man",
      nl: "Isle of Man",
      pt: "Ilha de Man",
      cs: "Ostrov Man",
      ro: "Insula Man",
      ru: "Остров Мэн"
    },
    rootIddCode: "+44"
  },
  IN: {
    i18nNames: {
      en: "India",
      it: "India",
      es: "India",
      de: "Indien",
      pl: "Indie",
      fr: "Inde",
      nl: "India",
      pt: "Índia",
      cs: "Indie",
      ro: "India",
      ru: "Индия"
    },
    rootIddCode: "+91"
  },
  IO: {
    i18nNames: {
      en: "British Indian Ocean Territory",
      es: "Territorio Británico del Océano Índico",
      it: "Territorio britannico dell'oceano indiano",
      de: "Britisches Territorium im Indischen Ozean",
      pl: "Brytyjskie Terytorium Oceanu Indyjskiego",
      fr: "Territoire britannique de l'océan Indien",
      nl: "Brits Indische Oceaanterritorium",
      pt: "Território Britânico do Oceano Índico",
      cs: "Britské indickooceánské území",
      ro: "Teritoriul Britanic din Oceanul Indian",
      ru: "Британская территория в Индийском океане"
    },
    rootIddCode: "+246"
  },
  IQ: {
    i18nNames: {
      en: "Iraq",
      it: "Iraq",
      es: "Irak",
      de: "Ирак",
      pl: "Irak",
      fr: "Irak",
      nl: "Irak",
      pt: "Iraque",
      cs: "Irák",
      ro: "Irak",
      ru: "Ирак"
    },
    rootIddCode: "+964"
  },
  IR: {
    i18nNames: {
      en: "Iran",
      it: "Iran",
      es: "Irán",
      de: "Iran",
      pl: "Iran",
      fr: "Iran",
      nl: "Iran",
      pt: "Irã",
      cs: "Írán",
      ro: "Iran",
      ru: "Иран"
    },
    rootIddCode: "+98"
  },
  IS: {
    i18nNames: {
      en: "Iceland",
      it: "Islanda",
      es: "Islandia",
      de: "Island",
      pl: "Islandia",
      fr: "Islande",
      nl: "IJsland",
      pt: "Islândia",
      cs: "Island",
      ro: "Islanda",
      ru: "Исландия"
    },
    rootIddCode: "+354",
    taxIdMandatory: !0,
    taxIdPattern: "^IS\\d{5,6}$",
    taxIdExample: "IS123456"
  },
  IT: {
    i18nNames: {
      en: "Italy",
      it: "Italia",
      es: "Italia",
      de: "Italien",
      pl: "Włochy",
      fr: "Italie",
      nl: "Italie",
      pt: "Itália",
      cs: "Itálie",
      ro: "Italia",
      ru: "Италия"
    },
    rootIddCode: "+39",
    blocMemberships: ["EU"],
    regions: jS,
    taxIdMandatory: !0,
    taxIdPattern: "^IT\\d{11}$",
    taxIdExample: "IT12345678901"
  },
  JE: {
    i18nNames: {
      en: "Jersey",
      it: "Isola di Jersey",
      es: "Jersey",
      de: "Jersey",
      pl: "Jersey",
      fr: "Jersey",
      nl: "Jersey",
      pt: "Jersey",
      cs: "Jersey",
      ro: "Jersey",
      ru: "Джерси"
    },
    rootIddCode: "+44"
  },
  JM: {
    i18nNames: {
      en: "Jamaica",
      it: "Giamaica",
      es: "Jamaica",
      de: "Jamaika",
      pl: "Jamajka",
      fr: "Jamaïque",
      nl: "Jamaica",
      pt: "Jamaica",
      cs: "Jamajka",
      ro: "Jamaica",
      ru: "Ямайка"
    },
    rootIddCode: "+1876"
  },
  JO: {
    i18nNames: {
      en: "Jordan",
      it: "Giordania",
      es: "Jordania",
      de: "Jordanien",
      pl: "Jordania",
      fr: "Jordanie",
      nl: "Jordanië",
      pt: "Jordânia",
      cs: "Jordánsko",
      ro: "Iordania",
      ru: "Иордания"
    },
    rootIddCode: "+962",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{7}$",
    taxIdExample: "1234567"
  },
  JP: {
    i18nNames: {
      en: "Japan",
      it: "Giappone",
      es: "Japón",
      de: "Japan",
      pl: "Japonia",
      fr: "Japon",
      nl: "Japan",
      pt: "Japão",
      cs: "Japonsko",
      ro: "Japonia",
      ru: "Япония"
    },
    rootIddCode: "+81"
  },
  KE: {
    i18nNames: {
      en: "Kenya",
      it: "Kenya",
      es: "Kenia",
      de: "Kenia",
      pl: "Kenia",
      fr: "Kenya",
      nl: "Kenia",
      pt: "Quênia",
      cs: "Keňa",
      ro: "Kenya",
      ru: "Кения"
    },
    rootIddCode: "+254"
  },
  KG: {
    i18nNames: {
      en: "Kyrgyzstan",
      it: "Kirghizistan",
      es: "Kirguistán",
      de: "Kirgisistan",
      pl: "Kirgistan",
      fr: "Kirghizistan",
      nl: "Kirgizië",
      pt: "Quirguistão",
      cs: "Kyrgyzstán",
      ro: "Kârgâzstan",
      ru: "Киргизия"
    },
    rootIddCode: "+996"
  },
  KH: {
    i18nNames: {
      en: "Cambodia",
      it: "Cambogia",
      es: "Camboya",
      de: "Kambodscha",
      pl: "Kambodża",
      fr: "Cambodge",
      nl: "Cambodja",
      pt: "Camboja",
      cs: "Kambodža",
      ro: "Cambodgia",
      ru: "Камбоджа"
    },
    rootIddCode: "+855"
  },
  KI: {
    i18nNames: {
      en: "Kiribati",
      it: "Kiribati",
      es: "Kiribati",
      de: "Kiribati",
      pl: "Kiribati",
      fr: "Kiribati",
      nl: "Kiribati",
      pt: "Kiribati",
      cs: "Kiribati",
      ro: "Kiribati",
      ru: "Кирибати"
    },
    rootIddCode: "+686"
  },
  KM: {
    i18nNames: {
      en: "Comoros",
      it: "Comore",
      es: "Comoras",
      de: "Komoren",
      pl: "Komory",
      fr: "Comores",
      nl: "Comoren",
      pt: "Comores",
      cs: "Komory",
      ro: "Comore",
      ru: "Коморы"
    },
    rootIddCode: "+269"
  },
  KN: {
    i18nNames: {
      en: "Saint Kitts and Nevis",
      es: "San Cristóbal y Nieves",
      it: "Saint Kitts e Nevis",
      de: "St. Kitts und Nevis",
      pl: "Saint Kitts i Nevis",
      fr: "Saint-Christophe-et-Niévès",
      nl: "Saint Kitts en Nevis",
      pt: "São Cristóvão e Névis",
      cs: "Svatý Kryštof a Nevis",
      ro: "Sfântul Kitts și Nevis",
      ru: "Сент-Китс и Невис"
    },
    rootIddCode: "+1869"
  },
  KP: {
    i18nNames: {
      en: "North Korea",
      it: "Corea del Nord",
      es: "Corea del Norte",
      de: "Nordkorea",
      pl: "Korea Północna",
      fr: "Corée du Nord",
      nl: "Noord-Korea",
      pt: "Coreia do Norte",
      cs: "Severní Korea",
      ro: "Coreea de Nord",
      ru: "Северная Корея"
    },
    rootIddCode: "+850"
  },
  KR: {
    i18nNames: {
      en: "South Korea",
      it: "Corea del Sud",
      es: "Corea del Sur",
      de: "Südkorea",
      pl: "Korea Południowa",
      fr: "Corée du Sud",
      nl: "Zuid-Korea",
      pt: "Coreia do Sul",
      cs: "Jižní Korea",
      ro: "Coreea de Sud",
      ru: "Южная Корея"
    },
    rootIddCode: "+82"
  },
  KW: {
    i18nNames: {
      en: "Kuwait",
      it: "Kuwait",
      es: "Kuwait",
      de: "Kuwait",
      pl: "Kuwejt",
      fr: "Koweït",
      nl: "Кувейт",
      pt: "Kuwait",
      cs: "Kuvajt",
      ro: "Kuweit",
      ru: "Кувейт"
    },
    rootIddCode: "+965"
  },
  KY: {
    i18nNames: {
      en: "Cayman Islands",
      it: "Isole Cayman",
      es: "Islas Caimán",
      de: "Kaimaninseln",
      pl: "Kajmany",
      fr: "Îles Caïmans",
      nl: "Kaaimaneilanden",
      pt: "Ilhas Cayman",
      cs: "Kajmanské ostrovy",
      ro: "Insulele Cayman",
      ru: "Каймановы острова"
    },
    rootIddCode: "+1345"
  },
  KZ: {
    i18nNames: {
      en: "Kazakhstan",
      it: "Kazakistan",
      es: "Kazajistán",
      de: "Kasachstan",
      pl: "Kazachstan",
      fr: "Kazakhstan",
      nl: "Kazachstan",
      pt: "Cazaquistão",
      cs: "Kazachstán",
      ro: "Kazahstan",
      ru: "Казахстан"
    },
    rootIddCode: "+77"
  },
  LA: {
    i18nNames: {
      en: "Laos",
      it: "Laos",
      es: "Laos",
      de: "Laos",
      pl: "Laos",
      fr: "Laos",
      nl: "Laos",
      pt: "Laos",
      cs: "Laos",
      ro: "Laos",
      ru: "Лаос"
    },
    rootIddCode: "+856"
  },
  LB: {
    i18nNames: {
      en: "Lebanon",
      it: "Libano",
      es: "Líbano",
      de: "Libanon",
      pl: "Liban",
      fr: "Liban",
      nl: "Libanon",
      pt: "Líbano",
      cs: "Libanon",
      ro: "Liban",
      ru: "Ливан"
    },
    rootIddCode: "+961",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{1,15}(-(601|603|604))?$",
    taxIdExample: "123456789-601"
  },
  LC: {
    i18nNames: {
      en: "Saint Lucia",
      it: "Santa Lucia",
      es: "Santa Lucía",
      de: "St. Lucia",
      pl: "Saint Lucia",
      fr: "Sainte-Lucie",
      nl: "Saint Lucia",
      pt: "Santa Lúcia",
      cs: "Svatá Lucie",
      ro: "Sfânta Lucia",
      ru: "Сент-Люсия"
    },
    rootIddCode: "+1758"
  },
  LI: {
    i18nNames: {
      en: "Liechtenstein",
      it: "Liechtenstein",
      es: "Liechtenstein",
      de: "Liechtenstein",
      pl: "Liechtenstein",
      fr: "Liechtenstein",
      nl: "Liechtenstein",
      pt: "Liechtenstein",
      cs: "Lichtenštejnsko",
      ro: "Liechtenstein",
      ru: "Лихтенштейн"
    },
    rootIddCode: "+423",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{5}$",
    taxIdExample: "12345"
  },
  LK: {
    i18nNames: {
      en: "Sri Lanka",
      it: "Sri Lanka",
      es: "Sri Lanka",
      de: "Sri Lanka",
      pl: "Sri Lanka",
      fr: "Sri Lanka",
      nl: "Sri Lanka",
      pt: "Sri Lanka",
      cs: "Srí Lanka",
      ro: "Sri Lanka",
      ru: "Шри-Ланка"
    },
    rootIddCode: "+94"
  },
  LR: {
    i18nNames: {
      en: "Liberia",
      it: "Liberia",
      es: "Liberia",
      de: "Liberia",
      pl: "Liberia",
      fr: "Libéria",
      nl: "Liberia",
      pt: "Libéria",
      cs: "Libérie",
      ro: "Liberia",
      ru: "Либерия"
    },
    rootIddCode: "+231"
  },
  LS: {
    i18nNames: {
      en: "Lesotho",
      it: "Lesotho",
      es: "Lesoto",
      de: "Lesotho",
      pl: "Lesotho",
      fr: "Lesotho",
      nl: "Lesotho",
      pt: "Lesoto",
      cs: "Lesotho",
      ro: "Lesotho",
      ru: "Лесото"
    },
    rootIddCode: "+266"
  },
  LT: {
    i18nNames: {
      en: "Lithuania",
      it: "Lituania",
      es: "Lituania",
      de: "Litauen",
      pl: "Litwa",
      fr: "Lituanie",
      nl: "Litouwen",
      pt: "Lituânia",
      cs: "Litva",
      ro: "Lituania",
      ru: "Литва"
    },
    rootIddCode: "+370",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LT(\\d{9}|\\d{12})$",
    taxIdExample: "LT123456789"
  },
  LU: {
    i18nNames: {
      en: "Luxembourg",
      it: "Lussemburgo",
      es: "Luxemburgo",
      de: "Luxemburg",
      pl: "Luksemburg",
      fr: "Luxembourg",
      nl: "Luxemburg",
      pt: "Luxemburgo",
      cs: "Lucembursko",
      ro: "Luxemburg",
      ru: "Люксембург"
    },
    rootIddCode: "+352",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LU\\d{8}$",
    taxIdExample: "LU12345678"
  },
  LV: {
    i18nNames: {
      en: "Latvia",
      it: "Lettonia",
      es: "Letonia",
      de: "Lettland",
      pl: "Łotwa",
      fr: "Lettonie",
      nl: "Letland",
      pt: "Letónia",
      cs: "Lotyšsko",
      ro: "Letonia",
      ru: "Латвия"
    },
    rootIddCode: "+371",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^LV\\d{11}$",
    taxIdExample: "LV12345678901"
  },
  LY: {
    i18nNames: {
      en: "Libya",
      it: "Libia",
      es: "Libia",
      de: "Libyen",
      pl: "Libia",
      fr: "Libye",
      nl: "Libië",
      pt: "Líbia",
      cs: "Libye",
      ro: "Libia",
      ru: "Ливия"
    },
    rootIddCode: "+218"
  },
  MA: {
    i18nNames: {
      en: "Morocco",
      it: "Marocco",
      es: "Marruecos",
      de: "Marokko",
      pl: "Maroko",
      fr: "Maroc",
      nl: "Marokko",
      pt: "Marrocos",
      cs: "Maroko",
      ro: "Maroc",
      ru: "Марокко"
    },
    rootIddCode: "+212",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  MC: {
    i18nNames: {
      en: "Monaco",
      it: "Principato di Monaco",
      es: "Mónaco",
      de: "Monaco",
      pl: "Monako",
      fr: "Monaco",
      nl: "Monaco",
      pt: "Mônaco",
      cs: "Monako",
      ro: "Monaco",
      ru: "Монако"
    },
    rootIddCode: "+377",
    taxIdMandatory: !0,
    taxIdPattern: "^FR[A-Z0-9]{2}\\d{9}$",
    taxIdExample: "FR9Z123456789"
  },
  MD: {
    i18nNames: {
      en: "Moldova",
      it: "Moldavia",
      es: "Moldavia",
      de: "Moldawien",
      pl: "Mołdawia",
      fr: "Moldavie",
      nl: "Moldavië",
      pt: "Moldávia",
      cs: "Moldavsko",
      ro: "Moldova",
      ru: "Молдова"
    },
    rootIddCode: "+373",
    taxIdMandatory: !0,
    taxIdPattern: "^MD\\d{7}$",
    taxIdExample: "MD1234567"
  },
  ME: {
    i18nNames: {
      en: "Montenegro",
      it: "Montenegro",
      es: "Montenegro",
      de: "Montenegro",
      pl: "Czarnogóra",
      fr: "Monténégro",
      nl: "Montenegro",
      pt: "Montenegro",
      cs: "Černá Hora",
      ro: "Muntenegru",
      ru: "Черногория"
    },
    rootIddCode: "+382",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  MF: {
    i18nNames: {
      en: "Saint Martin",
      it: "Saint Martin",
      es: "San Martín (parte francesa)",
      de: "Saint-Martin",
      pl: "Saint-Martin",
      fr: "Saint-Martin",
      nl: "Saint Martin",
      pt: "São Martinho",
      cs: "Saint-Martin",
      ro: "Sfântul Martin",
      ru: "Сен-Мартен"
    },
    rootIddCode: "+590"
  },
  MG: {
    i18nNames: {
      en: "Madagascar",
      it: "Madagascar",
      es: "Madagascar",
      de: "Madagaskar",
      pl: "Madagaskar",
      fr: "Madagascar",
      nl: "Madagaskar",
      pt: "Madagáscar",
      cs: "Madagaskar",
      ro: "Madagascar",
      ru: "Мадагаскар"
    },
    rootIddCode: "+261"
  },
  MH: {
    i18nNames: {
      en: "Marshall Islands",
      es: "Islas Marshall",
      it: "Isole Marshall",
      de: "Marshallinseln",
      pl: "Wyspy Marshalla",
      fr: "Îles Marshall",
      nl: "Marshalleilanden",
      pt: "Ilhas Marshall",
      cs: "Marshallovy ostrovy",
      ro: "Insulele Marshall",
      ru: "Маршалловы Острова"
    },
    rootIddCode: "+692"
  },
  MK: {
    i18nNames: {
      en: "North Macedonia",
      it: "Macedonia del Nord",
      es: "Macedonia del Norte",
      de: "Nordmazedonien",
      pl: "Macedonia Północna",
      fr: "Macédoine du Nord",
      nl: "Noord-Macedonië",
      pt: "Macedônia do Norte",
      cs: "Severní Makedonie",
      ro: "Macedonia de Nord",
      ru: "Северная Македония"
    },
    rootIddCode: "+389",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{13}$",
    taxIdExample: "1234567890123"
  },
  ML: {
    i18nNames: {
      en: "Mali",
      it: "Mali",
      es: "Malí",
      de: "Mali",
      pl: "Mali",
      fr: "Mali",
      nl: "Mali",
      pt: "Mali",
      cs: "Mali",
      ro: "Mali",
      ru: "Мали"
    },
    rootIddCode: "+223"
  },
  MM: {
    i18nNames: {
      en: "Myanmar",
      it: "Birmania",
      es: "Birmania",
      de: "Myanmar",
      pl: "Mjanma",
      fr: "Birmanie",
      nl: "Myanmar",
      pt: "Mianmar",
      cs: "Myanmar",
      ro: "Myanmar",
      ru: "Мьянма"
    },
    rootIddCode: "+95"
  },
  MN: {
    i18nNames: {
      en: "Mongolia",
      it: "Mongolia",
      es: "Mongolia",
      de: "Mongolei",
      pl: "Mongolia",
      fr: "Mongolie",
      nl: "Mongolië",
      pt: "Mongólia",
      cs: "Mongolsko",
      ro: "Mongolia",
      ru: "Монголия"
    },
    rootIddCode: "+976"
  },
  MO: {
    i18nNames: {
      en: "Macau",
      it: "Macao",
      es: "Macao",
      de: "Macau",
      pl: "Makau",
      fr: "Macao",
      nl: "Macau",
      pt: "Macau",
      cs: "Macao",
      ro: "Macao",
      ru: "Макао"
    },
    rootIddCode: "+853"
  },
  MP: {
    i18nNames: {
      en: "Northern Mariana Islands",
      es: "Islas Marianas del Norte",
      it: "Isole Marianne Settentrionali",
      de: "Nördliche Marianen",
      pl: "Mariany Północne",
      fr: "Îles Mariannes du Nord",
      nl: "Noordelijke Marianen",
      pt: "Ilhas Marianas do Norte",
      cs: "Severní Mariany",
      ro: "Insulele Mariane de Nord",
      ru: "Северные Марианские острова"
    },
    rootIddCode: "+1670"
  },
  MQ: {
    i18nNames: {
      en: "Martinique",
      it: "Martinica",
      es: "Martinica",
      de: "Martinique",
      pl: "Martynika",
      fr: "Martinique",
      nl: "Martinique",
      pt: "Martinica",
      cs: "Martinik",
      ro: "Martinica",
      ru: "Мартиника"
    },
    rootIddCode: "+596"
  },
  MR: {
    i18nNames: {
      en: "Mauritania",
      it: "Mauritania",
      es: "Mauritania",
      de: "Mauretanien",
      pl: "Mauretania",
      fr: "Mauritanie",
      nl: "Mauritanië",
      pt: "Mauritânia",
      cs: "Mauritánie",
      ro: "Mauritania",
      ru: "Мавритания"
    },
    rootIddCode: "+222"
  },
  MS: {
    i18nNames: {
      en: "Montserrat",
      it: "Montserrat",
      es: "Montserrat",
      de: "Montserrat",
      pl: "Montserrat",
      fr: "Montserrat",
      nl: "Montserrat",
      pt: "Montserrat",
      cs: "Montserrat",
      ro: "Montserrat",
      ru: "Монтсеррат"
    },
    rootIddCode: "+1664"
  },
  MT: {
    i18nNames: {
      en: "Malta",
      it: "Malta",
      es: "Malta",
      de: "Malta",
      pl: "Malta",
      fr: "Malte",
      nl: "Malta",
      pt: "Malta",
      cs: "Malta",
      ro: "Malta",
      ru: "Мальта"
    },
    rootIddCode: "+356",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^MT\\d{8}$",
    taxIdExample: "MT12345678"
  },
  MU: {
    i18nNames: {
      en: "Mauritius",
      it: "Mauritius",
      es: "Mauricio",
      de: "Mauritius",
      pl: "Mauritius",
      fr: "Île Maurice",
      nl: "Mauritius",
      pt: "Maurício",
      cs: "Mauricius",
      ro: "Mauritius",
      ru: "Маврикий"
    },
    rootIddCode: "+230"
  },
  MV: {
    i18nNames: {
      en: "Maldives",
      it: "Maldive",
      es: "Maldivas",
      de: "Malediven",
      pl: "Malediwy",
      fr: "Maldives",
      nl: "Maldiven",
      pt: "Maldivas",
      cs: "Maledivy",
      ro: "Maldive",
      ru: "Мальдивы"
    },
    rootIddCode: "+960"
  },
  MW: {
    i18nNames: {
      en: "Malawi",
      it: "Malawi",
      es: "Malaui",
      de: "Malawi",
      pl: "Malawi",
      fr: "Malawi",
      nl: "Malawi",
      pt: "Maláui",
      cs: "Malawi",
      ro: "Malawi",
      ru: "Малави"
    },
    rootIddCode: "+265"
  },
  MX: {
    i18nNames: {
      en: "Mexico",
      it: "Messico",
      es: "México",
      de: "Mexiko",
      pl: "Meksyk",
      fr: "Mexique",
      nl: "Mexico",
      pt: "México",
      cs: "Mexiko",
      ro: "Mexic",
      ru: "Мексика"
    },
    rootIddCode: "+52"
  },
  MY: {
    i18nNames: {
      en: "Malaysia",
      it: "Malesia",
      es: "Malasia",
      de: "Malaysia",
      pl: "Malezja",
      fr: "Malaisie",
      nl: "Maleisië",
      pt: "Malásia",
      cs: "Malajsie",
      ro: "Malaezia",
      ru: "Малайзия"
    },
    rootIddCode: "+60"
  },
  MZ: {
    i18nNames: {
      en: "Mozambique",
      it: "Mozambico",
      es: "Mozambique",
      de: "Mosambik",
      pl: "Mozambik",
      fr: "Mozambique",
      nl: "Mozambique",
      pt: "Moçambique",
      cs: "Mosambik",
      ro: "Mozambic",
      ru: "Мозамбик"
    },
    rootIddCode: "+258"
  },
  NA: {
    i18nNames: {
      en: "Namibia",
      it: "Namibia",
      es: "Namibia",
      de: "Namibia",
      pl: "Namibia",
      fr: "Namibie",
      nl: "Namibië",
      pt: "Namíbia",
      cs: "Namibie",
      ro: "Namibia",
      ru: "Намибия"
    },
    rootIddCode: "+264"
  },
  NC: {
    i18nNames: {
      en: "New Caledonia",
      it: "Nuova Caledonia",
      es: "Nueva Caledonia",
      de: "Neukaledonien",
      pl: "Nowa Kaledonia",
      fr: "Nouvelle-Calédonie",
      nl: "Nieuw-Caledonië",
      pt: "Nova Caledônia",
      cs: "Nová Kaledonie",
      ro: "Noua Caledonie",
      ru: "Новая Каледония"
    },
    rootIddCode: "+687"
  },
  NE: {
    i18nNames: {
      en: "Niger",
      it: "Niger",
      es: "Níger",
      de: "Niger",
      pl: "Niger",
      fr: "Niger",
      nl: "Niger",
      pt: "Níger",
      cs: "Niger",
      ro: "Niger",
      ru: "Нигер"
    },
    rootIddCode: "+227"
  },
  NF: {
    i18nNames: {
      en: "Norfolk Island",
      it: "Isola Norfolk",
      es: "Isla Norfolk",
      de: "Norfolkinsel",
      pl: "Wyspa Norfolk",
      fr: "Île Norfolk",
      nl: "Norfolkeiland",
      pt: "Ilha Norfolk",
      cs: "Ostrov Norfolk",
      ro: "Insula Norfolk",
      ru: "Остров Норфолк"
    },
    rootIddCode: "+672"
  },
  NG: {
    i18nNames: {
      en: "Nigeria",
      it: "Nigeria",
      es: "Nigeria",
      de: "Nigeria",
      pl: "Nigeria",
      fr: "Nigeria",
      nl: "Nigeria",
      pt: "Nigéria",
      cs: "Nigérie",
      ro: "Nigeria",
      ru: "Нигерия"
    },
    rootIddCode: "+234"
  },
  NI: {
    i18nNames: {
      en: "Nicaragua",
      it: "Nicaragua",
      es: "Nicaragua",
      de: "Nicaragua",
      pl: "Nikaragua",
      fr: "Nicaragua",
      nl: "Nicaragua",
      pt: "Nicarágua",
      cs: "Nikaragua",
      ro: "Nicaragua",
      ru: "Никарагуа"
    },
    rootIddCode: "+505"
  },
  NL: {
    i18nNames: {
      en: "Netherlands",
      it: "Paesi Bassi",
      es: "Países Bajos",
      de: "Niederlande",
      pl: "Holandia",
      fr: "Pays-Bas",
      nl: "Nederland",
      pt: "Países Baixos",
      cs: "Nizozemsko",
      ro: "Țările de Jos",
      ru: "Нидерланды"
    },
    rootIddCode: "+31",
    blocMemberships: ["EU"],
    taxIdMandatory: !1,
    taxIdPattern: "^NL\\d{9}B\\d{2}$",
    taxIdExample: "NL123456789B01"
  },
  NO: {
    i18nNames: {
      en: "Norway",
      it: "Norvegia",
      es: "Noruega",
      de: "Norwegen",
      pl: "Norwegia",
      fr: "Norvège",
      nl: "Noorwegen",
      pt: "Noruega",
      cs: "Norsko",
      ro: "Norvegia",
      ru: "Норвегия"
    },
    rootIddCode: "+47",
    taxIdMandatory: !0,
    taxIdPattern: "^NO\\d{9}MVA$",
    taxIdExample: "NO123456789MVA"
  },
  NP: {
    i18nNames: {
      en: "Nepal",
      it: "Nepal",
      es: "Nepal",
      de: "Nepal",
      pl: "Nepal",
      fr: "Népal",
      nl: "Nepal",
      pt: "Nepal",
      cs: "Nepál",
      ro: "Nepal",
      ru: "Непал"
    },
    rootIddCode: "+977"
  },
  NR: {
    i18nNames: {
      en: "Nauru",
      it: "Nauru",
      es: "Nauru",
      de: "Nauru",
      pl: "Nauru",
      fr: "Nauru",
      nl: "Nauru",
      pt: "Nauru",
      cs: "Nauru",
      ro: "Nauru",
      ru: "Науру"
    },
    rootIddCode: "+674"
  },
  NU: {
    i18nNames: {
      en: "Niue",
      it: "Niue",
      es: "Niue",
      de: "Niue",
      pl: "Niue",
      fr: "Niue",
      nl: "Niue",
      pt: "Niue",
      cs: "Niue",
      ro: "Niue",
      ru: "Ниуэ"
    },
    rootIddCode: "+683"
  },
  NZ: {
    i18nNames: {
      en: "New Zealand",
      it: "Nuova Zelanda",
      es: "Nueva Zelanda",
      de: "Neuseeland",
      pl: "Nowa Zelandia",
      fr: "Nouvelle-Zélande",
      nl: "Nieuw-Zeeland",
      pt: "Nova Zelândia",
      cs: "Nový Zéland",
      ro: "Noua Zeelandă",
      ru: "Новая Зеландия"
    },
    rootIddCode: "+64"
  },
  OM: {
    i18nNames: {
      en: "Oman",
      it: "Oman",
      es: "Omán",
      de: "Oman",
      pl: "Oman",
      fr: "Oman",
      nl: "Oman",
      pt: "Omã",
      cs: "Omán",
      ro: "Oman",
      ru: "Оман"
    },
    rootIddCode: "+968",
    taxIdMandatory: !0,
    taxIdPattern: "^OM\\d{10}$",
    taxIdExample: "OM1234567890"
  },
  PA: {
    i18nNames: {
      en: "Panama",
      it: "Panama",
      es: "Panamá",
      de: "Panama",
      pl: "Panama",
      fr: "Panama",
      nl: "Panama",
      pt: "Panamá",
      cs: "Panama",
      ro: "Panama",
      ru: "Панама"
    },
    rootIddCode: "+507"
  },
  PE: {
    i18nNames: {
      en: "Peru",
      it: "Perù",
      es: "Perú",
      de: "Peru",
      pl: "Peru",
      fr: "Pérou",
      nl: "Peru",
      pt: "Peru",
      cs: "Peru",
      ro: "Peru",
      ru: "Перу"
    },
    rootIddCode: "+51"
  },
  PF: {
    i18nNames: {
      en: "French Polynesia",
      es: "Polinesia Francesa",
      it: "Polinesia Francese",
      de: "Französisch-Polynesien",
      pl: "Polinezja Francuska",
      fr: "Polynésie française",
      nl: "Frans-Polynesië",
      pt: "Polinésia Francesa",
      cs: "Francouzská Polynésie",
      ro: "Polinezia Franceză",
      ru: "Французская Полинезия"
    },
    rootIddCode: "+689"
  },
  PG: {
    i18nNames: {
      en: "Papua New Guinea",
      es: "Papúa Nueva Guinea",
      it: "Papua Nuova Guinea",
      de: "Papua-Neuguinea",
      pl: "Papua-Nowa Gwinea",
      fr: "Papouasie-Nouvelle-Guinée",
      nl: "Papoea-Nieuw-Guinea",
      pt: "Papua-Nova Guiné",
      cs: "Papua-Nová Guinea",
      ro: "Papua Noua Guinee",
      ru: "Папуа — Новая Гвинея"
    },
    rootIddCode: "+675"
  },
  PH: {
    i18nNames: {
      en: "Philippines",
      it: "Filippine",
      es: "Filipinas",
      de: "Philippinen",
      pl: "Filipiny",
      fr: "Philippines",
      nl: "Filipijnen",
      pt: "Filipinas",
      cs: "Filipíny",
      ro: "Filipine",
      ru: "Филиппины"
    },
    rootIddCode: "+63"
  },
  PK: {
    i18nNames: {
      en: "Pakistan",
      it: "Pakistan",
      es: "Pakistán",
      de: "Pakistan",
      pl: "Pakistan",
      fr: "Pakistan",
      nl: "Pakistan",
      pt: "Paquistão",
      cs: "Pákistán",
      ro: "Pakistan",
      ru: "Пакистан"
    },
    rootIddCode: "+92"
  },
  PL: {
    i18nNames: {
      en: "Poland",
      it: "Polonia",
      es: "Polonia",
      de: "Polen",
      pl: "Polska",
      fr: "Pologne",
      nl: "Polen",
      pt: "Polónia",
      cs: "Polsko",
      ro: "Polonia",
      ru: "Польша"
    },
    rootIddCode: "+48",
    blocMemberships: ["EU"],
    regions: YS,
    taxIdMandatory: !0,
    taxIdPattern: "^PL\\d{10}$",
    taxIdExample: "PL1234567890"
  },
  PM: {
    i18nNames: {
      en: "Saint Pierre and Miquelon",
      es: "San Pedro y Miquelón",
      it: "Saint-Pierre e Miquelon",
      de: "Saint-Pierre und Miquelon",
      pl: "Saint-Pierre i Miquelon",
      fr: "Saint-Pierre-et-Miquelon",
      nl: "Saint-Pierre en Miquelon",
      pt: "Saint Pierre e Miquelon",
      cs: "Saint Pierre a Miquelon",
      ro: "Saint Pierre și Miquelon",
      ru: "Сен-Пьер и Микелон"
    },
    rootIddCode: "+508"
  },
  PN: {
    i18nNames: {
      en: "Pitcairn Islands",
      es: "Islas Pitcairn",
      it: "Isole Pitcairn",
      de: "Pitcairninseln",
      pl: "Wyspy Pitcairn",
      fr: "Îles Pitcairn",
      nl: "Pitcairneilanden",
      pt: "Ilhas Pitcairn",
      cs: "Pitcairnovy ostrovy",
      ro: "Insulele Pitcairn",
      ru: "Острова Питкэрн"
    },
    rootIddCode: "+64"
  },
  PR: {
    i18nNames: {
      en: "Puerto Rico",
      it: "Porto Rico",
      es: "Puerto Rico",
      de: "Puerto Rico",
      pl: "Portoryko",
      fr: "Porto Rico",
      nl: "Puerto Rico",
      pt: "Porto Rico",
      cs: "Portoriko",
      ro: "Puerto Rico",
      ru: "Пуэрто-Рико"
    },
    rootIddCode: "+1939"
  },
  PS: {
    i18nNames: {
      en: "Palestine",
      it: "Palestina",
      es: "Palestina",
      de: "Palästina",
      pl: "Palestyna",
      fr: "Palestine",
      nl: "Palestina",
      pt: "Palestina",
      cs: "Palestina",
      ro: "Palestina",
      ru: "Палестина"
    },
    rootIddCode: "+970",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  PT: {
    i18nNames: {
      en: "Portugal",
      it: "Portogallo",
      es: "Portugal",
      de: "Portugal",
      pl: "Portugalia",
      fr: "Portugal",
      nl: "Portugal",
      pt: "Portugal",
      cs: "Portugalsko",
      ro: "Portugalia",
      ru: "Португалия"
    },
    rootIddCode: "+351",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^PT\\d{9}$",
    taxIdExample: "PT123456789"
  },
  PW: {
    i18nNames: {
      en: "Palau",
      it: "Palau",
      es: "Palaos",
      de: "Palau",
      pl: "Palau",
      fr: "Palaos",
      nl: "Palau",
      pt: "Palau",
      cs: "Palau",
      ro: "Palau",
      ru: "Палау"
    },
    rootIddCode: "+680"
  },
  PY: {
    i18nNames: {
      en: "Paraguay",
      it: "Paraguay",
      es: "Paraguay",
      de: "Paraguay",
      pl: "Paragwaj",
      fr: "Paraguay",
      nl: "Paraguay",
      pt: "Paraguai",
      cs: "Paraguay",
      ro: "Paraguay",
      ru: "Парагвай"
    },
    rootIddCode: "+595"
  },
  QA: {
    i18nNames: {
      en: "Qatar",
      it: "Qatar",
      es: "Catar",
      de: "Katar",
      pl: "Katar",
      fr: "Qatar",
      nl: "Qatar",
      pt: "Catar",
      cs: "Katar",
      ro: "Qatar",
      ru: "Катар"
    },
    rootIddCode: "+974"
  },
  RE: {
    i18nNames: {
      en: "Réunion",
      it: "Riunione",
      es: "Reunión",
      de: "Réunion",
      pl: "Reunion",
      fr: "Réunion",
      nl: "Réunion",
      pt: "Reunião",
      cs: "Réunion",
      ro: "Réunion",
      ru: "Реюньон"
    },
    rootIddCode: "+262"
  },
  RO: {
    i18nNames: {
      en: "Romania",
      it: "Romania",
      es: "Rumanía",
      de: "Rumänien",
      pl: "Rumunia",
      fr: "Roumanie",
      nl: "Roemenië",
      pt: "Romênia",
      cs: "Rumunsko",
      ro: "România",
      ru: "Румыния"
    },
    rootIddCode: "+40",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^RO\\d{2,10}$",
    taxIdExample: "RO123456"
  },
  RS: {
    i18nNames: {
      en: "Serbia",
      it: "Serbia",
      es: "Serbia",
      de: "Serbien",
      pl: "Serbia",
      fr: "Serbie",
      nl: "Servië",
      pt: "Sérvia",
      cs: "Srbsko",
      ro: "Serbia",
      ru: "Сербия"
    },
    rootIddCode: "+381",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  RU: {
    i18nNames: {
      en: "Russia",
      it: "Russia",
      es: "Rusia",
      de: "Russland",
      pl: "Rosja",
      fr: "Russie",
      nl: "Rusland",
      pt: "Rússia",
      cs: "Rusko",
      ro: "Rusia",
      ru: "Россия"
    },
    rootIddCode: "+79",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{10}$",
    taxIdExample: "1234567890"
  },
  RW: {
    i18nNames: {
      en: "Rwanda",
      it: "Ruanda",
      es: "Ruanda",
      de: "Ruanda",
      pl: "Rwanda",
      fr: "Rwanda",
      nl: "Rwanda",
      pt: "Ruanda",
      cs: "Rwanda",
      ro: "Rwanda",
      ru: "Руанда"
    },
    rootIddCode: "+250"
  },
  SA: {
    i18nNames: {
      en: "Saudi Arabia",
      it: "Arabia Saudita",
      es: "Arabia Saudita",
      de: "Saudi-Arabien",
      pl: "Arabia Saudyjska",
      fr: "Arabie Saoudite",
      nl: "Saoedi-Arabië",
      pt: "Arábia Saudita",
      cs: "Saúdská Arábie",
      ro: "Arabia Saudită",
      ru: "Саудовская Аравия"
    },
    rootIddCode: "+966",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{15}$",
    taxIdExample: "123456789012345"
  },
  BA: {
    i18nNames: {
      en: "Bosnia and Herzegovina",
      es: "Bosnia y Herzegovina",
      it: "Bosnia ed Erzegovina",
      de: "Bosnien und Herzegовина",
      pl: "Bośnia i Hercegowina",
      fr: "Bosnie-Herzégovine",
      nl: "Bosnië en Herzegovina",
      pt: "Bósnia e Herzegovina",
      cs: "Bosna a Hercegovina",
      ro: "Bosnia și Herțegovina",
      ru: "Босния и Герцеговина"
    },
    rootIddCode: "+387",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{12}|\\d{13})$",
    taxIdExample: "123456789012"
  },
  SB: {
    i18nNames: {
      en: "Solomon Islands",
      it: "Isole Salomone",
      es: "Islas Salomón",
      de: "Salomonen",
      pl: "Wyspy Salomona",
      fr: "Îles Salomon",
      nl: "Salomonseilanden",
      pt: "Ilhas Salomão",
      cs: "Šalamounovy ostrovy",
      ro: "Insulele Solomon",
      ru: "Соломоновы Острова"
    },
    rootIddCode: "+677"
  },
  SC: {
    i18nNames: {
      en: "Seychelles",
      it: "Seychelles",
      es: "Seychelles",
      de: "Seychellen",
      pl: "Seszele",
      fr: "Seychelles",
      nl: "Seychellen",
      pt: "Seicheles",
      cs: "Seychely",
      ro: "Seychelles",
      ru: "Сейшельские Острова"
    },
    rootIddCode: "+248"
  },
  SD: {
    i18nNames: {
      en: "Sudan",
      it: "Sudan",
      es: "Sudán",
      de: "Sudan",
      pl: "Sudan",
      fr: "Soudan",
      nl: "Soedan",
      pt: "Sudão",
      cs: "Súdán",
      ro: "Sudan",
      ru: "Судан"
    },
    rootIddCode: "+249",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{12}$",
    taxIdExample: "123456789012"
  },
  SE: {
    i18nNames: {
      en: "Sweden",
      it: "Svezia",
      es: "Suecia",
      de: "Schweden",
      pl: "Szwecja",
      fr: "Suède",
      nl: "Zweden",
      pt: "Suécia",
      cs: "Švédsko",
      ro: "Suedia",
      ru: "Швеция"
    },
    rootIddCode: "+46",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SE\\d{12}$",
    taxIdExample: "SE123456789012"
  },
  SG: {
    i18nNames: {
      en: "Singapore",
      it: "Singapore",
      es: "Singapur",
      de: "Singapur",
      pl: "Singapur",
      fr: "Singapour",
      nl: "Singapore",
      pt: "Singapura",
      cs: "Singapur",
      ro: "Singapore",
      ru: "Сингапур"
    },
    rootIddCode: "+65"
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
  },
  SH: {
    i18nNames: {
      en: "Saint Helena, Ascension and Tristan da Cunha",
      es: "Santa Elena",
      it: "Sant'Elena, Ascensione e Tristan da Cunha",
      de: "Sankt Helena, Ascension und Tristan da Cunha",
      pl: "Wyspa Świętej Heleny, Wniebowstąpienia i Tristan da Cunha",
      fr: "Sainte-Hélène, Ascension et Tristan da Cunha",
      nl: "Sint-Helena, Ascension en Tristan da Cunha",
      pt: "Santa Helena, Ascensão e Tristão da Cunha",
      cs: "Svatá Helena, Ascension a Tristan da Cunha",
      ro: "Sfânta Elena, Ascension și Tristan da Cunha",
      ru: "Остров Святой Елены, Вознесения и Тристан-да-Кунья"
    },
    rootIddCode: "+247"
  },
  SI: {
    i18nNames: {
      en: "Slovenia",
      it: "Slovenia",
      es: "Eslovenia",
      de: "Slowenien",
      pl: "Słowenia",
      fr: "Slovénie",
      nl: "Slovenië",
      pt: "Eslovênia",
      cs: "Slovinsko",
      ro: "Slovenia",
      ru: "Словения"
    },
    rootIddCode: "+386",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SI\\d{8}$",
    taxIdExample: "SI12345678"
  },
  SJ: {
    i18nNames: {
      en: "Svalbard and Jan Mayen",
      es: "Svalbard y Jan Mayen",
      it: "Svalbard e Jan Mayen",
      de: "Svalbard und Jan Mayen",
      pl: "Svalbard i Jan Mayen",
      fr: "Svalbard et Jan Mayen",
      nl: "Spitsbergen en Jan Mayen",
      pt: "Svalbard e Jan Mayen",
      cs: "Špicberky a Jan Mayen",
      ro: "Svalbard și Jan Mayen",
      ru: "Шпицберген и Ян-Майен"
    },
    rootIddCode: "+4779"
  },
  SK: {
    i18nNames: {
      en: "Slovakia",
      it: "Slovacchia",
      es: "Eslovaquia",
      de: "Slowakei",
      pl: "Słowacja",
      fr: "Slovaquie",
      nl: "Slowakije",
      pt: "Eslováquia",
      cs: "Slovensko",
      ro: "Slovacia",
      ru: "Словакия"
    },
    rootIddCode: "+421",
    blocMemberships: ["EU"],
    taxIdMandatory: !0,
    taxIdPattern: "^SK\\d{10}$",
    taxIdExample: "SK1234567890"
  },
  SL: {
    i18nNames: {
      en: "Sierra Leone",
      it: "Sierra Leone",
      es: "Sierra Leona",
      de: "Sierra Leone",
      pl: "Sierra Leone",
      fr: "Sierra Leone",
      nl: "Sierra Leone",
      pt: "Serra Leoa",
      cs: "Sierra Leone",
      ro: "Sierra Leone",
      ru: "Сьерра-Леоне"
    },
    rootIddCode: "+232"
  },
  SM: {
    i18nNames: {
      en: "San Marino",
      it: "San Marino",
      es: "San Marino",
      de: "San Marino",
      pl: "San Marino",
      fr: "Saint-Marin",
      nl: "San Marino",
      pt: "San Marino",
      cs: "San Marino",
      ro: "San Marino",
      ru: "Сан-Марино"
    },
    rootIddCode: "+378",
    taxIdMandatory: !0,
    taxIdPattern: "^SM\\d{5}$",
    taxIdExample: "SM12345"
  },
  SN: {
    i18nNames: {
      en: "Senegal",
      it: "Senegal",
      es: "Senegal",
      de: "Senegal",
      pl: "Senegal",
      fr: "Sénégal",
      nl: "Senegal",
      pt: "Senegal",
      cs: "Senegal",
      ro: "Senegal",
      ru: "Сенегал"
    },
    rootIddCode: "+221"
  },
  SO: {
    i18nNames: {
      en: "Somalia",
      it: "Somalia",
      es: "Somalia",
      de: "Somalia",
      pl: "Somalia",
      fr: "Somalie",
      nl: "Somalië",
      pt: "Somália",
      cs: "Somálsko",
      ro: "Somalia",
      ru: "Сомали"
    },
    rootIddCode: "+252"
  },
  SR: {
    i18nNames: {
      en: "Suriname",
      it: "Suriname",
      es: "Surinam",
      de: "Suriname",
      pl: "Surinam",
      fr: "Suriname",
      nl: "Suriname",
      pt: "Suriname",
      cs: "Surinam",
      ro: "Surinam",
      ru: "Суринам"
    },
    rootIddCode: "+597"
  },
  SS: {
    i18nNames: {
      en: "South Sudan",
      it: "Sudan del sud",
      es: "Sudán del Sur",
      de: "Südsudan",
      pl: "Sudan Południowy",
      fr: "Soudan du Sud",
      nl: "Zuid-Soedan",
      pt: "Sudão do Sul",
      cs: "Jižní Súdán",
      ro: "Sudanul de Sud",
      ru: "Южный Судан"
    },
    rootIddCode: "+211"
  },
  ST: {
    i18nNames: {
      en: "São Tomé and Príncipe",
      es: "Santo Tomé y Príncipe",
      it: "São Tomé e Príncipe",
      de: "São Tomé und Príncipe",
      pl: "Wyspy Świętego Tomasza i Książęca",
      fr: "Sao Tomé-et-Principe",
      nl: "Sao Tomé en Principe",
      pt: "São Tomé e Príncipe",
      cs: "Svatý Tomáš a Princův ostrov",
      ro: "São Tomé și Príncipe",
      ru: "Сан-Томе и Принсипи"
    },
    rootIddCode: "+239"
  },
  SV: {
    i18nNames: {
      en: "El Salvador",
      it: "El Salvador",
      es: "El Salvador",
      de: "El Salvador",
      pl: "Salwador",
      fr: "Le Salvador",
      nl: "El Salvador",
      pt: "El Salvador",
      cs: "Salvador",
      ro: "El Salvador",
      ru: "Сальвадор"
    },
    rootIddCode: "+503"
  },
  SX: {
    i18nNames: {
      en: "Sint Maarten",
      it: "Sint Maarten",
      es: "San Martín (parte neerlandesa)",
      de: "Sint Maarten",
      pl: "Sint Maarten",
      fr: "Saint-Martin (partie néerlandaise)",
      nl: "Sint Maarten",
      pt: "Sint Maarten",
      cs: "Svatý Martin (nizozemská část)",
      ro: "Sint Maarten",
      ru: "Синт-Мартен"
    },
    rootIddCode: "+1721"
  },
  SY: {
    i18nNames: {
      en: "Syria",
      it: "Siria",
      es: "Siria",
      de: "Сирия",
      pl: "Syria",
      fr: "Syrie",
      nl: "Syrië",
      pt: "Síria",
      cs: "Sýrie",
      ro: "Siria",
      ru: "Сирия"
    },
    rootIddCode: "+963"
  },
  SZ: {
    i18nNames: {
      en: "Eswatini",
      it: "Swaziland",
      es: "Suazilandia",
      de: "Eswatini",
      pl: "Eswatini",
      fr: "Eswatini",
      nl: "Eswatini",
      pt: "Essuatíni",
      cs: "Eswatini",
      ro: "Eswatini",
      ru: "Эсватини"
    },
    rootIddCode: "+268"
  },
  TC: {
    i18nNames: {
      en: "Turks and Caicos Islands",
      es: "Islas Turcas y Caicos",
      it: "Isole Turks e Caicos",
      de: "Turks- und Caicosinseln",
      pl: "Turks i Caicos",
      fr: "Îles Turques-et-Caïques",
      nl: "Turks- en Caicoseilanden",
      pt: "Ilhas Turcas e Caicos",
      cs: "Ostrovy Turks a Caicos",
      ro: "Insulele Turks și Caicos",
      ru: "Теркс и Кайкос"
    },
    rootIddCode: "+1649"
  },
  TD: {
    i18nNames: {
      en: "Chad",
      it: "Ciad",
      es: "Chad",
      de: "Tschad",
      pl: "Czad",
      fr: "Tchad",
      nl: "Tsjaad",
      pt: "Chade",
      cs: "Čад",
      ro: "Ciad",
      ru: "Чад"
    },
    rootIddCode: "+235"
  },
  TF: {
    i18nNames: {
      en: "French Southern and Antarctic Lands",
      es: "Territorios Australes Franceses",
      it: "Territori Francesi del Sud",
      de: "Französische Süd- und Antarktisgebiete",
      pl: "Francuskie Terytoria Południowe i Antarktyczne",
      fr: "Terres australes et antarctiques françaises",
      nl: "Franse Zuidelijke en Antarctische Gebieden",
      pt: "Terras Austrais e Antárticas Francesas",
      cs: "Francouzská jižní a antarktická území",
      ro: "Teritoriile Australe și Antarctice Franceze",
      ru: "Французские южные и антарктические территории"
    },
    rootIddCode: "+262"
  },
  TG: {
    i18nNames: {
      en: "Togo",
      it: "Togo",
      es: "Togo",
      de: "Togo",
      pl: "Togo",
      fr: "Togo",
      nl: "Togo",
      pt: "Togo",
      cs: "Togo",
      ro: "Togo",
      ru: "Того"
    },
    rootIddCode: "+228"
  },
  TH: {
    i18nNames: {
      en: "Thailand",
      it: "Tailandia",
      es: "Tailandia",
      de: "Thailand",
      pl: "Tajlandia",
      fr: "Thaïlande",
      nl: "Thailand",
      pt: "Tailândia",
      cs: "Thajsko",
      ro: "Thailanda",
      ru: "Таиланд"
    },
    rootIddCode: "+66"
  },
  TJ: {
    i18nNames: {
      en: "Tajikistan",
      it: "Tagikistan",
      es: "Tayikistán",
      de: "Tadschikistan",
      pl: "Tadżykistan",
      fr: "Tadjikistan",
      nl: "Tadzjikistan",
      pt: "Tajiquistão",
      cs: "Tádžikistán",
      ro: "Tadjikistan",
      ru: "Таджикистан"
    },
    rootIddCode: "+992"
  },
  TK: {
    i18nNames: {
      en: "Tokelau",
      it: "Isole Tokelau",
      es: "Tokelau",
      de: "Tokelau",
      pl: "Tokelau",
      fr: "Tokelau",
      nl: "Tokelau",
      pt: "Tokelau",
      cs: "Tokelau",
      ro: "Tokelau",
      ru: "Токелау"
    },
    rootIddCode: "+690"
  },
  TL: {
    i18nNames: {
      en: "Timor-Leste",
      it: "Timor Est",
      es: "Timor-Leste",
      de: "Osttimor",
      pl: "Timor Wschodni",
      fr: "Timor oriental",
      nl: "Oost-Timor",
      pt: "Timor-Leste",
      cs: "Východní Timor",
      ro: "Timorul de Est",
      ru: "Восточный Тимор"
    },
    rootIddCode: "+670"
  },
  TM: {
    i18nNames: {
      en: "Turkmenistan",
      it: "Turkmenistan",
      es: "Turkmenistán",
      de: "Turkmenistan",
      pl: "Turkmenistan",
      fr: "Turkménistan",
      nl: "Turkmenistan",
      pt: "Turquemenistão",
      cs: "Turkmenistán",
      ro: "Turkmenistan",
      ru: "Туркменистан"
    },
    rootIddCode: "+993"
  },
  TN: {
    i18nNames: {
      en: "Tunisia",
      it: "Tunisia",
      es: "Túnez",
      de: "Tunesien",
      pl: "Tunezja",
      fr: "Tunisie",
      nl: "Tunesië",
      pt: "Tunísia",
      cs: "Tunisko",
      ro: "Tunisia",
      ru: "Тунис"
    },
    rootIddCode: "+216",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{8}$",
    taxIdExample: "12345678"
  },
  TO: {
    i18nNames: {
      en: "Tonga",
      it: "Tonga",
      es: "Tonga",
      de: "Tonga",
      pl: "Tonga",
      fr: "Tonga",
      nl: "Tonga",
      pt: "Tonga",
      cs: "Tonga",
      ro: "Tonga",
      ru: "Тонга"
    },
    rootIddCode: "+676"
  },
  TR: {
    i18nNames: {
      en: "Turkey",
      it: "Turchia",
      es: "Turquía",
      de: "Türkei",
      pl: "Turcja",
      fr: "Turquie",
      nl: "Turkije",
      pt: "Turquia",
      cs: "Turecko",
      ro: "Turcia",
      ru: "Турция"
    },
    rootIddCode: "+90"
  },
  TT: {
    i18nNames: {
      en: "Trinidad and Tobago",
      es: "Trinidad y Tobago",
      it: "Trinidad e Tobago",
      de: "Trinidad und Tobago",
      pl: "Trynidad i Tobago",
      fr: "Trinité-et-Tobago",
      nl: "Trinidad en Tobago",
      pt: "Trinidad e Tobago",
      cs: "Trinidad a Tobago",
      ro: "Trinidad și Tobago",
      ru: "Тринидад и Тобаго"
    },
    rootIddCode: "+1868"
  },
  TV: {
    i18nNames: {
      en: "Tuvalu",
      it: "Tuvalu",
      es: "Tuvalu",
      de: "Tuvalu",
      pl: "Tuvalu",
      fr: "Tuvalu",
      nl: "Tuvalu",
      pt: "Tuvalu",
      cs: "Tuvalu",
      ro: "Tuvalu",
      ru: "Тувалу"
    },
    rootIddCode: "+688"
  },
  TW: {
    i18nNames: {
      en: "Taiwan",
      it: "Taiwan",
      es: "Taiwán",
      de: "Taiwan",
      pl: "Tajwan",
      fr: "Taïwan",
      nl: "Taiwan",
      pt: "Taiwan",
      cs: "Tchaj-wan",
      ro: "Taiwan",
      ru: "Тайвань"
    },
    rootIddCode: "+886"
  },
  TZ: {
    i18nNames: {
      en: "Tanzania",
      it: "Tanzania",
      es: "Tanzania",
      de: "Tansania",
      pl: "Tanzania",
      fr: "Tanzanie",
      nl: "Tanzania",
      pt: "Tanzânia",
      cs: "Tanzanie",
      ro: "Tanzania",
      ru: "Танзания"
    },
    rootIddCode: "+255"
  },
  UA: {
    i18nNames: {
      en: "Ukraine",
      it: "Ucraina",
      es: "Ucrania",
      de: "Ukraine",
      pl: "Ukraina",
      fr: "Ukraine",
      nl: "Oekraïne",
      pt: "Ucrânia",
      cs: "Ukrajina",
      ro: "Ucraina",
      ru: "Украина"
    },
    rootIddCode: "+380",
    taxIdMandatory: !0,
    taxIdPattern: "^(\\d{8}|\\d{12})$",
    taxIdExample: "12345678"
  },
  UG: {
    i18nNames: {
      en: "Uganda",
      it: "Uganda",
      es: "Uganda",
      de: "Uganda",
      pl: "Uganda",
      fr: "Ouganda",
      nl: "Oeganda",
      pt: "Uganda",
      cs: "Uganda",
      ro: "Uganda",
      ru: "Уганда"
    },
    rootIddCode: "+256"
  },
  UM: {
    i18nNames: {
      en: "United States Minor Outlying Islands",
      es: "Islas menores alejadas de los Estados Unidos",
      it: "Isole minori esterne degli Stati Uniti d'America",
      de: "Kleinere Inselbesitzungen der Vereinigten Staaten",
      pl: "Dalekie Wyspy Mniejsze Stanów Zjednoczonych",
      fr: "Îles mineures éloignées des États-Unis",
      nl: "Kleine afgelegen eilanden van de Verenigde Staten",
      pt: "Ilhas Menores Distantes dos EUA",
      cs: "Menší odlehlé ostrovy USA",
      ro: "Insulele S.U.A. din Oceanul Pacific",
      ru: "Внешние малые острова США"
    },
    rootIddCode: "+268"
  },
  US: {
    i18nNames: {
      en: "United States",
      it: "Stati Uniti d'America",
      es: "Estados Unidos",
      de: "Vereinigte Staaten",
      pl: "Stany Zjednoczone",
      fr: "États-Unis",
      nl: "Verenigde Staten",
      pt: "Estados Unidos",
      cs: "Spojené státy americké",
      ro: "Statele Unite ale Americii",
      ru: "Соединённые Штаты"
    },
    rootIddCode: "+1989"
    //quando verrà mappata aggiungere taxIdMandatory: false, in quanto non obbligatorio
  },
  UY: {
    i18nNames: {
      en: "Uruguay",
      it: "Uruguay",
      es: "Uruguay",
      de: "Uruguay",
      pl: "Urugwaj",
      fr: "Uruguay",
      nl: "Uruguay",
      pt: "Uruguai",
      cs: "Uruguay",
      ro: "Uruguay",
      ru: "Уругвай"
    },
    rootIddCode: "+598"
  },
  UZ: {
    i18nNames: {
      en: "Uzbekistan",
      it: "Uzbekistan",
      es: "Uzbekistán",
      de: "Usbekistan",
      pl: "Uzbekistan",
      fr: "Ouzbékistan",
      nl: "Oezbekistan",
      pt: "Uzbequistão",
      cs: "Uzbekistán",
      ro: "Uzbekistan",
      ru: "Узбекистан"
    },
    rootIddCode: "+998"
  },
  VA: {
    i18nNames: {
      en: "Vatican City",
      it: "Città del Vaticano",
      es: "Ciudad del Vaticano",
      de: "Vatikanstadt",
      pl: "Watykan",
      fr: "Cité du Vatican",
      nl: "Vaticaanstad",
      pt: "Cidade do Vaticano",
      cs: "Vatikán",
      ro: "Vatican",
      ru: "Ватикан"
    },
    rootIddCode: "+379"
  },
  VC: {
    i18nNames: {
      en: "Saint Vincent and the Grenadines",
      es: "San Vicente y las Granadinas",
      it: "Saint Vincent e Grenadine",
      de: "St. Vincent und die Grenadinen",
      pl: "Saint Vincent i Grenadyny",
      fr: "Saint-Vincent-et-les-Grenadines",
      nl: "Saint Vincent en de Grenadines",
      pt: "São Vicente e Granadinas",
      cs: "Svatý Vincenc a Grenadiny",
      ro: "Sfântul Vincent și Grenadine",
      ru: "Сент-Винсент и Гренадины"
    },
    rootIddCode: "+1784"
  },
  VE: {
    i18nNames: {
      en: "Venezuela",
      it: "Venezuela",
      es: "Venezuela",
      de: "Venezuela",
      pl: "Wenezuela",
      fr: "Venezuela",
      nl: "Venezuela",
      pt: "Venezuela",
      cs: "Venezuela",
      ro: "Venezuela",
      ru: "Венесуэла"
    },
    rootIddCode: "+58"
  },
  VG: {
    i18nNames: {
      en: "British Virgin Islands",
      es: "Islas Vírgenes Británicas",
      it: "Isole Vergini Britanniche",
      de: "Britische Jungferninseln",
      pl: "Brytyjskie Wyspy Dziewicze",
      fr: "Îles Vierges britanniques",
      nl: "Britse Maagdeneilanden",
      pt: "Ilhas Virgens Britânicas",
      cs: "Britské Panenské ostrovy",
      ro: "Insulele Virgine Britanice",
      ru: "Британские Виргинские острова"
    },
    rootIddCode: "+1284"
  },
  VI: {
    i18nNames: {
      en: "United States Virgin Islands",
      es: "Islas Vírgenes de los Estados Unidos",
      it: "Isole Vergini americane",
      de: "Amerikanische Jungferninseln",
      pl: "Wyspy Dziewицze Stanów Зjednoczonych",
      fr: "Îles Vierges des États-Unis",
      nl: "Amerikaanse Maagdeneilanden",
      pt: "Ilhas Virgens dos Estados Unidos",
      cs: "Americké Panenské остроvy",
      ro: "Insulele Virgine Americane",
      ru: "Виргинские острова США"
    },
    rootIddCode: "+1340"
  },
  VN: {
    i18nNames: {
      en: "Vietnam",
      it: "Vietnam",
      es: "Vietnam",
      de: "Vietnam",
      pl: "Wietnam",
      fr: "Vietnam",
      nl: "Vietnam",
      pt: "Vietnã",
      cs: "Vietnam",
      ro: "Vietnam",
      ru: "Вьетнам"
    },
    rootIddCode: "+84"
  },
  VU: {
    i18nNames: {
      en: "Vanuatu",
      it: "Vanuatu",
      es: "Vanuatu",
      de: "Vanuatu",
      pl: "Vanuatu",
      fr: "Vanuatu",
      nl: "Vanuatu",
      pt: "Vanuatu",
      cs: "Vanuatu",
      ro: "Vanuatu",
      ru: "Вануату"
    },
    rootIddCode: "+678"
  },
  WF: {
    i18nNames: {
      en: "Wallis and Futuna",
      es: "Wallis y Futuna",
      it: "Wallis e Futuna",
      de: "Wallis und Futuna",
      pl: "Wallis i Futuna",
      fr: "Wallis-et-Futuna",
      nl: "Wallis en Futuna",
      pt: "Wallis e Futuna",
      cs: "Wallis a Futuna",
      ro: "Wallis și Futuna",
      ru: "Уоллис и Футуна"
    },
    rootIddCode: "+681"
  },
  WS: {
    i18nNames: {
      en: "Samoa",
      it: "Samoa",
      es: "Samoa",
      de: "Samoa",
      pl: "Samoa",
      fr: "Samoa",
      nl: "Samoa",
      pt: "Samoa",
      cs: "Samoa",
      ro: "Samoa",
      ru: "Самоа"
    },
    rootIddCode: "+685"
  },
  XK: {
    i18nNames: {
      en: "Kosovo",
      it: "Kosovo",
      es: "Kosovo",
      de: "Kosovo",
      pl: "Kosowo",
      fr: "Kosovo",
      nl: "Kosovo",
      pt: "Kosovo",
      cs: "Kosovo",
      ro: "Kosovo",
      ru: "Косово"
    },
    rootIddCode: "+383",
    taxIdMandatory: !0,
    taxIdPattern: "^\\d{9}$",
    taxIdExample: "123456789"
  },
  YE: {
    i18nNames: {
      en: "Yemen",
      it: "Yemen",
      es: "Yemen",
      de: "Jemen",
      pl: "Jemen",
      fr: "Yémen",
      nl: "Jemen",
      pt: "Iémen",
      cs: "Jemen",
      ro: "Yemen",
      ru: "Йемен"
    },
    rootIddCode: "+967"
  },
  YT: {
    i18nNames: {
      en: "Mayotte",
      it: "Mayotte",
      es: "Mayotte",
      de: "Mayotte",
      pl: "Majotta",
      fr: "Mayotte",
      nl: "Mayotte",
      pt: "Mayotte",
      cs: "Mayotte",
      ro: "Mayotte",
      ru: "Майотта"
    },
    rootIddCode: "+262"
  },
  ZA: {
    i18nNames: {
      en: "South Africa",
      it: "Sud Africa",
      es: "Sudáfrica",
      de: "Südafrika",
      pl: "Republika Południowej Afryki",
      fr: "Afrique du Sud",
      nl: "Zuid-Afrika",
      pt: "África do Sul",
      cs: "Jihoafrická republika",
      ro: "Africa de Sud",
      ru: "Южная Африка"
    },
    rootIddCode: "+27"
  },
  ZM: {
    i18nNames: {
      en: "Zambia",
      it: "Zambia",
      es: "Zambia",
      de: "Sambia",
      pl: "Zambia",
      fr: "Zambie",
      nl: "Zambia",
      pt: "Zâmbia",
      cs: "Zambie",
      ro: "Zambia",
      ru: "Замбия"
    },
    rootIddCode: "+260"
  },
  ZW: {
    i18nNames: {
      en: "Zimbabwe",
      it: "Zimbabwe",
      es: "Zimbabue",
      de: "Simbabwe",
      pl: "Zimbabwe",
      fr: "Zimbabwe",
      nl: "Zimbabwe",
      pt: "Zimbábue",
      cs: "Zimbabwe",
      ro: "Zimbabwe",
      ru: "Зимбабве"
    },
    rootIddCode: "+263"
  }
}, _l = [
  "AD",
  "AE",
  "AF",
  "AG",
  "AI",
  "AL",
  "AM",
  "AO",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AW",
  "AX",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BM",
  "BN",
  "BO",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BV",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CC",
  "CD",
  "CF",
  "CG",
  "CH",
  "CI",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CR",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DE",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "EH",
  "ER",
  "ES",
  "ET",
  "FI",
  "FJ",
  "FK",
  "FM",
  "FO",
  "FR",
  "GA",
  "GB",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GR",
  "GS",
  "GT",
  "GU",
  "GW",
  "GY",
  "HK",
  "HM",
  "HN",
  "HR",
  "HT",
  "HU",
  "ID",
  "IE",
  "IL",
  "IM",
  "IN",
  "IO",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JE",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KI",
  "KM",
  "KN",
  "KP",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NL",
  "NO",
  "NP",
  "NR",
  "NU",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PM",
  "PN",
  "PR",
  "PS",
  "PT",
  "PW",
  "PY",
  "QA",
  "RE",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TC",
  "TD",
  "TF",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TV",
  "TW",
  "TZ",
  "UA",
  "UG",
  "UM",
  "US",
  "UY",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "XK",
  // Kosovo
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW"
];
function A1(r) {
  if (e1(r) !== !0)
    throw new Error(`'${r}' is not a valid ISO 3166-1 alpha-2 Country code`);
  return r;
}
function e1(r) {
  return typeof r == "string" && _l.includes(r);
}
const ml = {
  AD: "AND",
  AE: "ARE",
  AF: "AFG",
  AG: "ATG",
  AI: "AIA",
  AL: "ALB",
  AM: "ARM",
  AO: "AGO",
  AQ: "ATA",
  AR: "ARG",
  AS: "ASM",
  AT: "AUT",
  AU: "AUS",
  AW: "ABW",
  AX: "ALA",
  AZ: "AZE",
  BB: "BRB",
  BD: "BGD",
  BE: "BEL",
  BF: "BFA",
  BG: "BGR",
  BH: "BHR",
  BI: "BDI",
  BJ: "BEN",
  BL: "BLM",
  BM: "BMU",
  BN: "BRN",
  BO: "BOL",
  BQ: "BES",
  BR: "BRA",
  BS: "BHS",
  BT: "BTN",
  BV: "BVT",
  BW: "BWA",
  BY: "BLR",
  BZ: "BLZ",
  CA: "CAN",
  CC: "CCK",
  CD: "COD",
  CF: "CAF",
  CG: "COG",
  CH: "CHE",
  CI: "CIV",
  CK: "COK",
  CL: "CHL",
  CM: "CMR",
  CN: "CHN",
  CO: "COL",
  CR: "CRI",
  CU: "CUB",
  CV: "CPV",
  CW: "CUW",
  CX: "CXR",
  CY: "CYP",
  CZ: "CZE",
  DE: "DEU",
  DJ: "DJI",
  DK: "DNK",
  DM: "DMA",
  DO: "DOM",
  DZ: "DZA",
  EC: "ECU",
  EE: "EST",
  EG: "EGY",
  EH: "ESH",
  ER: "ERI",
  ES: "ESP",
  ET: "ETH",
  FI: "FIN",
  FJ: "FJI",
  FK: "FLK",
  FM: "FSM",
  FO: "FRO",
  FR: "FRA",
  GA: "GAB",
  GB: "GBR",
  GD: "GRD",
  GE: "GEO",
  GF: "GUF",
  GG: "GGY",
  GH: "GHA",
  GI: "GIB",
  GL: "GRL",
  GM: "GMB",
  GN: "GIN",
  GP: "GLP",
  GQ: "GNQ",
  GR: "GRC",
  GS: "SGS",
  GT: "GTM",
  GU: "GUM",
  GW: "GNB",
  GY: "GUY",
  HK: "HKG",
  HM: "HMD",
  HN: "HND",
  HR: "HRV",
  HT: "HTI",
  HU: "HUN",
  ID: "IDN",
  IE: "IRL",
  IL: "ISR",
  IM: "IMN",
  IN: "IND",
  IO: "IOT",
  IQ: "IRQ",
  IR: "IRN",
  IS: "ISL",
  IT: "ITA",
  JE: "JEY",
  JM: "JAM",
  JO: "JOR",
  JP: "JPN",
  KE: "KEN",
  KG: "KGZ",
  KH: "KHM",
  KI: "KIR",
  KM: "COM",
  KN: "KNA",
  KP: "PRK",
  KR: "KOR",
  KW: "KWT",
  KY: "CYM",
  KZ: "KAZ",
  LA: "LAO",
  LB: "LBN",
  LC: "LCA",
  LI: "LIE",
  LK: "LKA",
  LR: "LBR",
  LS: "LSO",
  LT: "LTU",
  LU: "LUX",
  LV: "LVA",
  LY: "LBY",
  MA: "MAR",
  MC: "MCO",
  MD: "MDA",
  ME: "MNE",
  MF: "MAF",
  MG: "MDG",
  MH: "MHL",
  MK: "MKD",
  ML: "MLI",
  MM: "MMR",
  MN: "MNG",
  MO: "MAC",
  MP: "MNP",
  MQ: "MTQ",
  MR: "MRT",
  MS: "MSR",
  MT: "MLT",
  MU: "MUS",
  MV: "MDV",
  MW: "MWI",
  MX: "MEX",
  MY: "MYS",
  MZ: "MOZ",
  NA: "NAM",
  NC: "NCL",
  NE: "NER",
  NF: "NFK",
  NG: "NGA",
  NI: "NIC",
  NL: "NLD",
  NO: "NOR",
  NP: "NPL",
  NR: "NRU",
  NU: "NIU",
  NZ: "NZL",
  OM: "OMN",
  PA: "PAN",
  PE: "PER",
  PF: "PYF",
  PG: "PNG",
  PH: "PHL",
  PK: "PAK",
  PL: "POL",
  PM: "SPM",
  PN: "PCN",
  PR: "PRI",
  PS: "PSE",
  PT: "PRT",
  PW: "PLW",
  PY: "PRY",
  QA: "QAT",
  RE: "REU",
  RO: "ROU",
  RS: "SRB",
  RU: "RUS",
  RW: "RWA",
  SA: "SAU",
  BA: "BIH",
  SB: "SLB",
  SC: "SYC",
  SD: "SDN",
  SE: "SWE",
  SG: "SGP",
  SH: "SHN",
  SI: "SVN",
  SJ: "SJM",
  SK: "SVK",
  SL: "SLE",
  SM: "SMR",
  SN: "SEN",
  SO: "SOM",
  SR: "SUR",
  SS: "SSD",
  ST: "STP",
  SV: "SLV",
  SX: "SXM",
  SY: "SYR",
  SZ: "SWZ",
  TC: "TCA",
  TD: "TCD",
  TF: "ATF",
  TG: "TGO",
  TH: "THA",
  TJ: "TJK",
  TK: "TKL",
  TL: "TLS",
  TM: "TKM",
  TN: "TUN",
  TO: "TON",
  TR: "TUR",
  TT: "TTO",
  TV: "TUV",
  TW: "TWN",
  TZ: "TZA",
  UA: "UKR",
  UG: "UGA",
  UM: "UMI",
  US: "USA",
  UY: "URY",
  UZ: "UZB",
  VA: "VAT",
  VC: "VCT",
  VE: "VEN",
  VG: "VGB",
  VI: "VIR",
  VN: "VNM",
  VU: "VUT",
  WF: "WLF",
  WS: "WSM",
  XK: "UNK",
  YE: "YEM",
  YT: "MYT",
  ZA: "ZAF",
  ZM: "ZMB",
  ZW: "ZWE"
};
function n1(r) {
  return typeof r == "string" && Object.values(ml).includes(r);
}
function C1(r) {
  if (n1(r) !== !0)
    throw new Error(`'${r}' is not a valid ISO 3166-1 alpha-3 Country code`);
  return r;
}
function y1(r) {
  return ml[r];
}
const x1 = 10 * 1024 * 1024, w1 = "pdf", M1 = Object.fromEntries(
  Object.entries(QS).map(([r, t]) => [
    r,
    ("regions" in t ? t.regions : []).flatMap(
      (o) => ("provinces" in o ? o.provinces : []).map((s) => s)
    )
  ])
), r1 = [
  "aa",
  "ab",
  "ae",
  "af",
  "ak",
  "am",
  "an",
  "ar",
  "as",
  "av",
  "ay",
  "az",
  "ba",
  "be",
  "bg",
  "bh",
  "bi",
  "bm",
  "bn",
  "bo",
  "br",
  "bs",
  "ca",
  "ce",
  "ch",
  "co",
  "cr",
  "cs",
  "cu",
  "cv",
  "cy",
  "da",
  "de",
  "dv",
  "dz",
  "ee",
  "el",
  "en",
  "eo",
  "es",
  "et",
  "eu",
  "fa",
  "ff",
  "fi",
  "fj",
  "fo",
  "fr",
  "fy",
  "ga",
  "gd",
  "gl",
  "gn",
  "gu",
  "gv",
  "ha",
  "he",
  "hi",
  "ho",
  "hr",
  "ht",
  "hu",
  "hy",
  "hz",
  "ia",
  "id",
  "ie",
  "ig",
  "ii",
  "ik",
  "io",
  "is",
  "it",
  "iu",
  "ja",
  "jv",
  "ka",
  "kg",
  "ki",
  "kj",
  "kk",
  "kl",
  "km",
  "kn",
  "ko",
  "kr",
  "ks",
  "ku",
  "kv",
  "kw",
  "ky",
  "la",
  "lb",
  "lg",
  "li",
  "ln",
  "lo",
  "lt",
  "lu",
  "lv",
  "mg",
  "mh",
  "mi",
  "mk",
  "ml",
  "mn",
  "mr",
  "ms",
  "mt",
  "my",
  "na",
  "nb",
  "nd",
  "ne",
  "ng",
  "nl",
  "nn",
  "no",
  "nr",
  "nv",
  "ny",
  "oc",
  "oj",
  "om",
  "or",
  "os",
  "pa",
  "pi",
  "pl",
  "ps",
  "pt",
  "qu",
  "rm",
  "rn",
  "ro",
  "ru",
  "rw",
  "sa",
  "sc",
  "sd",
  "se",
  "sg",
  "si",
  "sk",
  "sl",
  "sm",
  "sn",
  "so",
  "sq",
  "sr",
  "ss",
  "st",
  "su",
  "sv",
  "sw",
  "ta",
  "te",
  "tg",
  "th",
  "ti",
  "tk",
  "tl",
  "tn",
  "to",
  "tr",
  "ts",
  "tt",
  "tw",
  "ty",
  "ug",
  "uk",
  "ur",
  "uz",
  "ve",
  "vi",
  "vo",
  "wa",
  "wo",
  "xh",
  "yi",
  "yo",
  "za",
  "zh",
  "zu"
], t1 = cl(r1), N1 = (r) => t1.parse(r), E1 = {
  aa: "Afar",
  ab: "Abkhazian",
  ae: "Avestan",
  af: "Afrikaans",
  ak: "Akan",
  am: "Amharic",
  an: "Aragonese",
  ar: "Arabic",
  as: "Assamese",
  av: "Avaric",
  ay: "Aymara",
  az: "Azerbaijani",
  ba: "Bashkir",
  be: "Belarusian",
  bg: "Bulgarian",
  bh: "Bihari languages",
  bi: "Bislama",
  bm: "Bambara",
  bn: "Bengali",
  bo: "Tibetan",
  br: "Breton",
  bs: "Bosnian",
  ca: "Catalan",
  ce: "Chechen",
  ch: "Chamorro",
  co: "Corsican",
  cr: "Cree",
  cs: "Czech",
  cu: "Church Slavic",
  cv: "Chuvash",
  cy: "Welsh",
  da: "Danish",
  de: "German",
  dv: "Dhivehi",
  dz: "Dzongkha",
  ee: "Ewe",
  el: "Greek",
  en: "English",
  eo: "Esperanto",
  es: "Spanish",
  et: "Estonian",
  eu: "Basque",
  fa: "Persian",
  ff: "Fulah",
  fi: "Finnish",
  fj: "Fijian",
  fo: "Faroese",
  fr: "French",
  fy: "Western Frisian",
  ga: "Irish",
  gd: "Scottish Gaelic",
  gl: "Galician",
  gn: "Guarani",
  gu: "Gujarati",
  gv: "Manx",
  ha: "Hausa",
  he: "Hebrew",
  hi: "Hindi",
  ho: "Hiri Motu",
  hr: "Croatian",
  ht: "Haitian Creole",
  hu: "Hungarian",
  hy: "Armenian",
  hz: "Herero",
  ia: "Interlingua",
  id: "Indonesian",
  ie: "Interlingue",
  ig: "Igbo",
  ii: "Sichuan Yi (Nuosu)",
  ik: "Inupiaq",
  io: "Ido",
  is: "Icelandic",
  it: "Italian",
  iu: "Inuktitut",
  ja: "Japanese",
  jv: "Javanese",
  ka: "Georgian",
  kg: "Kongo",
  ki: "Kikuyu",
  kj: "Kuanyama",
  kk: "Kazakh",
  kl: "Kalaallisut",
  km: "Khmer",
  kn: "Kannada",
  ko: "Korean",
  kr: "Kanuri",
  ks: "Kashmiri",
  ku: "Kurdish",
  kv: "Komi",
  kw: "Cornish",
  ky: "Kyrgyz",
  la: "Latin",
  lb: "Luxembourgish",
  lg: "Ganda",
  li: "Limburgish",
  ln: "Lingala",
  lo: "Lao",
  lt: "Lithuanian",
  lu: "Luba-Katanga",
  lv: "Latvian",
  mg: "Malagasy",
  mh: "Marshallese",
  mi: "Māori",
  mk: "Macedonian",
  ml: "Malayalam",
  mn: "Mongolian",
  mr: "Marathi",
  ms: "Malay",
  mt: "Maltese",
  my: "Burmese",
  na: "Nauru",
  nb: "Norwegian Bokmål",
  nd: "North Ndebele",
  ne: "Nepali",
  ng: "Ndonga",
  nl: "Dutch",
  nn: "Norwegian Nynorsk",
  no: "Norwegian",
  nr: "South Ndebele",
  nv: "Navajo",
  ny: "Chichewa",
  oc: "Occitan",
  oj: "Ojibwa",
  om: "Oromo",
  or: "Odia",
  os: "Ossetian",
  pa: "Punjabi",
  pi: "Pali",
  pl: "Polish",
  ps: "Pashto",
  pt: "Portuguese",
  qu: "Quechua",
  rm: "Romansh",
  rn: "Rundi",
  ro: "Romanian",
  ru: "Russian",
  rw: "Kinyarwanda",
  sa: "Sanskrit",
  sc: "Sardinian",
  sd: "Sindhi",
  se: "Northern Sami",
  sg: "Sango",
  si: "Sinhala",
  sk: "Slovak",
  sl: "Slovenian",
  sm: "Samoan",
  sn: "Shona",
  so: "Somali",
  sq: "Albanian",
  sr: "Serbian",
  ss: "Swati",
  st: "Southern Sotho",
  su: "Sundanese",
  sv: "Swedish",
  sw: "Swahili",
  ta: "Tamil",
  te: "Telugu",
  tg: "Tajik",
  th: "Thai",
  ti: "Tigrinya",
  tk: "Turkmen",
  tl: "Tagalog",
  tn: "Tswana",
  to: "Tongan",
  tr: "Turkish",
  ts: "Tsonga",
  tt: "Tatar",
  tw: "Twi",
  ty: "Tahitian",
  ug: "Uyghur",
  uk: "Ukrainian",
  ur: "Urdu",
  uz: "Uzbek",
  ve: "Venda",
  vi: "Vietnamese",
  vo: "Volapük",
  wa: "Walloon",
  wo: "Wolof",
  xh: "Xhosa",
  yi: "Yiddish",
  yo: "Yoruba",
  za: "Zhuang",
  zh: "Chinese",
  zu: "Zulu"
}, o1 = [..._l, "EU", "EXTRA_EU"];
function i1(r) {
  return typeof r == "string" && o1.includes(r);
}
function k1(r) {
  if (i1(r) !== !0)
    throw new Error(`'${r}' is not a valid tax code origin`);
  return r;
}
const B1 = "backoffice@fleequid.com", P1 = {
  geocodeForward: {
    url: "https://api.mapbox.com/search/geocode/v6/forward",
    params: { types: "place,street,address" }
  }
}, a1 = {
  AD: "ca",
  AE: "ar",
  AF: "ps",
  AG: "en",
  AI: "en",
  AL: "sq",
  AM: "hy",
  AO: "pt",
  AQ: "en",
  AR: "es",
  AS: "sm",
  AT: "de",
  AU: "en",
  AW: "nl",
  AX: "sv",
  AZ: "az",
  BA: "bs",
  BB: "en",
  BD: "bn",
  BE: "fr",
  BF: "fr",
  BG: "bg",
  BH: "ar",
  BI: "rn",
  BJ: "fr",
  BL: "fr",
  BM: "en",
  BN: "ms",
  BO: "es",
  BQ: "nl",
  BR: "pt",
  BS: "en",
  BT: "dz",
  BV: "no",
  BW: "en",
  BY: "ru",
  BZ: "en",
  CA: "fr",
  CC: "en",
  CD: "fr",
  CF: "fr",
  CG: "fr",
  CH: "de",
  CI: "fr",
  CK: "en",
  CL: "es",
  CM: "fr",
  CN: "zh",
  CO: "es",
  CR: "es",
  CU: "es",
  CV: "pt",
  CW: "nl",
  CX: "en",
  CY: "el",
  CZ: "cs",
  DE: "de",
  DJ: "fr",
  DK: "da",
  DM: "en",
  DO: "es",
  DZ: "ar",
  EC: "es",
  EE: "et",
  EG: "ar",
  EH: "ar",
  ER: "ti",
  ES: "es",
  ET: "am",
  FI: "fi",
  FJ: "en",
  FK: "en",
  FM: "en",
  FO: "fo",
  FR: "fr",
  GA: "fr",
  GB: "en",
  GD: "en",
  GE: "ka",
  GF: "fr",
  GG: "en",
  GH: "en",
  GI: "en",
  GL: "kl",
  GM: "en",
  GN: "fr",
  GP: "fr",
  GQ: "es",
  GR: "el",
  GS: "en",
  GT: "es",
  GU: "en",
  GW: "pt",
  GY: "en",
  HK: "zh",
  HM: "en",
  HN: "es",
  HR: "hr",
  HT: "fr",
  HU: "hu",
  ID: "id",
  IE: "en",
  IL: "he",
  IM: "en",
  IN: "hi",
  IO: "en",
  IQ: "ar",
  IR: "fa",
  IS: "is",
  IT: "it",
  JE: "en",
  JM: "en",
  JO: "ar",
  JP: "ja",
  KE: "sw",
  KG: "ru",
  KH: "km",
  KI: "en",
  KM: "ar",
  KN: "en",
  KP: "ko",
  KR: "ko",
  KW: "ar",
  KY: "en",
  KZ: "ru",
  LA: "lo",
  LB: "ar",
  LC: "en",
  LI: "de",
  LK: "si",
  LR: "en",
  LS: "st",
  LT: "lt",
  LU: "de",
  LV: "lv",
  LY: "ar",
  MA: "ar",
  MC: "fr",
  MD: "ro",
  ME: "sr",
  MF: "fr",
  MG: "fr",
  MH: "en",
  MK: "mk",
  ML: "fr",
  MM: "my",
  MN: "mn",
  MO: "zh",
  MP: "en",
  MQ: "fr",
  MR: "ar",
  MS: "en",
  MT: "mt",
  MU: "en",
  MV: "dv",
  MW: "ny",
  MX: "es",
  MY: "ms",
  MZ: "pt",
  NA: "en",
  NC: "fr",
  NE: "fr",
  NF: "en",
  NG: "en",
  NI: "es",
  NL: "nl",
  NO: "no",
  NP: "ne",
  NR: "en",
  NU: "en",
  NZ: "en",
  OM: "ar",
  PA: "es",
  PE: "es",
  PF: "fr",
  PG: "en",
  PH: "tl",
  PK: "ur",
  PL: "pl",
  PM: "fr",
  PN: "en",
  PR: "es",
  PS: "ar",
  PT: "pt",
  PW: "en",
  PY: "es",
  QA: "ar",
  RE: "fr",
  RO: "ro",
  RS: "sr",
  RU: "ru",
  RW: "fr",
  SA: "ar",
  SB: "en",
  SC: "en",
  SD: "ar",
  SE: "sv",
  SG: "en",
  SH: "en",
  SI: "sl",
  SJ: "no",
  SK: "sk",
  SL: "en",
  SM: "it",
  SN: "fr",
  SO: "so",
  SR: "nl",
  SS: "en",
  ST: "pt",
  SV: "es",
  SX: "nl",
  SY: "ar",
  SZ: "ss",
  TC: "en",
  TD: "fr",
  TF: "fr",
  TG: "fr",
  TH: "th",
  TJ: "tg",
  TK: "en",
  TL: "pt",
  TM: "tk",
  TN: "ar",
  TO: "to",
  TR: "tr",
  TT: "en",
  TV: "en",
  TW: "zh",
  TZ: "sw",
  UA: "uk",
  UG: "en",
  UM: "en",
  US: "en",
  UY: "es",
  UZ: "uz",
  VA: "it",
  VC: "en",
  VE: "es",
  VG: "en",
  VI: "en",
  VN: "vi",
  VU: "bi",
  WF: "fr",
  WS: "sm",
  XK: "sq",
  YE: "ar",
  YT: "fr",
  ZA: "en",
  ZM: "en",
  ZW: "en"
};
function R1(r) {
  return a1[r];
}
const gl = {
  addressNumber: xe().optional().nullable(),
  alternate: xe().optional().nullable(),
  country: xe(),
  countryCode: xe(),
  fullAddress: xe(),
  latitude: xu(),
  longitude: xu(),
  mapboxId: xe(),
  place: xe(),
  postcode: xe().optional().nullable(),
  region: xe(),
  streetName: xe().optional().nullable()
}, z1 = Zr(gl), O1 = (r) => Zr(gl, { error: r }), s1 = "AdminUserPasswordResetToken", L1 = Zr({
  type: dl(s1),
  adminUserId: xe(),
  /**
   * NB: this field is consumed by the client only, only has a presentational purposes
   */
  email: xe()
}), u1 = "CustomerUserPasswordResetToken", F1 = Zr({
  type: dl(u1),
  userId: xe()
}), G1 = () => xe().regex(/^\+[1-9]\d{1,14}$/, { message: "Phone must be in E.164 format (e.g. +393331234567)" }), vl = xe().min(5).brand("Tin");
function D1(r) {
  return vl.safeParse(r).success;
}
function l1(r) {
  const t = vl.safeParse(r);
  if (t.success)
    return t.data;
  throw new Error(`Could not parse '${r}' as Tin: ${t.error.issues.map(({ message: o }) => o).join(", ")}`);
}
function Z1(r) {
  return l1(r.replace(/[^a-zA-Z0-9]/g, ""));
}
const U1 = (r, ...t) => r ? t.map((o) => typeof o == "function" ? o() : o) : [];
var Ft = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Lr = { exports: {} };
var c1 = Lr.exports, Bu;
function d1() {
  return Bu || (Bu = 1, (function(r, t) {
    (function() {
      var o, s = "4.17.23", u = 200, f = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", p = "Expected a function", m = "Invalid `variable` option passed into `_.template`", S = "__lodash_hash_undefined__", x = 500, N = "__lodash_placeholder__", L = 1, O = 2, z = 4, te = 1, oe = 2, Ie = 1, gn = 2, Ur = 4, de = 8, pe = 16, ae = 32, $n = 64, qe = 128, pr = 256, qt = 512, Al = 30, Cl = "...", yl = 800, xl = 16, ki = 1, wl = 2, Ml = 3, En = 1 / 0, vn = 9007199254740991, Nl = 17976931348623157e292, $r = NaN, en = 4294967295, El = en - 1, kl = en >>> 1, Bl = [
        ["ary", qe],
        ["bind", Ie],
        ["bindKey", gn],
        ["curry", de],
        ["curryRight", pe],
        ["flip", qt],
        ["partial", ae],
        ["partialRight", $n],
        ["rearg", pr]
      ], Kn = "[object Arguments]", Kr = "[object Array]", Pl = "[object AsyncFunction]", fr = "[object Boolean]", hr = "[object Date]", Rl = "[object DOMException]", Hr = "[object Error]", Wr = "[object Function]", Bi = "[object GeneratorFunction]", Ve = "[object Map]", _r = "[object Number]", zl = "[object Null]", sn = "[object Object]", Pi = "[object Promise]", Ol = "[object Proxy]", mr = "[object RegExp]", Je = "[object Set]", gr = "[object String]", qr = "[object Symbol]", Ll = "[object Undefined]", vr = "[object WeakMap]", Fl = "[object WeakSet]", Ir = "[object ArrayBuffer]", Hn = "[object DataView]", Vt = "[object Float32Array]", Jt = "[object Float64Array]", jt = "[object Int8Array]", Yt = "[object Int16Array]", Xt = "[object Int32Array]", Qt = "[object Uint8Array]", eo = "[object Uint8ClampedArray]", no = "[object Uint16Array]", ro = "[object Uint32Array]", Gl = /\b__p \+= '';/g, Dl = /\b(__p \+=) '' \+/g, Zl = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Ri = /&(?:amp|lt|gt|quot|#39);/g, zi = /[&<>"']/g, Ul = RegExp(Ri.source), $l = RegExp(zi.source), Kl = /<%-([\s\S]+?)%>/g, Hl = /<%([\s\S]+?)%>/g, Oi = /<%=([\s\S]+?)%>/g, Wl = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ql = /^\w*$/, Vl = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, to = /[\\^$.*+?()[\]{}|]/g, Jl = RegExp(to.source), oo = /^\s+/, jl = /\s/, Yl = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Xl = /\{\n\/\* \[wrapped with (.+)\] \*/, Ql = /,? & /, ec = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, nc = /[()=,{}\[\]\/\s]/, rc = /\\(\\)?/g, tc = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Li = /\w*$/, oc = /^[-+]0x[0-9a-f]+$/i, ic = /^0b[01]+$/i, ac = /^\[object .+?Constructor\]$/, sc = /^0o[0-7]+$/i, uc = /^(?:0|[1-9]\d*)$/, lc = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Vr = /($^)/, cc = /['\n\r\u2028\u2029\\]/g, Jr = "\\ud800-\\udfff", dc = "\\u0300-\\u036f", pc = "\\ufe20-\\ufe2f", fc = "\\u20d0-\\u20ff", Fi = dc + pc + fc, Gi = "\\u2700-\\u27bf", Di = "a-z\\xdf-\\xf6\\xf8-\\xff", hc = "\\xac\\xb1\\xd7\\xf7", _c = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", mc = "\\u2000-\\u206f", gc = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Zi = "A-Z\\xc0-\\xd6\\xd8-\\xde", Ui = "\\ufe0e\\ufe0f", $i = hc + _c + mc + gc, io = "['’]", vc = "[" + Jr + "]", Ki = "[" + $i + "]", jr = "[" + Fi + "]", Hi = "\\d+", Ic = "[" + Gi + "]", Wi = "[" + Di + "]", qi = "[^" + Jr + $i + Hi + Gi + Di + Zi + "]", ao = "\\ud83c[\\udffb-\\udfff]", bc = "(?:" + jr + "|" + ao + ")", Vi = "[^" + Jr + "]", so = "(?:\\ud83c[\\udde6-\\uddff]){2}", uo = "[\\ud800-\\udbff][\\udc00-\\udfff]", Wn = "[" + Zi + "]", Ji = "\\u200d", ji = "(?:" + Wi + "|" + qi + ")", Sc = "(?:" + Wn + "|" + qi + ")", Yi = "(?:" + io + "(?:d|ll|m|re|s|t|ve))?", Xi = "(?:" + io + "(?:D|LL|M|RE|S|T|VE))?", Qi = bc + "?", ea = "[" + Ui + "]?", Tc = "(?:" + Ji + "(?:" + [Vi, so, uo].join("|") + ")" + ea + Qi + ")*", Ac = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Cc = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", na = ea + Qi + Tc, yc = "(?:" + [Ic, so, uo].join("|") + ")" + na, xc = "(?:" + [Vi + jr + "?", jr, so, uo, vc].join("|") + ")", wc = RegExp(io, "g"), Mc = RegExp(jr, "g"), lo = RegExp(ao + "(?=" + ao + ")|" + xc + na, "g"), Nc = RegExp([
        Wn + "?" + Wi + "+" + Yi + "(?=" + [Ki, Wn, "$"].join("|") + ")",
        Sc + "+" + Xi + "(?=" + [Ki, Wn + ji, "$"].join("|") + ")",
        Wn + "?" + ji + "+" + Yi,
        Wn + "+" + Xi,
        Cc,
        Ac,
        Hi,
        yc
      ].join("|"), "g"), Ec = RegExp("[" + Ji + Jr + Fi + Ui + "]"), kc = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Bc = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], Pc = -1, X = {};
      X[Vt] = X[Jt] = X[jt] = X[Yt] = X[Xt] = X[Qt] = X[eo] = X[no] = X[ro] = !0, X[Kn] = X[Kr] = X[Ir] = X[fr] = X[Hn] = X[hr] = X[Hr] = X[Wr] = X[Ve] = X[_r] = X[sn] = X[mr] = X[Je] = X[gr] = X[vr] = !1;
      var Y = {};
      Y[Kn] = Y[Kr] = Y[Ir] = Y[Hn] = Y[fr] = Y[hr] = Y[Vt] = Y[Jt] = Y[jt] = Y[Yt] = Y[Xt] = Y[Ve] = Y[_r] = Y[sn] = Y[mr] = Y[Je] = Y[gr] = Y[qr] = Y[Qt] = Y[eo] = Y[no] = Y[ro] = !0, Y[Hr] = Y[Wr] = Y[vr] = !1;
      var Rc = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, zc = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, Oc = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, Lc = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, Fc = parseFloat, Gc = parseInt, ra = typeof Ft == "object" && Ft && Ft.Object === Object && Ft, Dc = typeof self == "object" && self && self.Object === Object && self, me = ra || Dc || Function("return this")(), co = t && !t.nodeType && t, kn = co && !0 && r && !r.nodeType && r, ta = kn && kn.exports === co, po = ta && ra.process, Fe = (function() {
        try {
          var g = kn && kn.require && kn.require("util").types;
          return g || po && po.binding && po.binding("util");
        } catch {
        }
      })(), oa = Fe && Fe.isArrayBuffer, ia = Fe && Fe.isDate, aa = Fe && Fe.isMap, sa = Fe && Fe.isRegExp, ua = Fe && Fe.isSet, la = Fe && Fe.isTypedArray;
      function Be(g, b, I) {
        switch (I.length) {
          case 0:
            return g.call(b);
          case 1:
            return g.call(b, I[0]);
          case 2:
            return g.call(b, I[0], I[1]);
          case 3:
            return g.call(b, I[0], I[1], I[2]);
        }
        return g.apply(b, I);
      }
      function Zc(g, b, I, M) {
        for (var F = -1, W = g == null ? 0 : g.length; ++F < W; ) {
          var fe = g[F];
          b(M, fe, I(fe), g);
        }
        return M;
      }
      function Ge(g, b) {
        for (var I = -1, M = g == null ? 0 : g.length; ++I < M && b(g[I], I, g) !== !1; )
          ;
        return g;
      }
      function Uc(g, b) {
        for (var I = g == null ? 0 : g.length; I-- && b(g[I], I, g) !== !1; )
          ;
        return g;
      }
      function ca(g, b) {
        for (var I = -1, M = g == null ? 0 : g.length; ++I < M; )
          if (!b(g[I], I, g))
            return !1;
        return !0;
      }
      function In(g, b) {
        for (var I = -1, M = g == null ? 0 : g.length, F = 0, W = []; ++I < M; ) {
          var fe = g[I];
          b(fe, I, g) && (W[F++] = fe);
        }
        return W;
      }
      function Yr(g, b) {
        var I = g == null ? 0 : g.length;
        return !!I && qn(g, b, 0) > -1;
      }
      function fo(g, b, I) {
        for (var M = -1, F = g == null ? 0 : g.length; ++M < F; )
          if (I(b, g[M]))
            return !0;
        return !1;
      }
      function Q(g, b) {
        for (var I = -1, M = g == null ? 0 : g.length, F = Array(M); ++I < M; )
          F[I] = b(g[I], I, g);
        return F;
      }
      function bn(g, b) {
        for (var I = -1, M = b.length, F = g.length; ++I < M; )
          g[F + I] = b[I];
        return g;
      }
      function ho(g, b, I, M) {
        var F = -1, W = g == null ? 0 : g.length;
        for (M && W && (I = g[++F]); ++F < W; )
          I = b(I, g[F], F, g);
        return I;
      }
      function $c(g, b, I, M) {
        var F = g == null ? 0 : g.length;
        for (M && F && (I = g[--F]); F--; )
          I = b(I, g[F], F, g);
        return I;
      }
      function _o(g, b) {
        for (var I = -1, M = g == null ? 0 : g.length; ++I < M; )
          if (b(g[I], I, g))
            return !0;
        return !1;
      }
      var Kc = mo("length");
      function Hc(g) {
        return g.split("");
      }
      function Wc(g) {
        return g.match(ec) || [];
      }
      function da(g, b, I) {
        var M;
        return I(g, function(F, W, fe) {
          if (b(F, W, fe))
            return M = W, !1;
        }), M;
      }
      function Xr(g, b, I, M) {
        for (var F = g.length, W = I + (M ? 1 : -1); M ? W-- : ++W < F; )
          if (b(g[W], W, g))
            return W;
        return -1;
      }
      function qn(g, b, I) {
        return b === b ? od(g, b, I) : Xr(g, pa, I);
      }
      function qc(g, b, I, M) {
        for (var F = I - 1, W = g.length; ++F < W; )
          if (M(g[F], b))
            return F;
        return -1;
      }
      function pa(g) {
        return g !== g;
      }
      function fa(g, b) {
        var I = g == null ? 0 : g.length;
        return I ? vo(g, b) / I : $r;
      }
      function mo(g) {
        return function(b) {
          return b == null ? o : b[g];
        };
      }
      function go(g) {
        return function(b) {
          return g == null ? o : g[b];
        };
      }
      function ha(g, b, I, M, F) {
        return F(g, function(W, fe, j) {
          I = M ? (M = !1, W) : b(I, W, fe, j);
        }), I;
      }
      function Vc(g, b) {
        var I = g.length;
        for (g.sort(b); I--; )
          g[I] = g[I].value;
        return g;
      }
      function vo(g, b) {
        for (var I, M = -1, F = g.length; ++M < F; ) {
          var W = b(g[M]);
          W !== o && (I = I === o ? W : I + W);
        }
        return I;
      }
      function Io(g, b) {
        for (var I = -1, M = Array(g); ++I < g; )
          M[I] = b(I);
        return M;
      }
      function Jc(g, b) {
        return Q(b, function(I) {
          return [I, g[I]];
        });
      }
      function _a(g) {
        return g && g.slice(0, Ia(g) + 1).replace(oo, "");
      }
      function Pe(g) {
        return function(b) {
          return g(b);
        };
      }
      function bo(g, b) {
        return Q(b, function(I) {
          return g[I];
        });
      }
      function br(g, b) {
        return g.has(b);
      }
      function ma(g, b) {
        for (var I = -1, M = g.length; ++I < M && qn(b, g[I], 0) > -1; )
          ;
        return I;
      }
      function ga(g, b) {
        for (var I = g.length; I-- && qn(b, g[I], 0) > -1; )
          ;
        return I;
      }
      function jc(g, b) {
        for (var I = g.length, M = 0; I--; )
          g[I] === b && ++M;
        return M;
      }
      var Yc = go(Rc), Xc = go(zc);
      function Qc(g) {
        return "\\" + Lc[g];
      }
      function ed(g, b) {
        return g == null ? o : g[b];
      }
      function Vn(g) {
        return Ec.test(g);
      }
      function nd(g) {
        return kc.test(g);
      }
      function rd(g) {
        for (var b, I = []; !(b = g.next()).done; )
          I.push(b.value);
        return I;
      }
      function So(g) {
        var b = -1, I = Array(g.size);
        return g.forEach(function(M, F) {
          I[++b] = [F, M];
        }), I;
      }
      function va(g, b) {
        return function(I) {
          return g(b(I));
        };
      }
      function Sn(g, b) {
        for (var I = -1, M = g.length, F = 0, W = []; ++I < M; ) {
          var fe = g[I];
          (fe === b || fe === N) && (g[I] = N, W[F++] = I);
        }
        return W;
      }
      function Qr(g) {
        var b = -1, I = Array(g.size);
        return g.forEach(function(M) {
          I[++b] = M;
        }), I;
      }
      function td(g) {
        var b = -1, I = Array(g.size);
        return g.forEach(function(M) {
          I[++b] = [M, M];
        }), I;
      }
      function od(g, b, I) {
        for (var M = I - 1, F = g.length; ++M < F; )
          if (g[M] === b)
            return M;
        return -1;
      }
      function id(g, b, I) {
        for (var M = I + 1; M--; )
          if (g[M] === b)
            return M;
        return M;
      }
      function Jn(g) {
        return Vn(g) ? sd(g) : Kc(g);
      }
      function je(g) {
        return Vn(g) ? ud(g) : Hc(g);
      }
      function Ia(g) {
        for (var b = g.length; b-- && jl.test(g.charAt(b)); )
          ;
        return b;
      }
      var ad = go(Oc);
      function sd(g) {
        for (var b = lo.lastIndex = 0; lo.test(g); )
          ++b;
        return b;
      }
      function ud(g) {
        return g.match(lo) || [];
      }
      function ld(g) {
        return g.match(Nc) || [];
      }
      var cd = (function g(b) {
        b = b == null ? me : jn.defaults(me.Object(), b, jn.pick(me, Bc));
        var I = b.Array, M = b.Date, F = b.Error, W = b.Function, fe = b.Math, j = b.Object, To = b.RegExp, dd = b.String, De = b.TypeError, et = I.prototype, pd = W.prototype, Yn = j.prototype, nt = b["__core-js_shared__"], rt = pd.toString, q = Yn.hasOwnProperty, fd = 0, ba = (function() {
          var e = /[^.]+$/.exec(nt && nt.keys && nt.keys.IE_PROTO || "");
          return e ? "Symbol(src)_1." + e : "";
        })(), tt = Yn.toString, hd = rt.call(j), _d = me._, md = To(
          "^" + rt.call(q).replace(to, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), ot = ta ? b.Buffer : o, Tn = b.Symbol, it = b.Uint8Array, Sa = ot ? ot.allocUnsafe : o, at = va(j.getPrototypeOf, j), Ta = j.create, Aa = Yn.propertyIsEnumerable, st = et.splice, Ca = Tn ? Tn.isConcatSpreadable : o, Sr = Tn ? Tn.iterator : o, Bn = Tn ? Tn.toStringTag : o, ut = (function() {
          try {
            var e = Ln(j, "defineProperty");
            return e({}, "", {}), e;
          } catch {
          }
        })(), gd = b.clearTimeout !== me.clearTimeout && b.clearTimeout, vd = M && M.now !== me.Date.now && M.now, Id = b.setTimeout !== me.setTimeout && b.setTimeout, lt = fe.ceil, ct = fe.floor, Ao = j.getOwnPropertySymbols, bd = ot ? ot.isBuffer : o, ya = b.isFinite, Sd = et.join, Td = va(j.keys, j), he = fe.max, be = fe.min, Ad = M.now, Cd = b.parseInt, xa = fe.random, yd = et.reverse, Co = Ln(b, "DataView"), Tr = Ln(b, "Map"), yo = Ln(b, "Promise"), Xn = Ln(b, "Set"), Ar = Ln(b, "WeakMap"), Cr = Ln(j, "create"), dt = Ar && new Ar(), Qn = {}, xd = Fn(Co), wd = Fn(Tr), Md = Fn(yo), Nd = Fn(Xn), Ed = Fn(Ar), pt = Tn ? Tn.prototype : o, yr = pt ? pt.valueOf : o, wa = pt ? pt.toString : o;
        function c(e) {
          if (ie(e) && !G(e) && !(e instanceof K)) {
            if (e instanceof Ze)
              return e;
            if (q.call(e, "__wrapped__"))
              return Ms(e);
          }
          return new Ze(e);
        }
        var er = /* @__PURE__ */ (function() {
          function e() {
          }
          return function(n) {
            if (!ne(n))
              return {};
            if (Ta)
              return Ta(n);
            e.prototype = n;
            var i = new e();
            return e.prototype = o, i;
          };
        })();
        function ft() {
        }
        function Ze(e, n) {
          this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!n, this.__index__ = 0, this.__values__ = o;
        }
        c.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: Kl,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Hl,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: Oi,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: c
          }
        }, c.prototype = ft.prototype, c.prototype.constructor = c, Ze.prototype = er(ft.prototype), Ze.prototype.constructor = Ze;
        function K(e) {
          this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = en, this.__views__ = [];
        }
        function kd() {
          var e = new K(this.__wrapped__);
          return e.__actions__ = we(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = we(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = we(this.__views__), e;
        }
        function Bd() {
          if (this.__filtered__) {
            var e = new K(this);
            e.__dir__ = -1, e.__filtered__ = !0;
          } else
            e = this.clone(), e.__dir__ *= -1;
          return e;
        }
        function Pd() {
          var e = this.__wrapped__.value(), n = this.__dir__, i = G(e), a = n < 0, l = i ? e.length : 0, d = Hp(0, l, this.__views__), h = d.start, _ = d.end, v = _ - h, T = a ? _ : h - 1, C = this.__iteratees__, y = C.length, w = 0, E = be(v, this.__takeCount__);
          if (!i || !a && l == v && E == v)
            return Ya(e, this.__actions__);
          var P = [];
          e:
            for (; v-- && w < E; ) {
              T += n;
              for (var Z = -1, R = e[T]; ++Z < y; ) {
                var $ = C[Z], H = $.iteratee, Oe = $.type, Ce = H(R);
                if (Oe == wl)
                  R = Ce;
                else if (!Ce) {
                  if (Oe == ki)
                    continue e;
                  break e;
                }
              }
              P[w++] = R;
            }
          return P;
        }
        K.prototype = er(ft.prototype), K.prototype.constructor = K;
        function Pn(e) {
          var n = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++n < i; ) {
            var a = e[n];
            this.set(a[0], a[1]);
          }
        }
        function Rd() {
          this.__data__ = Cr ? Cr(null) : {}, this.size = 0;
        }
        function zd(e) {
          var n = this.has(e) && delete this.__data__[e];
          return this.size -= n ? 1 : 0, n;
        }
        function Od(e) {
          var n = this.__data__;
          if (Cr) {
            var i = n[e];
            return i === S ? o : i;
          }
          return q.call(n, e) ? n[e] : o;
        }
        function Ld(e) {
          var n = this.__data__;
          return Cr ? n[e] !== o : q.call(n, e);
        }
        function Fd(e, n) {
          var i = this.__data__;
          return this.size += this.has(e) ? 0 : 1, i[e] = Cr && n === o ? S : n, this;
        }
        Pn.prototype.clear = Rd, Pn.prototype.delete = zd, Pn.prototype.get = Od, Pn.prototype.has = Ld, Pn.prototype.set = Fd;
        function un(e) {
          var n = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++n < i; ) {
            var a = e[n];
            this.set(a[0], a[1]);
          }
        }
        function Gd() {
          this.__data__ = [], this.size = 0;
        }
        function Dd(e) {
          var n = this.__data__, i = ht(n, e);
          if (i < 0)
            return !1;
          var a = n.length - 1;
          return i == a ? n.pop() : st.call(n, i, 1), --this.size, !0;
        }
        function Zd(e) {
          var n = this.__data__, i = ht(n, e);
          return i < 0 ? o : n[i][1];
        }
        function Ud(e) {
          return ht(this.__data__, e) > -1;
        }
        function $d(e, n) {
          var i = this.__data__, a = ht(i, e);
          return a < 0 ? (++this.size, i.push([e, n])) : i[a][1] = n, this;
        }
        un.prototype.clear = Gd, un.prototype.delete = Dd, un.prototype.get = Zd, un.prototype.has = Ud, un.prototype.set = $d;
        function ln(e) {
          var n = -1, i = e == null ? 0 : e.length;
          for (this.clear(); ++n < i; ) {
            var a = e[n];
            this.set(a[0], a[1]);
          }
        }
        function Kd() {
          this.size = 0, this.__data__ = {
            hash: new Pn(),
            map: new (Tr || un)(),
            string: new Pn()
          };
        }
        function Hd(e) {
          var n = xt(this, e).delete(e);
          return this.size -= n ? 1 : 0, n;
        }
        function Wd(e) {
          return xt(this, e).get(e);
        }
        function qd(e) {
          return xt(this, e).has(e);
        }
        function Vd(e, n) {
          var i = xt(this, e), a = i.size;
          return i.set(e, n), this.size += i.size == a ? 0 : 1, this;
        }
        ln.prototype.clear = Kd, ln.prototype.delete = Hd, ln.prototype.get = Wd, ln.prototype.has = qd, ln.prototype.set = Vd;
        function Rn(e) {
          var n = -1, i = e == null ? 0 : e.length;
          for (this.__data__ = new ln(); ++n < i; )
            this.add(e[n]);
        }
        function Jd(e) {
          return this.__data__.set(e, S), this;
        }
        function jd(e) {
          return this.__data__.has(e);
        }
        Rn.prototype.add = Rn.prototype.push = Jd, Rn.prototype.has = jd;
        function Ye(e) {
          var n = this.__data__ = new un(e);
          this.size = n.size;
        }
        function Yd() {
          this.__data__ = new un(), this.size = 0;
        }
        function Xd(e) {
          var n = this.__data__, i = n.delete(e);
          return this.size = n.size, i;
        }
        function Qd(e) {
          return this.__data__.get(e);
        }
        function ep(e) {
          return this.__data__.has(e);
        }
        function np(e, n) {
          var i = this.__data__;
          if (i instanceof un) {
            var a = i.__data__;
            if (!Tr || a.length < u - 1)
              return a.push([e, n]), this.size = ++i.size, this;
            i = this.__data__ = new ln(a);
          }
          return i.set(e, n), this.size = i.size, this;
        }
        Ye.prototype.clear = Yd, Ye.prototype.delete = Xd, Ye.prototype.get = Qd, Ye.prototype.has = ep, Ye.prototype.set = np;
        function Ma(e, n) {
          var i = G(e), a = !i && Gn(e), l = !i && !a && wn(e), d = !i && !a && !l && or(e), h = i || a || l || d, _ = h ? Io(e.length, dd) : [], v = _.length;
          for (var T in e)
            (n || q.call(e, T)) && !(h && // Safari 9 has enumerable `arguments.length` in strict mode.
            (T == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            l && (T == "offset" || T == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            d && (T == "buffer" || T == "byteLength" || T == "byteOffset") || // Skip index properties.
            fn(T, v))) && _.push(T);
          return _;
        }
        function Na(e) {
          var n = e.length;
          return n ? e[Oo(0, n - 1)] : o;
        }
        function rp(e, n) {
          return wt(we(e), zn(n, 0, e.length));
        }
        function tp(e) {
          return wt(we(e));
        }
        function xo(e, n, i) {
          (i !== o && !Xe(e[n], i) || i === o && !(n in e)) && cn(e, n, i);
        }
        function xr(e, n, i) {
          var a = e[n];
          (!(q.call(e, n) && Xe(a, i)) || i === o && !(n in e)) && cn(e, n, i);
        }
        function ht(e, n) {
          for (var i = e.length; i--; )
            if (Xe(e[i][0], n))
              return i;
          return -1;
        }
        function op(e, n, i, a) {
          return An(e, function(l, d, h) {
            n(a, l, i(l), h);
          }), a;
        }
        function Ea(e, n) {
          return e && rn(n, _e(n), e);
        }
        function ip(e, n) {
          return e && rn(n, Ne(n), e);
        }
        function cn(e, n, i) {
          n == "__proto__" && ut ? ut(e, n, {
            configurable: !0,
            enumerable: !0,
            value: i,
            writable: !0
          }) : e[n] = i;
        }
        function wo(e, n) {
          for (var i = -1, a = n.length, l = I(a), d = e == null; ++i < a; )
            l[i] = d ? o : si(e, n[i]);
          return l;
        }
        function zn(e, n, i) {
          return e === e && (i !== o && (e = e <= i ? e : i), n !== o && (e = e >= n ? e : n)), e;
        }
        function Ue(e, n, i, a, l, d) {
          var h, _ = n & L, v = n & O, T = n & z;
          if (i && (h = l ? i(e, a, l, d) : i(e)), h !== o)
            return h;
          if (!ne(e))
            return e;
          var C = G(e);
          if (C) {
            if (h = qp(e), !_)
              return we(e, h);
          } else {
            var y = Se(e), w = y == Wr || y == Bi;
            if (wn(e))
              return es(e, _);
            if (y == sn || y == Kn || w && !l) {
              if (h = v || w ? {} : Is(e), !_)
                return v ? Op(e, ip(h, e)) : zp(e, Ea(h, e));
            } else {
              if (!Y[y])
                return l ? e : {};
              h = Vp(e, y, _);
            }
          }
          d || (d = new Ye());
          var E = d.get(e);
          if (E)
            return E;
          d.set(e, h), Vs(e) ? e.forEach(function(R) {
            h.add(Ue(R, n, i, R, e, d));
          }) : Ws(e) && e.forEach(function(R, $) {
            h.set($, Ue(R, n, i, $, e, d));
          });
          var P = T ? v ? qo : Wo : v ? Ne : _e, Z = C ? o : P(e);
          return Ge(Z || e, function(R, $) {
            Z && ($ = R, R = e[$]), xr(h, $, Ue(R, n, i, $, e, d));
          }), h;
        }
        function ap(e) {
          var n = _e(e);
          return function(i) {
            return ka(i, e, n);
          };
        }
        function ka(e, n, i) {
          var a = i.length;
          if (e == null)
            return !a;
          for (e = j(e); a--; ) {
            var l = i[a], d = n[l], h = e[l];
            if (h === o && !(l in e) || !d(h))
              return !1;
          }
          return !0;
        }
        function Ba(e, n, i) {
          if (typeof e != "function")
            throw new De(p);
          return Pr(function() {
            e.apply(o, i);
          }, n);
        }
        function wr(e, n, i, a) {
          var l = -1, d = Yr, h = !0, _ = e.length, v = [], T = n.length;
          if (!_)
            return v;
          i && (n = Q(n, Pe(i))), a ? (d = fo, h = !1) : n.length >= u && (d = br, h = !1, n = new Rn(n));
          e:
            for (; ++l < _; ) {
              var C = e[l], y = i == null ? C : i(C);
              if (C = a || C !== 0 ? C : 0, h && y === y) {
                for (var w = T; w--; )
                  if (n[w] === y)
                    continue e;
                v.push(C);
              } else d(n, y, a) || v.push(C);
            }
          return v;
        }
        var An = is(nn), Pa = is(No, !0);
        function sp(e, n) {
          var i = !0;
          return An(e, function(a, l, d) {
            return i = !!n(a, l, d), i;
          }), i;
        }
        function _t(e, n, i) {
          for (var a = -1, l = e.length; ++a < l; ) {
            var d = e[a], h = n(d);
            if (h != null && (_ === o ? h === h && !ze(h) : i(h, _)))
              var _ = h, v = d;
          }
          return v;
        }
        function up(e, n, i, a) {
          var l = e.length;
          for (i = D(i), i < 0 && (i = -i > l ? 0 : l + i), a = a === o || a > l ? l : D(a), a < 0 && (a += l), a = i > a ? 0 : js(a); i < a; )
            e[i++] = n;
          return e;
        }
        function Ra(e, n) {
          var i = [];
          return An(e, function(a, l, d) {
            n(a, l, d) && i.push(a);
          }), i;
        }
        function ge(e, n, i, a, l) {
          var d = -1, h = e.length;
          for (i || (i = jp), l || (l = []); ++d < h; ) {
            var _ = e[d];
            n > 0 && i(_) ? n > 1 ? ge(_, n - 1, i, a, l) : bn(l, _) : a || (l[l.length] = _);
          }
          return l;
        }
        var Mo = as(), za = as(!0);
        function nn(e, n) {
          return e && Mo(e, n, _e);
        }
        function No(e, n) {
          return e && za(e, n, _e);
        }
        function mt(e, n) {
          return In(n, function(i) {
            return hn(e[i]);
          });
        }
        function On(e, n) {
          n = yn(n, e);
          for (var i = 0, a = n.length; e != null && i < a; )
            e = e[tn(n[i++])];
          return i && i == a ? e : o;
        }
        function Oa(e, n, i) {
          var a = n(e);
          return G(e) ? a : bn(a, i(e));
        }
        function Te(e) {
          return e == null ? e === o ? Ll : zl : Bn && Bn in j(e) ? Kp(e) : tf(e);
        }
        function Eo(e, n) {
          return e > n;
        }
        function lp(e, n) {
          return e != null && q.call(e, n);
        }
        function cp(e, n) {
          return e != null && n in j(e);
        }
        function dp(e, n, i) {
          return e >= be(n, i) && e < he(n, i);
        }
        function ko(e, n, i) {
          for (var a = i ? fo : Yr, l = e[0].length, d = e.length, h = d, _ = I(d), v = 1 / 0, T = []; h--; ) {
            var C = e[h];
            h && n && (C = Q(C, Pe(n))), v = be(C.length, v), _[h] = !i && (n || l >= 120 && C.length >= 120) ? new Rn(h && C) : o;
          }
          C = e[0];
          var y = -1, w = _[0];
          e:
            for (; ++y < l && T.length < v; ) {
              var E = C[y], P = n ? n(E) : E;
              if (E = i || E !== 0 ? E : 0, !(w ? br(w, P) : a(T, P, i))) {
                for (h = d; --h; ) {
                  var Z = _[h];
                  if (!(Z ? br(Z, P) : a(e[h], P, i)))
                    continue e;
                }
                w && w.push(P), T.push(E);
              }
            }
          return T;
        }
        function pp(e, n, i, a) {
          return nn(e, function(l, d, h) {
            n(a, i(l), d, h);
          }), a;
        }
        function Mr(e, n, i) {
          n = yn(n, e), e = As(e, n);
          var a = e == null ? e : e[tn(Ke(n))];
          return a == null ? o : Be(a, e, i);
        }
        function La(e) {
          return ie(e) && Te(e) == Kn;
        }
        function fp(e) {
          return ie(e) && Te(e) == Ir;
        }
        function hp(e) {
          return ie(e) && Te(e) == hr;
        }
        function Nr(e, n, i, a, l) {
          return e === n ? !0 : e == null || n == null || !ie(e) && !ie(n) ? e !== e && n !== n : _p(e, n, i, a, Nr, l);
        }
        function _p(e, n, i, a, l, d) {
          var h = G(e), _ = G(n), v = h ? Kr : Se(e), T = _ ? Kr : Se(n);
          v = v == Kn ? sn : v, T = T == Kn ? sn : T;
          var C = v == sn, y = T == sn, w = v == T;
          if (w && wn(e)) {
            if (!wn(n))
              return !1;
            h = !0, C = !1;
          }
          if (w && !C)
            return d || (d = new Ye()), h || or(e) ? ms(e, n, i, a, l, d) : Up(e, n, v, i, a, l, d);
          if (!(i & te)) {
            var E = C && q.call(e, "__wrapped__"), P = y && q.call(n, "__wrapped__");
            if (E || P) {
              var Z = E ? e.value() : e, R = P ? n.value() : n;
              return d || (d = new Ye()), l(Z, R, i, a, d);
            }
          }
          return w ? (d || (d = new Ye()), $p(e, n, i, a, l, d)) : !1;
        }
        function mp(e) {
          return ie(e) && Se(e) == Ve;
        }
        function Bo(e, n, i, a) {
          var l = i.length, d = l, h = !a;
          if (e == null)
            return !d;
          for (e = j(e); l--; ) {
            var _ = i[l];
            if (h && _[2] ? _[1] !== e[_[0]] : !(_[0] in e))
              return !1;
          }
          for (; ++l < d; ) {
            _ = i[l];
            var v = _[0], T = e[v], C = _[1];
            if (h && _[2]) {
              if (T === o && !(v in e))
                return !1;
            } else {
              var y = new Ye();
              if (a)
                var w = a(T, C, v, e, n, y);
              if (!(w === o ? Nr(C, T, te | oe, a, y) : w))
                return !1;
            }
          }
          return !0;
        }
        function Fa(e) {
          if (!ne(e) || Xp(e))
            return !1;
          var n = hn(e) ? md : ac;
          return n.test(Fn(e));
        }
        function gp(e) {
          return ie(e) && Te(e) == mr;
        }
        function vp(e) {
          return ie(e) && Se(e) == Je;
        }
        function Ip(e) {
          return ie(e) && Pt(e.length) && !!X[Te(e)];
        }
        function Ga(e) {
          return typeof e == "function" ? e : e == null ? Ee : typeof e == "object" ? G(e) ? Ua(e[0], e[1]) : Za(e) : su(e);
        }
        function Po(e) {
          if (!Br(e))
            return Td(e);
          var n = [];
          for (var i in j(e))
            q.call(e, i) && i != "constructor" && n.push(i);
          return n;
        }
        function bp(e) {
          if (!ne(e))
            return rf(e);
          var n = Br(e), i = [];
          for (var a in e)
            a == "constructor" && (n || !q.call(e, a)) || i.push(a);
          return i;
        }
        function Ro(e, n) {
          return e < n;
        }
        function Da(e, n) {
          var i = -1, a = Me(e) ? I(e.length) : [];
          return An(e, function(l, d, h) {
            a[++i] = n(l, d, h);
          }), a;
        }
        function Za(e) {
          var n = Jo(e);
          return n.length == 1 && n[0][2] ? Ss(n[0][0], n[0][1]) : function(i) {
            return i === e || Bo(i, e, n);
          };
        }
        function Ua(e, n) {
          return Yo(e) && bs(n) ? Ss(tn(e), n) : function(i) {
            var a = si(i, e);
            return a === o && a === n ? ui(i, e) : Nr(n, a, te | oe);
          };
        }
        function gt(e, n, i, a, l) {
          e !== n && Mo(n, function(d, h) {
            if (l || (l = new Ye()), ne(d))
              Sp(e, n, h, i, gt, a, l);
            else {
              var _ = a ? a(Qo(e, h), d, h + "", e, n, l) : o;
              _ === o && (_ = d), xo(e, h, _);
            }
          }, Ne);
        }
        function Sp(e, n, i, a, l, d, h) {
          var _ = Qo(e, i), v = Qo(n, i), T = h.get(v);
          if (T) {
            xo(e, i, T);
            return;
          }
          var C = d ? d(_, v, i + "", e, n, h) : o, y = C === o;
          if (y) {
            var w = G(v), E = !w && wn(v), P = !w && !E && or(v);
            C = v, w || E || P ? G(_) ? C = _ : se(_) ? C = we(_) : E ? (y = !1, C = es(v, !0)) : P ? (y = !1, C = ns(v, !0)) : C = [] : Rr(v) || Gn(v) ? (C = _, Gn(_) ? C = Ys(_) : (!ne(_) || hn(_)) && (C = Is(v))) : y = !1;
          }
          y && (h.set(v, C), l(C, v, a, d, h), h.delete(v)), xo(e, i, C);
        }
        function $a(e, n) {
          var i = e.length;
          if (i)
            return n += n < 0 ? i : 0, fn(n, i) ? e[n] : o;
        }
        function Ka(e, n, i) {
          n.length ? n = Q(n, function(d) {
            return G(d) ? function(h) {
              return On(h, d.length === 1 ? d[0] : d);
            } : d;
          }) : n = [Ee];
          var a = -1;
          n = Q(n, Pe(B()));
          var l = Da(e, function(d, h, _) {
            var v = Q(n, function(T) {
              return T(d);
            });
            return { criteria: v, index: ++a, value: d };
          });
          return Vc(l, function(d, h) {
            return Rp(d, h, i);
          });
        }
        function Tp(e, n) {
          return Ha(e, n, function(i, a) {
            return ui(e, a);
          });
        }
        function Ha(e, n, i) {
          for (var a = -1, l = n.length, d = {}; ++a < l; ) {
            var h = n[a], _ = On(e, h);
            i(_, h) && Er(d, yn(h, e), _);
          }
          return d;
        }
        function Ap(e) {
          return function(n) {
            return On(n, e);
          };
        }
        function zo(e, n, i, a) {
          var l = a ? qc : qn, d = -1, h = n.length, _ = e;
          for (e === n && (n = we(n)), i && (_ = Q(e, Pe(i))); ++d < h; )
            for (var v = 0, T = n[d], C = i ? i(T) : T; (v = l(_, C, v, a)) > -1; )
              _ !== e && st.call(_, v, 1), st.call(e, v, 1);
          return e;
        }
        function Wa(e, n) {
          for (var i = e ? n.length : 0, a = i - 1; i--; ) {
            var l = n[i];
            if (i == a || l !== d) {
              var d = l;
              fn(l) ? st.call(e, l, 1) : Go(e, l);
            }
          }
          return e;
        }
        function Oo(e, n) {
          return e + ct(xa() * (n - e + 1));
        }
        function Cp(e, n, i, a) {
          for (var l = -1, d = he(lt((n - e) / (i || 1)), 0), h = I(d); d--; )
            h[a ? d : ++l] = e, e += i;
          return h;
        }
        function Lo(e, n) {
          var i = "";
          if (!e || n < 1 || n > vn)
            return i;
          do
            n % 2 && (i += e), n = ct(n / 2), n && (e += e);
          while (n);
          return i;
        }
        function U(e, n) {
          return ei(Ts(e, n, Ee), e + "");
        }
        function yp(e) {
          return Na(ir(e));
        }
        function xp(e, n) {
          var i = ir(e);
          return wt(i, zn(n, 0, i.length));
        }
        function Er(e, n, i, a) {
          if (!ne(e))
            return e;
          n = yn(n, e);
          for (var l = -1, d = n.length, h = d - 1, _ = e; _ != null && ++l < d; ) {
            var v = tn(n[l]), T = i;
            if (v === "__proto__" || v === "constructor" || v === "prototype")
              return e;
            if (l != h) {
              var C = _[v];
              T = a ? a(C, v, _) : o, T === o && (T = ne(C) ? C : fn(n[l + 1]) ? [] : {});
            }
            xr(_, v, T), _ = _[v];
          }
          return e;
        }
        var qa = dt ? function(e, n) {
          return dt.set(e, n), e;
        } : Ee, wp = ut ? function(e, n) {
          return ut(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value: ci(n),
            writable: !0
          });
        } : Ee;
        function Mp(e) {
          return wt(ir(e));
        }
        function $e(e, n, i) {
          var a = -1, l = e.length;
          n < 0 && (n = -n > l ? 0 : l + n), i = i > l ? l : i, i < 0 && (i += l), l = n > i ? 0 : i - n >>> 0, n >>>= 0;
          for (var d = I(l); ++a < l; )
            d[a] = e[a + n];
          return d;
        }
        function Np(e, n) {
          var i;
          return An(e, function(a, l, d) {
            return i = n(a, l, d), !i;
          }), !!i;
        }
        function vt(e, n, i) {
          var a = 0, l = e == null ? a : e.length;
          if (typeof n == "number" && n === n && l <= kl) {
            for (; a < l; ) {
              var d = a + l >>> 1, h = e[d];
              h !== null && !ze(h) && (i ? h <= n : h < n) ? a = d + 1 : l = d;
            }
            return l;
          }
          return Fo(e, n, Ee, i);
        }
        function Fo(e, n, i, a) {
          var l = 0, d = e == null ? 0 : e.length;
          if (d === 0)
            return 0;
          n = i(n);
          for (var h = n !== n, _ = n === null, v = ze(n), T = n === o; l < d; ) {
            var C = ct((l + d) / 2), y = i(e[C]), w = y !== o, E = y === null, P = y === y, Z = ze(y);
            if (h)
              var R = a || P;
            else T ? R = P && (a || w) : _ ? R = P && w && (a || !E) : v ? R = P && w && !E && (a || !Z) : E || Z ? R = !1 : R = a ? y <= n : y < n;
            R ? l = C + 1 : d = C;
          }
          return be(d, El);
        }
        function Va(e, n) {
          for (var i = -1, a = e.length, l = 0, d = []; ++i < a; ) {
            var h = e[i], _ = n ? n(h) : h;
            if (!i || !Xe(_, v)) {
              var v = _;
              d[l++] = h === 0 ? 0 : h;
            }
          }
          return d;
        }
        function Ja(e) {
          return typeof e == "number" ? e : ze(e) ? $r : +e;
        }
        function Re(e) {
          if (typeof e == "string")
            return e;
          if (G(e))
            return Q(e, Re) + "";
          if (ze(e))
            return wa ? wa.call(e) : "";
          var n = e + "";
          return n == "0" && 1 / e == -En ? "-0" : n;
        }
        function Cn(e, n, i) {
          var a = -1, l = Yr, d = e.length, h = !0, _ = [], v = _;
          if (i)
            h = !1, l = fo;
          else if (d >= u) {
            var T = n ? null : Dp(e);
            if (T)
              return Qr(T);
            h = !1, l = br, v = new Rn();
          } else
            v = n ? [] : _;
          e:
            for (; ++a < d; ) {
              var C = e[a], y = n ? n(C) : C;
              if (C = i || C !== 0 ? C : 0, h && y === y) {
                for (var w = v.length; w--; )
                  if (v[w] === y)
                    continue e;
                n && v.push(y), _.push(C);
              } else l(v, y, i) || (v !== _ && v.push(y), _.push(C));
            }
          return _;
        }
        function Go(e, n) {
          n = yn(n, e);
          var i = -1, a = n.length;
          if (!a)
            return !0;
          for (var l = e == null || typeof e != "object" && typeof e != "function"; ++i < a; ) {
            var d = n[i];
            if (typeof d == "string") {
              if (d === "__proto__" && !q.call(e, "__proto__"))
                return !1;
              if (d === "constructor" && i + 1 < a && typeof n[i + 1] == "string" && n[i + 1] === "prototype") {
                if (l && i === 0)
                  continue;
                return !1;
              }
            }
          }
          var h = As(e, n);
          return h == null || delete h[tn(Ke(n))];
        }
        function ja(e, n, i, a) {
          return Er(e, n, i(On(e, n)), a);
        }
        function It(e, n, i, a) {
          for (var l = e.length, d = a ? l : -1; (a ? d-- : ++d < l) && n(e[d], d, e); )
            ;
          return i ? $e(e, a ? 0 : d, a ? d + 1 : l) : $e(e, a ? d + 1 : 0, a ? l : d);
        }
        function Ya(e, n) {
          var i = e;
          return i instanceof K && (i = i.value()), ho(n, function(a, l) {
            return l.func.apply(l.thisArg, bn([a], l.args));
          }, i);
        }
        function Do(e, n, i) {
          var a = e.length;
          if (a < 2)
            return a ? Cn(e[0]) : [];
          for (var l = -1, d = I(a); ++l < a; )
            for (var h = e[l], _ = -1; ++_ < a; )
              _ != l && (d[l] = wr(d[l] || h, e[_], n, i));
          return Cn(ge(d, 1), n, i);
        }
        function Xa(e, n, i) {
          for (var a = -1, l = e.length, d = n.length, h = {}; ++a < l; ) {
            var _ = a < d ? n[a] : o;
            i(h, e[a], _);
          }
          return h;
        }
        function Zo(e) {
          return se(e) ? e : [];
        }
        function Uo(e) {
          return typeof e == "function" ? e : Ee;
        }
        function yn(e, n) {
          return G(e) ? e : Yo(e, n) ? [e] : ws(V(e));
        }
        var Ep = U;
        function xn(e, n, i) {
          var a = e.length;
          return i = i === o ? a : i, !n && i >= a ? e : $e(e, n, i);
        }
        var Qa = gd || function(e) {
          return me.clearTimeout(e);
        };
        function es(e, n) {
          if (n)
            return e.slice();
          var i = e.length, a = Sa ? Sa(i) : new e.constructor(i);
          return e.copy(a), a;
        }
        function $o(e) {
          var n = new e.constructor(e.byteLength);
          return new it(n).set(new it(e)), n;
        }
        function kp(e, n) {
          var i = n ? $o(e.buffer) : e.buffer;
          return new e.constructor(i, e.byteOffset, e.byteLength);
        }
        function Bp(e) {
          var n = new e.constructor(e.source, Li.exec(e));
          return n.lastIndex = e.lastIndex, n;
        }
        function Pp(e) {
          return yr ? j(yr.call(e)) : {};
        }
        function ns(e, n) {
          var i = n ? $o(e.buffer) : e.buffer;
          return new e.constructor(i, e.byteOffset, e.length);
        }
        function rs(e, n) {
          if (e !== n) {
            var i = e !== o, a = e === null, l = e === e, d = ze(e), h = n !== o, _ = n === null, v = n === n, T = ze(n);
            if (!_ && !T && !d && e > n || d && h && v && !_ && !T || a && h && v || !i && v || !l)
              return 1;
            if (!a && !d && !T && e < n || T && i && l && !a && !d || _ && i && l || !h && l || !v)
              return -1;
          }
          return 0;
        }
        function Rp(e, n, i) {
          for (var a = -1, l = e.criteria, d = n.criteria, h = l.length, _ = i.length; ++a < h; ) {
            var v = rs(l[a], d[a]);
            if (v) {
              if (a >= _)
                return v;
              var T = i[a];
              return v * (T == "desc" ? -1 : 1);
            }
          }
          return e.index - n.index;
        }
        function ts(e, n, i, a) {
          for (var l = -1, d = e.length, h = i.length, _ = -1, v = n.length, T = he(d - h, 0), C = I(v + T), y = !a; ++_ < v; )
            C[_] = n[_];
          for (; ++l < h; )
            (y || l < d) && (C[i[l]] = e[l]);
          for (; T--; )
            C[_++] = e[l++];
          return C;
        }
        function os(e, n, i, a) {
          for (var l = -1, d = e.length, h = -1, _ = i.length, v = -1, T = n.length, C = he(d - _, 0), y = I(C + T), w = !a; ++l < C; )
            y[l] = e[l];
          for (var E = l; ++v < T; )
            y[E + v] = n[v];
          for (; ++h < _; )
            (w || l < d) && (y[E + i[h]] = e[l++]);
          return y;
        }
        function we(e, n) {
          var i = -1, a = e.length;
          for (n || (n = I(a)); ++i < a; )
            n[i] = e[i];
          return n;
        }
        function rn(e, n, i, a) {
          var l = !i;
          i || (i = {});
          for (var d = -1, h = n.length; ++d < h; ) {
            var _ = n[d], v = a ? a(i[_], e[_], _, i, e) : o;
            v === o && (v = e[_]), l ? cn(i, _, v) : xr(i, _, v);
          }
          return i;
        }
        function zp(e, n) {
          return rn(e, jo(e), n);
        }
        function Op(e, n) {
          return rn(e, gs(e), n);
        }
        function bt(e, n) {
          return function(i, a) {
            var l = G(i) ? Zc : op, d = n ? n() : {};
            return l(i, e, B(a, 2), d);
          };
        }
        function nr(e) {
          return U(function(n, i) {
            var a = -1, l = i.length, d = l > 1 ? i[l - 1] : o, h = l > 2 ? i[2] : o;
            for (d = e.length > 3 && typeof d == "function" ? (l--, d) : o, h && Ae(i[0], i[1], h) && (d = l < 3 ? o : d, l = 1), n = j(n); ++a < l; ) {
              var _ = i[a];
              _ && e(n, _, a, d);
            }
            return n;
          });
        }
        function is(e, n) {
          return function(i, a) {
            if (i == null)
              return i;
            if (!Me(i))
              return e(i, a);
            for (var l = i.length, d = n ? l : -1, h = j(i); (n ? d-- : ++d < l) && a(h[d], d, h) !== !1; )
              ;
            return i;
          };
        }
        function as(e) {
          return function(n, i, a) {
            for (var l = -1, d = j(n), h = a(n), _ = h.length; _--; ) {
              var v = h[e ? _ : ++l];
              if (i(d[v], v, d) === !1)
                break;
            }
            return n;
          };
        }
        function Lp(e, n, i) {
          var a = n & Ie, l = kr(e);
          function d() {
            var h = this && this !== me && this instanceof d ? l : e;
            return h.apply(a ? i : this, arguments);
          }
          return d;
        }
        function ss(e) {
          return function(n) {
            n = V(n);
            var i = Vn(n) ? je(n) : o, a = i ? i[0] : n.charAt(0), l = i ? xn(i, 1).join("") : n.slice(1);
            return a[e]() + l;
          };
        }
        function rr(e) {
          return function(n) {
            return ho(iu(ou(n).replace(wc, "")), e, "");
          };
        }
        function kr(e) {
          return function() {
            var n = arguments;
            switch (n.length) {
              case 0:
                return new e();
              case 1:
                return new e(n[0]);
              case 2:
                return new e(n[0], n[1]);
              case 3:
                return new e(n[0], n[1], n[2]);
              case 4:
                return new e(n[0], n[1], n[2], n[3]);
              case 5:
                return new e(n[0], n[1], n[2], n[3], n[4]);
              case 6:
                return new e(n[0], n[1], n[2], n[3], n[4], n[5]);
              case 7:
                return new e(n[0], n[1], n[2], n[3], n[4], n[5], n[6]);
            }
            var i = er(e.prototype), a = e.apply(i, n);
            return ne(a) ? a : i;
          };
        }
        function Fp(e, n, i) {
          var a = kr(e);
          function l() {
            for (var d = arguments.length, h = I(d), _ = d, v = tr(l); _--; )
              h[_] = arguments[_];
            var T = d < 3 && h[0] !== v && h[d - 1] !== v ? [] : Sn(h, v);
            if (d -= T.length, d < i)
              return ps(
                e,
                n,
                St,
                l.placeholder,
                o,
                h,
                T,
                o,
                o,
                i - d
              );
            var C = this && this !== me && this instanceof l ? a : e;
            return Be(C, this, h);
          }
          return l;
        }
        function us(e) {
          return function(n, i, a) {
            var l = j(n);
            if (!Me(n)) {
              var d = B(i, 3);
              n = _e(n), i = function(_) {
                return d(l[_], _, l);
              };
            }
            var h = e(n, i, a);
            return h > -1 ? l[d ? n[h] : h] : o;
          };
        }
        function ls(e) {
          return pn(function(n) {
            var i = n.length, a = i, l = Ze.prototype.thru;
            for (e && n.reverse(); a--; ) {
              var d = n[a];
              if (typeof d != "function")
                throw new De(p);
              if (l && !h && yt(d) == "wrapper")
                var h = new Ze([], !0);
            }
            for (a = h ? a : i; ++a < i; ) {
              d = n[a];
              var _ = yt(d), v = _ == "wrapper" ? Vo(d) : o;
              v && Xo(v[0]) && v[1] == (qe | de | ae | pr) && !v[4].length && v[9] == 1 ? h = h[yt(v[0])].apply(h, v[3]) : h = d.length == 1 && Xo(d) ? h[_]() : h.thru(d);
            }
            return function() {
              var T = arguments, C = T[0];
              if (h && T.length == 1 && G(C))
                return h.plant(C).value();
              for (var y = 0, w = i ? n[y].apply(this, T) : C; ++y < i; )
                w = n[y].call(this, w);
              return w;
            };
          });
        }
        function St(e, n, i, a, l, d, h, _, v, T) {
          var C = n & qe, y = n & Ie, w = n & gn, E = n & (de | pe), P = n & qt, Z = w ? o : kr(e);
          function R() {
            for (var $ = arguments.length, H = I($), Oe = $; Oe--; )
              H[Oe] = arguments[Oe];
            if (E)
              var Ce = tr(R), Le = jc(H, Ce);
            if (a && (H = ts(H, a, l, E)), d && (H = os(H, d, h, E)), $ -= Le, E && $ < T) {
              var ue = Sn(H, Ce);
              return ps(
                e,
                n,
                St,
                R.placeholder,
                i,
                H,
                ue,
                _,
                v,
                T - $
              );
            }
            var Qe = y ? i : this, mn = w ? Qe[e] : e;
            return $ = H.length, _ ? H = of(H, _) : P && $ > 1 && H.reverse(), C && v < $ && (H.length = v), this && this !== me && this instanceof R && (mn = Z || kr(mn)), mn.apply(Qe, H);
          }
          return R;
        }
        function cs(e, n) {
          return function(i, a) {
            return pp(i, e, n(a), {});
          };
        }
        function Tt(e, n) {
          return function(i, a) {
            var l;
            if (i === o && a === o)
              return n;
            if (i !== o && (l = i), a !== o) {
              if (l === o)
                return a;
              typeof i == "string" || typeof a == "string" ? (i = Re(i), a = Re(a)) : (i = Ja(i), a = Ja(a)), l = e(i, a);
            }
            return l;
          };
        }
        function Ko(e) {
          return pn(function(n) {
            return n = Q(n, Pe(B())), U(function(i) {
              var a = this;
              return e(n, function(l) {
                return Be(l, a, i);
              });
            });
          });
        }
        function At(e, n) {
          n = n === o ? " " : Re(n);
          var i = n.length;
          if (i < 2)
            return i ? Lo(n, e) : n;
          var a = Lo(n, lt(e / Jn(n)));
          return Vn(n) ? xn(je(a), 0, e).join("") : a.slice(0, e);
        }
        function Gp(e, n, i, a) {
          var l = n & Ie, d = kr(e);
          function h() {
            for (var _ = -1, v = arguments.length, T = -1, C = a.length, y = I(C + v), w = this && this !== me && this instanceof h ? d : e; ++T < C; )
              y[T] = a[T];
            for (; v--; )
              y[T++] = arguments[++_];
            return Be(w, l ? i : this, y);
          }
          return h;
        }
        function ds(e) {
          return function(n, i, a) {
            return a && typeof a != "number" && Ae(n, i, a) && (i = a = o), n = _n(n), i === o ? (i = n, n = 0) : i = _n(i), a = a === o ? n < i ? 1 : -1 : _n(a), Cp(n, i, a, e);
          };
        }
        function Ct(e) {
          return function(n, i) {
            return typeof n == "string" && typeof i == "string" || (n = He(n), i = He(i)), e(n, i);
          };
        }
        function ps(e, n, i, a, l, d, h, _, v, T) {
          var C = n & de, y = C ? h : o, w = C ? o : h, E = C ? d : o, P = C ? o : d;
          n |= C ? ae : $n, n &= ~(C ? $n : ae), n & Ur || (n &= -4);
          var Z = [
            e,
            n,
            l,
            E,
            y,
            P,
            w,
            _,
            v,
            T
          ], R = i.apply(o, Z);
          return Xo(e) && Cs(R, Z), R.placeholder = a, ys(R, e, n);
        }
        function Ho(e) {
          var n = fe[e];
          return function(i, a) {
            if (i = He(i), a = a == null ? 0 : be(D(a), 292), a && ya(i)) {
              var l = (V(i) + "e").split("e"), d = n(l[0] + "e" + (+l[1] + a));
              return l = (V(d) + "e").split("e"), +(l[0] + "e" + (+l[1] - a));
            }
            return n(i);
          };
        }
        var Dp = Xn && 1 / Qr(new Xn([, -0]))[1] == En ? function(e) {
          return new Xn(e);
        } : fi;
        function fs(e) {
          return function(n) {
            var i = Se(n);
            return i == Ve ? So(n) : i == Je ? td(n) : Jc(n, e(n));
          };
        }
        function dn(e, n, i, a, l, d, h, _) {
          var v = n & gn;
          if (!v && typeof e != "function")
            throw new De(p);
          var T = a ? a.length : 0;
          if (T || (n &= -97, a = l = o), h = h === o ? h : he(D(h), 0), _ = _ === o ? _ : D(_), T -= l ? l.length : 0, n & $n) {
            var C = a, y = l;
            a = l = o;
          }
          var w = v ? o : Vo(e), E = [
            e,
            n,
            i,
            a,
            l,
            C,
            y,
            d,
            h,
            _
          ];
          if (w && nf(E, w), e = E[0], n = E[1], i = E[2], a = E[3], l = E[4], _ = E[9] = E[9] === o ? v ? 0 : e.length : he(E[9] - T, 0), !_ && n & (de | pe) && (n &= -25), !n || n == Ie)
            var P = Lp(e, n, i);
          else n == de || n == pe ? P = Fp(e, n, _) : (n == ae || n == (Ie | ae)) && !l.length ? P = Gp(e, n, i, a) : P = St.apply(o, E);
          var Z = w ? qa : Cs;
          return ys(Z(P, E), e, n);
        }
        function hs(e, n, i, a) {
          return e === o || Xe(e, Yn[i]) && !q.call(a, i) ? n : e;
        }
        function _s(e, n, i, a, l, d) {
          return ne(e) && ne(n) && (d.set(n, e), gt(e, n, o, _s, d), d.delete(n)), e;
        }
        function Zp(e) {
          return Rr(e) ? o : e;
        }
        function ms(e, n, i, a, l, d) {
          var h = i & te, _ = e.length, v = n.length;
          if (_ != v && !(h && v > _))
            return !1;
          var T = d.get(e), C = d.get(n);
          if (T && C)
            return T == n && C == e;
          var y = -1, w = !0, E = i & oe ? new Rn() : o;
          for (d.set(e, n), d.set(n, e); ++y < _; ) {
            var P = e[y], Z = n[y];
            if (a)
              var R = h ? a(Z, P, y, n, e, d) : a(P, Z, y, e, n, d);
            if (R !== o) {
              if (R)
                continue;
              w = !1;
              break;
            }
            if (E) {
              if (!_o(n, function($, H) {
                if (!br(E, H) && (P === $ || l(P, $, i, a, d)))
                  return E.push(H);
              })) {
                w = !1;
                break;
              }
            } else if (!(P === Z || l(P, Z, i, a, d))) {
              w = !1;
              break;
            }
          }
          return d.delete(e), d.delete(n), w;
        }
        function Up(e, n, i, a, l, d, h) {
          switch (i) {
            case Hn:
              if (e.byteLength != n.byteLength || e.byteOffset != n.byteOffset)
                return !1;
              e = e.buffer, n = n.buffer;
            case Ir:
              return !(e.byteLength != n.byteLength || !d(new it(e), new it(n)));
            case fr:
            case hr:
            case _r:
              return Xe(+e, +n);
            case Hr:
              return e.name == n.name && e.message == n.message;
            case mr:
            case gr:
              return e == n + "";
            case Ve:
              var _ = So;
            case Je:
              var v = a & te;
              if (_ || (_ = Qr), e.size != n.size && !v)
                return !1;
              var T = h.get(e);
              if (T)
                return T == n;
              a |= oe, h.set(e, n);
              var C = ms(_(e), _(n), a, l, d, h);
              return h.delete(e), C;
            case qr:
              if (yr)
                return yr.call(e) == yr.call(n);
          }
          return !1;
        }
        function $p(e, n, i, a, l, d) {
          var h = i & te, _ = Wo(e), v = _.length, T = Wo(n), C = T.length;
          if (v != C && !h)
            return !1;
          for (var y = v; y--; ) {
            var w = _[y];
            if (!(h ? w in n : q.call(n, w)))
              return !1;
          }
          var E = d.get(e), P = d.get(n);
          if (E && P)
            return E == n && P == e;
          var Z = !0;
          d.set(e, n), d.set(n, e);
          for (var R = h; ++y < v; ) {
            w = _[y];
            var $ = e[w], H = n[w];
            if (a)
              var Oe = h ? a(H, $, w, n, e, d) : a($, H, w, e, n, d);
            if (!(Oe === o ? $ === H || l($, H, i, a, d) : Oe)) {
              Z = !1;
              break;
            }
            R || (R = w == "constructor");
          }
          if (Z && !R) {
            var Ce = e.constructor, Le = n.constructor;
            Ce != Le && "constructor" in e && "constructor" in n && !(typeof Ce == "function" && Ce instanceof Ce && typeof Le == "function" && Le instanceof Le) && (Z = !1);
          }
          return d.delete(e), d.delete(n), Z;
        }
        function pn(e) {
          return ei(Ts(e, o, ks), e + "");
        }
        function Wo(e) {
          return Oa(e, _e, jo);
        }
        function qo(e) {
          return Oa(e, Ne, gs);
        }
        var Vo = dt ? function(e) {
          return dt.get(e);
        } : fi;
        function yt(e) {
          for (var n = e.name + "", i = Qn[n], a = q.call(Qn, n) ? i.length : 0; a--; ) {
            var l = i[a], d = l.func;
            if (d == null || d == e)
              return l.name;
          }
          return n;
        }
        function tr(e) {
          var n = q.call(c, "placeholder") ? c : e;
          return n.placeholder;
        }
        function B() {
          var e = c.iteratee || di;
          return e = e === di ? Ga : e, arguments.length ? e(arguments[0], arguments[1]) : e;
        }
        function xt(e, n) {
          var i = e.__data__;
          return Yp(n) ? i[typeof n == "string" ? "string" : "hash"] : i.map;
        }
        function Jo(e) {
          for (var n = _e(e), i = n.length; i--; ) {
            var a = n[i], l = e[a];
            n[i] = [a, l, bs(l)];
          }
          return n;
        }
        function Ln(e, n) {
          var i = ed(e, n);
          return Fa(i) ? i : o;
        }
        function Kp(e) {
          var n = q.call(e, Bn), i = e[Bn];
          try {
            e[Bn] = o;
            var a = !0;
          } catch {
          }
          var l = tt.call(e);
          return a && (n ? e[Bn] = i : delete e[Bn]), l;
        }
        var jo = Ao ? function(e) {
          return e == null ? [] : (e = j(e), In(Ao(e), function(n) {
            return Aa.call(e, n);
          }));
        } : hi, gs = Ao ? function(e) {
          for (var n = []; e; )
            bn(n, jo(e)), e = at(e);
          return n;
        } : hi, Se = Te;
        (Co && Se(new Co(new ArrayBuffer(1))) != Hn || Tr && Se(new Tr()) != Ve || yo && Se(yo.resolve()) != Pi || Xn && Se(new Xn()) != Je || Ar && Se(new Ar()) != vr) && (Se = function(e) {
          var n = Te(e), i = n == sn ? e.constructor : o, a = i ? Fn(i) : "";
          if (a)
            switch (a) {
              case xd:
                return Hn;
              case wd:
                return Ve;
              case Md:
                return Pi;
              case Nd:
                return Je;
              case Ed:
                return vr;
            }
          return n;
        });
        function Hp(e, n, i) {
          for (var a = -1, l = i.length; ++a < l; ) {
            var d = i[a], h = d.size;
            switch (d.type) {
              case "drop":
                e += h;
                break;
              case "dropRight":
                n -= h;
                break;
              case "take":
                n = be(n, e + h);
                break;
              case "takeRight":
                e = he(e, n - h);
                break;
            }
          }
          return { start: e, end: n };
        }
        function Wp(e) {
          var n = e.match(Xl);
          return n ? n[1].split(Ql) : [];
        }
        function vs(e, n, i) {
          n = yn(n, e);
          for (var a = -1, l = n.length, d = !1; ++a < l; ) {
            var h = tn(n[a]);
            if (!(d = e != null && i(e, h)))
              break;
            e = e[h];
          }
          return d || ++a != l ? d : (l = e == null ? 0 : e.length, !!l && Pt(l) && fn(h, l) && (G(e) || Gn(e)));
        }
        function qp(e) {
          var n = e.length, i = new e.constructor(n);
          return n && typeof e[0] == "string" && q.call(e, "index") && (i.index = e.index, i.input = e.input), i;
        }
        function Is(e) {
          return typeof e.constructor == "function" && !Br(e) ? er(at(e)) : {};
        }
        function Vp(e, n, i) {
          var a = e.constructor;
          switch (n) {
            case Ir:
              return $o(e);
            case fr:
            case hr:
              return new a(+e);
            case Hn:
              return kp(e, i);
            case Vt:
            case Jt:
            case jt:
            case Yt:
            case Xt:
            case Qt:
            case eo:
            case no:
            case ro:
              return ns(e, i);
            case Ve:
              return new a();
            case _r:
            case gr:
              return new a(e);
            case mr:
              return Bp(e);
            case Je:
              return new a();
            case qr:
              return Pp(e);
          }
        }
        function Jp(e, n) {
          var i = n.length;
          if (!i)
            return e;
          var a = i - 1;
          return n[a] = (i > 1 ? "& " : "") + n[a], n = n.join(i > 2 ? ", " : " "), e.replace(Yl, `{
/* [wrapped with ` + n + `] */
`);
        }
        function jp(e) {
          return G(e) || Gn(e) || !!(Ca && e && e[Ca]);
        }
        function fn(e, n) {
          var i = typeof e;
          return n = n ?? vn, !!n && (i == "number" || i != "symbol" && uc.test(e)) && e > -1 && e % 1 == 0 && e < n;
        }
        function Ae(e, n, i) {
          if (!ne(i))
            return !1;
          var a = typeof n;
          return (a == "number" ? Me(i) && fn(n, i.length) : a == "string" && n in i) ? Xe(i[n], e) : !1;
        }
        function Yo(e, n) {
          if (G(e))
            return !1;
          var i = typeof e;
          return i == "number" || i == "symbol" || i == "boolean" || e == null || ze(e) ? !0 : ql.test(e) || !Wl.test(e) || n != null && e in j(n);
        }
        function Yp(e) {
          var n = typeof e;
          return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? e !== "__proto__" : e === null;
        }
        function Xo(e) {
          var n = yt(e), i = c[n];
          if (typeof i != "function" || !(n in K.prototype))
            return !1;
          if (e === i)
            return !0;
          var a = Vo(i);
          return !!a && e === a[0];
        }
        function Xp(e) {
          return !!ba && ba in e;
        }
        var Qp = nt ? hn : _i;
        function Br(e) {
          var n = e && e.constructor, i = typeof n == "function" && n.prototype || Yn;
          return e === i;
        }
        function bs(e) {
          return e === e && !ne(e);
        }
        function Ss(e, n) {
          return function(i) {
            return i == null ? !1 : i[e] === n && (n !== o || e in j(i));
          };
        }
        function ef(e) {
          var n = kt(e, function(a) {
            return i.size === x && i.clear(), a;
          }), i = n.cache;
          return n;
        }
        function nf(e, n) {
          var i = e[1], a = n[1], l = i | a, d = l < (Ie | gn | qe), h = a == qe && i == de || a == qe && i == pr && e[7].length <= n[8] || a == (qe | pr) && n[7].length <= n[8] && i == de;
          if (!(d || h))
            return e;
          a & Ie && (e[2] = n[2], l |= i & Ie ? 0 : Ur);
          var _ = n[3];
          if (_) {
            var v = e[3];
            e[3] = v ? ts(v, _, n[4]) : _, e[4] = v ? Sn(e[3], N) : n[4];
          }
          return _ = n[5], _ && (v = e[5], e[5] = v ? os(v, _, n[6]) : _, e[6] = v ? Sn(e[5], N) : n[6]), _ = n[7], _ && (e[7] = _), a & qe && (e[8] = e[8] == null ? n[8] : be(e[8], n[8])), e[9] == null && (e[9] = n[9]), e[0] = n[0], e[1] = l, e;
        }
        function rf(e) {
          var n = [];
          if (e != null)
            for (var i in j(e))
              n.push(i);
          return n;
        }
        function tf(e) {
          return tt.call(e);
        }
        function Ts(e, n, i) {
          return n = he(n === o ? e.length - 1 : n, 0), function() {
            for (var a = arguments, l = -1, d = he(a.length - n, 0), h = I(d); ++l < d; )
              h[l] = a[n + l];
            l = -1;
            for (var _ = I(n + 1); ++l < n; )
              _[l] = a[l];
            return _[n] = i(h), Be(e, this, _);
          };
        }
        function As(e, n) {
          return n.length < 2 ? e : On(e, $e(n, 0, -1));
        }
        function of(e, n) {
          for (var i = e.length, a = be(n.length, i), l = we(e); a--; ) {
            var d = n[a];
            e[a] = fn(d, i) ? l[d] : o;
          }
          return e;
        }
        function Qo(e, n) {
          if (!(n === "constructor" && typeof e[n] == "function") && n != "__proto__")
            return e[n];
        }
        var Cs = xs(qa), Pr = Id || function(e, n) {
          return me.setTimeout(e, n);
        }, ei = xs(wp);
        function ys(e, n, i) {
          var a = n + "";
          return ei(e, Jp(a, af(Wp(a), i)));
        }
        function xs(e) {
          var n = 0, i = 0;
          return function() {
            var a = Ad(), l = xl - (a - i);
            if (i = a, l > 0) {
              if (++n >= yl)
                return arguments[0];
            } else
              n = 0;
            return e.apply(o, arguments);
          };
        }
        function wt(e, n) {
          var i = -1, a = e.length, l = a - 1;
          for (n = n === o ? a : n; ++i < n; ) {
            var d = Oo(i, l), h = e[d];
            e[d] = e[i], e[i] = h;
          }
          return e.length = n, e;
        }
        var ws = ef(function(e) {
          var n = [];
          return e.charCodeAt(0) === 46 && n.push(""), e.replace(Vl, function(i, a, l, d) {
            n.push(l ? d.replace(rc, "$1") : a || i);
          }), n;
        });
        function tn(e) {
          if (typeof e == "string" || ze(e))
            return e;
          var n = e + "";
          return n == "0" && 1 / e == -En ? "-0" : n;
        }
        function Fn(e) {
          if (e != null) {
            try {
              return rt.call(e);
            } catch {
            }
            try {
              return e + "";
            } catch {
            }
          }
          return "";
        }
        function af(e, n) {
          return Ge(Bl, function(i) {
            var a = "_." + i[0];
            n & i[1] && !Yr(e, a) && e.push(a);
          }), e.sort();
        }
        function Ms(e) {
          if (e instanceof K)
            return e.clone();
          var n = new Ze(e.__wrapped__, e.__chain__);
          return n.__actions__ = we(e.__actions__), n.__index__ = e.__index__, n.__values__ = e.__values__, n;
        }
        function sf(e, n, i) {
          (i ? Ae(e, n, i) : n === o) ? n = 1 : n = he(D(n), 0);
          var a = e == null ? 0 : e.length;
          if (!a || n < 1)
            return [];
          for (var l = 0, d = 0, h = I(lt(a / n)); l < a; )
            h[d++] = $e(e, l, l += n);
          return h;
        }
        function uf(e) {
          for (var n = -1, i = e == null ? 0 : e.length, a = 0, l = []; ++n < i; ) {
            var d = e[n];
            d && (l[a++] = d);
          }
          return l;
        }
        function lf() {
          var e = arguments.length;
          if (!e)
            return [];
          for (var n = I(e - 1), i = arguments[0], a = e; a--; )
            n[a - 1] = arguments[a];
          return bn(G(i) ? we(i) : [i], ge(n, 1));
        }
        var cf = U(function(e, n) {
          return se(e) ? wr(e, ge(n, 1, se, !0)) : [];
        }), df = U(function(e, n) {
          var i = Ke(n);
          return se(i) && (i = o), se(e) ? wr(e, ge(n, 1, se, !0), B(i, 2)) : [];
        }), pf = U(function(e, n) {
          var i = Ke(n);
          return se(i) && (i = o), se(e) ? wr(e, ge(n, 1, se, !0), o, i) : [];
        });
        function ff(e, n, i) {
          var a = e == null ? 0 : e.length;
          return a ? (n = i || n === o ? 1 : D(n), $e(e, n < 0 ? 0 : n, a)) : [];
        }
        function hf(e, n, i) {
          var a = e == null ? 0 : e.length;
          return a ? (n = i || n === o ? 1 : D(n), n = a - n, $e(e, 0, n < 0 ? 0 : n)) : [];
        }
        function _f(e, n) {
          return e && e.length ? It(e, B(n, 3), !0, !0) : [];
        }
        function mf(e, n) {
          return e && e.length ? It(e, B(n, 3), !0) : [];
        }
        function gf(e, n, i, a) {
          var l = e == null ? 0 : e.length;
          return l ? (i && typeof i != "number" && Ae(e, n, i) && (i = 0, a = l), up(e, n, i, a)) : [];
        }
        function Ns(e, n, i) {
          var a = e == null ? 0 : e.length;
          if (!a)
            return -1;
          var l = i == null ? 0 : D(i);
          return l < 0 && (l = he(a + l, 0)), Xr(e, B(n, 3), l);
        }
        function Es(e, n, i) {
          var a = e == null ? 0 : e.length;
          if (!a)
            return -1;
          var l = a - 1;
          return i !== o && (l = D(i), l = i < 0 ? he(a + l, 0) : be(l, a - 1)), Xr(e, B(n, 3), l, !0);
        }
        function ks(e) {
          var n = e == null ? 0 : e.length;
          return n ? ge(e, 1) : [];
        }
        function vf(e) {
          var n = e == null ? 0 : e.length;
          return n ? ge(e, En) : [];
        }
        function If(e, n) {
          var i = e == null ? 0 : e.length;
          return i ? (n = n === o ? 1 : D(n), ge(e, n)) : [];
        }
        function bf(e) {
          for (var n = -1, i = e == null ? 0 : e.length, a = {}; ++n < i; ) {
            var l = e[n];
            a[l[0]] = l[1];
          }
          return a;
        }
        function Bs(e) {
          return e && e.length ? e[0] : o;
        }
        function Sf(e, n, i) {
          var a = e == null ? 0 : e.length;
          if (!a)
            return -1;
          var l = i == null ? 0 : D(i);
          return l < 0 && (l = he(a + l, 0)), qn(e, n, l);
        }
        function Tf(e) {
          var n = e == null ? 0 : e.length;
          return n ? $e(e, 0, -1) : [];
        }
        var Af = U(function(e) {
          var n = Q(e, Zo);
          return n.length && n[0] === e[0] ? ko(n) : [];
        }), Cf = U(function(e) {
          var n = Ke(e), i = Q(e, Zo);
          return n === Ke(i) ? n = o : i.pop(), i.length && i[0] === e[0] ? ko(i, B(n, 2)) : [];
        }), yf = U(function(e) {
          var n = Ke(e), i = Q(e, Zo);
          return n = typeof n == "function" ? n : o, n && i.pop(), i.length && i[0] === e[0] ? ko(i, o, n) : [];
        });
        function xf(e, n) {
          return e == null ? "" : Sd.call(e, n);
        }
        function Ke(e) {
          var n = e == null ? 0 : e.length;
          return n ? e[n - 1] : o;
        }
        function wf(e, n, i) {
          var a = e == null ? 0 : e.length;
          if (!a)
            return -1;
          var l = a;
          return i !== o && (l = D(i), l = l < 0 ? he(a + l, 0) : be(l, a - 1)), n === n ? id(e, n, l) : Xr(e, pa, l, !0);
        }
        function Mf(e, n) {
          return e && e.length ? $a(e, D(n)) : o;
        }
        var Nf = U(Ps);
        function Ps(e, n) {
          return e && e.length && n && n.length ? zo(e, n) : e;
        }
        function Ef(e, n, i) {
          return e && e.length && n && n.length ? zo(e, n, B(i, 2)) : e;
        }
        function kf(e, n, i) {
          return e && e.length && n && n.length ? zo(e, n, o, i) : e;
        }
        var Bf = pn(function(e, n) {
          var i = e == null ? 0 : e.length, a = wo(e, n);
          return Wa(e, Q(n, function(l) {
            return fn(l, i) ? +l : l;
          }).sort(rs)), a;
        });
        function Pf(e, n) {
          var i = [];
          if (!(e && e.length))
            return i;
          var a = -1, l = [], d = e.length;
          for (n = B(n, 3); ++a < d; ) {
            var h = e[a];
            n(h, a, e) && (i.push(h), l.push(a));
          }
          return Wa(e, l), i;
        }
        function ni(e) {
          return e == null ? e : yd.call(e);
        }
        function Rf(e, n, i) {
          var a = e == null ? 0 : e.length;
          return a ? (i && typeof i != "number" && Ae(e, n, i) ? (n = 0, i = a) : (n = n == null ? 0 : D(n), i = i === o ? a : D(i)), $e(e, n, i)) : [];
        }
        function zf(e, n) {
          return vt(e, n);
        }
        function Of(e, n, i) {
          return Fo(e, n, B(i, 2));
        }
        function Lf(e, n) {
          var i = e == null ? 0 : e.length;
          if (i) {
            var a = vt(e, n);
            if (a < i && Xe(e[a], n))
              return a;
          }
          return -1;
        }
        function Ff(e, n) {
          return vt(e, n, !0);
        }
        function Gf(e, n, i) {
          return Fo(e, n, B(i, 2), !0);
        }
        function Df(e, n) {
          var i = e == null ? 0 : e.length;
          if (i) {
            var a = vt(e, n, !0) - 1;
            if (Xe(e[a], n))
              return a;
          }
          return -1;
        }
        function Zf(e) {
          return e && e.length ? Va(e) : [];
        }
        function Uf(e, n) {
          return e && e.length ? Va(e, B(n, 2)) : [];
        }
        function $f(e) {
          var n = e == null ? 0 : e.length;
          return n ? $e(e, 1, n) : [];
        }
        function Kf(e, n, i) {
          return e && e.length ? (n = i || n === o ? 1 : D(n), $e(e, 0, n < 0 ? 0 : n)) : [];
        }
        function Hf(e, n, i) {
          var a = e == null ? 0 : e.length;
          return a ? (n = i || n === o ? 1 : D(n), n = a - n, $e(e, n < 0 ? 0 : n, a)) : [];
        }
        function Wf(e, n) {
          return e && e.length ? It(e, B(n, 3), !1, !0) : [];
        }
        function qf(e, n) {
          return e && e.length ? It(e, B(n, 3)) : [];
        }
        var Vf = U(function(e) {
          return Cn(ge(e, 1, se, !0));
        }), Jf = U(function(e) {
          var n = Ke(e);
          return se(n) && (n = o), Cn(ge(e, 1, se, !0), B(n, 2));
        }), jf = U(function(e) {
          var n = Ke(e);
          return n = typeof n == "function" ? n : o, Cn(ge(e, 1, se, !0), o, n);
        });
        function Yf(e) {
          return e && e.length ? Cn(e) : [];
        }
        function Xf(e, n) {
          return e && e.length ? Cn(e, B(n, 2)) : [];
        }
        function Qf(e, n) {
          return n = typeof n == "function" ? n : o, e && e.length ? Cn(e, o, n) : [];
        }
        function ri(e) {
          if (!(e && e.length))
            return [];
          var n = 0;
          return e = In(e, function(i) {
            if (se(i))
              return n = he(i.length, n), !0;
          }), Io(n, function(i) {
            return Q(e, mo(i));
          });
        }
        function Rs(e, n) {
          if (!(e && e.length))
            return [];
          var i = ri(e);
          return n == null ? i : Q(i, function(a) {
            return Be(n, o, a);
          });
        }
        var eh = U(function(e, n) {
          return se(e) ? wr(e, n) : [];
        }), nh = U(function(e) {
          return Do(In(e, se));
        }), rh = U(function(e) {
          var n = Ke(e);
          return se(n) && (n = o), Do(In(e, se), B(n, 2));
        }), th = U(function(e) {
          var n = Ke(e);
          return n = typeof n == "function" ? n : o, Do(In(e, se), o, n);
        }), oh = U(ri);
        function ih(e, n) {
          return Xa(e || [], n || [], xr);
        }
        function ah(e, n) {
          return Xa(e || [], n || [], Er);
        }
        var sh = U(function(e) {
          var n = e.length, i = n > 1 ? e[n - 1] : o;
          return i = typeof i == "function" ? (e.pop(), i) : o, Rs(e, i);
        });
        function zs(e) {
          var n = c(e);
          return n.__chain__ = !0, n;
        }
        function uh(e, n) {
          return n(e), e;
        }
        function Mt(e, n) {
          return n(e);
        }
        var lh = pn(function(e) {
          var n = e.length, i = n ? e[0] : 0, a = this.__wrapped__, l = function(d) {
            return wo(d, e);
          };
          return n > 1 || this.__actions__.length || !(a instanceof K) || !fn(i) ? this.thru(l) : (a = a.slice(i, +i + (n ? 1 : 0)), a.__actions__.push({
            func: Mt,
            args: [l],
            thisArg: o
          }), new Ze(a, this.__chain__).thru(function(d) {
            return n && !d.length && d.push(o), d;
          }));
        });
        function ch() {
          return zs(this);
        }
        function dh() {
          return new Ze(this.value(), this.__chain__);
        }
        function ph() {
          this.__values__ === o && (this.__values__ = Js(this.value()));
          var e = this.__index__ >= this.__values__.length, n = e ? o : this.__values__[this.__index__++];
          return { done: e, value: n };
        }
        function fh() {
          return this;
        }
        function hh(e) {
          for (var n, i = this; i instanceof ft; ) {
            var a = Ms(i);
            a.__index__ = 0, a.__values__ = o, n ? l.__wrapped__ = a : n = a;
            var l = a;
            i = i.__wrapped__;
          }
          return l.__wrapped__ = e, n;
        }
        function _h() {
          var e = this.__wrapped__;
          if (e instanceof K) {
            var n = e;
            return this.__actions__.length && (n = new K(this)), n = n.reverse(), n.__actions__.push({
              func: Mt,
              args: [ni],
              thisArg: o
            }), new Ze(n, this.__chain__);
          }
          return this.thru(ni);
        }
        function mh() {
          return Ya(this.__wrapped__, this.__actions__);
        }
        var gh = bt(function(e, n, i) {
          q.call(e, i) ? ++e[i] : cn(e, i, 1);
        });
        function vh(e, n, i) {
          var a = G(e) ? ca : sp;
          return i && Ae(e, n, i) && (n = o), a(e, B(n, 3));
        }
        function Ih(e, n) {
          var i = G(e) ? In : Ra;
          return i(e, B(n, 3));
        }
        var bh = us(Ns), Sh = us(Es);
        function Th(e, n) {
          return ge(Nt(e, n), 1);
        }
        function Ah(e, n) {
          return ge(Nt(e, n), En);
        }
        function Ch(e, n, i) {
          return i = i === o ? 1 : D(i), ge(Nt(e, n), i);
        }
        function Os(e, n) {
          var i = G(e) ? Ge : An;
          return i(e, B(n, 3));
        }
        function Ls(e, n) {
          var i = G(e) ? Uc : Pa;
          return i(e, B(n, 3));
        }
        var yh = bt(function(e, n, i) {
          q.call(e, i) ? e[i].push(n) : cn(e, i, [n]);
        });
        function xh(e, n, i, a) {
          e = Me(e) ? e : ir(e), i = i && !a ? D(i) : 0;
          var l = e.length;
          return i < 0 && (i = he(l + i, 0)), Rt(e) ? i <= l && e.indexOf(n, i) > -1 : !!l && qn(e, n, i) > -1;
        }
        var wh = U(function(e, n, i) {
          var a = -1, l = typeof n == "function", d = Me(e) ? I(e.length) : [];
          return An(e, function(h) {
            d[++a] = l ? Be(n, h, i) : Mr(h, n, i);
          }), d;
        }), Mh = bt(function(e, n, i) {
          cn(e, i, n);
        });
        function Nt(e, n) {
          var i = G(e) ? Q : Da;
          return i(e, B(n, 3));
        }
        function Nh(e, n, i, a) {
          return e == null ? [] : (G(n) || (n = n == null ? [] : [n]), i = a ? o : i, G(i) || (i = i == null ? [] : [i]), Ka(e, n, i));
        }
        var Eh = bt(function(e, n, i) {
          e[i ? 0 : 1].push(n);
        }, function() {
          return [[], []];
        });
        function kh(e, n, i) {
          var a = G(e) ? ho : ha, l = arguments.length < 3;
          return a(e, B(n, 4), i, l, An);
        }
        function Bh(e, n, i) {
          var a = G(e) ? $c : ha, l = arguments.length < 3;
          return a(e, B(n, 4), i, l, Pa);
        }
        function Ph(e, n) {
          var i = G(e) ? In : Ra;
          return i(e, Bt(B(n, 3)));
        }
        function Rh(e) {
          var n = G(e) ? Na : yp;
          return n(e);
        }
        function zh(e, n, i) {
          (i ? Ae(e, n, i) : n === o) ? n = 1 : n = D(n);
          var a = G(e) ? rp : xp;
          return a(e, n);
        }
        function Oh(e) {
          var n = G(e) ? tp : Mp;
          return n(e);
        }
        function Lh(e) {
          if (e == null)
            return 0;
          if (Me(e))
            return Rt(e) ? Jn(e) : e.length;
          var n = Se(e);
          return n == Ve || n == Je ? e.size : Po(e).length;
        }
        function Fh(e, n, i) {
          var a = G(e) ? _o : Np;
          return i && Ae(e, n, i) && (n = o), a(e, B(n, 3));
        }
        var Gh = U(function(e, n) {
          if (e == null)
            return [];
          var i = n.length;
          return i > 1 && Ae(e, n[0], n[1]) ? n = [] : i > 2 && Ae(n[0], n[1], n[2]) && (n = [n[0]]), Ka(e, ge(n, 1), []);
        }), Et = vd || function() {
          return me.Date.now();
        };
        function Dh(e, n) {
          if (typeof n != "function")
            throw new De(p);
          return e = D(e), function() {
            if (--e < 1)
              return n.apply(this, arguments);
          };
        }
        function Fs(e, n, i) {
          return n = i ? o : n, n = e && n == null ? e.length : n, dn(e, qe, o, o, o, o, n);
        }
        function Gs(e, n) {
          var i;
          if (typeof n != "function")
            throw new De(p);
          return e = D(e), function() {
            return --e > 0 && (i = n.apply(this, arguments)), e <= 1 && (n = o), i;
          };
        }
        var ti = U(function(e, n, i) {
          var a = Ie;
          if (i.length) {
            var l = Sn(i, tr(ti));
            a |= ae;
          }
          return dn(e, a, n, i, l);
        }), Ds = U(function(e, n, i) {
          var a = Ie | gn;
          if (i.length) {
            var l = Sn(i, tr(Ds));
            a |= ae;
          }
          return dn(n, a, e, i, l);
        });
        function Zs(e, n, i) {
          n = i ? o : n;
          var a = dn(e, de, o, o, o, o, o, n);
          return a.placeholder = Zs.placeholder, a;
        }
        function Us(e, n, i) {
          n = i ? o : n;
          var a = dn(e, pe, o, o, o, o, o, n);
          return a.placeholder = Us.placeholder, a;
        }
        function $s(e, n, i) {
          var a, l, d, h, _, v, T = 0, C = !1, y = !1, w = !0;
          if (typeof e != "function")
            throw new De(p);
          n = He(n) || 0, ne(i) && (C = !!i.leading, y = "maxWait" in i, d = y ? he(He(i.maxWait) || 0, n) : d, w = "trailing" in i ? !!i.trailing : w);
          function E(ue) {
            var Qe = a, mn = l;
            return a = l = o, T = ue, h = e.apply(mn, Qe), h;
          }
          function P(ue) {
            return T = ue, _ = Pr($, n), C ? E(ue) : h;
          }
          function Z(ue) {
            var Qe = ue - v, mn = ue - T, uu = n - Qe;
            return y ? be(uu, d - mn) : uu;
          }
          function R(ue) {
            var Qe = ue - v, mn = ue - T;
            return v === o || Qe >= n || Qe < 0 || y && mn >= d;
          }
          function $() {
            var ue = Et();
            if (R(ue))
              return H(ue);
            _ = Pr($, Z(ue));
          }
          function H(ue) {
            return _ = o, w && a ? E(ue) : (a = l = o, h);
          }
          function Oe() {
            _ !== o && Qa(_), T = 0, a = v = l = _ = o;
          }
          function Ce() {
            return _ === o ? h : H(Et());
          }
          function Le() {
            var ue = Et(), Qe = R(ue);
            if (a = arguments, l = this, v = ue, Qe) {
              if (_ === o)
                return P(v);
              if (y)
                return Qa(_), _ = Pr($, n), E(v);
            }
            return _ === o && (_ = Pr($, n)), h;
          }
          return Le.cancel = Oe, Le.flush = Ce, Le;
        }
        var Zh = U(function(e, n) {
          return Ba(e, 1, n);
        }), Uh = U(function(e, n, i) {
          return Ba(e, He(n) || 0, i);
        });
        function $h(e) {
          return dn(e, qt);
        }
        function kt(e, n) {
          if (typeof e != "function" || n != null && typeof n != "function")
            throw new De(p);
          var i = function() {
            var a = arguments, l = n ? n.apply(this, a) : a[0], d = i.cache;
            if (d.has(l))
              return d.get(l);
            var h = e.apply(this, a);
            return i.cache = d.set(l, h) || d, h;
          };
          return i.cache = new (kt.Cache || ln)(), i;
        }
        kt.Cache = ln;
        function Bt(e) {
          if (typeof e != "function")
            throw new De(p);
          return function() {
            var n = arguments;
            switch (n.length) {
              case 0:
                return !e.call(this);
              case 1:
                return !e.call(this, n[0]);
              case 2:
                return !e.call(this, n[0], n[1]);
              case 3:
                return !e.call(this, n[0], n[1], n[2]);
            }
            return !e.apply(this, n);
          };
        }
        function Kh(e) {
          return Gs(2, e);
        }
        var Hh = Ep(function(e, n) {
          n = n.length == 1 && G(n[0]) ? Q(n[0], Pe(B())) : Q(ge(n, 1), Pe(B()));
          var i = n.length;
          return U(function(a) {
            for (var l = -1, d = be(a.length, i); ++l < d; )
              a[l] = n[l].call(this, a[l]);
            return Be(e, this, a);
          });
        }), oi = U(function(e, n) {
          var i = Sn(n, tr(oi));
          return dn(e, ae, o, n, i);
        }), Ks = U(function(e, n) {
          var i = Sn(n, tr(Ks));
          return dn(e, $n, o, n, i);
        }), Wh = pn(function(e, n) {
          return dn(e, pr, o, o, o, n);
        });
        function qh(e, n) {
          if (typeof e != "function")
            throw new De(p);
          return n = n === o ? n : D(n), U(e, n);
        }
        function Vh(e, n) {
          if (typeof e != "function")
            throw new De(p);
          return n = n == null ? 0 : he(D(n), 0), U(function(i) {
            var a = i[n], l = xn(i, 0, n);
            return a && bn(l, a), Be(e, this, l);
          });
        }
        function Jh(e, n, i) {
          var a = !0, l = !0;
          if (typeof e != "function")
            throw new De(p);
          return ne(i) && (a = "leading" in i ? !!i.leading : a, l = "trailing" in i ? !!i.trailing : l), $s(e, n, {
            leading: a,
            maxWait: n,
            trailing: l
          });
        }
        function jh(e) {
          return Fs(e, 1);
        }
        function Yh(e, n) {
          return oi(Uo(n), e);
        }
        function Xh() {
          if (!arguments.length)
            return [];
          var e = arguments[0];
          return G(e) ? e : [e];
        }
        function Qh(e) {
          return Ue(e, z);
        }
        function e_(e, n) {
          return n = typeof n == "function" ? n : o, Ue(e, z, n);
        }
        function n_(e) {
          return Ue(e, L | z);
        }
        function r_(e, n) {
          return n = typeof n == "function" ? n : o, Ue(e, L | z, n);
        }
        function t_(e, n) {
          return n == null || ka(e, n, _e(n));
        }
        function Xe(e, n) {
          return e === n || e !== e && n !== n;
        }
        var o_ = Ct(Eo), i_ = Ct(function(e, n) {
          return e >= n;
        }), Gn = La(/* @__PURE__ */ (function() {
          return arguments;
        })()) ? La : function(e) {
          return ie(e) && q.call(e, "callee") && !Aa.call(e, "callee");
        }, G = I.isArray, a_ = oa ? Pe(oa) : fp;
        function Me(e) {
          return e != null && Pt(e.length) && !hn(e);
        }
        function se(e) {
          return ie(e) && Me(e);
        }
        function s_(e) {
          return e === !0 || e === !1 || ie(e) && Te(e) == fr;
        }
        var wn = bd || _i, u_ = ia ? Pe(ia) : hp;
        function l_(e) {
          return ie(e) && e.nodeType === 1 && !Rr(e);
        }
        function c_(e) {
          if (e == null)
            return !0;
          if (Me(e) && (G(e) || typeof e == "string" || typeof e.splice == "function" || wn(e) || or(e) || Gn(e)))
            return !e.length;
          var n = Se(e);
          if (n == Ve || n == Je)
            return !e.size;
          if (Br(e))
            return !Po(e).length;
          for (var i in e)
            if (q.call(e, i))
              return !1;
          return !0;
        }
        function d_(e, n) {
          return Nr(e, n);
        }
        function p_(e, n, i) {
          i = typeof i == "function" ? i : o;
          var a = i ? i(e, n) : o;
          return a === o ? Nr(e, n, o, i) : !!a;
        }
        function ii(e) {
          if (!ie(e))
            return !1;
          var n = Te(e);
          return n == Hr || n == Rl || typeof e.message == "string" && typeof e.name == "string" && !Rr(e);
        }
        function f_(e) {
          return typeof e == "number" && ya(e);
        }
        function hn(e) {
          if (!ne(e))
            return !1;
          var n = Te(e);
          return n == Wr || n == Bi || n == Pl || n == Ol;
        }
        function Hs(e) {
          return typeof e == "number" && e == D(e);
        }
        function Pt(e) {
          return typeof e == "number" && e > -1 && e % 1 == 0 && e <= vn;
        }
        function ne(e) {
          var n = typeof e;
          return e != null && (n == "object" || n == "function");
        }
        function ie(e) {
          return e != null && typeof e == "object";
        }
        var Ws = aa ? Pe(aa) : mp;
        function h_(e, n) {
          return e === n || Bo(e, n, Jo(n));
        }
        function __(e, n, i) {
          return i = typeof i == "function" ? i : o, Bo(e, n, Jo(n), i);
        }
        function m_(e) {
          return qs(e) && e != +e;
        }
        function g_(e) {
          if (Qp(e))
            throw new F(f);
          return Fa(e);
        }
        function v_(e) {
          return e === null;
        }
        function I_(e) {
          return e == null;
        }
        function qs(e) {
          return typeof e == "number" || ie(e) && Te(e) == _r;
        }
        function Rr(e) {
          if (!ie(e) || Te(e) != sn)
            return !1;
          var n = at(e);
          if (n === null)
            return !0;
          var i = q.call(n, "constructor") && n.constructor;
          return typeof i == "function" && i instanceof i && rt.call(i) == hd;
        }
        var ai = sa ? Pe(sa) : gp;
        function b_(e) {
          return Hs(e) && e >= -vn && e <= vn;
        }
        var Vs = ua ? Pe(ua) : vp;
        function Rt(e) {
          return typeof e == "string" || !G(e) && ie(e) && Te(e) == gr;
        }
        function ze(e) {
          return typeof e == "symbol" || ie(e) && Te(e) == qr;
        }
        var or = la ? Pe(la) : Ip;
        function S_(e) {
          return e === o;
        }
        function T_(e) {
          return ie(e) && Se(e) == vr;
        }
        function A_(e) {
          return ie(e) && Te(e) == Fl;
        }
        var C_ = Ct(Ro), y_ = Ct(function(e, n) {
          return e <= n;
        });
        function Js(e) {
          if (!e)
            return [];
          if (Me(e))
            return Rt(e) ? je(e) : we(e);
          if (Sr && e[Sr])
            return rd(e[Sr]());
          var n = Se(e), i = n == Ve ? So : n == Je ? Qr : ir;
          return i(e);
        }
        function _n(e) {
          if (!e)
            return e === 0 ? e : 0;
          if (e = He(e), e === En || e === -En) {
            var n = e < 0 ? -1 : 1;
            return n * Nl;
          }
          return e === e ? e : 0;
        }
        function D(e) {
          var n = _n(e), i = n % 1;
          return n === n ? i ? n - i : n : 0;
        }
        function js(e) {
          return e ? zn(D(e), 0, en) : 0;
        }
        function He(e) {
          if (typeof e == "number")
            return e;
          if (ze(e))
            return $r;
          if (ne(e)) {
            var n = typeof e.valueOf == "function" ? e.valueOf() : e;
            e = ne(n) ? n + "" : n;
          }
          if (typeof e != "string")
            return e === 0 ? e : +e;
          e = _a(e);
          var i = ic.test(e);
          return i || sc.test(e) ? Gc(e.slice(2), i ? 2 : 8) : oc.test(e) ? $r : +e;
        }
        function Ys(e) {
          return rn(e, Ne(e));
        }
        function x_(e) {
          return e ? zn(D(e), -vn, vn) : e === 0 ? e : 0;
        }
        function V(e) {
          return e == null ? "" : Re(e);
        }
        var w_ = nr(function(e, n) {
          if (Br(n) || Me(n)) {
            rn(n, _e(n), e);
            return;
          }
          for (var i in n)
            q.call(n, i) && xr(e, i, n[i]);
        }), Xs = nr(function(e, n) {
          rn(n, Ne(n), e);
        }), zt = nr(function(e, n, i, a) {
          rn(n, Ne(n), e, a);
        }), M_ = nr(function(e, n, i, a) {
          rn(n, _e(n), e, a);
        }), N_ = pn(wo);
        function E_(e, n) {
          var i = er(e);
          return n == null ? i : Ea(i, n);
        }
        var k_ = U(function(e, n) {
          e = j(e);
          var i = -1, a = n.length, l = a > 2 ? n[2] : o;
          for (l && Ae(n[0], n[1], l) && (a = 1); ++i < a; )
            for (var d = n[i], h = Ne(d), _ = -1, v = h.length; ++_ < v; ) {
              var T = h[_], C = e[T];
              (C === o || Xe(C, Yn[T]) && !q.call(e, T)) && (e[T] = d[T]);
            }
          return e;
        }), B_ = U(function(e) {
          return e.push(o, _s), Be(Qs, o, e);
        });
        function P_(e, n) {
          return da(e, B(n, 3), nn);
        }
        function R_(e, n) {
          return da(e, B(n, 3), No);
        }
        function z_(e, n) {
          return e == null ? e : Mo(e, B(n, 3), Ne);
        }
        function O_(e, n) {
          return e == null ? e : za(e, B(n, 3), Ne);
        }
        function L_(e, n) {
          return e && nn(e, B(n, 3));
        }
        function F_(e, n) {
          return e && No(e, B(n, 3));
        }
        function G_(e) {
          return e == null ? [] : mt(e, _e(e));
        }
        function D_(e) {
          return e == null ? [] : mt(e, Ne(e));
        }
        function si(e, n, i) {
          var a = e == null ? o : On(e, n);
          return a === o ? i : a;
        }
        function Z_(e, n) {
          return e != null && vs(e, n, lp);
        }
        function ui(e, n) {
          return e != null && vs(e, n, cp);
        }
        var U_ = cs(function(e, n, i) {
          n != null && typeof n.toString != "function" && (n = tt.call(n)), e[n] = i;
        }, ci(Ee)), $_ = cs(function(e, n, i) {
          n != null && typeof n.toString != "function" && (n = tt.call(n)), q.call(e, n) ? e[n].push(i) : e[n] = [i];
        }, B), K_ = U(Mr);
        function _e(e) {
          return Me(e) ? Ma(e) : Po(e);
        }
        function Ne(e) {
          return Me(e) ? Ma(e, !0) : bp(e);
        }
        function H_(e, n) {
          var i = {};
          return n = B(n, 3), nn(e, function(a, l, d) {
            cn(i, n(a, l, d), a);
          }), i;
        }
        function W_(e, n) {
          var i = {};
          return n = B(n, 3), nn(e, function(a, l, d) {
            cn(i, l, n(a, l, d));
          }), i;
        }
        var q_ = nr(function(e, n, i) {
          gt(e, n, i);
        }), Qs = nr(function(e, n, i, a) {
          gt(e, n, i, a);
        }), V_ = pn(function(e, n) {
          var i = {};
          if (e == null)
            return i;
          var a = !1;
          n = Q(n, function(d) {
            return d = yn(d, e), a || (a = d.length > 1), d;
          }), rn(e, qo(e), i), a && (i = Ue(i, L | O | z, Zp));
          for (var l = n.length; l--; )
            Go(i, n[l]);
          return i;
        });
        function J_(e, n) {
          return eu(e, Bt(B(n)));
        }
        var j_ = pn(function(e, n) {
          return e == null ? {} : Tp(e, n);
        });
        function eu(e, n) {
          if (e == null)
            return {};
          var i = Q(qo(e), function(a) {
            return [a];
          });
          return n = B(n), Ha(e, i, function(a, l) {
            return n(a, l[0]);
          });
        }
        function Y_(e, n, i) {
          n = yn(n, e);
          var a = -1, l = n.length;
          for (l || (l = 1, e = o); ++a < l; ) {
            var d = e == null ? o : e[tn(n[a])];
            d === o && (a = l, d = i), e = hn(d) ? d.call(e) : d;
          }
          return e;
        }
        function X_(e, n, i) {
          return e == null ? e : Er(e, n, i);
        }
        function Q_(e, n, i, a) {
          return a = typeof a == "function" ? a : o, e == null ? e : Er(e, n, i, a);
        }
        var nu = fs(_e), ru = fs(Ne);
        function em(e, n, i) {
          var a = G(e), l = a || wn(e) || or(e);
          if (n = B(n, 4), i == null) {
            var d = e && e.constructor;
            l ? i = a ? new d() : [] : ne(e) ? i = hn(d) ? er(at(e)) : {} : i = {};
          }
          return (l ? Ge : nn)(e, function(h, _, v) {
            return n(i, h, _, v);
          }), i;
        }
        function nm(e, n) {
          return e == null ? !0 : Go(e, n);
        }
        function rm(e, n, i) {
          return e == null ? e : ja(e, n, Uo(i));
        }
        function tm(e, n, i, a) {
          return a = typeof a == "function" ? a : o, e == null ? e : ja(e, n, Uo(i), a);
        }
        function ir(e) {
          return e == null ? [] : bo(e, _e(e));
        }
        function om(e) {
          return e == null ? [] : bo(e, Ne(e));
        }
        function im(e, n, i) {
          return i === o && (i = n, n = o), i !== o && (i = He(i), i = i === i ? i : 0), n !== o && (n = He(n), n = n === n ? n : 0), zn(He(e), n, i);
        }
        function am(e, n, i) {
          return n = _n(n), i === o ? (i = n, n = 0) : i = _n(i), e = He(e), dp(e, n, i);
        }
        function sm(e, n, i) {
          if (i && typeof i != "boolean" && Ae(e, n, i) && (n = i = o), i === o && (typeof n == "boolean" ? (i = n, n = o) : typeof e == "boolean" && (i = e, e = o)), e === o && n === o ? (e = 0, n = 1) : (e = _n(e), n === o ? (n = e, e = 0) : n = _n(n)), e > n) {
            var a = e;
            e = n, n = a;
          }
          if (i || e % 1 || n % 1) {
            var l = xa();
            return be(e + l * (n - e + Fc("1e-" + ((l + "").length - 1))), n);
          }
          return Oo(e, n);
        }
        var um = rr(function(e, n, i) {
          return n = n.toLowerCase(), e + (i ? tu(n) : n);
        });
        function tu(e) {
          return li(V(e).toLowerCase());
        }
        function ou(e) {
          return e = V(e), e && e.replace(lc, Yc).replace(Mc, "");
        }
        function lm(e, n, i) {
          e = V(e), n = Re(n);
          var a = e.length;
          i = i === o ? a : zn(D(i), 0, a);
          var l = i;
          return i -= n.length, i >= 0 && e.slice(i, l) == n;
        }
        function cm(e) {
          return e = V(e), e && $l.test(e) ? e.replace(zi, Xc) : e;
        }
        function dm(e) {
          return e = V(e), e && Jl.test(e) ? e.replace(to, "\\$&") : e;
        }
        var pm = rr(function(e, n, i) {
          return e + (i ? "-" : "") + n.toLowerCase();
        }), fm = rr(function(e, n, i) {
          return e + (i ? " " : "") + n.toLowerCase();
        }), hm = ss("toLowerCase");
        function _m(e, n, i) {
          e = V(e), n = D(n);
          var a = n ? Jn(e) : 0;
          if (!n || a >= n)
            return e;
          var l = (n - a) / 2;
          return At(ct(l), i) + e + At(lt(l), i);
        }
        function mm(e, n, i) {
          e = V(e), n = D(n);
          var a = n ? Jn(e) : 0;
          return n && a < n ? e + At(n - a, i) : e;
        }
        function gm(e, n, i) {
          e = V(e), n = D(n);
          var a = n ? Jn(e) : 0;
          return n && a < n ? At(n - a, i) + e : e;
        }
        function vm(e, n, i) {
          return i || n == null ? n = 0 : n && (n = +n), Cd(V(e).replace(oo, ""), n || 0);
        }
        function Im(e, n, i) {
          return (i ? Ae(e, n, i) : n === o) ? n = 1 : n = D(n), Lo(V(e), n);
        }
        function bm() {
          var e = arguments, n = V(e[0]);
          return e.length < 3 ? n : n.replace(e[1], e[2]);
        }
        var Sm = rr(function(e, n, i) {
          return e + (i ? "_" : "") + n.toLowerCase();
        });
        function Tm(e, n, i) {
          return i && typeof i != "number" && Ae(e, n, i) && (n = i = o), i = i === o ? en : i >>> 0, i ? (e = V(e), e && (typeof n == "string" || n != null && !ai(n)) && (n = Re(n), !n && Vn(e)) ? xn(je(e), 0, i) : e.split(n, i)) : [];
        }
        var Am = rr(function(e, n, i) {
          return e + (i ? " " : "") + li(n);
        });
        function Cm(e, n, i) {
          return e = V(e), i = i == null ? 0 : zn(D(i), 0, e.length), n = Re(n), e.slice(i, i + n.length) == n;
        }
        function ym(e, n, i) {
          var a = c.templateSettings;
          i && Ae(e, n, i) && (n = o), e = V(e), n = zt({}, n, a, hs);
          var l = zt({}, n.imports, a.imports, hs), d = _e(l), h = bo(l, d), _, v, T = 0, C = n.interpolate || Vr, y = "__p += '", w = To(
            (n.escape || Vr).source + "|" + C.source + "|" + (C === Oi ? tc : Vr).source + "|" + (n.evaluate || Vr).source + "|$",
            "g"
          ), E = "//# sourceURL=" + (q.call(n, "sourceURL") ? (n.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Pc + "]") + `
`;
          e.replace(w, function(R, $, H, Oe, Ce, Le) {
            return H || (H = Oe), y += e.slice(T, Le).replace(cc, Qc), $ && (_ = !0, y += `' +
__e(` + $ + `) +
'`), Ce && (v = !0, y += `';
` + Ce + `;
__p += '`), H && (y += `' +
((__t = (` + H + `)) == null ? '' : __t) +
'`), T = Le + R.length, R;
          }), y += `';
`;
          var P = q.call(n, "variable") && n.variable;
          if (!P)
            y = `with (obj) {
` + y + `
}
`;
          else if (nc.test(P))
            throw new F(m);
          y = (v ? y.replace(Gl, "") : y).replace(Dl, "$1").replace(Zl, "$1;"), y = "function(" + (P || "obj") + `) {
` + (P ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (_ ? ", __e = _.escape" : "") + (v ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + y + `return __p
}`;
          var Z = au(function() {
            return W(d, E + "return " + y).apply(o, h);
          });
          if (Z.source = y, ii(Z))
            throw Z;
          return Z;
        }
        function xm(e) {
          return V(e).toLowerCase();
        }
        function wm(e) {
          return V(e).toUpperCase();
        }
        function Mm(e, n, i) {
          if (e = V(e), e && (i || n === o))
            return _a(e);
          if (!e || !(n = Re(n)))
            return e;
          var a = je(e), l = je(n), d = ma(a, l), h = ga(a, l) + 1;
          return xn(a, d, h).join("");
        }
        function Nm(e, n, i) {
          if (e = V(e), e && (i || n === o))
            return e.slice(0, Ia(e) + 1);
          if (!e || !(n = Re(n)))
            return e;
          var a = je(e), l = ga(a, je(n)) + 1;
          return xn(a, 0, l).join("");
        }
        function Em(e, n, i) {
          if (e = V(e), e && (i || n === o))
            return e.replace(oo, "");
          if (!e || !(n = Re(n)))
            return e;
          var a = je(e), l = ma(a, je(n));
          return xn(a, l).join("");
        }
        function km(e, n) {
          var i = Al, a = Cl;
          if (ne(n)) {
            var l = "separator" in n ? n.separator : l;
            i = "length" in n ? D(n.length) : i, a = "omission" in n ? Re(n.omission) : a;
          }
          e = V(e);
          var d = e.length;
          if (Vn(e)) {
            var h = je(e);
            d = h.length;
          }
          if (i >= d)
            return e;
          var _ = i - Jn(a);
          if (_ < 1)
            return a;
          var v = h ? xn(h, 0, _).join("") : e.slice(0, _);
          if (l === o)
            return v + a;
          if (h && (_ += v.length - _), ai(l)) {
            if (e.slice(_).search(l)) {
              var T, C = v;
              for (l.global || (l = To(l.source, V(Li.exec(l)) + "g")), l.lastIndex = 0; T = l.exec(C); )
                var y = T.index;
              v = v.slice(0, y === o ? _ : y);
            }
          } else if (e.indexOf(Re(l), _) != _) {
            var w = v.lastIndexOf(l);
            w > -1 && (v = v.slice(0, w));
          }
          return v + a;
        }
        function Bm(e) {
          return e = V(e), e && Ul.test(e) ? e.replace(Ri, ad) : e;
        }
        var Pm = rr(function(e, n, i) {
          return e + (i ? " " : "") + n.toUpperCase();
        }), li = ss("toUpperCase");
        function iu(e, n, i) {
          return e = V(e), n = i ? o : n, n === o ? nd(e) ? ld(e) : Wc(e) : e.match(n) || [];
        }
        var au = U(function(e, n) {
          try {
            return Be(e, o, n);
          } catch (i) {
            return ii(i) ? i : new F(i);
          }
        }), Rm = pn(function(e, n) {
          return Ge(n, function(i) {
            i = tn(i), cn(e, i, ti(e[i], e));
          }), e;
        });
        function zm(e) {
          var n = e == null ? 0 : e.length, i = B();
          return e = n ? Q(e, function(a) {
            if (typeof a[1] != "function")
              throw new De(p);
            return [i(a[0]), a[1]];
          }) : [], U(function(a) {
            for (var l = -1; ++l < n; ) {
              var d = e[l];
              if (Be(d[0], this, a))
                return Be(d[1], this, a);
            }
          });
        }
        function Om(e) {
          return ap(Ue(e, L));
        }
        function ci(e) {
          return function() {
            return e;
          };
        }
        function Lm(e, n) {
          return e == null || e !== e ? n : e;
        }
        var Fm = ls(), Gm = ls(!0);
        function Ee(e) {
          return e;
        }
        function di(e) {
          return Ga(typeof e == "function" ? e : Ue(e, L));
        }
        function Dm(e) {
          return Za(Ue(e, L));
        }
        function Zm(e, n) {
          return Ua(e, Ue(n, L));
        }
        var Um = U(function(e, n) {
          return function(i) {
            return Mr(i, e, n);
          };
        }), $m = U(function(e, n) {
          return function(i) {
            return Mr(e, i, n);
          };
        });
        function pi(e, n, i) {
          var a = _e(n), l = mt(n, a);
          i == null && !(ne(n) && (l.length || !a.length)) && (i = n, n = e, e = this, l = mt(n, _e(n)));
          var d = !(ne(i) && "chain" in i) || !!i.chain, h = hn(e);
          return Ge(l, function(_) {
            var v = n[_];
            e[_] = v, h && (e.prototype[_] = function() {
              var T = this.__chain__;
              if (d || T) {
                var C = e(this.__wrapped__), y = C.__actions__ = we(this.__actions__);
                return y.push({ func: v, args: arguments, thisArg: e }), C.__chain__ = T, C;
              }
              return v.apply(e, bn([this.value()], arguments));
            });
          }), e;
        }
        function Km() {
          return me._ === this && (me._ = _d), this;
        }
        function fi() {
        }
        function Hm(e) {
          return e = D(e), U(function(n) {
            return $a(n, e);
          });
        }
        var Wm = Ko(Q), qm = Ko(ca), Vm = Ko(_o);
        function su(e) {
          return Yo(e) ? mo(tn(e)) : Ap(e);
        }
        function Jm(e) {
          return function(n) {
            return e == null ? o : On(e, n);
          };
        }
        var jm = ds(), Ym = ds(!0);
        function hi() {
          return [];
        }
        function _i() {
          return !1;
        }
        function Xm() {
          return {};
        }
        function Qm() {
          return "";
        }
        function eg() {
          return !0;
        }
        function ng(e, n) {
          if (e = D(e), e < 1 || e > vn)
            return [];
          var i = en, a = be(e, en);
          n = B(n), e -= en;
          for (var l = Io(a, n); ++i < e; )
            n(i);
          return l;
        }
        function rg(e) {
          return G(e) ? Q(e, tn) : ze(e) ? [e] : we(ws(V(e)));
        }
        function tg(e) {
          var n = ++fd;
          return V(e) + n;
        }
        var og = Tt(function(e, n) {
          return e + n;
        }, 0), ig = Ho("ceil"), ag = Tt(function(e, n) {
          return e / n;
        }, 1), sg = Ho("floor");
        function ug(e) {
          return e && e.length ? _t(e, Ee, Eo) : o;
        }
        function lg(e, n) {
          return e && e.length ? _t(e, B(n, 2), Eo) : o;
        }
        function cg(e) {
          return fa(e, Ee);
        }
        function dg(e, n) {
          return fa(e, B(n, 2));
        }
        function pg(e) {
          return e && e.length ? _t(e, Ee, Ro) : o;
        }
        function fg(e, n) {
          return e && e.length ? _t(e, B(n, 2), Ro) : o;
        }
        var hg = Tt(function(e, n) {
          return e * n;
        }, 1), _g = Ho("round"), mg = Tt(function(e, n) {
          return e - n;
        }, 0);
        function gg(e) {
          return e && e.length ? vo(e, Ee) : 0;
        }
        function vg(e, n) {
          return e && e.length ? vo(e, B(n, 2)) : 0;
        }
        return c.after = Dh, c.ary = Fs, c.assign = w_, c.assignIn = Xs, c.assignInWith = zt, c.assignWith = M_, c.at = N_, c.before = Gs, c.bind = ti, c.bindAll = Rm, c.bindKey = Ds, c.castArray = Xh, c.chain = zs, c.chunk = sf, c.compact = uf, c.concat = lf, c.cond = zm, c.conforms = Om, c.constant = ci, c.countBy = gh, c.create = E_, c.curry = Zs, c.curryRight = Us, c.debounce = $s, c.defaults = k_, c.defaultsDeep = B_, c.defer = Zh, c.delay = Uh, c.difference = cf, c.differenceBy = df, c.differenceWith = pf, c.drop = ff, c.dropRight = hf, c.dropRightWhile = _f, c.dropWhile = mf, c.fill = gf, c.filter = Ih, c.flatMap = Th, c.flatMapDeep = Ah, c.flatMapDepth = Ch, c.flatten = ks, c.flattenDeep = vf, c.flattenDepth = If, c.flip = $h, c.flow = Fm, c.flowRight = Gm, c.fromPairs = bf, c.functions = G_, c.functionsIn = D_, c.groupBy = yh, c.initial = Tf, c.intersection = Af, c.intersectionBy = Cf, c.intersectionWith = yf, c.invert = U_, c.invertBy = $_, c.invokeMap = wh, c.iteratee = di, c.keyBy = Mh, c.keys = _e, c.keysIn = Ne, c.map = Nt, c.mapKeys = H_, c.mapValues = W_, c.matches = Dm, c.matchesProperty = Zm, c.memoize = kt, c.merge = q_, c.mergeWith = Qs, c.method = Um, c.methodOf = $m, c.mixin = pi, c.negate = Bt, c.nthArg = Hm, c.omit = V_, c.omitBy = J_, c.once = Kh, c.orderBy = Nh, c.over = Wm, c.overArgs = Hh, c.overEvery = qm, c.overSome = Vm, c.partial = oi, c.partialRight = Ks, c.partition = Eh, c.pick = j_, c.pickBy = eu, c.property = su, c.propertyOf = Jm, c.pull = Nf, c.pullAll = Ps, c.pullAllBy = Ef, c.pullAllWith = kf, c.pullAt = Bf, c.range = jm, c.rangeRight = Ym, c.rearg = Wh, c.reject = Ph, c.remove = Pf, c.rest = qh, c.reverse = ni, c.sampleSize = zh, c.set = X_, c.setWith = Q_, c.shuffle = Oh, c.slice = Rf, c.sortBy = Gh, c.sortedUniq = Zf, c.sortedUniqBy = Uf, c.split = Tm, c.spread = Vh, c.tail = $f, c.take = Kf, c.takeRight = Hf, c.takeRightWhile = Wf, c.takeWhile = qf, c.tap = uh, c.throttle = Jh, c.thru = Mt, c.toArray = Js, c.toPairs = nu, c.toPairsIn = ru, c.toPath = rg, c.toPlainObject = Ys, c.transform = em, c.unary = jh, c.union = Vf, c.unionBy = Jf, c.unionWith = jf, c.uniq = Yf, c.uniqBy = Xf, c.uniqWith = Qf, c.unset = nm, c.unzip = ri, c.unzipWith = Rs, c.update = rm, c.updateWith = tm, c.values = ir, c.valuesIn = om, c.without = eh, c.words = iu, c.wrap = Yh, c.xor = nh, c.xorBy = rh, c.xorWith = th, c.zip = oh, c.zipObject = ih, c.zipObjectDeep = ah, c.zipWith = sh, c.entries = nu, c.entriesIn = ru, c.extend = Xs, c.extendWith = zt, pi(c, c), c.add = og, c.attempt = au, c.camelCase = um, c.capitalize = tu, c.ceil = ig, c.clamp = im, c.clone = Qh, c.cloneDeep = n_, c.cloneDeepWith = r_, c.cloneWith = e_, c.conformsTo = t_, c.deburr = ou, c.defaultTo = Lm, c.divide = ag, c.endsWith = lm, c.eq = Xe, c.escape = cm, c.escapeRegExp = dm, c.every = vh, c.find = bh, c.findIndex = Ns, c.findKey = P_, c.findLast = Sh, c.findLastIndex = Es, c.findLastKey = R_, c.floor = sg, c.forEach = Os, c.forEachRight = Ls, c.forIn = z_, c.forInRight = O_, c.forOwn = L_, c.forOwnRight = F_, c.get = si, c.gt = o_, c.gte = i_, c.has = Z_, c.hasIn = ui, c.head = Bs, c.identity = Ee, c.includes = xh, c.indexOf = Sf, c.inRange = am, c.invoke = K_, c.isArguments = Gn, c.isArray = G, c.isArrayBuffer = a_, c.isArrayLike = Me, c.isArrayLikeObject = se, c.isBoolean = s_, c.isBuffer = wn, c.isDate = u_, c.isElement = l_, c.isEmpty = c_, c.isEqual = d_, c.isEqualWith = p_, c.isError = ii, c.isFinite = f_, c.isFunction = hn, c.isInteger = Hs, c.isLength = Pt, c.isMap = Ws, c.isMatch = h_, c.isMatchWith = __, c.isNaN = m_, c.isNative = g_, c.isNil = I_, c.isNull = v_, c.isNumber = qs, c.isObject = ne, c.isObjectLike = ie, c.isPlainObject = Rr, c.isRegExp = ai, c.isSafeInteger = b_, c.isSet = Vs, c.isString = Rt, c.isSymbol = ze, c.isTypedArray = or, c.isUndefined = S_, c.isWeakMap = T_, c.isWeakSet = A_, c.join = xf, c.kebabCase = pm, c.last = Ke, c.lastIndexOf = wf, c.lowerCase = fm, c.lowerFirst = hm, c.lt = C_, c.lte = y_, c.max = ug, c.maxBy = lg, c.mean = cg, c.meanBy = dg, c.min = pg, c.minBy = fg, c.stubArray = hi, c.stubFalse = _i, c.stubObject = Xm, c.stubString = Qm, c.stubTrue = eg, c.multiply = hg, c.nth = Mf, c.noConflict = Km, c.noop = fi, c.now = Et, c.pad = _m, c.padEnd = mm, c.padStart = gm, c.parseInt = vm, c.random = sm, c.reduce = kh, c.reduceRight = Bh, c.repeat = Im, c.replace = bm, c.result = Y_, c.round = _g, c.runInContext = g, c.sample = Rh, c.size = Lh, c.snakeCase = Sm, c.some = Fh, c.sortedIndex = zf, c.sortedIndexBy = Of, c.sortedIndexOf = Lf, c.sortedLastIndex = Ff, c.sortedLastIndexBy = Gf, c.sortedLastIndexOf = Df, c.startCase = Am, c.startsWith = Cm, c.subtract = mg, c.sum = gg, c.sumBy = vg, c.template = ym, c.times = ng, c.toFinite = _n, c.toInteger = D, c.toLength = js, c.toLower = xm, c.toNumber = He, c.toSafeInteger = x_, c.toString = V, c.toUpper = wm, c.trim = Mm, c.trimEnd = Nm, c.trimStart = Em, c.truncate = km, c.unescape = Bm, c.uniqueId = tg, c.upperCase = Pm, c.upperFirst = li, c.each = Os, c.eachRight = Ls, c.first = Bs, pi(c, (function() {
          var e = {};
          return nn(c, function(n, i) {
            q.call(c.prototype, i) || (e[i] = n);
          }), e;
        })(), { chain: !1 }), c.VERSION = s, Ge(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
          c[e].placeholder = c;
        }), Ge(["drop", "take"], function(e, n) {
          K.prototype[e] = function(i) {
            i = i === o ? 1 : he(D(i), 0);
            var a = this.__filtered__ && !n ? new K(this) : this.clone();
            return a.__filtered__ ? a.__takeCount__ = be(i, a.__takeCount__) : a.__views__.push({
              size: be(i, en),
              type: e + (a.__dir__ < 0 ? "Right" : "")
            }), a;
          }, K.prototype[e + "Right"] = function(i) {
            return this.reverse()[e](i).reverse();
          };
        }), Ge(["filter", "map", "takeWhile"], function(e, n) {
          var i = n + 1, a = i == ki || i == Ml;
          K.prototype[e] = function(l) {
            var d = this.clone();
            return d.__iteratees__.push({
              iteratee: B(l, 3),
              type: i
            }), d.__filtered__ = d.__filtered__ || a, d;
          };
        }), Ge(["head", "last"], function(e, n) {
          var i = "take" + (n ? "Right" : "");
          K.prototype[e] = function() {
            return this[i](1).value()[0];
          };
        }), Ge(["initial", "tail"], function(e, n) {
          var i = "drop" + (n ? "" : "Right");
          K.prototype[e] = function() {
            return this.__filtered__ ? new K(this) : this[i](1);
          };
        }), K.prototype.compact = function() {
          return this.filter(Ee);
        }, K.prototype.find = function(e) {
          return this.filter(e).head();
        }, K.prototype.findLast = function(e) {
          return this.reverse().find(e);
        }, K.prototype.invokeMap = U(function(e, n) {
          return typeof e == "function" ? new K(this) : this.map(function(i) {
            return Mr(i, e, n);
          });
        }), K.prototype.reject = function(e) {
          return this.filter(Bt(B(e)));
        }, K.prototype.slice = function(e, n) {
          e = D(e);
          var i = this;
          return i.__filtered__ && (e > 0 || n < 0) ? new K(i) : (e < 0 ? i = i.takeRight(-e) : e && (i = i.drop(e)), n !== o && (n = D(n), i = n < 0 ? i.dropRight(-n) : i.take(n - e)), i);
        }, K.prototype.takeRightWhile = function(e) {
          return this.reverse().takeWhile(e).reverse();
        }, K.prototype.toArray = function() {
          return this.take(en);
        }, nn(K.prototype, function(e, n) {
          var i = /^(?:filter|find|map|reject)|While$/.test(n), a = /^(?:head|last)$/.test(n), l = c[a ? "take" + (n == "last" ? "Right" : "") : n], d = a || /^find/.test(n);
          l && (c.prototype[n] = function() {
            var h = this.__wrapped__, _ = a ? [1] : arguments, v = h instanceof K, T = _[0], C = v || G(h), y = function($) {
              var H = l.apply(c, bn([$], _));
              return a && w ? H[0] : H;
            };
            C && i && typeof T == "function" && T.length != 1 && (v = C = !1);
            var w = this.__chain__, E = !!this.__actions__.length, P = d && !w, Z = v && !E;
            if (!d && C) {
              h = Z ? h : new K(this);
              var R = e.apply(h, _);
              return R.__actions__.push({ func: Mt, args: [y], thisArg: o }), new Ze(R, w);
            }
            return P && Z ? e.apply(this, _) : (R = this.thru(y), P ? a ? R.value()[0] : R.value() : R);
          });
        }), Ge(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
          var n = et[e], i = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", a = /^(?:pop|shift)$/.test(e);
          c.prototype[e] = function() {
            var l = arguments;
            if (a && !this.__chain__) {
              var d = this.value();
              return n.apply(G(d) ? d : [], l);
            }
            return this[i](function(h) {
              return n.apply(G(h) ? h : [], l);
            });
          };
        }), nn(K.prototype, function(e, n) {
          var i = c[n];
          if (i) {
            var a = i.name + "";
            q.call(Qn, a) || (Qn[a] = []), Qn[a].push({ name: n, func: i });
          }
        }), Qn[St(o, gn).name] = [{
          name: "wrapper",
          func: o
        }], K.prototype.clone = kd, K.prototype.reverse = Bd, K.prototype.value = Pd, c.prototype.at = lh, c.prototype.chain = ch, c.prototype.commit = dh, c.prototype.next = ph, c.prototype.plant = hh, c.prototype.reverse = _h, c.prototype.toJSON = c.prototype.valueOf = c.prototype.value = mh, c.prototype.first = c.prototype.head, Sr && (c.prototype[Sr] = fh), c;
      }), jn = cd();
      kn ? ((kn.exports = jn)._ = jn, co._ = jn) : me._ = jn;
    }).call(c1);
  })(Lr, Lr.exports)), Lr.exports;
}
var Fr = d1();
const $1 = (r, t) => {
  const o = Fr.mapValues(r, (u) => u === "" || u === void 0 ? null : u);
  return Fr.omit(o, t);
}, K1 = (r, t, o) => {
  const s = o ? Fr.omitBy(o, (u) => u === null) : {};
  Fr.assign(r, t, Fr.pick(s, Object.keys(r)));
}, H1 = (r) => {
  const { properties: t } = r, { context: o } = t;
  return {
    addressNumber: o.address?.address_number,
    alternate: o.region?.alternate?.name,
    country: o.country?.name,
    countryCode: o.country?.country_code,
    fullAddress: t.full_address,
    latitude: t.coordinates.latitude,
    longitude: t.coordinates.longitude,
    mapboxId: t.mapbox_id,
    place: o.place?.name,
    postcode: o.postcode?.name,
    region: o.region?.name,
    streetName: o.street?.name
  };
}, W1 = (r) => /^[+]?[\s0-9]{6,}$/.test(r), q1 = (r) => {
  if (typeof r != "string") return !1;
  const t = r.replace(/-\d{1,2}$/, ""), o = /^\d+$/.test(t), s = /^[a-zA-Z0-9]+$/.test(t), u = t.length;
  return o && u >= 8 && u <= 10 || s && u === 17;
}, V1 = (r, t) => {
  if (typeof r != "number" || !Number.isInteger(r)) return !1;
  const o = -(2 ** (t - 1)), s = 2 ** (t - 1) - 1;
  return r >= o && r <= s;
};
class J1 {
  constructor(t, o, s) {
    this.minBidStepAmount = t, this.maxBidStepAmount = s, this.effectiveThreshold = Math.ceil(o / t) * t;
  }
  validateAmount(t) {
    const [o, s] = t < this.effectiveThreshold ? [t, this.minBidStepAmount] : [t - this.effectiveThreshold, this.maxBidStepAmount];
    return o % s === 0;
  }
  getStepRoundedAmount(t) {
    return this.getStepRoundedValue(t, Math.floor);
  }
  getStepRoundedReservePrice(t) {
    return this.getStepRoundedValue(t, Math.ceil);
  }
  getDeltaStepsAmount(t, o) {
    if (!this.validateAmount(t))
      throw new Error("Error in AuctionSteppedPrice.getDeltaStepsAmount, base is not a valid amount");
    return this.computeDeltaStepsAmount(t, o);
  }
  /*
   * Implementation of the starting price computation formula defined in
   * https://adorea.atlassian.net/browse/BSD-3693
   */
  getAuctionStartingPriceDefaultValue(t) {
    const s = t - 25e3 * (1 - Math.exp(-25e-6 * t));
    return this.getStepRoundedAmount(s);
  }
  getDirectSaleMinNegotiationOfferDefaultValue(t) {
    return this.getStepRoundedAmount(t * 0.3);
  }
  getDirectSaleSuggestedPriceDefaultValue(t) {
    const u = 1 - 0.24 * Math.exp(-2245e-9 * t);
    return this.getStepRoundedAmount(t * u);
  }
  getStepRoundedValue(t, o) {
    const [s, u, f] = t < this.effectiveThreshold ? [t, this.minBidStepAmount, 0] : [t - this.effectiveThreshold, this.maxBidStepAmount, this.effectiveThreshold];
    return o(s / u) * u + f;
  }
  computeDeltaStepsAmount(t, o) {
    const s = o / Math.abs(o);
    return o === 0 ? t : this.computeDeltaStepsAmount(
      t + ((o > 0 ? t < this.effectiveThreshold : t <= this.effectiveThreshold) ? this.minBidStepAmount : this.maxBidStepAmount) * s,
      o - s
    );
  }
}
const j1 = ({ reservePrice: r, isToBeScraped: t }) => {
  const o = t || r < 5e3 ? 50 : r < 1e4 ? 100 : r < 5e4 ? 500 : 1e3, s = t ? 50 : r < 5e3 ? 100 : r < 1e4 ? 500 : (r < 5e4, 1e3), u = t ? 1e3 : r < 5e3 ? 5e3 : r < 1e4 ? 1e4 : 5e4, f = t ? 250 : r < 5e4 ? 1e3 : r < 1e5 ? 1500 : 2e3;
  return {
    minStepDefaultValue: o,
    maxStepDefaultValue: s,
    thresholdDefaultValue: u,
    bailDefaultValue: f
  };
};
function cr(r) {
  const t = Object.prototype.toString.call(r);
  return r instanceof Date || typeof r == "object" && t === "[object Date]" ? new r.constructor(+r) : typeof r == "number" || t === "[object Number]" || typeof r == "string" || t === "[object String]" ? new Date(r) : /* @__PURE__ */ new Date(NaN);
}
function p1(r, t) {
  const o = cr(r), s = cr(t);
  return o.getTime() > s.getTime();
}
function f1(r, t) {
  const o = cr(r), s = cr(t);
  return +o < +s;
}
function Pu(r, t) {
  const o = cr(r), s = cr(t);
  return +o == +s;
}
function Ei(r) {
  throw new Error("Should not have reached this line");
}
var on = /* @__PURE__ */ ((r) => (r.Seller = "Seller", r.Buyer = "Buyer", r))(on || {}), an = /* @__PURE__ */ ((r) => (r.FixedPercentage = "FixedPercentage", r.FixedAmount = "FixedAmount", r.Standard = "Standard", r))(an || {});
const h1 = /* @__PURE__ */ new Date("2025-11-24"), _1 = /* @__PURE__ */ new Date("2025-11-28"), sr = 250, Si = 0.0875, Il = 0.0375, bl = 5250, Ti = 1e5, Sl = 2500, m1 = (r, [t, o]) => (Pu(r, t) || p1(r, t)) && (f1(r, o) || Pu(r, o)), Tl = ({
  feeTarget: r,
  baseAmount: t,
  assetsCount: o,
  feeConfiguration: s
}) => {
  const u = {
    [on.Seller]: 1,
    [on.Buyer]: -1
  }[r], f = t / o;
  return (() => {
    if (!s || s.type === an.Standard) {
      const m = Sl - sr * u;
      if (f <= m) return f + sr * u;
      const S = Ti - sr * u - Si * Ti * u;
      return f <= S ? (f + sr * u) / (1 - Si * u) : (f + bl * u) / (1 - Il * u);
    }
    if (s.type === an.FixedPercentage)
      return f / (1 - s.feeOverrideValue * u);
    if (s.type === an.FixedAmount)
      return f + s.feeOverrideValue * u;
    Ei(s.type);
  })() * o;
}, Y1 = ({
  feeTarget: r,
  baseAmount: t,
  assetsCount: o,
  referenceDate: s,
  feeConfiguration: u
}) => {
  const f = t / o, m = (() => {
    if (!u || u.type === an.Standard)
      return f <= Sl ? sr : f <= Ti ? sr + Si * f : bl + Il * f;
    if (u.type === an.FixedPercentage)
      return f * u.feeOverrideValue;
    if (u.type === an.FixedAmount)
      return u.feeOverrideValue;
    Ei(u.type);
  })() * o, x = r === on.Buyer && s && m1(s, [h1, _1]) ? m * 0.5 : m;
  return {
    grossTotal: Math.ceil(r === on.Buyer ? t + m : t),
    grossNet: Math.ceil(r === on.Buyer ? t : t - m),
    grossFees: Math.ceil(m),
    total: Math.ceil(r === on.Buyer ? t + x : t),
    net: Math.ceil(r === on.Buyer ? t : t - x),
    fees: Math.ceil(x)
  };
}, X1 = ({
  sellerReservePrice: r,
  assetsCount: t,
  feeConfiguration: o
}) => {
  const s = Math.ceil(
    Tl({
      feeTarget: on.Seller,
      baseAmount: r,
      assetsCount: t,
      feeConfiguration: o
    })
  );
  return {
    sellerReservePrice: r,
    fees: s - r,
    reservePrice: s
  };
}, Q1 = ({
  buyerBudget: r,
  assetsCount: t,
  feeConfiguration: o
}) => {
  const s = Math.ceil(
    Tl({
      feeTarget: on.Buyer,
      baseAmount: r,
      assetsCount: t,
      feeConfiguration: o
    })
  );
  return {
    buyerBudget: r,
    fees: r - s,
    buyerMaxOffer: s
  };
}, e0 = ({
  sellerReservePrice: r,
  feeConfiguration: t
}) => {
  const o = (() => {
    if (!t || t.type === an.Standard)
      return r <= 2250 ? 250 : r <= 91e3 ? (r + 250) / 0.9125 : (r + 5250) / 0.9625;
    if (t.type === an.FixedPercentage)
      return r / (1 - t.feeOverrideValue);
    if (t.type === an.FixedAmount)
      return r + t.feeOverrideValue;
    Ei(t.type);
  })();
  return Math.ceil(o);
};
var g1 = /* @__PURE__ */ ((r) => (r.VEHICLE_TOO_OLD = "VEHICLE_TOO_OLD", r.ELECTRIC_OR_HYBRID = "ELECTRIC_OR_HYBRID", r.MILEAGE_OR_MAINTENANCE_EXCEEDED = "MILEAGE_OR_MAINTENANCE_EXCEEDED", r.NOT_SUPPORTED_VEHICLE_CLASS = "NOT_SUPPORTED_VEHICLE_CLASS", r.MISSING_REQUIRED_DATA = "MISSING_REQUIRED_DATA", r))(g1 || {});
const n0 = {
  FleequidCare: {
    coverageCap: 1e4,
    warrantyDurationMonths: 3,
    creditPercentageGuidelines: [
      { maxAmount: 3e3, minCreditPercentage: 50 },
      { maxAmount: 5e3, minCreditPercentage: 45 },
      { maxAmount: 7e3, minCreditPercentage: 40 },
      { maxAmount: 9e3, minCreditPercentage: 35 },
      { maxAmount: 1e4, minCreditPercentage: 30 }
    ]
  },
  PowertrainWarranty: {
    coverageCap: 25e3,
    mileageLimits: [
      { durationMonths: 3, maxKm: 15e3 },
      { durationMonths: 6, maxKm: 3e4 },
      { durationMonths: 9, maxKm: 45e3 },
      { durationMonths: 12, maxKm: 6e4 }
    ],
    creditPercentageGuidelines: [
      { maxAmount: 1e4, minCreditPercentage: 30 },
      { maxAmount: 15e3, minCreditPercentage: 25 },
      { maxAmount: 2e4, minCreditPercentage: 20 },
      { maxAmount: 25e3, minCreditPercentage: 10 }
    ]
  }
};
export {
  s1 as ADMIN_USER_PASSWORD_RESET_TOKEN_PAYLOAD_TYPE,
  L1 as AdminUserPasswordResetTokenPayloadSchema,
  b1 as BANK_TRANSFER_BAIL_AUTHORIZATION_ID_PREFIX,
  S1 as BUS_ASSET_BASE_IMAGES,
  T1 as BUS_ASSET_COVER_IMAGES,
  u1 as CUSTOMER_USER_PASSWORD_RESET_TOKEN_PAYLOAD_TYPE,
  v1 as CalcomBookingMetadataSchema,
  F1 as CustomerUserPasswordResetTokenPayloadSchema,
  w1 as FILE_UPLOAD_EXTENSIONS,
  x1 as FILE_UPLOAD_PDF_MAX_SIZE,
  on as FeeTarget,
  an as FeeType,
  t1 as LanguageISO6391Schema,
  P1 as MAPBOX_API_CONFIG,
  g1 as PowertrainWarrantyIneligibilityReason,
  I1 as STEP_LOWEST_COMMON_DENOMINATOR,
  J1 as SaleSteppedPrice,
  n0 as VAS_CLAIM_CONFIGURATION,
  $1 as adaptFormDataToDto,
  H1 as adaptMapboxFeatureToAddressBody,
  z1 as addressFormFieldSchema,
  Q1 as computeBuyerMaxOfferAndFees,
  Y1 as computeFees,
  e0 as computeReservePrice,
  j1 as computeSaleDefaultValues,
  X1 as computeSellerReservePriceAndFees,
  QS as countriesConfig,
  _l as countryIso2List,
  B1 as customerServiceEmail,
  O1 as getAddressFormFieldSchema,
  A1 as getAsCountryISO2,
  C1 as getAsCountryISO3,
  N1 as getAsLanguageISO6391,
  k1 as getAsTaxCodeOrigin,
  l1 as getAsTin,
  y1 as getCountryISO3FromISO2,
  R1 as getLanguage6391FromCountryIso2,
  K1 as initFormData,
  U1 as insertIf,
  e1 as isCountryISO2,
  n1 as isCountryISO3,
  V1 as isDbIntegerValidator,
  i1 as isTaxCodeOrigin,
  D1 as isTin,
  E1 as languageNames,
  Z1 as parseAsTin,
  W1 as phoneValidator,
  M1 as provinces,
  o1 as taxCodeOriginList,
  q1 as vinValidator,
  G1 as zodPhoneE164
};
//# sourceMappingURL=shared.mjs.map
